/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { request } from '@/lib/request'

/**
 * @file 自动生成的API类型和请求函数
 * @description 根据OpenAPI规范自动生成
 * @source 默认模块 - 1.0.0
 * 此文件由脚本自动生成，请勿手动修改
 */

const baseUrl = '/backend-api/fabric'

/**
 * Pet接口类型
 */
export interface Pet {
  /** 宠物ID编号 */
  id: number
  /** 分组 */
  category: Category
  /** 名称 */
  name: string
  /** 照片URL */
  photoUrls: string[]
  /** 标签 */
  tags: Tag[]
  /** 宠物销售状态 */
  status: string
}

/**
 * Category接口类型
 */
export interface Category {
  /** 分组ID编号 */
  id?: number
  /** 分组名称 */
  name?: string
}

/**
 * Tag接口类型
 */
export interface Tag {
  /** 标签ID编号 */
  id?: number
  /** 标签名称 */
  name?: string
}

/**
 * CollectItemEntity接口类型
 */
export interface CollectItemEntity {
  /** 适用年龄 */
  age?: string
  /** 本期收藏量 */
  aggCollection?: number
  /** 本期销售额 */
  aggSaleAmount?: number
  /** 本期销量 */
  aggSaleVolume?: number
  /** 货号 */
  articleNo?: string
  /** 品牌名称 */
  brand?: string
  cancelTime?: string
  /** 商品品类ID */
  categoryId?: number
  /** 商品品类名 */
  categoryName?: string
  /** 累计收藏里 */
  collect?: object
  /** 近30天收藏 */
  collect30day?: number
  /** 监控时间 */
  collectAt?: string
  /** 是否在自己的监控中，团队使用 */
  collectFlag?: boolean
  /** 颜色 */
  colors?: string
  /** 是否在对比清单中 */
  contrastFlag?: boolean
  /** 商品预估到手价 */
  couponCprice?: number
  /** 上新首日收藏 */
  firstDayCollectCount?: object
  /** 上新首日销售额 */
  firstDaySale?: number
  /** 上新首日销量 */
  firstDaySalesVolume?: object
  /** 上新30天销量 */
  firstMonthSalesVolume?: object
  /** 监控时间 */
  followTime?: string
  /** 历史高价左区间 */
  historyMaxLeftCprice?: number
  /** 历史低价左区间 */
  historyMinLeftCprice?: number
  /** 是否监控 */
  isFollowed?: boolean
  /** 商品分组标签,最多3个 */
  itemGroupNames?: string[]
  /** 商品ID */
  itemId?: number
  /** 尺寸 */
  itemSizes?: string[]
  latestChangeInfo?: ItemInfoChange
  /** 材质成分 */
  materialComposition?: string
  /** 促销价最大值 */
  maxCprice?: number
  /** 划线价最大值 */
  maxSprice?: number
  /** 1- 有商品修改提醒 */
  notifyFlag?: number
  /** 时间范围内 最后价格 */
  periodLatestPrice?: number
  /** 时间范围内 最后库存数 */
  periodLatestStock?: number
  /** 时间范围内 最大价格 */
  periodMaxPrice?: number
  /** 时间范围内 最小价格 */
  periodMinPrice?: number
  /** 商品PicURL */
  picUrl?: string
  /** 商品PicURLList */
  picUrlList?: string[]
  /** 商品PicURLs */
  picUrls?: string
  /** 商品价格 */
  price?: number
  /** 商品根品类ID */
  rootCategoryId?: number
  /** 行业 */
  rootCategoryName?: string
  sale30dayInsertTime?: string
  /** 商品上新时间 */
  saleTime?: string
  /** 本期销售趋势 */
  saleTrendList?: DailyNewItemDO[]
  /** 累计销量 */
  salesVolume?: object
  /** 近30天销量 */
  salesVolume30?: object
  /** 销售渠道 */
  sellPlatform?: string
  /** 售卖状态 */
  shelves?: number
  /** 商品所属店铺ID */
  shopId?: number
  /** 店铺名 */
  shopName?: string
  /** 商品划线价格 */
  sprice?: number
  /** 开卖日期 */
  startSellDate?: string
  /** 开卖首日销量 */
  startSellVolume?: number
  /** 库存 */
  stock?: number
  /** 款号 */
  styleNo?: string
  /** 商品名 */
  title?: string
  /** 总收藏量 */
  totalCollect?: number
  /** 总评价 */
  totalComment?: number
  /** 总销售额 */
  totalSaleAmount?: number
  /** 总销量 */
  totalSalesVolume?: number
  /** 上架次数 */
  totalShelvesCount?: number
  /** 最新下架时间 */
  withdrawalDate?: string
  /** 年份季节 */
  yearSeason?: string
}

/**
 * TaobaoCategory接口类型
 */
export interface TaobaoCategory {
  id?: number
  isShow?: number
  name?: string
  rank?: number
  rootCategoryId?: number
  rootCategoryName?: string
  rootCategoryShortName?: string
  second?: TaobaoCategory[]
}

/**
 * ApiResult_PageSet_NewFollowShopResponse接口类型
 */
export interface ApiResult_PageSet_NewFollowShopResponse {
  errorCode?: string
  errorDesc?: string
  result?: PageSet_NewFollowShopResponse
  success?: boolean
}

/**
 * ItemSimpleResponse接口类型
 */
export interface ItemSimpleResponse {
  age?: string
  articleNo?: string
  /** 是否加入屏蔽 */
  blackListFlag?: boolean
  brandName?: string
  cancelTime?: string
  categoryId?: number
  categoryName?: string
  collect?: number
  /** 是否在自己的监控中 */
  collectFlag?: boolean
  commentCount?: number
  cprice?: number
  firstDayCollect?: number
  firstDaySalesVolume?: number
  firstMonthSalesVolume?: number
  fullAdvanceSale?: number
  itemId?: number
  launchYearSeason?: string
  materialComposition?: string
  maxCprice?: number
  maxSprice?: number
  orderedItemVolume?: number
  picUrl?: string
  picUrlList?: string
  presalePrice?: number
  presalePromotion?: string
  rootCategoryId?: number
  sale?: number
  sale30Day?: number
  sale30DayAfterReturns?: number
  sale30dayInsertTime?: string
  sale7Day?: number
  saleDay?: number
  saleTime?: string
  sellPlatform?: string
  shelves?: number
  shopId?: number
  sprice?: number
  title?: string
  totalSalesVolume?: number
}

/**
 * ApiResult_PageSet_CollectItemEntity接口类型
 */
export interface ApiResult_PageSet_CollectItemEntity {
  errorCode?: string
  errorDesc?: string
  result?: PageSet_CollectItemEntity
  success?: boolean
}

/**
 * NewFollowShopResponse接口类型
 */
export interface NewFollowShopResponse {
  agency?: boolean
  averagePrice?: string
  /** 近30天热卖面料 */
  clothTop3?: string[]
  contrastFlag?: boolean
  createdAt?: string
  /** 近30天热卖材质组合 */
  fabricTop3?: string[]
  /** 粉丝数 */
  fansCount?: string
  /** 粉丝数数值 */
  fansNumNoUnit?: number
  follow?: boolean
  /** 监控日期，为了兼容前端高速导出 */
  followTime?: string
  /** 时间段内是否有优惠活动 */
  hasPromotion?: boolean
  /** 是否是天猫店 */
  isTmall?: boolean
  /** 上新商品 */
  itemDOList?: ItemSimpleResponse[]
  logoUrl?: string
  /** 店铺主营行业 */
  mainIndustry?: string
  /** 近30天热卖面料材质 */
  materialTop3?: string[]
  /** 上新商品收藏量 */
  newItemCollectCount?: object
  /** 上新商品数 */
  newItemCount?: object
  /** 近30天上新 */
  newItemCount30Day?: number
  /** 上新商品销售额 */
  newItemSale?: object
  /** 上新商品销量 */
  newItemSalesVolume?: object
  /** 预热商品数 */
  preSaleItemCount?: number
  /** 近30天销售额 */
  sale30Day?: number
  saleAmountOrigin?: number
  /** 动销率 */
  saleRate?: string
  saleVolumeOrigin?: number
  /** 近30天销量 */
  salesVolume30Day?: number
  sellerName?: string
  shopAgencyType?: number
  /** 店铺分组标签,最多3个 */
  shopGroupNames?: string[]
  shopId?: number
  shopName?: string
  shopRatioDataDTO?: ShopRatioDataResponse
  shopStyle?: string
  shopType?: string
  shopUrl?: string
  shopYearRatioDataDTO?: ShopRatioDataResponse
  topItemList?: ItemSimpleResponse[]
  /** 上新商品销量top */
  topNewItemList?: ItemSimpleResponse[]
  /** 店铺商品总销售额 */
  totalSale?: object
  /** 店铺商品总销量 */
  totalSalesVolume?: object
  /** 监控者，为了兼容前端高速导出 */
  userName?: string
  userShopFollowDTO?: UserShopFollowResponse
  wangwangId?: string
}

/**
 * PageSet_CollectItemEntity接口类型
 */
export interface PageSet_CollectItemEntity {
  boundaryId?: string
  currentPageNo?: number
  needCount?: boolean
  pageSize?: number
  param?: object
  resultCount?: number
  resultList?: CollectItemEntity[]
  start?: number
  totalPageCount?: number
  totallPageCount?: number
}

/**
 * UserShopFollowResponse接口类型
 */
export interface UserShopFollowResponse {
  cancelFollowRemainDays?: number
  followTime?: string
  followTimeBak?: string
  userId?: number
  userName?: string
}

/**
 * PageSet_NewFollowShopResponse接口类型
 */
export interface PageSet_NewFollowShopResponse {
  boundaryId?: string
  currentPageNo?: number
  needCount?: boolean
  pageSize?: number
  param?: object
  resultCount?: number
  resultList?: NewFollowShopResponse[]
  start?: number
  totalPageCount?: number
  totallPageCount?: number
}

/**
 * Promotion接口类型
 */
export interface Promotion {
  /** 活动列表 */
  activityList?: string[]
  /** 活动名称 */
  activityName?: string
  /** 优惠类型(1：平台，2：店铺，3：商品) */
  couponType?: number
  crawlDate?: string
  /** 活动结束时间 */
  endTime?: string
  /** 是否有优惠 */
  hasPromotion?: boolean
  itemId?: number
  /** 优惠活动：活动类型+内容 */
  promotionDataList?: PromotionData[]
  /** 优惠活动 */
  promotionList?: string[]
  /** 优惠后的最高价 */
  promotionPriceMax?: number
  /** 优惠后的最低价 */
  promotionPriceMin?: number
  promotions?: string
  shopId?: number
  /** 优惠占比 */
  shopPromotionRatio?: number
  /** 活动开始时间 */
  startTime?: string
}

/**
 * ShopRatioDataResponse接口类型
 */
export interface ShopRatioDataResponse {
  /** 上新商品数环比 */
  newItemCountRingRatio?: number
  /** 估算销售额环比 */
  saleRingRatio?: number
  /** 店铺销量环比 */
  salesVolumeRingRatio?: number
}

/**
 * TaobaoFirstSecondCategory接口类型
 */
export interface TaobaoFirstSecondCategory {
  aiData?: boolean
  authAble?: boolean
  first?: TaobaoCategory
  hydc?: boolean
  industryAnalysis?: boolean
  second?: TaobaoCategory[]
  topCategoryId?: boolean
}

/**
 * DailyNewItemDO接口类型
 */
export interface DailyNewItemDO {
  /** 品类名 */
  categoryName?: string
  /** 收藏量 */
  collect?: number
  /** 评论量 */
  commentCount?: number
  /** 促销 价 */
  cprice?: number
  /** 日收藏 */
  dailyCollect?: number
  day30SalesVolume?: number
  /** 今日销量 */
  daySale?: number
  /** 日销售额 */
  daySaleAmount?: number
  /** 聚合时间 */
  granularityDate?: string
  /** 是否有引流 */
  hasInboudMarketing?: boolean
  /** 爆款值 */
  hotScore?: number
  /** 上新时间 */
  insertDate?: string
  /** 商品id */
  itemId?: number
  /** 主图URL */
  picUrl?: string
  promotionDTO?: Promotion
  /** 店铺id */
  shopId?: number
  /** sku */
  sku?: number
  /** 原始 价 */
  sprice?: number
  /** 商品名 */
  title?: string
  /** 总销量 */
  totleSale?: number
}

/**
 * ItemInfoChange接口类型
 */
export interface ItemInfoChange {
  afterInfo?: object
  beforeInfo?: object
  changeElement?: string
  changeElementCode?: string
  changeTime?: string
  itemId?: number
}

/**
 * ApiResult_List_TaobaoFirstSecondCategory接口类型
 */
export interface ApiResult_List_TaobaoFirstSecondCategory {
  errorCode?: string
  errorDesc?: string
  result?: TaobaoFirstSecondCategory[]
  success?: boolean
}

/**
 * PromotionData接口类型
 */
export interface PromotionData {
  /** 优惠类型(1：平台，2：店铺，3：商品) */
  couponType?: number
  /** 优惠活动内容 */
  promotionList?: string[]
}

/**
 * ApiResult_PageSet_RpcWindowDailyGoods接口类型
 */
export interface ApiResult_PageSet_RpcWindowDailyGoods {
  errorCode?: string
  errorDesc?: string
  result?: PageSet_RpcWindowDailyGoods
  success?: boolean
}

/**
 * PageSet_RpcWindowDailyGoods接口类型
 */
export interface PageSet_RpcWindowDailyGoods {
  boundaryId?: string
  currentPageNo?: number
  needCount?: boolean
  pageSize?: number
  param?: object
  resultCount?: number
  resultList?: RpcWindowDailyGoods[]
  start?: number
  totalPageCount?: number
  totallPageCount?: number
}

/**
 * ApiResult_PageSet_RunwayData接口类型
 */
export interface ApiResult_PageSet_RunwayData {
  errorCode?: string
  errorDesc?: string
  result?: PageSet_RunwayData
  success?: boolean
}

/**
 * PageSet_RunwayData接口类型
 */
export interface PageSet_RunwayData {
  boundaryId?: string
  currentPageNo?: number
  needCount?: boolean
  pageSize?: number
  param?: object
  resultCount?: number
  resultList?: RunwayData[]
  start?: number
  totalPageCount?: number
  totallPageCount?: number
}

/**
 * PageSet_ImageEntity接口类型
 */
export interface PageSet_ImageEntity {
  boundaryId?: string
  currentPageNo?: number
  needCount?: boolean
  pageSize?: number
  param?: object
  resultCount?: number
  resultList?: ImageEntity[]
  start?: number
  totalPageCount?: number
  totallPageCount?: number
}

/**
 * 笔记榜单_请求参数接口类型
 */
export interface 笔记榜单_请求参数 {
  /** 发布时间结束 格式 yyyy-MM-dd HH:mm:SS */
  blogPublishTimeEnd?: string
  /** 发布时间开始 格式 yyyy-MM-dd HH:mm:SS */
  blogPublishTimeStart?: string
  /** 结束时间 格式 yyyy-MM-dd */
  blogTimeEnd: string
  /** 开始时间 格式 yyyy-MM-dd */
  blogTimeStart: string
  /** 二级品类 */
  category?: string
  /** 地区列表 */
  cityList?: string[]
  /** 面料 */
  fabricList?: string[]
  /** 过滤内部屏蔽的博主 */
  filterInnerFiledBlogger?: boolean
  /** 行业：女装 男装 男童 女童 童装 */
  gender: string
  /** 最大粉丝数 */
  maxFansNum?: number
  /** 最大价格 单位：分 */
  maxPrice?: number
  /** 最小粉丝数 */
  minFansNum?: number
  /** 最小价格 单位：分 */
  minPrice?: number
  /** 笔记类型 (xhs:1-图文 2-视频) (ins:1-仅含图片 2-含视频 3-仅含视频 4-含图片) */
  noteType?: number
  /** pageSize */
  pageSize?: number
  /** 平台id */
  platformId: number
  /** 1-款式榜 2-飙升榜 3-新款榜 4-赞粉比榜 */
  rankType: number
  /** 地区 */
  region?: string
  /** 一级品类 */
  rootCategory?: string
  /** start */
  start?: number
  /** 风格 */
  style?: string
  /** 博主风格 */
  styleList?: string[]
}

/**
 * ApiResult_PageSet_ImageEntity接口类型
 */
export interface ApiResult_PageSet_ImageEntity {
  errorCode?: string
  errorDesc?: string
  result?: PageSet_ImageEntity
  success?: boolean
}

/**
 * 供应商公司信息
 */
export interface PromotionCompany {
  /** 供应商公司地址 */
  address?: string
  /** 供应商公司logo */
  logo?: string
  /** 供应商公司主营业务 */
  mainBusiness?: string
  /** 供应商公司商品信息 */
  promotionFabricItems?: PromotionFabricItem[]
  /** 供应商公司id */
  teamId?: number
  /** 供应商公司名称 */
  teamName?: string
}

/**
 * ApiResult_object接口类型
 */
export interface ApiResult_object {
  errorCode?: string
  errorDesc?: string
  result?: object
  success?: boolean
}

/**
 * ShopMonitorRequest接口类型
 */
export interface ShopMonitorRequest {
  /** 时间粒度 1-昨天 2-近7天 3-近30天 4-近90天 */
  dateGranularity?: number
  /** 结束时间 */
  endDate?: string
  /** 导出是否需要热卖面料 */
  exportFabricFlag?: boolean
  /** 分组id */
  groupId?: number
  /** 分组列表 */
  groupIdList?: number[]
  /** 标记是否导出 0-非导出 1-导出 */
  isExport?: number
  /** 店铺行业 */
  labelIndustry?: string
  /** 店铺风格 */
  labelStyle?: string
  /** 店铺类型 */
  labelType?: string
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 排序 1-上新desc,1-上新asc,3-销量desc,4-销量asc,5-销售额desc,6-销售额asc,7-平均动销率desc,8-平均动销率asc,9-监控时间desc,10-监控时间asc,11-预热商品数desc,12-预热商品数asc,13-粉丝数desc,14-粉丝数asc */
  rankStatus?: number
  /** rootCategoryId */
  rootCategoryId?: number
  /** 搜索店铺名 */
  shopLikeName?: string
  /** 市场类型 */
  shopType?: number
  sortField?: string
  sortType?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 开始时间 */
  startDate?: string
  /** 热卖面料 */
  topCloth?: string
  /** 热卖材质组合 */
  topFabric?: string
  /** 热卖面料材质 */
  topMaterial?: string
}

/**
 * ApiResult_FabricUserAuthGreetingCountRespone接口类型
 */
export interface ApiResult_FabricUserAuthGreetingCountRespone {
  errorCode?: string
  errorDesc?: string
  result?: FabricUserAuthGreetingCountRespone
  success?: boolean
}

/**
 * 打招呼次数
 */
export interface FabricUserAuthGreetingCountRespone {
  /** 打招呼次数 */
  count?: number
  /** 0 无权限，1 有权限 */
  status?: number
  /** 剩余打招呼次数 */
  surplusGreetingCount?: number
}

/**
 * handleUsingGETBody接口类型
 */
export interface handleUsingGETBody {
  
}

/**
 * ApiResultPaginationResultFabricInfoListResponse接口类型
 */
export interface ApiResultPaginationResultFabricInfoListResponse {
  result?: PaginationResultFabricInfoListResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * PaginationResultFabricInfoListResponse接口类型
 */
export interface PaginationResultFabricInfoListResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricInfoListResponse[]
}

/**
 * 面料列表查询请求参数
 */
export interface FabricInfoQueryRequest {
  /** 货号 */
  articleNo?: string
  /** 货号导入 */
  articleNoList?: string[]
  /** 品类 */
  categoryList?: string[]
  /** 品类名称 */
  categoryNameList?: string[]
  /** 成分 */
  compositionLists?: string[]
  /** 工艺 */
  crafts?: string[]
  /** 下架时间结束 */
  endOffShelfTime?: string
  /** 审核驳回时间结束 */
  endRejectionTime?: string
  /** 上架时间结束 */
  endShelfTime?: string
  /** 提交审核时间结束 */
  endSubmissionReviewTime?: string
  /** 创建时间-结束 */
  endTime?: string
  /** 面料id */
  fabricId?: string
  /** 面料id导入 */
  fabricIdList?: string[]
  /** 面料名称 */
  fabricName?: string
  /** 主推色 */
  fabricSpecificationPics?: string[]
  /** 功能性 */
  functionalityLists?: string[]
  /** 面料名称/品类搜索框 */
  fuzzySearchField?: string
  /** 面料名称/id/货号搜索 */
  fuzzySearchName?: string
  /** 关键词搜索 */
  keyword?: string
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 克重max */
  maxGramWeight?: number
  /** 克重min */
  minGramWeight?: number
  operator?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 图案 */
  patterns?: string[]
  /** 最高 */
  priceMax?: string
  /** 最低售价 */
  priceMin?: string
  /** 用途 */
  purposes?: string[]
  /** 上下架状态  1审核驳回；2已下架；3在售；4审核中 */
  shelfStatus?: number
  /** 店铺装修分类,支持一级&二级 */
  shopClassifyIds?: unknown[]
  /** 店铺推荐: 1-推荐 */
  shopRecommendStatus?: number
  /** sortField */
  sortField?: string
  /** 排序方式：asc/desc */
  sortOrder?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 下架时间开始 */
  startOffShelfTime?: string
  /** 审核驳回时间开始 */
  startRejectionTime?: string
  /** 上架时间开始 */
  startShelfTime?: string
  /** 提交审核时间开始 */
  startSubmissionReviewTime?: string
  /** 创建时间-开始 */
  startTime?: string
  /** 状态 1未推广；2审核中；3推广中；4已结束；5不通过 */
  statusList?: number[]
  /** 适用季节 */
  suitableSeasons?: string[]
  /** 面料标签id */
  tagIdList?: string[]
  /** 查询商家详情面料列表时必传 */
  teamId?: number
  /** 编辑时间-结束 */
  updateEndTime?: string
  /** 编辑时间-开始 */
  updateStartTime?: string
}

/**
 * 面料信息编辑请求参数（新增、修改、删除时用）
 */
export interface FabricInfoEditRequest {
  /** 货号 */
  articleNo?: string
  /** 起批量 */
  bulkOrder?: string
  /** 顶破度 */
  burstingStrength?: string
  /** 品类（传字典id） */
  category?: string
  /** 发货地 */
  city?: string
  /** 色牢度 */
  colorFastness?: string
  /** 成分 */
  compositionList?: Composition[]
  /** 工艺（传字典id） */
  craft?: string
  /** 悬垂 */
  drapeability?: string
  /** 弹力 */
  elasticity?: string
  /** 面料色卡图 */
  fabricColorPic?: string
  /** 面料细节图 */
  fabricDetailPic?: string
  /** 特性 */
  fabricFeature?: string
  /** 面料id，修改时必传 */
  fabricId?: string
  /** 面料id集合，删除时必传 */
  fabricIdList?: string[]
  /** 面料名称 */
  fabricName?: string
  /** 面料详情图 */
  fabricParticularsPic?: string
  /** 面料规格图（颜色,图片url英文逗号隔开） */
  fabricSpecificationPic?: string[]
  /** 面料类型 1现货 2期货 */
  fabricType?: number
  /** 面料视频 */
  fabricVideo?: string
  /** 门幅 */
  fabricWidth?: string
  /** 出布率 */
  fabricYield?: string
  /** 功能性 */
  functionalityList?: Functionality[]
  /** 成衣展示图 存的是关联商品id和上传款式的id */
  garmentDisplayList?: garmentDisplay[]
  /** 克重 */
  gramWeight?: string
  /** 最大克重 */
  gramWeightMax?: string
  /** 最小克重 */
  gramWeightMin?: string
  /** 吸湿 */
  hygroscopic?: string
  /** 不在面料中心详情页显示  0否；1是 */
  isComposition?: number
  /** 主要用途 */
  mainPurpose?: string
  /** 起批量最大阈值（超过面议） */
  maxOrderQuantity?: string
  operator?: number
  /** 图案 */
  pattern?: string
  /** 面料售价 -1为面议 */
  price?: string
  /** 面料最大售价 */
  priceMax?: string
  /** 面料最小售价 */
  priceMin?: string
  /** 面料销售单位 */
  priceUnit?: string
  /** 用途 */
  purpose?: string
  /** 备注 */
  remark?: string
  /** 柔软 */
  softness?: string
  /** 状态 1未推广；2审核中；3推广中；4已结束；5不通过（编辑的时候需要回传） */
  status?: number
  /** 适用季节 */
  suitableSeason?: string
  /** 商家id */
  teamId?: number
  /** 商家名称 */
  teamName?: string
  /** 保暖 */
  thermalInsulation?: string
  /** 厚度 */
  thickness?: string
  /** 支数 */
  threadCount?: string
  /** 透气 */
  ventilate?: string
  /** 经缩 */
  warpShrinkage?: string
  /** 纬缩 */
  weftShrinkage?: string
}

/**
 * ApiResultListDataDictResponse接口类型
 */
export interface ApiResultListDataDictResponse {
  result?: DataDictResponse[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料列表返回信息
 */
export interface FabricInfoListResponse {
  /** 上架审核驳回补充说明 */
  additionalNotes?: string
  /** 货号 */
  articleNo?: string
  /** 关联商品数 */
  associatedStyleCount?: number
  /** 起批量 */
  bulkOrder?: string
  /** 顶破度 */
  burstingStrength?: string
  /** 品类 */
  category?: string
  /** 发货地 */
  city?: string
  /** 色牢度 */
  colorFastness?: string
  /** 成分 */
  compositionList?: Composition[]
  /** 工艺 */
  craft?: string
  /** 创建时间 */
  createdAt?: string
  /** 创建人id */
  creatorId?: number
  /** 创建人姓名 */
  creatorName?: string
  /** 创建人手机号 */
  creatorPhone?: string
  /** 删除时间 */
  deletedAt?: string
  /** 悬垂 */
  drapeability?: string
  /** 弹力 */
  elasticity?: string
  /** 面料色卡图 */
  fabricColorPic?: string
  /** 面料细节图 */
  fabricDetailPic?: string
  /** 特性 */
  fabricFeature?: string
  /** 面料id */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 面料详情图 */
  fabricParticularsPic?: string
  /** 面料关联商品 */
  fabricProductAssociationList?: FabricProductAssociation[]
  /** 面料关联推广项目 */
  fabricPromotionProjectList?: PromotionProject[]
  /** 面料规格图（颜色,图片url英文逗号隔开） */
  fabricSpecificationPic?: string[]
  /** 面料关联标签 */
  fabricTagList?: FabricTag[]
  /** 面料类型 1现货 2期货 */
  fabricType?: number
  /** 面料视频 */
  fabricVideo?: string
  /** 门幅 */
  fabricWidth?: string
  /** 出布率 */
  fabricYield?: string
  /** 功能性 */
  functionalityList?: Functionality[]
  /** 成衣展示图数组 */
  garmentDisplayList?: GarmentDisplay[]
  /** 成衣展示图 */
  garmentDisplayPic?: string
  /** 克重 */
  gramWeight?: string
  /** 最大克重 */
  gramWeightMax?: string
  /** 最小克重 */
  gramWeightMin?: string
  /** 吸湿 */
  hygroscopic?: string
  /** id */
  id?: number
  /** 咨询次数 */
  inquiryCount?: number
  /** 是否有操作权限 0无；1有 */
  isAuthorized?: number
  /** 不在面料中心详情页显示  0否；1是 */
  isComposition?: number
  /** 是否运营创建 0否；1是； */
  isOperation?: number
  /** 主要用途 */
  mainPurpose?: string
  /** 起批量最大阈值（超过面议 */
  maxOrderQuantity?: string
  /** 下架时间 */
  offShelfAt?: string
  /** 下架原因 */
  offShelfReason?: string
  /** 图案 */
  pattern?: string
  /** 面料售价 -1为面议 */
  price?: string
  /** 面料最大售价 */
  priceMax?: string
  /** 面料最小售价 */
  priceMin?: string
  /** 面料销售单位 */
  priceUnit?: string
  /** 推广审核驳回补充说明 */
  promotionAdditionalNotes?: string
  /** 推广审核驳回原因 */
  promotionRejectReason?: string
  /** 用途 */
  purpose?: string
  /** 上架审核驳回原因 */
  rejectReason?: string
  /** 上架审核驳回时间 */
  rejectionAt?: string
  /** 备注 */
  remark?: string
  /** 上架时间 */
  shelfAt?: string
  /** 上下架状态 1审核驳回；2已下架；3在售；4审核中 */
  shelfStatus?: number
  /** 柔软 */
  softness?: string
  /** 状态 1未推广；2审核中；3推广中；4已结束；5不通过 */
  status?: number
  /** 款式id */
  styleId?: string
  /** 上架审核提交时间 */
  submissionReviewAt?: string
  /** 适用季节 */
  suitableSeason?: string
  /** 商家id */
  teamId?: number
  /** 商家名称 */
  teamName?: string
  /** 保暖 */
  thermalInsulation?: string
  /** 厚度 */
  thickness?: string
  /** 支数 */
  threadCount?: string
  /** 更新时间 */
  updatedAt?: string
  /** 修改人id */
  updaterId?: number
  /** 修改人姓名 */
  updaterName?: string
  /** 修改人手机号 */
  updaterPhone?: string
  /** 透气 */
  ventilate?: string
  /** 版本号 */
  version?: number
  /** 展现次数 */
  viewCount?: number
  /** 经缩 */
  warpShrinkage?: string
  /** 纬缩 */
  weftShrinkage?: string
}

/**
 * BasicItemInfo接口类型
 */
export interface BasicItemInfo {
  /** 商品ID */
  itemId?: number
  /** 商品logo图URL */
  picUrl?: string
  /** 销量 */
  saleVolume?: number
  /** 商品名 */
  title?: string
}

/**
 * ApiResultFabricInfoListResponse接口类型
 */
export interface ApiResultFabricInfoListResponse {
  result?: FabricInfoListResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料数据字典返回信息
 */
export interface DataDictResponse {
  /** 字段名 */
  columnCode?: string
  /** 字段注释 */
  columnComment?: string
  /** 字段键值 */
  columnKey?: string
  /** 字段数据 */
  columnValue?: string
  /** id */
  id?: number
  /** 父id */
  parentId?: number
  /** 排序 */
  sort?: number
}

/**
 * ApiResult_List_UserCollectFabricMaterialResponse接口类型
 */
export interface ApiResult_List_UserCollectFabricMaterialResponse {
  errorCode?: string
  errorDesc?: string
  result?: UserCollectFabricMaterialResponse[]
  success?: boolean
}

/**
 * PaginationResult_MonitorCenterDistributionResponse接口类型
 */
export interface PaginationResult_MonitorCenterDistributionResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: MonitorCenterDistributionResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * ModelAndView接口类型
 */
export interface ModelAndView {
  empty?: boolean
  model?: object
  modelMap?: object
  reference?: boolean
  status?: string
  view?: View
  viewName?: string
}

/**
 * ApiResult_HotClothResponse接口类型
 */
export interface ApiResult_HotClothResponse {
  errorCode?: string
  errorDesc?: string
  result?: HotClothResponse
  success?: boolean
}

/**
 * 热门面料/材质参数
 */
export interface HotFabricMaterialRequest {
  /** 品类id */
  categoryId?: number
  /** 是否优先展示收藏面料：true-是 */
  collectFlag?: boolean
  /** 模糊搜索 */
  fuzzyValue?: string
  /** 返回个数 */
  limit?: number
  /** 行业id */
  rootCategoryId?: number
}

/**
 * ApiResult_PaginationResult_MonitorCenterDistributionResponse接口类型
 */
export interface ApiResult_PaginationResult_MonitorCenterDistributionResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_MonitorCenterDistributionResponse
  success?: boolean
}

/**
 * ApiResult_HotMaterialResponse接口类型
 */
export interface ApiResult_HotMaterialResponse {
  errorCode?: string
  errorDesc?: string
  result?: HotMaterialResponse
  success?: boolean
}

/**
 * 热门面料材质
 */
export interface HotMaterialResponse {
  /** 热度 */
  hotIndex?: number
  /** 热门搭配 */
  hotMatchList?: MaterialHotMatchResponse[]
  /** 热卖面料占比 */
  hotPercent?: string
  /** 是否收藏：1-是 */
  isCollected?: number
  /** 材质 */
  material?: string
  /** 材质图片 */
  picUrl?: string
  /** 排序 */
  rank?: number
}

/**
 * SubmitQueryRequest接口类型
 */
export interface SubmitQueryRequest {
  /** 任务请求参数 */
  taskParams?: string
  /** 任务类型 */
  taskType?: string
}

/**
 * 面料魔方-xx分布请求参数
 */
export interface AnalysisDistributionRequest {
  /** 分析维度：CLOTH-面料 FABRIC-材质组合，MATERIAL-材质，MATERIAL_PERCENT-材质成分占比，CATEGORY-品类，PRICE-价格带，COLOR-颜色，PROPERTY-属性，SHOP-店铺，BRAND-品牌 */
  analysisDimension?: string
  /** 分析结果个数限制 */
  analysisLimit?: number
  /** 分析排序：SALE_VOLUME-销量，NEGATIVE_COMMENT_RATE-差评率，SALE_VOLUME_MOM_RATE-销量飙升，SALE_AMOUNT-销售额，SALE_AMOUNT_MOM_RATE-销售额飙升，FIRST_DAY_SALE_VOLUME-首日销量，FIRST_DAY_SALE_AMOUNT-首日销售额，NEW_ITEM_NUM-上新数，NEW_ITEM_NUM_MON_RATE-上新数飙升 */
  analysisSort?: string
  /** 品类id */
  categoryId?: number
  /** 面料 */
  cloth?: string
  /** 统计时间结束 */
  endDate?: string
  /** 材质组合 */
  fabric?: string
  /** 模糊搜索 */
  fuzzyQuery?: string
  /** 监控分组id */
  groupIdList?: string[]
  /** 面料材质 */
  material?: string
  /** 材质成分占比区间 */
  materialPercentRangeList?: string[]
  /** 材质成分占比区间max */
  maxMaterialPercent?: number
  /** 材质成分占比区间min */
  minMaterialPercent?: number
  /** 价格带区间 */
  priceRangeList?: string[]
  /** 价格类型: 1-售价 2-当前到手价 4-历史最低价 */
  priceType?: number
  /** 属性名 */
  propertyName?: string
  /** 行业id */
  rootCategoryId?: number
  /** 上新时间-结束(包含当天) */
  saleTimeEnd?: string
  /** 上新时间-开始(包含当天) */
  saleTimeStart?: string
  /** 店铺id */
  shopId?: number
  /** 市场类型：0-淘宝，1-天猫 */
  shopType?: number
  /** 统计时间开始 */
  startDate?: string
  /** 趋势日期类型：RANGE_DAY-天，RANGE_WEEK-周，RANGE_MONTH-月 */
  trendDateRange?: string
}

/**
 * BasicShopInfo接口类型
 */
export interface BasicShopInfo {
  /** 店铺logo图URL */
  logoUrl?: string
  /** 销量 */
  saleVolume?: number
  /** 店铺ID */
  shopId?: number
  /** 店铺名 */
  shopName?: string
}

/**
 * SubmitQueryResponse接口类型
 */
export interface SubmitQueryResponse {
  /** 任务id */
  taskId?: string
}

/**
 * ApiResult_List_HotFabricResponse接口类型
 */
export interface ApiResult_List_HotFabricResponse {
  errorCode?: string
  errorDesc?: string
  result?: HotFabricResponse[]
  success?: boolean
}

/**
 * RequestContext接口类型
 */
export interface RequestContext {
  client?: string
  groupId?: number
  teamId?: number
  userId?: number
}

/**
 * ApiResult_AnalysisSummaryResponse接口类型
 */
export interface ApiResult_AnalysisSummaryResponse {
  errorCode?: string
  errorDesc?: string
  result?: AnalysisSummaryResponse
  success?: boolean
}

/**
 * 热门搭配
 */
export interface MaterialHotMatchResponse {
  /** 搭配度 */
  matchIndex?: number
  /** 搭配面料材质 */
  matchMaterial?: string
}

/**
 * HealthData接口类型
 */
export interface HealthData {
  build_commit_id?: string
  build_commit_ref_name?: string
  build_commit_title?: string
  build_datetime?: string
  build_pipeline_name?: string
  build_pipeline_number?: string
  pod_name?: string
  pod_pz?: string
}

/**
 * ApiResult_List_HotMaterialResponse接口类型
 */
export interface ApiResult_List_HotMaterialResponse {
  errorCode?: string
  errorDesc?: string
  result?: HotMaterialResponse[]
  success?: boolean
}

/**
 * ApiResult_List_AnalysisTrendResponse接口类型
 */
export interface ApiResult_List_AnalysisTrendResponse {
  errorCode?: string
  errorDesc?: string
  result?: AnalysisTrendResponse[]
  success?: boolean
}

/**
 * ApiResult_GetResultResponse接口类型
 */
export interface ApiResult_GetResultResponse {
  errorCode?: string
  errorDesc?: string
  result?: GetResultResponse
  success?: boolean
}

/**
 * 面料魔方-监控中心请求参数
 */
export interface MonitorCenterDistributionRequest {
  /** 分析维度：FABRIC-面料，MATERIAL-材质，MATERIAL_PERCENT-面料材质成分占比分布 */
  analysisDimension?: string
  /** 分析排序：SALE_VOLUME-销量，SALE_VOLUME_MOM_RATE-销量飙升，SALE_AMOUNT-销售额，SALE_AMOUNT_MOM_RATE-销售额飙升，NEW_ITEM_COUNT-上新数，NEW_ITEM_COUNT_MOM_RATE-上新数飙升 */
  analysisSort?: string
  /** 品类id */
  categoryId?: number
  /** 统计时间结束 */
  endDate?: string
  /** 监控分组id */
  groupIdList?: string[]
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 材质成分占比区间 */
  materialPercentRangeList?: string[]
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 搜索关键字 */
  queryTitle?: string
  /** 行业id */
  rootCategoryId?: number
  /** 市场类型：0-淘宝，1-天猫 */
  shopType?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 统计时间开始 */
  startDate?: string
}

/**
 * ApiResult_HotFabricResponse接口类型
 */
export interface ApiResult_HotFabricResponse {
  errorCode?: string
  errorDesc?: string
  result?: HotFabricResponse
  success?: boolean
}

/**
 * GetResultResponse接口类型
 */
export interface GetResultResponse {
  /** 查询消耗时间 */
  cost?: number
  /** 结果 */
  data?: string
  /** 失败原因 */
  failReason?: string
  stackTrace?: string
  /** 任务状态 */
  status?: number
  /** 查询的任务id */
  taskId?: string
}

/**
 * ApiResult_boolean接口类型
 */
export interface ApiResult_boolean {
  errorCode?: string
  errorDesc?: string
  result?: boolean
  success?: boolean
}

/**
 * 收藏面料/材质参数
 */
export interface UserCollectFabricMaterialRequest {
  /** 收藏类型：FABRIC-材质组合，MATERIAL-材质，CLOTH-面料 */
  collectType?: string
  /** 收藏的面料/材质组合/材质名称 */
  collectValue?: string
}

/**
 * 面料魔方趋势中心-数据概览
 */
export interface AnalysisSummaryResponse {
  /** 评论数 */
  aggCommentNum?: number
  /** 差评数 */
  aggNegativeCommentNum?: number
  /** 差评率 */
  negativeCommentRate?: number
  /** 上新数 */
  newItemCount?: number
  /** 上新数环比 */
  newItemCountMOMRate?: number
  /** 上新数同比 */
  newItemCountYOYRate?: number
  /** 销售额 */
  saleAmount?: number
  /** 销售额环比 */
  saleAmountMOMRate?: number
  /** 销售额同比 */
  saleAmountYOYRate?: number
  /** 销量 */
  saleVolume?: number
  /** 销量环比 */
  saleVolumeMOMRate?: number
  /** 销量同比 */
  saleVolumeYOYRate?: number
  /** 应用率 */
  utilityRatio?: number
}

/**
 * View接口类型
 */
export interface View {
  contentType?: string
}

/**
 * 面料魔方趋势中心-数据分布
 */
export interface AnalysisDistributionResponse {
  /** 评论数 */
  aggCommentNum?: number
  /** 差评数 */
  aggNegativeCommentNum?: number
  /** 数据key */
  analysisKey?: string
  /** 数据名称 */
  analysisName?: string
  /** 数据额外信息 */
  extraInfo?: object
  /** 首日销售额 */
  firstDaySaleAmount?: number
  /** 首日销售额占比 */
  firstDaySaleAmountPercent?: number
  /** 首日销量 */
  firstDaySaleVolume?: number
  /** 首日销量占比 */
  firstDaySaleVolumePercent?: number
  /** 差评率 */
  negativeCommentRate?: number
  /** 上新数 */
  newItemCount?: number
  /** 上新数环比 */
  newItemCountMOMRate?: number
  /** 上新数占比 */
  newItemCountPercent?: number
  /** 销售额 */
  saleAmount?: number
  /** 销售额环比 */
  saleAmountMOMRate?: number
  /** 销售额占比 */
  saleAmountPercent?: number
  /** 销量 */
  saleVolume?: number
  /** 销量环比 */
  saleVolumeMOMRate?: number
  /** 销量占比 */
  saleVolumePercent?: number
}

/**
 * 热门材质组合
 */
export interface HotFabricResponse {
  /** 面料 */
  fabric?: string
  /** 是否收藏：1-是 */
  isCollected?: number
  /** 排序 */
  rank?: number
  /** 相似面料 */
  similarFabricList?: string[]
}

/**
 * TrendResponse接口类型
 */
export interface TrendResponse {
  /** 日期 */
  date?: string
  /** 行业销售占比 */
  percent?: number
  /** 数值：销量/销售额/上新数/首日销量/首日销售额 */
  value?: number
}

/**
 * 面料魔方-监控中心-分布
 */
export interface MonitorCenterDistributionResponse {
  /** 数据key */
  analysisKey?: string
  /** 数据名称 */
  analysisName?: string
  /** 数据额外信息 */
  extraInfo?: object
  /** 热卖商品top3 */
  hotItemList?: BasicItemInfo[]
  /** 热卖店铺top3 */
  hotShopList?: BasicShopInfo[]
  /** 上新数 */
  newItemCount?: number
  /** 上新数环比 */
  newItemCountMOMRate?: number
  /** 上新数占比 */
  newItemCountPercent?: number
  /** 销售额 */
  saleAmount?: number
  /** 销售额环比 */
  saleAmountMOMRate?: number
  /** 销售额占比 */
  saleAmountPercent?: number
  /** 销量 */
  saleVolume?: number
  /** 销量环比 */
  saleVolumeMOMRate?: number
  /** 销量占比 */
  saleVolumePercent?: number
}

/**
 * Result_HealthData接口类型
 */
export interface Result_HealthData {
  data?: HealthData
  errorCode?: string
  errorDesc?: string
  success?: boolean
}

/**
 * ApiResult_SubmitQueryResponse接口类型
 */
export interface ApiResult_SubmitQueryResponse {
  errorCode?: string
  errorDesc?: string
  result?: SubmitQueryResponse
  success?: boolean
}

/**
 * ApiResult_List_AnalysisDistributionResponse接口类型
 */
export interface ApiResult_List_AnalysisDistributionResponse {
  errorCode?: string
  errorDesc?: string
  result?: AnalysisDistributionResponse[]
  success?: boolean
}

/**
 * ApiResult_RequestContext接口类型
 */
export interface ApiResult_RequestContext {
  errorCode?: string
  errorDesc?: string
  result?: RequestContext
  success?: boolean
}

/**
 * 收藏面料/材质信息
 */
export interface UserCollectFabricMaterialResponse {
  /** 收藏类型：1-面料，2-材质 */
  collectType?: string
  /** 收藏的面料/材质名称 */
  collectValue?: string
}

/**
 * ApiResult_List_HotClothResponse接口类型
 */
export interface ApiResult_List_HotClothResponse {
  errorCode?: string
  errorDesc?: string
  result?: HotClothResponse[]
  success?: boolean
}

/**
 * 面料魔方趋势中心-数据趋势
 */
export interface AnalysisTrendResponse {
  /** 数据key */
  analysisKey?: string
  /** 数据名称 */
  analysisName?: string
  /** 数据额外信息 */
  extraInfo?: object
  /** 合计占比 */
  percent?: number
  /** 趋势详情 */
  trendList?: TrendResponse[]
  /** 合计 */
  value?: number
}

/**
 * 热门面料
 */
export interface HotClothResponse {
  /** 面料 */
  cloth?: string
  /** 是否收藏：1-是 */
  isCollected?: number
  /** 排序 */
  rank?: number
}

/**
 * 面料魔方-趋势概览请求参数
 */
export interface AnalysisSummaryRequest {
  /** 品类id */
  categoryId?: number
  /** 面料 */
  cloth?: string
  /** 统计时间结束 */
  endDate?: string
  /** 材质组合 */
  fabric?: string
  /** 监控分组id */
  groupIdList?: string[]
  /** 面料材质 */
  material?: string
  /** 行业id */
  rootCategoryId?: number
  /** 上新时间-结束(包含当天) */
  saleTimeEnd?: string
  /** 上新时间-开始(包含当天) */
  saleTimeStart?: string
  /** 店铺id */
  shopId?: number
  /** 市场类型：0-淘宝，1-天猫 */
  shopType?: number
  /** 统计时间开始 */
  startDate?: string
}

/**
 * RpcGoodsPresellInfo接口类型
 */
export interface RpcGoodsPresellInfo {
  deliveryDays?: number
  depositPrice?: number
  endTime?: string
  startTime?: string
}

/**
 * RpcDouyinGoods接口类型
 */
export interface RpcDouyinGoods {
  /** 货号 */
  articleNo?: string
  /** 买家 月评论数 */
  commentNum30day?: number
  /** 收录时间 */
  firstRecordTime?: string
  /** 历史带货总人数 */
  hasGoodsStreamerNum?: number
  /** 是否官方品牌 */
  isOfficialBrand?: number
  /** 最新合作视频 */
  latestVideo?: string
  /** 最新合作视频id */
  latestVideoId?: string
  /** 抖音直播销量峰值 */
  liveMaxSaleVolume?: number
  /** 抖音直播销量峰值日期 */
  liveMaxSaleVolumeDate?: string
  /** 抖音直播销量峰值 对应liveId */
  liveMaxSaleVolumeLiveId?: string
  /** 直播最低价 */
  liveMinPrice?: number
  /** 抖音直播最低价日期 */
  liveMinPriceDate?: string
  /** 抖音直播最低价 对应liveId */
  liveMinPriceLiveId?: string
  /** 直播 销售额 */
  liveSaleAmount?: number
  /** 直播上架时间 */
  liveSaleTime?: string
  /** 直播销量 */
  liveSaleVolume?: number
  /** 直播 浏览量 */
  liveViewNum?: number
  newSaleAmount?: number
  newSaleVolume?: number
  newViewNum?: number
  /** 相关联直播数 */
  relateLiveNum?: number
  /** 直播近30天销量 */
  relateLiveSaleVolume30day?: number
  /** 直播近3天销量 */
  relateLiveSaleVolume3day?: number
  /** 直播近7天销量 */
  relateLiveSaleVolume7day?: number
  /** 直播昨日销量 */
  relateLiveSaleVolumeYesterday?: number
  /** 直播达人数 */
  relateLiveStreamerNum?: number
  /** 相关联短视频数 */
  relateProductNum?: number
  /** 相关联短视频达人数 */
  relateProductStreamerNum?: number
  /** 关联视频评论数 */
  relateVideoCommentNum?: number
  /** 关联视频转发数 */
  relateVideoForwardNum?: number
  /** 关联视频点赞数 */
  relateVideoLikeNum?: number
  /** 短视频近30天点赞数 */
  relateVideoLikeNum30day?: number
  /** 短视频近7天点赞数 */
  relateVideoLikeNum7day?: number
  /** 短视频昨日点赞数 */
  relateVideoLikeNumYesterday?: number
  /** 近30天关联视频数 */
  relateVideoNum30day?: number
  /** 昨日关联视频数 */
  relateVideoNumYesterday?: number
  /** 30天新增热推达人数 */
  relateVideoStreamerNum30day?: number
  /** 昨日新增热推达人数 */
  relateVideoStreamerNumYesterday?: number
  saleAmount?: number
  saleAmount15day?: number
  /** 收录首日销售额 */
  saleAmount1dRecord?: number
  saleAmount1day?: number
  /** 收录30日销售额 */
  saleAmount30dRecord?: number
  saleAmount30day?: number
  saleAmount3day?: number
  /** 收录7日销售额 */
  saleAmount7dRecord?: number
  saleAmount7day?: number
  saleVolume?: number
  saleVolume15day?: number
  /** 收录首日销量 */
  saleVolume1dRecord?: number
  saleVolume1day?: number
  /** 收录30日销量 */
  saleVolume30dRecord?: number
  saleVolume30day?: number
  saleVolume3day?: number
  /** 收录7日销量 */
  saleVolume7dRecord?: number
  saleVolume7day?: number
  totalViewNum?: number
  /** 抖音短视频里的最低价 */
  videoMinPrice?: number
  /** 抖音短视频最低价日期 */
  videoMinPriceDate?: string
  /** 截止最后一次爬取到的抖音详情页 销售额 */
  videoSaleAmount?: number
  /** 短视频上架时间 */
  videoSaleTime?: string
  /** 短视频销量（截止最后一次爬取到的抖音详情页 销量） */
  videoSaleVolume?: number
  viewNum?: number
  viewNum15day?: number
  viewNum1day?: number
  viewNum30day?: number
  viewNum3day?: number
  viewNum7day?: number
  /** 抖音橱窗 销售额峰值 */
  windowMaxSaleAmount?: number
  /** 抖音橱窗 销售额峰值日期 */
  windowMaxSaleAmountDate?: string
  /** 抖音橱窗 销量峰值 */
  windowMaxSaleVolume?: number
  /** 抖音橱窗 销量峰值日期 */
  windowMaxSaleVolumeDate?: string
  /** 抖音橱窗 浏览量峰值 */
  windowMaxViewNum?: number
  /** 抖音橱窗 浏览量峰值日期 */
  windowMaxViewNumDate?: string
  /** 月销售额 */
  windowSaleAmount30day?: number
  /** 昨日销售额 */
  windowSaleAmountYesterday?: number
  /** 商品上架橱窗时间 */
  windowSaleTime?: string
  /** 月销量 */
  windowSaleVolume30day?: number
  /** 商品近7天销量 */
  windowSaleVolume7day?: number
  /** 商品昨日销量 */
  windowSaleVolumeYesterday?: number
  /** 抖音橱窗 总销售额 */
  windowTotalSaleAmount?: number
  /** 抖音橱窗 总销量 */
  windowTotalSaleVolume?: number
  /** 商品近30天浏览量 */
  windowViewNum30day?: number
  /** 商品近7天浏览量 */
  windowViewNum7day?: number
  /** 商品昨日浏览量 */
  windowViewNumYesterday?: number
}

/**
 * RpcWindowDailyGoods接口类型
 */
export interface RpcWindowDailyGoods {
  /** 货号 */
  articleNo?: string
  /** 关联面料列表 */
  associatedFabrics?: AssociatedFabric[]
  /** 品牌 */
  brand?: string
  /** 子品类 */
  categoryId?: number
  /** 子品类名称 */
  categoryName?: string
  /** 颜色 */
  color?: string
  /** 近30天评论数 */
  commentNum30day?: number
  /** 通用agg字段 */
  commonNum?: number
  /** 定金预售 */
  depositPresellInfo?: RpcGoodsPresellInfo[]
  /** 定金预售状态 */
  depositPresellStatus?: string
  douyinGoods?: RpcDouyinGoods
  /** 导出属性 */
  exportProperties?: string
  /** 收录时间 */
  firstRecordTime?: string
  fullPresellInfo?: RpcGoodsPresellInfo
  /** 全款预售状态 */
  fullPresellStatus?: string
  /** 适用性别 */
  gender?: string
  /** 展示价 */
  goodsPrice?: number
  /** 商品类型 */
  goodsType?: number
  /** 小时销售额 */
  hourSaleAmount?: number
  /** 小时销量 */
  hourSaleVolume?: number
  /** 小时浏览量 */
  hourViewNum?: number
  /** 主图数量 */
  imageNum?: number
  /** 1-参与过商品卡 */
  isCardItem?: number
  /** 1-直播热卖商品 */
  isLiveHotSaleItem?: number
  /** 1-参与过直播 */
  isLiveItem?: number
  /** 商品是否收录 */
  isRecorded?: boolean
  /** 1-参与过短视频 */
  isVideoItem?: number
  /** 商品Id */
  itemId?: string
  /** 最近一次上架时间 */
  latestSaleDate?: string
  /** 抖音历史最高价 */
  maxPrice?: number
  /** 抖音历史最低价 */
  minPrice?: number
  /** 近30天最低价 */
  minPrice30day?: number
  /** 已监控的达人关联信息 */
  monitorStreamerRelateInfo?: RpcDyGoodsRelateInfo[]
  /** 本期商品卡销售额 */
  newCardSaleAmount?: number
  /** 本期商品卡销量 */
  newCardSaleVolume?: number
  /** 橱窗本期 买家评价数 */
  newCommentNum?: number
  /** 本期直播销售额 */
  newLiveSaleAmount?: number
  /** 本期直播销量 */
  newLiveSaleVolume?: number
  /** 关联直播数 */
  newRelateLiveNum?: number
  /** 本期销售额 */
  newSaleAmount?: number
  /** 本期销量 */
  newSaleVolume?: number
  /** 本期视频销售额 */
  newVideoSaleAmount?: number
  /** 本期视频销量 */
  newVideoSaleVolume?: number
  /** 橱窗本期浏览量 */
  newViewNum?: number
  /** 本期最新展示价 */
  periodLatestCPrice?: number
  /** 本期最新划线价 */
  periodLatestSPrice?: number
  /** 主图 */
  picUrl?: string
  /** 图片列表 */
  picUrlList?: string[]
  /** 属性 */
  properties?: string[]
  /** 根品类 */
  rootCategoryId?: number
  /** 根品类名称 */
  rootCategoryName?: string
  /** 近15天销售额 */
  saleAmount15day?: number
  /** 近30天销售额 */
  saleAmount30day?: number
  /** 近3天销售额 */
  saleAmount3day?: number
  /** 近7天销售额 */
  saleAmount7day?: number
  /** 今日销售额 */
  saleAmountToday?: number
  /** 昨日销售额 */
  saleAmountYesterday?: number
  /** 近15天销量 */
  saleVolume15day?: number
  /** 近30天销量 */
  saleVolume30day?: number
  /** 近3天销量 */
  saleVolume3day?: number
  /** 近7天销量 */
  saleVolume7day?: number
  /** 今日销量 */
  saleVolumeToday?: number
  /** 昨日销量 */
  saleVolumeYesterday?: number
  /** 同款商品标识 */
  sameClothes?: string
  /** 同款商品数 */
  sameItemNum?: number
  /** 同款商品店铺数 */
  sameItemShopNum?: number
  /** 发货地 */
  shipAddress?: string
  /** shopId */
  shopId?: number
  /** 店铺Logo */
  shopLogo?: string
  /** 店铺名 */
  shopName?: string
  /** 尺码 */
  size?: string
  /** sku最高价 */
  skuMaxPrice?: number
  /** sku最低价 */
  skuMinPrice?: number
  /** 划线价 */
  sprice?: number
  /** 达人直播销售额 */
  streamerLiveSaleAmount?: number
  /** 达人直播销量 */
  streamerLiveSaleVolume?: number
  /** 达人本期直播销售额 */
  streamerPeriodLiveSaleAmount?: number
  /** 达人本期直播销量 */
  streamerPeriodLiveSaleVolume?: number
  /** 达人本期总销售额 */
  streamerPeriodSaleAmount?: number
  /** 达人本期销量 */
  streamerPeriodSaleVolume?: number
  /** 达人本期视频销售额 */
  streamerPeriodVideoSaleAmount?: number
  /** 达人本期视频销量 */
  streamerPeriodVideoSaleVolume?: number
  /** 达人关联信息 */
  streamerRelateInfo?: RpcDyGoodsRelateInfo[]
  /** 关联达人直播或作品数量 */
  streamerRelateNum?: number
  /** 达人总销售额 */
  streamerSaleAmount?: number
  /** 达人收录首日销售额 */
  streamerSaleAmount1dRecord?: number
  /** 达人收录30日销售额 */
  streamerSaleAmount30dRecord?: number
  /** 达人收录7日销售额 */
  streamerSaleAmount7dRecord?: number
  /** 达人总销量 */
  streamerSaleVolume?: number
  /** 达人收录首日销量 */
  streamerSaleVolume1dRecord?: number
  /** 达人收录30日销量 */
  streamerSaleVolume30dRecord?: number
  /** 达人收录7日销量 */
  streamerSaleVolume7dRecord?: number
  /** 达人视频销售额 */
  streamerVideoSaleAmount?: number
  /** 达人视频销量 */
  streamerVideoSaleVolume?: number
  /** 商品标题 */
  title?: string
  /** 总评价数 */
  totalCommentNum?: number
  /** 橱窗总销售额 */
  totalSaleAmount?: number
  /** 橱窗总销量 */
  totalSaleVolume?: number
  /** 总浏览量 */
  totalViewNum?: number
  /** 更新时间 */
  updateTime?: string
  /** 近30天点赞数 */
  videoLikeNum30day?: number
  /** 近15天浏览量 */
  viewNum15day?: number
  /** 近30天浏览量 */
  viewNum30day?: number
  /** 近3天浏览量 */
  viewNum3day?: number
  /** 近7天浏览量 */
  viewNum7day?: number
  /** 今日浏览量 */
  viewNumToday?: number
  /** 昨日浏览量 */
  viewNumYesterday?: number
  /** 年份季节 */
  yearSeason?: string
}

/**
 * RpcSearchDyGoodsInfoRequest接口类型
 */
export interface RpcSearchDyGoodsInfoRequest {
  /** 适用年龄 */
  applyAge?: string
  /** 适用年龄 */
  applyAgeList?: string[]
  /** 供应面料过滤 */
  associatedFabricFilter?: number
  /** 品牌 */
  brand?: string
  /** 类目 */
  categoryId?: number
  /** 类目 */
  categoryIdList?: number[]
  /** 色彩 */
  color?: string
  /** 颜色id */
  colorId?: string
  /** 统计时间 */
  countEndDate?: string
  /** 统计时间 */
  countStartDate?: string
  /** 设计要素 */
  designValue?: unknown[]
  /** 过滤商品标题关键字 */
  excludeTitleList?: string[]
  /** 面料搜索 */
  fabricSearch?: string
  /** 适用性别 */
  gender?: string
  /** 商品来源 */
  goodsType?: number
  /** 本期有商品卡销售 1-是 */
  hasCardSale?: number
  /** 本期有直播销售 1-是 */
  hasLiveSale?: number
  /** 是否官方爆款榜商品，0-未上榜，1-上榜 */
  hasMarketingRank?: number
  /** 品牌官方 0-否 1-是 */
  hasOfficialBrand?: number
  /** 本期有作品销售 1-是 */
  hasVideoSale?: number
  /** 热门属性 */
  hotProperties?: unknown[]
  /** 参与过商品卡带货 0-否 1-是 */
  isCardItem?: number
  /** 是否导出本期价格 */
  isExportPeriodPrice?: number
  /** 过滤已采集 */
  isFilterCollected?: number
  /** 抖In热销榜 0-否 1-是 */
  isHotStyleRank?: number
  /** 1-只看直播热卖 */
  isLiveHotSaleItem?: number
  /** 参与过直播带货 0-否 1-是 */
  isLiveItem?: number
  /** 只看监控店铺 0- 不看 1-只看 null-不限 */
  isMonitorShop?: number
  /** 只看监控达人 0- 不看 1-只看 null-不限 */
  isMonitorStreamer?: number
  /** 知衣推荐达人 */
  isStreamerRecommend?: number
  /** 实时商品 */
  isToday?: number
  /** 参与过作品带货 0-否 1-是 */
  isVideoItem?: number
  /** 是否白底图 0-否 1-是 */
  isWhiteBg?: number
  /** 商品id */
  itemIdList?: string[]
  /** 关键字查询 标题/店铺名 */
  keyword?: string
  maxCommentNum?: number
  maxCosRatio?: number
  maxFirstRecordDate?: string
  maxHasGoodsStreamerNum?: number
  maxHistoryPrice?: number
  maxLiveDate?: string
  maxLiveSaleAmountTotal?: number
  maxLiveSaleVolumeTotal?: number
  maxMinPrice30day?: number
  maxPresellDeliveryDayNum?: number
  maxPresellDepositRatio?: number
  maxPrice?: number
  maxRelateLiveNum?: number
  maxRelateLiveNum30day?: number
  maxRelateLiveNumToday?: number
  maxRelateLiveNumYesterday?: number
  maxRelateStreamerNum30day?: number
  maxRelateStreamerNumToday?: number
  maxRelateStreamerNumYesterday?: number
  maxRelateVideoNum?: number
  maxRelateVideoNum30day?: number
  maxRelateVideoNumYesterday?: number
  maxSaleAmount30day?: number
  maxSaleAmountToday?: number
  maxSaleAmountTotal?: number
  maxSaleAmountYesterday?: number
  maxSaleVolume30day?: number
  maxSaleVolumeToday?: number
  maxSaleVolumeTotal?: number
  maxSaleVolumeYesterday?: number
  maxShopReputation?: number
  maxStreamerFansNum?: number
  maxVideoDate?: string
  maxViewNum30day?: number
  maxViewNumToday?: number
  maxViewNumTotal?: number
  maxViewNumYesterday?: number
  /** 评论数 */
  minCommentNum?: number
  /** 佣金比例 */
  minCosRatio?: number
  /** 收录时间 */
  minFirstRecordDate?: string
  /** 带货达人数 */
  minHasGoodsStreamerNum?: number
  /** 历史最低价价格 */
  minHistoryPrice?: number
  /** 直播带货时间 */
  minLiveDate?: string
  /** 直播总销售额 */
  minLiveSaleAmountTotal?: number
  /** 直播总销量 */
  minLiveSaleVolumeTotal?: number
  /** 30天最低价 */
  minMinPrice30day?: number
  /** 预售结束后 N天发货 */
  minPresellDeliveryDayNum?: number
  /** 预售定金比例 */
  minPresellDepositRatio?: number
  /** 价格 */
  minPrice?: number
  /** 总关联直播数 */
  minRelateLiveNum?: number
  /** 30天关联直播数 */
  minRelateLiveNum30day?: number
  /** 今日关联直播数 */
  minRelateLiveNumToday?: number
  /** 昨日关联直播数 */
  minRelateLiveNumYesterday?: number
  /** 30天带货达人数 */
  minRelateStreamerNum30day?: number
  /** 今日带货达人数 */
  minRelateStreamerNumToday?: number
  /** 昨日带货达人数 */
  minRelateStreamerNumYesterday?: number
  /** 总关联作品数 */
  minRelateVideoNum?: number
  /** 30天关联作品数 */
  minRelateVideoNum30day?: number
  /** 昨日关联作品数 */
  minRelateVideoNumYesterday?: number
  /** 30天销售额 */
  minSaleAmount30day?: number
  /** 今日销售额 */
  minSaleAmountToday?: number
  /** 总销售额 */
  minSaleAmountTotal?: number
  /** 昨日销售额 */
  minSaleAmountYesterday?: number
  /** 30天销量 */
  minSaleVolume30day?: number
  /** 今日销量 */
  minSaleVolumeToday?: number
  /** 总销量 */
  minSaleVolumeTotal?: number
  /** 昨日销量 */
  minSaleVolumeYesterday?: number
  /** 店铺口碑 */
  minShopReputation?: number
  /** 达人粉丝数 */
  minStreamerFansNum?: number
  /** 作品带货时间 */
  minVideoDate?: string
  /** 30天浏览量 */
  minViewNum30day?: number
  /** 今日浏览量 */
  minViewNumToday?: number
  /** 总浏览量 */
  minViewNumTotal?: number
  /** 昨日浏览量 */
  minViewNumYesterday?: number
  /** 仅看商品卡销售 0-否 1-是 */
  onlyCardSale?: number
  /** 仅看直播销售 0-否 1-是 */
  onlyLiveSale?: number
  /** 仅看作品销售 0-否 1-是 */
  onlyVideoSale?: number
  /** 排序字段 */
  orderField?: string
  /** 达人播为主 0-否 1-是 */
  otherSale?: number
  pageNo?: number
  pageSize?: number
  /** 预售状态 */
  presellStatus?: string
  /** 投放状态 0:未投放；1: 投放中 */
  promotedFabricFilter?: number
  /** 查询来源 */
  queryType?: string
  /** 推荐标签 */
  recommendProperty?: string
  /** 行业 */
  rootCategoryId?: number
  /** 行业 */
  rootCategoryIdList?: number[]
  /** 销售时间，近1/3/7/15/30天，活动则yyyyMMdd_yyyyMMdd */
  saleDate?: string
  /** 同款商品标识 */
  sameClothes?: string
  /** 同款标识模糊查询 */
  searchSameClothes?: string
  /** 店播为主 0-否 1-是 */
  selfSale?: number
  /** 发货地 */
  shipAddress?: string
  /** 监控店铺 */
  shopGroupIds?: number[]
  /** 店铺id */
  shopId?: string
  /** 主要销售方式 */
  shopMainSaleType?: string
  /** 排序项时间 */
  sortEndDate?: string
  /** 排序字段 */
  sortField?: string
  /** 排序项时间 */
  sortStartDate?: string
  sortType?: string
  sourceChannel?: string
  /** 监控达人 */
  streamerGroupIds?: number[]
  /** 橱窗达人 */
  streamerId?: string
  /** 达人风格 */
  streamerStyleTag?: string
  /** 达人风格,多选 */
  streamerStyleTagList?: string[]
  /** 商品标题关键字 */
  title?: string
  /** 智能过滤 */
  wiseFilterFlag?: number
  /** 年份季节 */
  yearSeason?: string
  /** 年份季节 */
  yearSeasonList?: string[]
  /** 排序类型 */
  orderType?: string
}

/**
 * RpcDyRecommendGoodsRequest接口类型
 */
export interface RpcDyRecommendGoodsRequest {
  /** 适用年龄 */
  applyAge?: string
  /** 适用年龄 */
  applyAgeList?: string[]
  /** 供应面料过滤 */
  associatedFabricFilter?: number
  /** 品牌 */
  brand?: string
  /** 类目 */
  categoryId?: number
  /** 类目 */
  categoryIdList?: number[]
  /** 色彩 */
  color?: string
  /** 颜色id */
  colorId?: string
  /** 统计时间 */
  countEndDate?: string
  /** 统计时间 */
  countStartDate?: string
  /** 设计要素 */
  designValue?: unknown[]
  /** 过滤商品标题关键字 */
  excludeTitleList?: string[]
  /** 面料搜索 */
  fabricSearch?: string
  /** 导出数据时第一个商品id */
  firstItemId?: string
  /** 适用性别 */
  gender?: string
  /** 商品来源 */
  goodsType?: number
  /** 本期有商品卡销售 1-是 */
  hasCardSale?: number
  /** 本期有直播销售 1-是 */
  hasLiveSale?: number
  /** 是否官方爆款榜商品，0-未上榜，1-上榜 */
  hasMarketingRank?: number
  /** 品牌官方 0-否 1-是 */
  hasOfficialBrand?: number
  /** 本期有作品销售 1-是 */
  hasVideoSale?: number
  /** 热门属性 */
  hotProperties?: unknown[]
  /** 参与过商品卡带货 0-否 1-是 */
  isCardItem?: number
  /** 导出数据标识位 */
  isExport?: string
  /** 是否导出本期价格 */
  isExportPeriodPrice?: number
  /** 过滤已采集 */
  isFilterCollected?: number
  /** 抖In热销榜 0-否 1-是 */
  isHotStyleRank?: number
  /** 1-只看直播热卖 */
  isLiveHotSaleItem?: number
  /** 参与过直播带货 0-否 1-是 */
  isLiveItem?: number
  /** 只看监控店铺 0- 不看 1-只看 null-不限 */
  isMonitorShop?: number
  /** 只看监控达人 0- 不看 1-只看 null-不限 */
  isMonitorStreamer?: number
  /** 知衣推荐达人 */
  isStreamerRecommend?: number
  /** 实时商品 */
  isToday?: number
  /** 参与过作品带货 0-否 1-是 */
  isVideoItem?: number
  /** 是否白底图 0-否 1-是 */
  isWhiteBg?: number
  /** 商品id */
  itemIdList?: string[]
  /** 关键字查询 标题/店铺名 */
  keyword?: string
  /** 上一次请求的最后一个商品信息id */
  lastItemId?: string
  maxCommentNum?: number
  maxCosRatio?: number
  maxFirstRecordDate?: string
  maxHasGoodsStreamerNum?: number
  maxHistoryPrice?: number
  maxLiveDate?: string
  maxLiveSaleAmountTotal?: number
  maxLiveSaleVolumeTotal?: number
  maxMinPrice30day?: number
  maxPresellDeliveryDayNum?: number
  maxPresellDepositRatio?: number
  maxPrice?: number
  maxRelateLiveNum?: number
  maxRelateLiveNum30day?: number
  maxRelateLiveNumToday?: number
  maxRelateLiveNumYesterday?: number
  maxRelateStreamerNum30day?: number
  maxRelateStreamerNumToday?: number
  maxRelateStreamerNumYesterday?: number
  maxRelateVideoNum?: number
  maxRelateVideoNum30day?: number
  maxRelateVideoNumYesterday?: number
  maxSaleAmount30day?: number
  maxSaleAmountToday?: number
  maxSaleAmountTotal?: number
  maxSaleAmountYesterday?: number
  maxSaleVolume30day?: number
  maxSaleVolumeToday?: number
  maxSaleVolumeTotal?: number
  maxSaleVolumeYesterday?: number
  maxShopReputation?: number
  maxStreamerFansNum?: number
  maxVideoDate?: string
  maxViewNum30day?: number
  maxViewNumToday?: number
  maxViewNumTotal?: number
  maxViewNumYesterday?: number
  /** 评论数 */
  minCommentNum?: number
  /** 佣金比例 */
  minCosRatio?: number
  /** 收录时间 */
  minFirstRecordDate?: string
  /** 带货达人数 */
  minHasGoodsStreamerNum?: number
  /** 历史最低价价格 */
  minHistoryPrice?: number
  /** 直播带货时间 */
  minLiveDate?: string
  /** 直播总销售额 */
  minLiveSaleAmountTotal?: number
  /** 直播总销量 */
  minLiveSaleVolumeTotal?: number
  /** 30天最低价 */
  minMinPrice30day?: number
  /** 预售结束后 N天发货 */
  minPresellDeliveryDayNum?: number
  /** 预售定金比例 */
  minPresellDepositRatio?: number
  /** 价格 */
  minPrice?: number
  /** 总关联直播数 */
  minRelateLiveNum?: number
  /** 30天关联直播数 */
  minRelateLiveNum30day?: number
  /** 今日关联直播数 */
  minRelateLiveNumToday?: number
  /** 昨日关联直播数 */
  minRelateLiveNumYesterday?: number
  /** 30天带货达人数 */
  minRelateStreamerNum30day?: number
  /** 今日带货达人数 */
  minRelateStreamerNumToday?: number
  /** 昨日带货达人数 */
  minRelateStreamerNumYesterday?: number
  /** 总关联作品数 */
  minRelateVideoNum?: number
  /** 30天关联作品数 */
  minRelateVideoNum30day?: number
  /** 昨日关联作品数 */
  minRelateVideoNumYesterday?: number
  /** 30天销售额 */
  minSaleAmount30day?: number
  /** 今日销售额 */
  minSaleAmountToday?: number
  /** 总销售额 */
  minSaleAmountTotal?: number
  /** 昨日销售额 */
  minSaleAmountYesterday?: number
  /** 30天销量 */
  minSaleVolume30day?: number
  /** 今日销量 */
  minSaleVolumeToday?: number
  /** 总销量 */
  minSaleVolumeTotal?: number
  /** 昨日销量 */
  minSaleVolumeYesterday?: number
  /** 店铺口碑 */
  minShopReputation?: number
  /** 达人粉丝数 */
  minStreamerFansNum?: number
  /** 作品带货时间 */
  minVideoDate?: string
  /** 30天浏览量 */
  minViewNum30day?: number
  /** 今日浏览量 */
  minViewNumToday?: number
  /** 总浏览量 */
  minViewNumTotal?: number
  /** 昨日浏览量 */
  minViewNumYesterday?: number
  /** 仅看商品卡销售 0-否 1-是 */
  onlyCardSale?: number
  /** 仅看直播销售 0-否 1-是 */
  onlyLiveSale?: number
  /** 仅看作品销售 0-否 1-是 */
  onlyVideoSale?: number
  /** 排序字段 */
  orderField?: string
  /** 达人播为主 0-否 1-是 */
  otherSale?: number
  pageNo?: number
  pageSize?: number
  /** 预售状态 */
  presellStatus?: string
  /** 投放状态 0:未投放；1: 投放中 */
  promotedFabricFilter?: number
  /** 查询来源 */
  queryType?: string
  /** 推荐标签 */
  recommendProperty?: string
  /** 行业 */
  rootCategoryId?: number
  /** 行业 */
  rootCategoryIdList?: number[]
  /** 销售时间，近1/3/7/15/30天，活动则yyyyMMdd_yyyyMMdd */
  saleDate?: string
  /** 同款商品标识 */
  sameClothes?: string
  /** 同款标识模糊查询 */
  searchSameClothes?: string
  /** 店播为主 0-否 1-是 */
  selfSale?: number
  /** 发货地 */
  shipAddress?: string
  /** 监控店铺 */
  shopGroupIds?: number[]
  /** 店铺id */
  shopId?: string
  /** 主要销售方式 */
  shopMainSaleType?: string
  /** 排序项时间 */
  sortEndDate?: string
  /** 排序字段 */
  sortField?: string
  /** 排序项时间 */
  sortStartDate?: string
  sortType?: string
  sourceChannel?: string
  /** 监控达人 */
  streamerGroupIds?: number[]
  /** 橱窗达人 */
  streamerId?: string
  /** 达人风格 */
  streamerStyleTag?: string
  /** 达人风格,多选 */
  streamerStyleTagList?: string[]
  /** 商品标题关键字 */
  title?: string
  /** 智能过滤 */
  wiseFilterFlag?: number
  /** 年份季节 */
  yearSeason?: string
  /** 年份季节 */
  yearSeasonList?: string[]
  /** 排序类型 */
  orderType?: string
}

/**
 * RpcDyGoodsRelateInfo接口类型
 */
export interface RpcDyGoodsRelateInfo {
  /** 直播id */
  liveId?: string
  /** 关联时间 */
  relateDate?: string
  /** 关联方式 */
  relateType?: string
  /** 达人头像 */
  streamerAvatar?: string
  /** 达人id */
  streamerId?: string
  /** 达人名称 */
  streamerName?: string
  /** 视频id */
  videoId?: string
}

/**
 * MenuItemDO接口类型
 */
export interface MenuItemDO {
  createdAt?: string
  deletedAt?: string
  id?: number
  itemName?: string
  itemTreeValue?: object
  itemValue?: string
  itemValueType?: number
  menuPage?: string
  order?: number
  pageName?: string
  status?: number
  updatedAt?: string
}

/**
 * 成册列表-请求参数
 */
export interface ShowInfoParam {
  /** 订阅分组ID */
  bloggerGroupIdList?: number[]
  /** 品牌名称(完全匹配) */
  brand?: string
  /** 品牌名称列表（完全匹配） */
  brandList?: string[]
  /** 品牌风格列表 */
  brandStyleList?: string[]
  /** 品牌类型列表 */
  brandTypeList?: string[]
  /** 城市 */
  city?: string
  /** 发布会城市列表 */
  cityList?: string[]
  /** 栏目 */
  columnName?: string
  /** 栏目 */
  columnNames?: string[]
  /** 结束时间 */
  endTime?: string
  /** 排除掉的发布会类型 */
  excludeShowClassify?: string[]
  /** 性别行业 */
  gender?: string
  /** 关键词搜索 */
  keyWords?: string
  /** 品牌（模糊） */
  likeBrand?: string
  rankStatus?: number
  /** id或秀场名搜索 */
  searchLikeStr?: string
  /** 季度 */
  season?: string
  /** 季节列表 */
  seasonList?: string[]
  /** 发布会类型 */
  showClassify?: string
  /** 发布会id */
  showId?: string
  /** 发布会idList */
  showIdList?: string[]
  /** 开始时间 */
  startTime?: string
  /** 订阅类型，0：全库，1：我的订阅，2：团队订阅 */
  subscribeType?: number
  userId?: number
  /** 视频状态 1-有 0-无 */
  videoStatus?: number
}

/**
 * PluginUploadData接口类型
 */
export interface PluginUploadData {
  /** 描述 */
  desc?: string
  /** 详情图 */
  detailUrls?: string
  /** 图片数量 */
  imageNum?: number
  /** 原始链接 */
  originUrl?: string
  /** 原始站点 */
  originWeb?: string
  /** 标题 */
  title?: string
  /** 更新时间 */
  updatedAt?: string
  /** 上传时间 */
  uploadTime?: string
  /** 用户id */
  userId?: number
  /** 上传用户对象 */
  userObj?: object
}

/**
 * FDPlusData接口类型
 */
export interface FDPlusData {
  blogId?: string
  /** 描述 */
  desc?: string
  /** 描述 */
  describes?: string
  height?: number
  /** 作品id */
  itemId?: number
  mainUrl?: string
  /** 原始链接 */
  originUrl?: string
  /** 去除掉拼接platformId的原始款式id */
  sourceBlogId?: string
  /** 来源时间 */
  sourceTime?: string
  /** 标题 */
  title?: string
  /** 更新时间 */
  updatedAt?: string
  userId?: number
  width?: number
}

/**
 * PinterestBlogger接口类型
 */
export interface PinterestBlogger {
  /** 账户 */
  account?: string
  /** 画板数--采集到的画板数 */
  boardNum?: number
  /** 打标 体形 */
  bodyType?: string
  /** 收藏量--pin图的转发数 */
  collectNum?: number
  /** 用户订阅状态 1：已订阅，0：未订阅 */
  currentSubscribed?: number
  /** 粉丝数 */
  fansNum?: number
  /** 近30天粉丝增量 */
  fansNum30day?: number
  /** 关注数 */
  followNum?: number
  /** 头像 */
  headImg?: string
  /** 是否隐藏打标标记 0隐藏 1不隐藏 */
  hideTag?: number
  /** 打标 身份 */
  identity?: string
  /** 简介 */
  introduction?: string
  /** 认证标记，0未认证，1认证 */
  isVerified?: number
  /** 类型--经过认证的商家 */
  isVerifiedMerchant?: number
  /** 最近更新图片数量 */
  lastImgNum?: number
  /** 达人 作品 最近更新时间 */
  lastPinUpdateTime?: string
  /** 达人 数据 最近更新时间 */
  lastUpdateTime?: string
  /** 近30天点赞数 */
  likeNum30day?: number
  /** 月浏览量 */
  monthViews?: number
  /** 昵称 */
  nickName?: string
  /** pin图数量 */
  pinPicNum?: number
  /** 达人收录时间 */
  recordTime?: string
  /** 打标 行业 */
  rootCategory?: string
  /** 打标 肤色 */
  skinColor?: string
  /** 打标 风格 */
  style?: string
  /** 风格种类 */
  sumTags?: string
  /** 是否置顶 */
  topFlag?: number
  /** 博主id */
  userId?: string
  /** 源站链接 */
  userUrl?: string
  /** 监控者 */
  watchMen?: 守望者_监控者[]
}

/**
 * WeiboData接口类型
 */
export interface WeiboData {
  /** 微博博文id */
  articleId?: string
  /** 博主一些filter过滤 */
  bloggerFilters?: string[]
  /** 博主id */
  bloggerId?: string
  /** 博主名称 */
  bloggerName?: string
  bloggerObj?: WbBlogger
  /** 博主标签 */
  bloggerTags?: string[]
  /** 评论数 */
  commentNum?: number
  /** 细节图url们，逗号分隔 */
  detailUrls?: string
  /** 转发数 */
  forwardNum?: number
  /** 是否有商品，1-有，0-没有 */
  hasItem?: number
  /** 图片数量 */
  imageNum?: number
  /** 点赞数 */
  likeNum?: number
  /** PC端微博id */
  pcArticleId?: string
  /** 微博售卖商品Id，逗号分隔 */
  saleItemIdList?: string
  /** 季度标签 */
  season?: string
  /** 微博商品信息列表 */
  storeItemDOList?: object[]
  /** 博文内容 */
  textContent?: string
}

/**
 * StreetSnapBrand接口类型
 */
export interface StreetSnapBrand {
  /** 品牌 */
  brand?: string
  /** 品牌信息 */
  brandObj?: object
  /** 品类 */
  category?: string
}

/**
 * InsVideoDataDO接口类型
 */
export interface InsVideoDataDO {
  bloggerGender?: string[]
  videoIndex?: number
  videoUrl?: string
  videoViewCount?: number
}

/**
 * TopicSimple接口类型
 */
export interface TopicSimple {
  /** 话题 */
  content?: string
  /** 话题id */
  topicId?: string
}

/**
 * ApiResult_List_string接口类型
 */
export interface ApiResult_List_string {
  errorCode?: string
  errorDesc?: string
  result?: string[]
  success?: boolean
}

/**
 * DyItemData接口类型
 */
export interface DyItemData {
  /** 商品品牌 */
  brand?: string
  /** 子品类 */
  categoryId?: number
  /** 首次插入时间 */
  firstInsertTime?: string
  /** 首次上架时间 */
  firstSaleTime?: string
  /** 历史带货总人数 */
  hasGoodsStreamerNum?: number
  /** 图片数量 */
  imageNum?: number
  /** 商品Id */
  itemId?: number
  /** 商品Id, 解决id过长问题 */
  itemIdString?: string
  /** 商品标题 */
  itemTitle?: string
  /** 更新时间 */
  latestUpdateTime?: string
  /** 30天点赞量 */
  likeMonthly?: number
  /** 最低价 */
  minPrice?: number
  /** 商品配图 */
  picUrlList?: string
  /** 商品价格 */
  price?: number
  /** 相关联直播数 */
  relateLiveNum?: number
  /** 直播达人数 */
  relateLiveStreamerNum?: number
  /** 相关联短视频数 */
  relateProductNum?: number
  /** 相关联短视频达人数 */
  relateProductStreamerNum?: number
  /** 根品类 */
  rootCategoryId?: number
  /** 销售额 */
  saleAmount?: number
  /** 30天销售额 */
  saleAmountMonthly?: number
  /** 30天销量 */
  saleMonthly?: number
  /** 销量 */
  saleVolume?: number
  /** 店铺Id */
  shopId?: number
  /** 店铺名称 */
  shopName?: string
  /** 店铺实体对象 */
  shopObj?: object
  /** 30天浏览量 */
  viewMonthly?: number
}

/**
 * XhsBloggerInfoZxh接口类型
 */
export interface XhsBloggerInfoZxh {
  /** 粉丝画像-活跃粉丝占比 */
  activeFanPct?: number
  /** 粉丝画像-年龄分布 */
  ageDistribution?: string
  /** 头像 */
  avatar?: string
  /** 市 */
  city?: string
  /** 粉丝画像-城市分布 */
  cityDistribution?: string
  /** 收藏数 */
  collectNum?: number
  /** 国家 */
  country?: string
  /** 邮箱 */
  emailNumber?: string
  /** 粉丝画像-互动粉丝占比 */
  engageFanPct?: number
  /** 粉丝数 */
  fansNum?: number
  /** 关注数 */
  followNum?: number
  /** 性别：0-男，1-女，2-企业 */
  gender?: number
  /** 粉丝画像-性别分布 */
  genderDistribution?: string
  /** 是否商业合作：0-否，1-是 */
  haveBusinessCoo?: string
  /** 身高：cm */
  height?: number
  /** 爆文数 */
  hotNoteNum?: number
  /** 爆文率 */
  hotNoteRate?: number
  /** 收录时间 */
  includeTime?: string
  /** 简介 */
  intro?: string
  /** 隐藏简介 */
  introHidden?: string
  /** 等级图标 */
  levelImage?: string
  /** 等级名称 */
  levelName?: string
  /** 账号等级 */
  levelNumber?: number
  /** 点赞数 */
  likeNum?: number
  /** 昵称 */
  nickname?: string
  /** 粉丝画像-下单粉丝占比 */
  orderFanPct?: number
  /** 电话号码 */
  phoneNumber?: string
  /** 省 */
  province?: string
  /** 粉丝画像-省分布 */
  provincesDistribution?: string
  /** 小红书号 */
  redId?: string
  /** 认证身份 */
  redOvContent?: string
  /** 认证类型：1-红色认证（个人），2-蓝色认证（品牌认证就是开通专业号） */
  redOvType?: string
  /** 风格 */
  styleList?: string[]
  /** 标记 */
  tags?: string[]
  /** 更新时间 */
  updateTime?: string
  /** 体重：g */
  weight?: number
  /** 达人id */
  xhsUserId?: string
  /** 知款状态：0-无效，1-有效 */
  zkStatus?: string
  /** 知小红状态：0-无效，1-有效 */
  zxhStatus?: string
}

/**
 * RunwayDetailAsMainShowData接口类型
 */
export interface RunwayDetailAsMainShowData {
  /** 品类数 */
  categoryNum?: number
  /** 封面 */
  coverUrl?: string
  /** 图片数量 */
  imgNum?: number
  /** mainShowId */
  mainShowId?: string
  /** showId */
  showId?: string
}

/**
 * UserBrandOrderListRequest接口类型
 */
export interface UserBrandOrderListRequest {
  /** 行业 */
  gender?: string
  userBrandList?: UserBrandOrderItem[]
}

/**
 * DewuData接口类型
 */
export interface DewuData {
  /** 品牌 */
  brand?: string
  /** 品牌对象 */
  brandObj?: object
  /** 评论数 */
  comment?: number
  /** 细节图url们，逗号分隔 */
  detailUrls?: string
  /** 首日销量 */
  firstSaleVolume?: number
  /** 图片数量 */
  imageNum?: number
  /** 增量数据 */
  incrementNum?: number
  /** 商品标题 */
  itemTitle?: string
  /** 环比数据 */
  linkRelativeRatio?: number
  /** 划线价 负数代表无价格 单位：分 */
  maxPrice?: number
  /** 原始品类 */
  originCategory?: string
  /** 原始风格 */
  originStyleList?: string[]
  /** 价格 负数代表无价格 单位：分 */
  price?: number
  /** 销量 */
  saleVolume?: number
  /** 近7日销量 */
  saleVolume7Day?: number
  /** 季节 */
  season?: string
  /** 销售日期 */
  sellDate?: string
}

/**
 * BrandTypeCount接口类型
 */
export interface BrandTypeCount {
  /** 品牌类型 */
  brandType?: string
}

/**
 * BloggerDO接口类型
 */
export interface BloggerDO {
  biographyLinks?: string
  blogNum?: number
  /** 昨日新增博文数 */
  blogNum1day?: number
  /** 近30天新增博文数 */
  blogNum30day?: number
  blogTime?: string
  bloggerId?: string
  /** 近30天识别品类to3 */
  categoryTop30day?: string
  /** 近30天识别品类to3 */
  categoryTop30dayList?: string[]
  createdAt?: string
  deletedAt?: string
  deltaFansNum?: number
  fansNum?: number
  /** 近30天粉丝增量 */
  fansNum30day?: number
  /** 涨粉趋势，1-持续涨粉 2-持续掉粉 */
  fansRisingTrendTag?: number
  finishedHistory?: number
  followNum?: number
  fullName?: string
  headImg?: string
  imageNum?: number
  includedTime?: string
  includerUserId?: string
  insItemNum?: number
  introduction?: string
  isPrivate?: number
  isVerified?: number
  /** 近30天点赞数 */
  likeNum30day?: number
  /** 近30天新增博文最大点赞数 */
  maxLikeNumRecent30Day?: number
  nickName?: string
  /** 近30天识别风格top3 */
  recognitionStyleTop30day?: string
  /** 近30天识别风格top3 */
  recognitionStyleTop30dayList?: string[]
  /** 精选博主标识，1：精选，0：非精选 */
  selected?: number
  source?: number
  status?: number
  /** 总点赞数 */
  totalLikeNum?: number
  updatedAt?: string
  updatedUserId?: number
}

/**
 * PinterestAbroadData接口类型
 */
export interface PinterestAbroadData {
  /** 点赞数 */
  collectNum?: number
  /** 简介 */
  description?: string
  /** 源站连接 url */
  jumpUrl?: string
  /** 点赞数 */
  likeNum?: number
  /** 用户头像 */
  logo?: string
  /** 用户昵称 */
  nickName?: string
  /** 去除掉拼接platformId的原始款式id */
  sourceBlogId?: string
  /** 标题 */
  title?: string
  /** 用户ID */
  userId?: string
  /** 用户名 */
  userName?: string
}

/**
 * WholesaleData接口类型
 */
export interface WholesaleData {
  /** 品牌 */
  brand?: string
  /** 品牌对象 */
  brandObj?: object
  /** 二级城市 */
  city?: string
  /** 专栏名称，批发市场，名牌精选等 */
  column?: string
  /** 图组宽高信息,json格式 */
  detailUrlInfo?: string
  /** 图组urls，逗号分隔 */
  detailUrls?: string
  /** 会展名 */
  exhibition?: string
  /** 商品id */
  goodsId?: string
  /** 商品标题 */
  goodsTitle?: string
  /** 商品链接 */
  goodsUrl?: string
  /** 图片数量 */
  imageNum?: number
  /** 行业 */
  industry?: string
  /** 是否中国品牌，0-不是，1-是 */
  isChineseBrand?: number
  /** 市场名称 */
  marketName?: string
  /** 原始品牌 */
  originBrand?: string
  /** 原始品类 */
  originCategory?: string
  /** 原始性别 */
  originGender?: string
  /** 原始季度 */
  originSeason?: string
  /** 季度 */
  season?: string
}

/**
 * XhsBlogger接口类型
 */
export interface XhsBlogger {
  /** 近30天平均赞粉比 */
  avgLikeFanRate30Day?: number
  /** 博主ID */
  bloggerId?: string
  /** 近30天识别品类to3 */
  categoryTop30day?: string
  /** 近30天识别品类to3 */
  categoryTop30dayList?: string[]
  /** 收藏数 */
  collectNum?: number
  /** 近30天收藏数 */
  collectNum30Day?: number
  /** 收录时间 */
  createdAt?: string
  /** 订阅状态 1-已订阅 0-未订阅 */
  currentSubscribed?: number
  /** 粉丝数 */
  fansNum?: number
  /** 涨粉趋势，1-持续涨粉 2-持续掉粉 */
  fansRisingTrendTag?: number
  /** 关注数 */
  followNum?: number
  /** 性别 0-男 1-女 2-企业 */
  gender?: number
  /** 头像 */
  headImg?: string
  /** 近30天爆文率 */
  hotNoteRate30Day?: number
  /** 收录状态 0-未收录 1-已收录 */
  includeStatus?: number
  /** 近15天互动增量 */
  interactNum15day?: number
  /** 近30天互动增量 */
  interactNum30day?: number
  /** 近3天互动增量 */
  interactNum3day?: number
  /** 近7天互动增量 */
  interactNum7day?: number
  /** 近15天互动量幅度 */
  interactNumRate15day?: number
  /** 近30天互动量幅度 */
  interactNumRate30day?: number
  /** 近3天互动量幅度 */
  interactNumRate3day?: number
  /** 近7天互动量幅度 */
  interactNumRate7day?: number
  /** 简介 */
  introduction?: string
  /** 最近更新图片数量 */
  lastImgNum?: number
  /** 等级图标 */
  levelImage?: string
  /** 等级名称 */
  levelName?: string
  /** 等级 */
  levelNumber?: number
  /** 获赞与收藏 */
  likeAndCollectNum?: number
  /** 获赞数 */
  likeNum?: number
  /** 近30天点赞数 */
  likeNum30day?: number
  /** 地区 */
  location?: string
  /** 近30天新增博文最大点赞数 */
  maxLikeNumRecent30Day?: number
  /** 月粉丝数变化 */
  monthDeltaFansNum?: number
  /** 昵称 */
  nickname?: string
  /** 笔记数量 */
  noteNum?: number
  /** 近30天新增博文数 */
  noteNum30day?: number
  /** 最新笔记时间 */
  noteTime?: string
  /** 近30天识别风格top3 */
  recognitionStyleTop30day?: string
  /** 近30天识别风格top3 */
  recognitionStyleTop30dayList?: string[]
  /** 小红书iD */
  redId?: string
  /** 是否认证 */
  redOv?: number
  /** 达人认证信息 */
  redOvContent?: string
  /** 精选 1-精选 0-非精选 */
  selected?: number
  /** 博主内部屏蔽状态 0-未屏蔽 1-屏蔽已提交 2-已屏蔽 */
  shieldStatus?: number
  /** 博主体型 */
  somatotype?: string
  /** 状态 1-有效 */
  status?: number
  /** 点赞与藏 */
  sumLikeCollectNum?: number
  /** 风格种类 */
  sumTags?: string
  /** top10博文均赞 */
  top10LikeNumAvg?: number
  /** 近30日top10博文均赞 */
  top10LikeNumAvg30day?: number
  /** 是否置顶 */
  topFlag?: number
  /** top话题id */
  topTopicId?: string
  /** top话题名称 */
  topTopicName?: string
  /** 博主更新频率 周更 月更 日更 */
  updateFreq?: string
  updatedAt?: string
  /** 用户屏蔽博主标识：true-屏蔽 */
  userBlackBloggerFlag?: boolean
  /** 监控者 */
  watchMen?: 守望者_监控者[]
  xhsBloggerBrand?: 小红书博主品牌
  zxhBloggerDTO?: XhsBloggerInfoZxh
}

/**
 * InsItemData接口类型
 */
export interface InsItemData {
  /** 博主id */
  bloggerId?: string
  /** 博主名称 */
  bloggerName?: string
  bloggerObj?: BloggerDO
  /** 博主标签 */
  bloggerTags?: string[]
  /** 品牌 */
  brand?: string
  /** 品牌实体对象 */
  brandObj?: object
  /** 图片数量 */
  imageNum?: number
  /** 0-未收录 */
  includedFlag?: number
  /** 店铺id */
  merchantId?: string
  oprice?: number
  opriceStr?: string
  /** 商品名称 */
  productName?: string
  /** 商品源站链接 */
  productUrl?: string
  /** 1-精选 */
  selectedFlag?: number
  /** 去除掉拼接platformId的原始款式id */
  sourceBlogId?: string
  sprice?: number
  spriceStr?: string
}

/**
 * UserBrandOrderItem接口类型
 */
export interface UserBrandOrderItem {
  /** 季节 */
  brand?: string
  /** 行业 */
  gender?: string
}

/**
 * PorterData接口类型
 */
export interface PorterData {
  /** 品牌 */
  brand?: string
  /** 品牌 */
  brandObj?: object
  /** 货币 */
  currencyCode?: string
  /** 商品内容 */
  goodsContent?: string
  /** 商品链接 */
  goodsUrl?: string
  /** 图片数量 */
  imageNum?: number
  /** 详情图 */
  imageUrlList?: string
  /** 原始品类 */
  originCategory?: string
  /** 价格 */
  price?: number
  /** 商品标题 */
  title?: string
}

/**
 * StreetSnapData接口类型
 */
export interface StreetSnapData {
  /** 品牌 */
  brandInfos?: StreetSnapBrand[]
  /** 城市 */
  city?: string
  /** 国家 */
  country?: string
  /** 细节图url们，逗号分隔 */
  detailUrls?: string
  /** 图片数量 */
  imageNum?: number
  /** 模特名 */
  modelName?: string
  /** 拍摄者 */
  photographer?: string
  /** 季度 */
  season?: string
  /** 图源 */
  source?: string
}

/**
 * XhsData接口类型
 */
export interface XhsData {
  /** 博主Id */
  bloggerId?: string
  /** 博主名称 */
  bloggerName?: string
  bloggerObj?: XhsBlogger
  /** 合作品牌list */
  brandDetailList?: 小红书品牌详情[]
  /** 品牌list */
  brandList?: string[]
  /** 收藏夹信息 */
  collectInfo?: 收藏夹信息[]
  /** 收藏数 */
  collectNum?: number
  /** 昨日收藏数 */
  collectNum1day?: number
  /** 近3日收藏数 */
  collectNum3day?: number
  /** 近7日收藏数 */
  collectNum7day?: number
  /** 评论数 */
  commentNum?: number
  /** 昨日评论数 */
  commentNum1day?: number
  /** 近3日评论数 */
  commentNum3day?: number
  /** 近7日评论数 */
  commentNum7day?: number
  /** 笔记内容 */
  content?: string
  /** 细节图url们，逗号分隔 */
  detailUrls?: string
  /** 图片数量 */
  imageNum?: number
  /** 增量数据 */
  incrementNum?: number
  /** 最近编辑的时间 */
  lastUpdateTime?: string
  /** 赞藏比 */
  likeCollectRatio?: number
  /** 赞粉比 */
  likeFansRatio?: number
  /** 点赞数 */
  likeNum?: number
  /** 昨日点赞数 */
  likeNum1day?: number
  /** 近3日点赞数 */
  likeNum3day?: number
  /** 近7日点赞数 */
  likeNum7day?: number
  /** 环比数据 */
  linkRelativeRatio?: number
  /** 笔记类型 视频-video */
  noteType?: string
  /** 季度 */
  season?: string
  /** 笔记标题 */
  title?: string
  /** 话题list */
  topicList?: string[]
  /** 话题list详细信息 */
  topicObjectList?: object[]
  /** 视频链接 */
  videoUrl?: string
}

/**
 * BrandSelectedData接口类型
 */
export interface BrandSelectedData {
  /** 品牌 */
  brand?: string
  /** 品牌对象 */
  brandObj?: object
  /** 二级城市 */
  city?: string
  /** 专栏名称，批发市场，名牌精选等 */
  column?: string
  /** 图组宽高信息,json格式 */
  detailUrlInfo?: string
  /** 图组urls，逗号分隔 */
  detailUrls?: string
  /** 会展名 */
  exhibition?: string
  /** 商品id */
  goodsId?: string
  /** 商品标题 */
  goodsTitle?: string
  /** 商品链接 */
  goodsUrl?: string
  /** 图片数量 */
  imageNum?: number
  /** 行业 */
  industry?: string
  /** 是否中国品牌，0-不是，1-是 */
  isChineseBrand?: number
  /** 市场名称 */
  marketName?: string
  /** 原始品牌 */
  originBrand?: string
  /** 原始品类 */
  originCategory?: string
  /** 原始性别 */
  originGender?: string
  /** 原始季度 */
  originSeason?: string
  /** 浏览量 */
  pageViews?: number
  /** 季度 */
  season?: string
  /** 品牌预售id */
  selectBrandId?: string
}

/**
 * DewuItemInfo接口类型
 */
export interface DewuItemInfo {
  /** 品牌 */
  brand?: string
  /** 品牌ID */
  brandId?: string
  /** 品牌对象 */
  brandObj?: object
  /** 评论数 */
  comment?: number
  /** 细节图url们，逗号分隔 */
  detailUrls?: string
  /** 首日销量 */
  firstSaleVolume?: number
  /** 图片数量 */
  imageNum?: number
  /** 商品标题 */
  itemTitle?: string
  /** 划线价 负数代表无价格 单位：分 */
  maxPrice?: number
  /** 原始品类 */
  originCategory?: string
  /** 原始风格 */
  originStyleList?: string[]
  /** 价格 负数代表无价格 单位：分 */
  price?: number
  /** 销量 */
  saleVolume?: number
  /** 近7日销量 */
  saleVolume7Day?: number
  /** 季节 */
  season?: string
  /** 销售日期 */
  sellDate?: string
  /** 来源 null/1-得物 2-得物商品 */
  source?: number
  /** 来源时间 */
  sourceTime?: string
  /** spuId */
  spuId?: string
  /** 数据更新时间 */
  updateTime?: string
}

/**
 * FansAgePct接口类型
 */
export interface FansAgePct {
  /** 粉丝年龄结束 */
  fansAgeEnd?: number
  /** 粉丝年龄百分比起始 */
  fansAgePctStart?: string
  /** 粉丝年龄起始 */
  fansAgeStart?: number
}

/**
 * 守望者_监控者接口类型
 */
export interface 守望者_监控者 {
  /** 头像 */
  avatar?: string
  /** 用户id */
  id?: number
  /** 用户昵称 */
  name?: string
  /** 备注名 */
  remark?: string
}

/**
 * MusinsaData接口类型
 */
export interface MusinsaData {
  /** 品牌 */
  brand?: string
  /** 品牌实体对象 */
  brandObj?: object
  /** 图片数 */
  imageNum?: number
  /** 商品id */
  itemId?: string
  /** 源站链接 */
  itemUrl?: string
  /** 商品价格 */
  price?: number
  /** 商品标题 */
  title?: string
}

/**
 * UserUploadData接口类型
 */
export interface UserUploadData {
  /** 描述 */
  desc?: string
  /** 详情图 */
  detailUrls?: string
  /** 图片数量 */
  imageNum?: number
  /** 原始链接 */
  originUrl?: string
  /** 原始站点 */
  originWeb?: string
  /** 标题 */
  title?: string
  /** 更新时间 */
  updatedAt?: string
  /** 上传时间 */
  uploadTime?: string
  /** 用户id */
  userId?: number
  /** 上传用户对象 */
  userObj?: object
}

/**
 * TagData接口类型
 */
export interface TagData {
  groupId?: number
  tagName?: string
}

/**
 * InsData接口类型
 */
export interface InsData {
  /** 博文类型 0-图文 1-包含短视频 */
  blogType?: number
  /** 博文链接 */
  blogUrl?: string
  /** 博主一些filter过滤 */
  bloggerFilters?: string[]
  /** 博主id */
  bloggerId?: string
  /** 博文@博主信息 */
  bloggerIncludeList?: BloggerInclude[]
  /** 博主名称 */
  bloggerName?: string
  bloggerObj?: BloggerDO
  /** 博主标签 */
  bloggerTags?: string[]
  /** 评论数 */
  commentNum?: number
  /** 昨日评论数 */
  commentNum1day?: number
  /** 近3日评论数 */
  commentNum3day?: number
  /** 近7日评论数 */
  commentNum7day?: number
  /** 细节图url们，逗号分隔 */
  detailUrls?: string
  /** 图片数量 */
  imageNum?: number
  /** 0-未收录 */
  includedFlag?: number
  /** 增量数据 */
  incrementNum?: number
  /** ins video data */
  insVideoDataList?: InsVideoDataDO[]
  /** 赞粉比 */
  likeFansRatio?: number
  /** 点赞数 */
  likeNum?: number
  /** 昨日点赞数 */
  likeNum1day?: number
  /** 近3日点赞数 */
  likeNum3day?: number
  /** 近7日点赞数 */
  likeNum7day?: number
  /** 环比数据 */
  linkRelativeRatio?: number
  /** 季度标签 */
  season?: string
  /** 1-精选 */
  selectedFlag?: number
  /** 去除掉拼接platformId的原始款式id */
  sourceBlogId?: string
  /** 博文内容 */
  textContent?: string
  /** ins @ data */
  toTagBloggerDataDOList?: ToTagBloggerDataDO[]
  topicObjectList?: TopicSimple[]
  /** 话题 */
  topics?: string[]
}

/**
 * ImageEntity接口类型
 */
export interface ImageEntity {
  /** 关联面料列表 */
  associatedFabrics?: AssociatedFabric[]
  /** 图片识别信息 */
  boxLabelRetList?: object[]
  /** 原始图片识别信息备份 */
  boxLabelRetListOrigin?: object[]
  brandSelectedDataDTO?: BrandSelectedData
  /** 色条信息 */
  colorBarDOList?: object[]
  dewuDataDTO?: DewuData
  dewuItemInfoDTO?: DewuItemInfo
  dhhDataDTO?: DhhData
  /** 图像识别返回的distance，值越小越相似 */
  distance?: number
  /** 与哪张图重复 */
  dupWith?: string
  dyItemDataDTO?: DyItemData
  farfetchDataDTO?: FarfetchData
  fashionMasterpieceDataDTO?: FashionMasterpieceData
  fdPlusDataDTO?: FDPlusData
  /** 高 */
  height?: number
  /** 图片处理过滤器结果们,质量过滤，服装过滤等 */
  imageFilters?: string[]
  /** 图片关联图集实体id，比如ins博文，微博博文实体 */
  imageGroupEntityId?: string
  /** 图片所在图集index，1-主图（类似ins 9图概念） */
  imageGroupIndex?: number
  /** 图像识别的图源id */
  imageSearchPlatformId?: number
  insDataDTO?: InsData
  insItemDataDTO?: InsItemData
  itemDataDTO?: ItemData
  /** 主图url */
  mainUrl?: string
  musinsaDataDTO?: MusinsaData
  pinterestAbroadDataDTO?: PinterestAbroadData
  pinterestDataDTO?: PinterestData
  /** 图片来源, 2-发布会，9-品牌精选，11-ins，20-微博, to be continued ... */
  platformId?: number
  /** 来源名称 */
  platformName?: string
  pluginUploadDataDTO?: PluginUploadData
  porterDataDTO?: PorterData
  retailDataDTO?: RetailData
  runwayDataDTO?: RunwayData
  runwayDetailDataDTO?: RunwayDetailData
  shopbopDataDTO?: ShopbopData
  /** 排序值 */
  sortValues?: object[]
  /** 图片发布时间 */
  sourceTime?: string
  ssenseDataDTO?: SsenseData
  standaloneSiteDataDTO?: StandaloneSiteData
  streetSnapDataDTO?: StreetSnapData
  /** 图片代表性聚类维度id，ins取博主，微博取博主，发布会取发布会id等 */
  symbolClusterBucket?: string
  /** 图片unionId */
  unionId?: string
  /** 用户屏蔽博主标识：true-屏蔽 */
  userBlackBloggerFlag?: boolean
  userUploadDataDTO?: UserUploadData
  weiboDataDTO?: WeiboData
  wholesaleDataDTO?: WholesaleData
  /** 宽 */
  width?: number
  xhsDataDTO?: XhsData
  /** 知款款式列表图片识别信息备份 */
  zkBoxLabelRetListOrigin?: object[]
}

/**
 * BloggerInclude接口类型
 */
export interface BloggerInclude {
  /** 博主id，仅在收录成功时存在 */
  blogId?: string
  /** 收录状态 1:是 0:否 */
  isInclude?: number
  /** 博主名称 */
  nickname?: string
}

/**
 * ToTagBloggerDataDO接口类型
 */
export interface ToTagBloggerDataDO {
  bloggerName?: string
  isInclude?: number
  picIndex?: number
  tagPosX?: string
  tagPosY?: string
  toBloggerId?: string
}

/**
 * RunwayDetailData接口类型
 */
export interface RunwayDetailData {
  /** 图片类型 */
  contentType?: string
  dataFrom?: string
  mainShowId?: string
  runwayDataDTO?: RunwayData
  runwayImgNum?: number
  showId?: string
}

/**
 * ApiResult_List_BrandTypeCount接口类型
 */
export interface ApiResult_List_BrandTypeCount {
  errorCode?: string
  errorDesc?: string
  result?: BrandTypeCount[]
  success?: boolean
}

/**
 * StandaloneSiteData接口类型
 */
export interface StandaloneSiteData {
  /** 品牌 */
  brand?: string
  /** 品牌实体对象 */
  brandObj?: object
  /** 商品描述 */
  content?: string
  /** 货币单位 */
  currency?: string
  /** 用户站点订阅状态 1：已订阅，0：未订阅 */
  currentPlatformSubscribed?: number
  /** 数据来源 */
  dataFrom?: string
  /** 细节图 */
  detailUrl?: string
  /** 细节图索引 */
  detailUrlIndex?: number
  /** 图片数 */
  imageNum?: number
  /** 图片列表 */
  imageUrlList?: string
  /** 图源ID */
  platformId?: number
  /** 图源名称 */
  platformName?: string
  /** 商品价格 */
  price?: number
  /** 商品id */
  productId?: string
  /** 源站链接 */
  productUrl?: string
  /** 商品标题 */
  title?: string
}

/**
 * ItemData接口类型
 */
export interface ItemData {
  /** 差评率 */
  badRate?: number
  /** 品牌 */
  brand?: string
  /** 品牌实体对象 */
  brandObj?: object
  /** 二级类目id */
  categoryId?: number
  /** 收藏量 */
  collect?: number
  /** 月收藏量 */
  collectMonthly?: number
  /** 评价数 */
  commentCount?: number
  /** 首次插入时间 */
  firstInsertTime?: string
  /** 历史最低价 */
  historyMinLeftCprice?: number
  /** 图片数量 */
  imageNum?: number
  /** 商品id */
  itemId?: number
  /** 标题 */
  itemTitle?: string
  /** 数据更新时间 */
  latestUpdateTime?: string
  /** 图片细节图 */
  picUrlList?: string
  /** 价格 */
  price?: number
  /** 行业id，根品类id */
  rootCategoryId?: number
  /** 昨日销量 */
  saleDay?: number
  /** 近一个月销量 */
  saleMonthly?: number
  /** 上新时间 */
  saleTime?: string
  /** 季度 */
  season?: string
  /** 上下架状态 */
  shelves?: number
  /** 店铺id */
  shopId?: number
  /** 店铺logo */
  shopLogo?: string
  /** 店铺名称 */
  shopName?: string
  /** 店铺实体对象 */
  shopObj?: object
  /** 店铺类型，0-淘宝，1-天猫 */
  shopType?: number
  /** 总销量 */
  totalSaleVolume?: number
}

/**
 * 小红书品牌详情接口类型
 */
export interface 小红书品牌详情 {
  /** 品牌 */
  brand?: string
  /** 是否商业合作 */
  isBusiness?: number
}

/**
 * FashionMasterpieceData接口类型
 */
export interface FashionMasterpieceData {
  /** 大片id */
  articleId?: string
  /** 品牌名 */
  brand?: string
  /** 城市区域 */
  city?: string
  /** 栏目 */
  columnName?: string
  /** 说明 */
  contentIntro?: string
  /** 封面图 */
  coverUrl?: string
  currentSubscribed?: number
  /** 数据来源 */
  dataFrom?: string
  /** 行业 */
  gender?: string
  /** 图片数 */
  imgNum?: number
  /** 杂志实体id */
  magazineId?: string
  /** 杂志名 */
  magazineName?: string
  /** 上线时间 */
  onlineTime?: string
  platformId?: number
  /** 季度/杂志月份 */
  season?: string
  /** 发布时间 */
  sourceTime?: string
  /** 状态 */
  status?: number
  /** 标题 */
  title?: string
  /** 用户上传封面图 */
  userCoverUrl?: string
  /** 视频链接 */
  videoUrl?: string
}

/**
 * RunwayData接口类型
 */
export interface RunwayData {
  /** 品牌名 */
  brand?: string
  /** 品牌Logo */
  brandLogo?: string
  /** 品类数 */
  categoryNum?: number
  /** 城市 */
  city?: string
  /** 发布会栏目 */
  columnName?: string
  /** 秀场说明 */
  contentIntro?: string
  /** 封面图 */
  coverUrl?: string
  /** 是否订阅品牌：0.未订阅 1.已订阅 */
  currentSubscribed?: number
  /** 来自细节图（服装秀的细节图，提升到秀场成册纬度） */
  fromDetailShowFlag?: number
  fromDetailShowId?: string
  fromRunwayDetailDataDTO?: RunwayDetailAsMainShowData
  /** 性别 */
  gender?: string
  /** 最近更新图片缩略图 */
  lastBlogList?: ImageEntity[]
  /** 平台id */
  platformId?: number
  /** 关联的趋势报告ID */
  reportKey?: string
  /** 发布会图片数量 */
  runwayImgNum?: number
  /** 季度 */
  season?: string
  /** 是否属于精选品牌 */
  selectedBrandFlag?: number
  /** 发布会类型 */
  showClassify?: string
  /** 发布会Id */
  showId?: string
  /** 发布时间 */
  sourceTime?: string
  /** 关联的趋势报告标题 */
  title?: string
  /** 排名前3的颜色列表 */
  topColorList?: ColorMapDO[]
  /** 近30天用户是否已经查看 true-是 false-否 */
  userBrowseFlag?: boolean
  /** 运营设置的封面图 */
  userCoverUrl?: string
  videoStatus?: number
  /** 视频链接 */
  videoUrl?: string
}

/**
 * 收藏夹信息接口类型
 */
export interface 收藏夹信息 {
  /** 收藏夹index */
  collectIndex?: number
  /** 博主id */
  symbolClusterBucket?: string
}

/**
 * 博文列表-请求参数
 */
export interface ImageBlogRequest {
  /** 时尚大片ID */
  articleId?: string
  /** 关联面料过滤 */
  associatedFabricFilter?: number
  /** 劣质博主过滤 0-未开启 1-开始 default 0 */
  badBloggerFilter?: number
  /** 是否显示因黑人导致的被质量过滤过滤掉的图片 1-显示/0-不显示 默认不显示 */
  blackFlag?: number
  /** 博文ID列表 */
  blogIdList?: string[]
  /** 查询结束时间 */
  blogTimeEnd?: string
  /** 查询起始时间 */
  blogTimeStart?: string
  /** 博文话题 */
  blogTopicName?: string
  /** 博主体型肤色 */
  bloggerBodyShapes?: string[]
  /** 博主分组ID */
  bloggerGroupId?: number
  /** 博主分组ID列表 */
  bloggerGroupIdList?: number[]
  /** 博主ID */
  bloggerId?: string
  /** 博主ID列表 */
  bloggerIdList?: string[]
  /** 博主名称 */
  bloggerName?: string
  /** 博主肤色 */
  bloggerSkinColors?: string[]
  /** 博主风格 */
  bloggerStyles?: string[]
  /** ins 地区标签 */
  bloggerTags?: string[]
  /** ins、xhs 博主类型 */
  bloggerTypes?: string[]
  /** 品牌名 */
  brand?: string
  /** 品牌地区 */
  brandAreaList?: string[]
  /** 品牌行业 */
  brandIndustryList?: string[]
  /** 品牌名列表 */
  brandList?: string[]
  brandNeedRelCount?: boolean
  /** 品牌风格 */
  brandStyleList?: string[]
  /** 品牌类型 */
  brandTypeList?: string[]
  /** 浏览模式 0=款式 1=单图 */
  browseMode?: number
  /** 子品类集合（淘宝在用） */
  categoryIdList?: number[]
  /** 品类 */
  categoryList?: string[]
  /** 二级城市地区 */
  city?: string
  /** 二级城市地区集合 */
  cityList?: string[]
  /** 秀场-栏目 */
  columnNames?: string[]
  /** 小红书合作品牌 */
  cooperationBrand?: string
  /** 订货会ID */
  dhhId?: string
  /** 重复图过滤 true-开启过滤 默认开启 */
  duplicateFilter?: boolean
  /** 需要排除的ImageGroupEntityIdList列表 */
  exceptBlogIdList?: string[]
  /** 不看已收藏的博文，1：是，0：否 */
  exceptCollected?: number
  excludeBloggerIdList?: string[]
  /** 面料搜索 */
  fabricSearch?: string
  /** 粉丝年龄占比 */
  fansAgePctList?: FansAgePct[]
  /** 根据行业过滤博主标签 true:开启 false:关闭 */
  filterDefaultBloggerTags?: boolean
  /** 过滤内部屏蔽的博主 */
  filterInnerFiledBlogger?: boolean
  /** 过滤明星博主笔记 */
  filterStarBlogger?: boolean
  /** 过滤用户标记拉黑的博主 */
  filterUserShieldBlogger?: boolean
  /** 性别行业 */
  gender?: string
  /** 是否有Box */
  hasBox?: boolean
  /** 是否查看拉黑的图片 */
  imageAccessLevelFilter?: boolean
  /** 款式风格 */
  imageStyleList?: string[]
  /** 收录博主 */
  includedFlag?: number
  /** ins订阅关键词查询 */
  insKeywordList?: string[]
  /** 商品标题 */
  itemTitle?: string
  /** 关键词查询 */
  keyword?: string
  /** 二维标签值 */
  labelMatrix?: unknown[]
  /** 杂志ID */
  magazineId?: string
  /** 标记博主id */
  markBloggerId?: string
  /** 零售市场 */
  marketName?: string
  /** 零售市场列表 */
  marketNameList?: string[]
  /** 收藏数右闭区间 */
  maxCollectNum?: number
  /** 评论数右闭区间 */
  maxCommentNum?: number
  /** 粉丝数右闭区间 */
  maxFansNum?: number
  /** 最大款式图片数 */
  maxImageNum?: number
  /** 最大赞藏比 */
  maxLikeCollectRatio?: number
  /** 最大赞粉比 */
  maxLikeFansRatio?: number
  /** 点赞数右闭区间 */
  maxLikeNum?: number
  /** 最大价格 */
  maxPrice?: number
  /** 最大累计销量数 */
  maxSaleVolume?: number
  /** 收藏数左闭区间 */
  minCollectNum?: number
  /** 评论数左闭区间 */
  minCommentNum?: number
  /** 粉丝数左闭区间 */
  minFansNum?: number
  /** 最小款式图片数 */
  minImageNum?: number
  /** 最小赞藏比 */
  minLikeCollectRatio?: number
  /** 最小赞粉比 */
  minLikeFansRatio?: number
  /** 点赞数左闭区间 */
  minLikeNum?: number
  /** 最小价格 */
  minPrice?: number
  /** 最小累计销量数 */
  minSaleVolume?: number
  /** 最大用户月浏览量 */
  monthViewsEnd?: number
  /** 最小用户月浏览量 */
  monthViewsStart?: number
  /** 是否需要标签转换 */
  needFinalTag?: boolean
  /** 笔记类型 1-仅含图片 2-含视频 3-仅含视频 4-含图片 */
  noteType?: number
  /** 场合 */
  occasionTags?: string[]
  /** 仅查询款式图片 1-是/0-其他 默认关闭 */
  onlyClothes?: number
  /** 仅需要count */
  onlyNeedCount?: boolean
  /** 最新排序过滤(xhs和ins专用) 1-使用/0-不使用 默认关闭 */
  orderFilter?: number
  /** 得物原始风格 */
  originStyleList?: string[]
  /** pageSize */
  pageSize?: number
  /** pinterest类型 1-图片，2-视频 */
  pinterestBlogType?: number
  /** pinterest画板id */
  pinterestBoardId?: string
  /** pinterest画板id集合 */
  pinterestBoardIdList?: string[]
  /** 站点分类 */
  platformClassification?: string[]
  /** 数据源类型(2-发布会/8-电商/9-品牌精选/11-ins/20-微博库/37-小红书) */
  platformId?: number
  /** 多数据源类型 */
  platformIdList?: number[]
  /** 站点地区 */
  platformLocations?: string[]
  /** 投放状态 0:未投放；1: 投放中 */
  promotedFabricFilter?: number
  /** 质量过滤 1-使用/0-不使用 默认开启 */
  qualityFlag?: number
  /** 排序规则 1-发布时间倒序 2-ins点赞 3-ins评论 4-wb评论 5-wb点赞 6-wb转发 7-单场发布会内图片正序 8-昨日销量 9-月销量 10-收藏量 11-总销量 12-评价数 13-价格 20-xhs 点赞21-xhs评论 22-xhs收藏 23-款式entityId 25-最新发布 26-销量最多 27-评价最多 30-精选排序 31-ins赞粉比最多 32-wb赞粉比最多 33-xhs赞粉比最多 34-xhs点赞升序 35-xhs评论升序 36-xhs收藏升序 37-单场订货会内图片正序 38-ins商品价格升序 39-ins商品价格降序 40-得物近7日销量降序 41-时装大片内图片正序 42-发布会细节内图片正序 43-品牌预售内图片正序 44-ins赞粉比倒序 45-品牌预售单图模式排序 46-小红书收藏夹默认顺序 47-精选排序按人群 48-小红书赞藏比倒序  49-收录时间正序 50-收录时间倒序 51-xhs昨日评论 52-xhs近3日评论 53-xhs近7日评论 54-ins昨日评论 55-ins近3日评论 56-ins近7日评论  57-xhs昨日点赞 58-xhs近3日点赞 59-xhs近7日点赞 60-ins昨日点赞 61-ins近3日点赞 62-ins近7日点赞  63-xhs昨日收藏数 64-xhs近3日收藏数 65-xhs近7日收藏数 70-pinterest收藏最多 71-pinterest点赞最多 72-pinterest月浏览量最多100-采集时间 101-最新批注 102-标记通过110-搜索排序 */
  rankStatus?: number
  /** 根品类（淘宝在用） */
  rootCategoryId?: number
  /** 场景 */
  sceneTags?: string[]
  /** 排序人群类型 0，1，2对应三种人群，用户没有归类默认查询1 */
  scoreType?: number
  /** 季度标签 */
  season?: string
  /** 季度列表 */
  seasonList?: string[]
  /** 二维标签值（智能选款过滤） */
  seconderyLableMatrix?: unknown[]
  /** 品牌预售ID */
  selectBrandId?: string
  /** 品牌预售ID列表 */
  selectBrandIdList?: string[]
  /** 精选博主 1-精选 0-非精选 */
  selectedFlag?: number
  /** 店铺ID集合 */
  shopIdList?: number[]
  /** 店铺名称 */
  shopName?: string
  /** 店铺市场 */
  shopType?: number
  /** shopbop细节 */
  shopbopDetailList?: string[]
  /** shopbop部位 */
  shopbopPositionList?: string[]
  /** shopbop类型 1-细节 */
  shopbopViewType?: number
  /** 发布会ID */
  showId?: string
  /** 展示订阅博主，0：否，1：是 */
  showSubBloggerFlag?: number
  /** 是否智能过滤 */
  smartFilter?: boolean
  /** 0-desc（默认）1-asc */
  sortOrderStatus?: number
  /** 排序值 */
  sortValues?: string[]
  sourceChannel?: string
  /** 订阅来源(1-INS/2-微博/3-品牌/4-话题/5-小红书) */
  sourceType?: number
  /** start */
  start?: number
  /** 风格热词 */
  styleTermList?: string[]
  /** 订阅类型，0：全库，1：我的订阅，2：团队订阅 */
  subscribeType?: number
  /** 源站信息筛选 */
  tagDataList?: TagData[]
  /** 用户过滤词 */
  userFilterTerms?: string[]
  /** 用户包含关键词 */
  userIncludeTerms?: string[]
  /** 小红书收藏夹标志 1：收藏夹笔记 */
  xhsCollectionFlag?: number
}

/**
 * ColorMapDO接口类型
 */
export interface ColorMapDO {
  /** 颜色的色调 */
  color?: string
  /** 颜色等级 */
  colorLevel?: number
  /** 颜色对应的编号 */
  colorNumber?: string
  /** 颜色描述 */
  desc?: string
  /** 颜色对应的英文名 */
  enName?: string
  /** id */
  id?: number
  /** 颜色对应的中文名 */
  name?: string
  /** 父Id */
  rootColorId?: number
  sort?: number
  status?: number
}

/**
 * PinterestData接口类型
 */
export interface PinterestData {
  /** pinterest类型 0-单图，1-多图，2-视频 */
  blogType?: number
  bloggerObj?: PinterestBlogger
  /** 博主标签 */
  bloggerTags?: string[]
  /** 画板id */
  boardId?: string
  /** 收藏数 */
  collectNum?: number
  /** 内容 */
  content?: string
  /** 粉丝数 */
  fansNum?: number
  /** 图片数 */
  imageNum?: number
  /** 点赞数 */
  likeNum?: number
  /** 用户头像 */
  logo?: string
  /** 月浏览量 */
  monthViews?: number
  /** 用户昵称 */
  nickName?: string
  /** 源站连接 url */
  pinUrl?: string
  /** 标题 */
  title?: string
  /** 用户ID */
  userId?: string
  /** 视频链接 url */
  videoUrl?: string
}

/**
 * ZKLabelMapping接口类型
 */
export interface ZKLabelMapping {
  category?: string
  labelList?: string[]
}

/**
 * WbBlogger接口类型
 */
export interface WbBlogger {
  biographyLinks?: string
  birthPlace?: string
  birthday?: string
  blogNum?: number
  /** 昨日新增博文数 */
  blogNum1day?: number
  /** 近30天新增博文数 */
  blogNum30day?: number
  blogTime?: string
  bloggerId?: string
  bloggerTag?: string
  bloggerType?: number
  bloggerUrl?: string
  /** 近30天识别品类to3 */
  categoryTop30day?: string
  /** 近30天识别品类to3 */
  categoryTop30dayList?: string[]
  clothingTypes?: string
  createdAt?: string
  currentSubscribed?: number
  deletedAt?: string
  deltaFansNum?: number
  fansNum?: number
  /** 近30天粉丝增量 */
  fansNum30day?: number
  /** 涨粉趋势，1-持续涨粉 2-持续掉粉 */
  fansRisingTrendTag?: number
  finishedHistory?: number
  followNum?: number
  fromPlace?: string
  fullName?: string
  gender?: string
  hasStore?: number
  headImg?: string
  identitys?: string
  imageNum?: number
  includedTime?: string
  includerUserId?: string
  industryCategory?: string
  insItemNum?: number
  inspirations?: string
  introduction?: string
  isPrivate?: number
  isVerified?: number
  lastBlogList?: ImageEntity[]
  /** 最近更新图片数量 */
  lastImgNum?: number
  legalize?: number
  legalizeText?: string
  /** 近30天点赞数 */
  likeNum30day?: number
  linksInfo?: string
  materials?: string
  /** 近30天新增博文最大点赞数 */
  maxLikeNumRecent30Day?: number
  memberGrade?: string
  nickName?: string
  postTypes?: string
  /** 近30天识别风格top3 */
  recognitionStyleTop30day?: string
  /** 近30天识别风格top3 */
  recognitionStyleTop30dayList?: string[]
  recommendWords?: string
  region?: string
  remarksName?: string
  reviewTime?: string
  /** 精选博主标识，1：精选，0：非精选 */
  selected?: number
  /** 博主屏蔽状态 0-未屏蔽 1-屏蔽已提交 2-已屏蔽 */
  shieldStatus?: number
  source?: number
  status?: number
  styles?: string
  sumTags?: string
  tbShopId?: number
  /** 总点赞数 */
  totalLikeNum?: number
  updatedAt?: string
  updatedUserId?: number
  /** 监控者 */
  watchMen?: 守望者_监控者[]
}

/**
 * RetailData接口类型
 */
export interface RetailData {
  /** 品牌 */
  brand?: string
  /** 品牌对象 */
  brandObj?: object
  /** 二级城市 */
  city?: string
  /** 专栏名称，批发市场，名牌精选等 */
  column?: string
  /** 图组宽高信息,json格式 */
  detailUrlInfo?: string
  /** 图组urls，逗号分隔 */
  detailUrls?: string
  /** 会展名 */
  exhibition?: string
  /** 商品id */
  goodsId?: string
  /** 商品标题 */
  goodsTitle?: string
  /** 商品链接 */
  goodsUrl?: string
  /** 图片数量 */
  imageNum?: number
  /** 行业 */
  industry?: string
  /** 是否中国品牌，0-不是，1-是 */
  isChineseBrand?: number
  /** 市场名称 */
  marketName?: string
  /** 原始品牌 */
  originBrand?: string
  /** 原始品类 */
  originCategory?: string
  /** 原始性别 */
  originGender?: string
  /** 原始季度 */
  originSeason?: string
  /** 季度 */
  season?: string
}

/**
 * ShopbopData接口类型
 */
export interface ShopbopData {
  /** 品牌 */
  brand?: string
  /** 品牌 */
  brandObj?: object
  /** 货币 */
  currencyCode?: string
  /** 类目 */
  descript?: string
  /** 细节图链接 */
  detailUrl?: string
  /** 商品链接 */
  goodsUrl?: string
  /** 图片数 */
  imageNum?: number
  /** 价格 */
  price?: number
  /** 季度 */
  season?: string
  /** 市场名 */
  title?: string
}

/**
 * FarfetchData接口类型
 */
export interface FarfetchData {
  /** 品牌 */
  brand?: string
  /** 品牌 */
  brandObj?: object
  /** 货币 */
  currencyCode?: string
  /** 最终价格 */
  finalPrice?: number
  /** 商品内容 */
  goodsContent?: string
  /** 商品链接 */
  goodsUrl?: string
  /** 图片数量 */
  imageNum?: number
  /** 详情图列表 */
  imageUrlList?: string
  /** 初识价格 */
  initialPrice?: number
  /** 原始类目 */
  originCategory?: string[]
  /** 类目 */
  rootCategory?: string
  /** 标题 */
  title?: string
}

/**
 * 小红书博主品牌接口类型
 */
export interface 小红书博主品牌 {
  /** 品牌名 */
  brand?: string
  /** 合作次数 */
  cooperationCount?: number
}

/**
 * ApiResult_List_ZKLabelMapping接口类型
 */
export interface ApiResult_List_ZKLabelMapping {
  errorCode?: string
  errorDesc?: string
  result?: ZKLabelMapping[]
  success?: boolean
}

/**
 * DhhData接口类型
 */
export interface DhhData {
  /** 品牌 */
  brand?: string
  /** 品牌实体对象 */
  brandObj?: object
  /** 订货会id */
  dhhId?: string
  /** 原始类目 */
  originCategory?: string[]
  /** 季度 */
  season?: string
}

/**
 * SsenseData接口类型
 */
export interface SsenseData {
  /** 品牌 */
  brand?: string
  /** 品牌 */
  brandObj?: object
  /** 城市 */
  city?: string
  column?: string
  /** 亮点 */
  composition?: string
  /** 货币 */
  currencyCode?: string
  /** 商品描述 */
  description?: string
  detailUrlInfo?: string
  /** 详情图 */
  detailUrls?: string
  exhibition?: string
  /** 商品id */
  goodsId?: string
  /** 商品标题 */
  goodsTitle?: string
  /** 商品链接 */
  goodsUrl?: string
  /** 图片数量 */
  imageNum?: number
  /** 类目 */
  industry?: string
  /** 市场名 */
  marketName?: string
  /** 原始品牌 */
  originBrand?: string
  /** 原始品类 */
  originCategory?: string
  /** 原始gender */
  originGender?: string
  /** 原始季度 */
  originSeason?: string
  /** 价格 */
  price?: number
  /** 季度 */
  season?: string
}

/**
 * ApiResult_List_MenuItemDO接口类型
 */
export interface ApiResult_List_MenuItemDO {
  errorCode?: string
  errorDesc?: string
  result?: MenuItemDO[]
  success?: boolean
}

/**
 * ItemListRequest接口类型
 */
export interface ItemListRequest {
  /** 参与活动类型 1- 淘宝直播 2-聚划算 */
  activityType?: number
  /** 新的适用年龄，只限女装、男装 */
  ageLevelList?: string[]
  /** 关联面料过滤 */
  associatedFabricFilter?: number
  /** 只看低于常卖价商品 */
  belowUsualCprice?: number
  /** 品牌匹配 */
  brandList?: string[]
  /** 品类折叠 1 */
  categoryCollapse?: number
  /** 二级类目匹配(单个) */
  categoryId?: number
  /** 二级类目匹配数组（多选） */
  categoryIdList?: number[]
  /** 发货地省份匹配，传入该参数将覆盖deliveryLocationList */
  city?: string
  /** 经典标志位 */
  classicFilter?: number
  /** 面料 */
  cloth?: string
  /** 折叠字段 */
  collapseFields?: string
  /** 折叠展开 1 */
  collapseUnfold?: number
  /** 是否有搭配商品，选中则传'collocation_item' */
  collocationTag?: string
  /** 颜色匹配 */
  colors?: string[]
  commentNumFilterFlag?: number
  crawlImportantStatus?: number
  /** 发货地匹配 */
  deliveryLocationList?: string[]
  /** 连衣裙市场热卖 销量过滤, 1-过滤 */
  dressMarketHotFilter?: number
  /** 抖音热销标志位 1-是抖音热销 非抖音热销传0 */
  dyFlag?: number
  /** 本期的结束时间，只有用到本期字段才需要传入 */
  endDate: string
  /** 是否隐藏用户采集的商品：0-不限 1-隐藏，默认不隐藏 */
  excludeCollectedItemFlag?: number
  /** 是否隐藏用户监控的商品：0-不限 1-隐藏，默认不隐藏 */
  excludeMonitoredItemFlag?: number
  /** 是否隐藏用户监控的店铺：0-不限 1-隐藏，默认不隐藏 */
  excludeMonitoredShopFlag?: number
  /** 不看正在预售类型：1-新品预热，2-定金预售，3-全款预售 */
  excludePreSaleTypes?: number[]
  /** 隐藏用户今日浏览的商品 1-隐藏，默认-不隐藏 */
  excludeViewedItemFlag?: number
  /** 过滤本商品ID */
  excludedItemId?: number
  excludedRankListBlackFilterFlag?: number
  /** 商品库导出类型 1 全部， 2-热销， 3 -品牌热销， 4-首发热销  */
  exportType?: number
  extraFilterTerms?: object
  /** 材质组合 */
  fabric?: string
  /** 面料标志 */
  fabricFlag?: number
  /** 商品特征标签：持续热卖、持续滞销、新品持续热卖、新品持续滞销 */
  featureTag?: string
  /** 上新14天收藏量最大匹配 */
  first14dayMaxCollect?: number
  /** 上新14天销量最大匹配 */
  first14dayMaxVolume?: number
  /** 上新14天收藏量最小匹配 */
  first14dayMinCollect?: number
  /** 上新14天销量最小匹配 */
  first14dayMinVolume?: number
  /** 上新3天收藏量最大匹配 */
  first3dayMaxCollect?: number
  /** 上新3天销量最大匹配 */
  first3dayMaxVolume?: number
  /** 上新3天收藏量最小匹配 */
  first3dayMinCollect?: number
  /** 上新3天销量最小匹配 */
  first3dayMinVolume?: number
  /** 上新首日收藏量最大匹配 */
  firstDayMaxCollect?: number
  /** 上新首日销量最大匹配 */
  firstDayMaxVolume?: number
  /** 上新首日收藏量最小匹配 */
  firstDayMinCollect?: number
  /** 上新首日销量最小匹配 */
  firstDayMinVolume?: number
  /** 首发热销初筛过滤字段 商品库-首发热销传 1 */
  firstDayVolumeSortFilter?: number
  /** 上新30天收藏量最大匹配 */
  firstMonthMaxCollect?: number
  /** 上新30天销量最大匹配 */
  firstMonthMaxVolume?: number
  /** 上新30天收藏量最小匹配 */
  firstMonthMinCollect?: number
  /** 上新30天销量最小匹配 */
  firstMonthMinVolume?: number
  /** 上新7天收藏量最大匹配 */
  firstWeekMaxCollect?: number
  /** 上新7天销量最大匹配 */
  firstWeekMaxVolume?: number
  /** 上新7天收藏量最小匹配 */
  firstWeekMinCollect?: number
  /** 上新7天销量最小匹配 */
  firstWeekMinVolume?: number
  /** 适用性别 */
  genders?: string
  /** 高库存新品 选中传1 */
  highSkuNewFlag?: number
  /** 是否行业洞察范围 */
  hydcFlag?: number
  /** 智能搜索-文字 */
  imgSearchText?: string
  /** 智能搜索-图片 */
  imgSearchUrl?: string
  /** 标记是否导出 0-非导出 1-导出 */
  isExport?: number
  /** 参与过聚划算标记 选中传1， 非聚划算传0 */
  isJhsItem?: number
  /** 参与过直播商品标记 选中传1， 非直播传0 */
  isLiveItem?: number
  /** 商场标记: 商场同款:1, 线上专供:2 */
  isMallItem?: number
  /** 非参与过聚划算标记 选中传1 */
  isNotJhsItem?: number
  /** 非参与过直播商品标记 选中传1 */
  isNotLiveItem?: number
  /** 非商场同款标记 选中传1 */
  isNotMallItem?: number
  /** 高售罄商品 选中传1 */
  isOutStockItem?: number
  /** 商品ID匹配 */
  itemIdList?: number[]
  /** 商品名匹配 */
  itemLikeName?: string
  /** 商品名过滤 */
  itemNameFilters?: string[]
  /** 上一页最后一个itemId */
  lastItemId?: number
  /** 上期收藏最大匹配 */
  lastPeriodMaxCollect?: number
  /** 上期销量最大匹配 */
  lastPeriodMaxSalesVolume?: number
  /** 上期收藏最小匹配 */
  lastPeriodMinCollect?: number
  /** 上期销量最小匹配 */
  lastPeriodMinSalesVolume?: number
  /** 粗排限制 */
  limit: number
  /** 面料材质 */
  material?: string
  /** 面料材质百分比-结束 */
  materialPercentEnd?: number
  /** 面料材质百分比-开始 */
  materialPercentStart?: number
  /** 最大加购数 */
  maxAddPurchaseNum?: number
  /** 总收藏最大匹配 */
  maxCollect?: number
  /** 总评论数最大匹配 */
  maxComment?: number
  /** 预估到手价(券后价)最大匹配 */
  maxCouponCprice?: number
  /** 第一天售卖最高价格 (元) */
  maxFirstSaleTimePrice?: number
  /** 历史最低价最大匹配 */
  maxHistoryMinLeftCprice?: number
  /** 新品预售结束 不包含 */
  maxNewPresaleTime?: string
  /** 本期平均到手价最大匹配（单位：元） */
  maxPeriodAvgCouponCPrice?: number
  /** 促销价最大匹配（单位：元） */
  maxPrice?: number
  /** 销售转化率区间max */
  maxSaleCollectRate?: number
  /** 总销量最大匹配 */
  maxVolume?: number
  /** 最小加购数 */
  minAddPurchaseNum?: number
  /** 总收藏最小匹配 */
  minCollect?: number
  /** 总评论数最小匹配 */
  minComment?: number
  /** 预估到手价(券后价)最小匹配 */
  minCouponCprice?: number
  /** 第一天售卖最低价格 (元) */
  minFirstSaleTimePrice?: number
  /** 历史最低价最小匹配 */
  minHistoryMinLeftCprice?: number
  /** 新品预售开始 包含 */
  minNewPresaleTime?: string
  /** 本期平均到手价最小匹配（单位：元） */
  minPeriodAvgCouponCPrice?: number
  /** 促销价最小匹配（单位：元） */
  minPrice?: number
  /** 销售转化率区间min */
  minSaleCollectRate?: number
  /** 总销量最小匹配 */
  minVolume?: number
  /** 竞店新品 首日热卖过滤 */
  monitorFirstDayHotFilter?: number
  /** 30日销量最大匹配 */
  monthMaxVolume?: number
  /** 30日销量最小匹配 */
  monthMinVolume?: number
  /** 最新上架时间结束 */
  nearlySaleEndDate?: string
  /** 最新上架时间开始 */
  nearlySaleStartDate?: string
  /** 新品标记 选中传1 */
  newFlag?: number
  /** 当季新品过滤 1-当季新品 */
  newItemFilter?: number
  /** 降级传1 */
  notCrawlImportantStatus?: number
  /** 非首次上架 筛选-商品库新品模块 0-非首次 */
  onlyFirstNewFlag?: number
  /** 活动名 */
  originActivityName?: string
  /** 活动名数组 */
  originActivityNameList?: string[]
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 本期收藏最大匹配 */
  periodMaxCollect?: number
  /** 本期销量最大匹配 */
  periodMaxSalesVolume?: number
  /** 本期收藏最小匹配 */
  periodMinCollect?: number
  /** 本期销量最小匹配 */
  periodMinSalesVolume?: number
  /** 本期销量过滤 */
  periodVolumeFilter?: number
  /** 投放状态 0:未投放；1: 投放中 */
  promotedFabricFilter?: number
  /** 属性匹配 */
  propertyList?: ItemPropertyRequest[]
  /** 属性匹配 字符串 逗号分割 k:v,k:v  */
  propertyString?: string
  /** 发货地省份匹配，传入该参数将覆盖deliveryLocationList */
  province?: string
  /** 搜索标题 */
  queryTitle?: string
  /** 商品标题仅模糊搜索，多个 */
  queryTitleList?: string[]
  /** 店铺等级（ 一红心 11 ,二红心 12 ,三红心 13 ,四红心 14 ,五红心 15 ,六红心 16 ,一钻石 21 ,二钻石 22 ,三钻石 23 ,四钻石 24 ,五钻石 25 ,六钻石 26 ,一皇冠 31 ,二皇冠 32 ,三皇冠 33 ,四皇冠 34 ,五皇冠 35 ,六皇冠 36 ,一金冠 41 ,二金冠 42 ,三金冠 43 ,四金冠 44 ,五金冠 45 ，六金冠 46 ） */
  rankTypeList?: number
  /** 店铺等级（多选） */
  rankTypes?: number[]
  /** 一级类目匹配 */
  rootCategoryId?: number
  /** 一级类目匹配数组（多选） */
  rootCategoryIdList?: number[]
  /** 上架时间-结束 */
  saleEndDate?: string
  /** 上架时间-开始 */
  saleStartDate?: string
  /** 销售状态匹配（2- 在售， 3- 已下架） */
  saleTypeStatus?: number
  /** 上下架当日收藏右区间 */
  shelfMaxCollect?: number
  /** 上下架当日销量右区间 */
  shelfMaxVolume?: number
  /** 上下架当日收藏左区间 */
  shelfMinCollect?: number
  /** 上下架当日销量左区间 */
  shelfMinVolume?: number
  /** 上下架类型 1- 上架 2-非首次上架，3-下架 */
  shelfType?: number
  /** 店铺id */
  shopId?: number
  /** 店铺ID匹配 */
  shopIdList?: number[]
  /** shopLabel匹配 */
  shopLabelList?: string[]
  /** 店铺名过滤 */
  shopNameFilters?: string[]
  /** shopStyle匹配 */
  shopStyleList?: string[]
  /** shopType匹配（淘宝天猫标记） */
  shopType?: number
  /** 小众店铺过滤 选中传1 */
  smallShopFilter?: number
  /** 排序字段 */
  sortField: string
  /** 排序方式 */
  sortType: string
  sourceChannel?: string
  /** 清仓/福袋商品, 1-只看, 0-不看， null-不限 */
  specialItem?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 本期的开始时间，只有用到本期字段才需要传入 */
  startDate: string
  /** 是否年度宝藏店铺top240店铺, 1-是 */
  treasureShopFlag?: number
  /** 用户屏蔽店铺商品过滤 1-过滤 */
  userBlacklistFilterFlag?: number
  /** 商品是否有视频：true-只看有视频，false-只看无视频，null-不限 */
  videoUrlFlag?: number
  /** 是否白底图 1-只看白底图 0-不看白底图 */
  whiteBgFlag?: number
  /** 智能过滤 选中传1 */
  wiseFilterFlag?: number
  /** 下架时间筛选 max */
  withdrawTimeEnd?: string
  /** 下架时间筛选 min */
  withdrawTimeStart?: string
  /** 年份季节筛选 */
  yearSeason?: string
  /** 年份季节数组（多选） */
  yearSeasonList?: string[]
}

/**
 * PaginationResultItem接口类型
 */
export interface PaginationResultItem {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: Item[]
}

/**
 * ApiResultPaginationResultItem接口类型
 */
export interface ApiResultPaginationResultItem {
  result?: PaginationResultItem
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ItemPropertyRequest接口类型
 */
export interface ItemPropertyRequest {
  name?: string
  values?: string
}

/**
 * 推广趋势节点
 */
export interface TrendNode {
  /** 消费次数 */
  consumeCount?: number
  /** 日期 */
  date?: string
  /** 投放方式 1 精准投放；2 智能投放 */
  deliveryType?: number
  /** 展示日期 */
  displayDate?: string
  /** 商品/款式推广中数量 */
  inPromotionEntityCount?: number
  /** 布匹推广中数量 */
  inPromotionFabricCount?: number
  /** 系统商品/款式推广中数量 */
  inPromotionSystemEntityCount?: number
  /** 咨询次数 */
  inquiryCount?: number
  /** 展示次数 */
  viewCount?: number
  /** 查看详情次数 */
  viewDetailCount?: number
}

/**
 * Item接口类型
 */
export interface Item {
  /** 加购数 */
  addPurchaseNum?: number
  /** 适用年龄 */
  age?: string
  /** 本期收藏量 */
  aggCollection?: number
  /** 商品数 */
  aggItemCount?: number
  /** 本期定金预售商品数 */
  aggLastPreSaleCount?: number
  /** 上期定金预售销量 */
  aggLastPreSaleVolume?: number
  /** 上期销售额 */
  aggLastSaleAmount?: number
  /** 上期销量 */
  aggLastSaleVolume?: number
  /** 去年同期销售额 */
  aggLastYearSaleAmount?: number
  /** 去年同期销售额 */
  aggLastYearSaleVolume?: number
  /** 本期定金预售销售额 */
  aggPreSaleAmount?: number
  /** 本期定金预售商品数 */
  aggPreSaleCount?: number
  /** 本期定金预售商品数 */
  aggPreSaleCountMtmRatio?: number
  /** 定金预售商品数占比 */
  aggPreSaleCountPercent?: number
  /** 本期定金预售销量 */
  aggPreSaleVolume?: number
  /** 本期定金预售销量环比 */
  aggPreSaleVolumeMtmRatio?: number
  /** 定金预售销量占比 */
  aggPreSaleVolumePercent?: number
  /** 本期销售额 */
  aggSaleAmount?: number
  /** 本期销量 */
  aggSaleVolume?: number
  /** 销售额占比 */
  amountPercent?: number
  /** 应用标签 */
  applyTags?: string[]
  /** 货号 */
  articleNo?: string
  /** 关联面料列表 */
  associatedFabrics?: AssociatedFabric[]
  /** 差评数 */
  badCommentCount?: number
  /** 差评率 */
  badRate?: number
  /** 品牌名称 */
  brand?: string
  /** 回收时间, 最近下架时间 */
  cancelTime?: string
  /** 详细类目 */
  categoryDetail?: string
  /** 二级类目id */
  categoryId?: number
  /** 二级类目名称 */
  categoryName?: string
  /** 面料 */
  cloth?: string
  /** 折叠数量 */
  collapseDocCount?: number
  /** 总收藏量 */
  collect?: number
  /** 近30天收藏 */
  collect30day?: number
  /** 收藏量环比 */
  collectionMtmRatio?: number
  /** 颜色 */
  colors?: string
  /** 总评论数 */
  commentCount?: number
  /** 评论最多sku */
  commentTopOne?: string
  /** 对比清单标志 */
  contrastFlag?: boolean
  /** 预估到手价（券后价） */
  couponCprice?: number
  cprice?: number
  /** 是否降级， 1-非降级，0--降级 */
  crawlImportantStatus?: number
  /** 日销峰值日期 */
  dailyTopSaleDate?: string
  /** 日销峰值 */
  dailyTopSaleVolume?: number
  /** 发货地 */
  delivery?: string
  /** 参加抖音标识 1-参与 */
  dyStatus?: number
  /** 材质组合 */
  fabric?: string
  /** 上新14天销量 */
  first14daySalesVolume?: number
  /** 上新3天销售额 */
  first3daySale?: number
  /** 上新3天销量 */
  first3daySalesVolume?: number
  /** 首天收藏量 */
  firstDayCollect?: number
  /** 首天销售额 */
  firstDaySale?: number
  /** 首天销量 */
  firstDaySalesVolume?: number
  /** 上新首日sku */
  firstDaySkuNum?: number
  /** 上新首日库存量 */
  firstDayStock?: number
  /** 爬取时间 */
  firstInsertTime?: string
  /** 首月销售额 */
  firstMonthSale?: number
  /** 首月销量 */
  firstMonthSalesVolume?: number
  /** 首次上新当天 价格 */
  firstSaletimePrice?: number
  /** 首周销售额 */
  firstWeekSale?: number
  /** 首周销量 */
  firstWeekSalesVolume?: number
  /** 全款预售状态 */
  fullAdvanceSale?: number
  /** 性别 */
  gender?: string
  /** 分组列表 */
  groupList?: string[]
  /** 参考身高 */
  height?: string
  /** 历史高价左区间 */
  historyMaxLeftCprice?: number
  /** 历史最低价时间 */
  historyMinCpriceDate?: string
  /** 历史低价左区间 */
  historyMinLeftCprice?: number
  /** 历史低价右区间 */
  historyMinRightCprice?: number
  /** 本期热度 */
  hot?: number
  /** 监控状态(用户） */
  isMonitored?: number
  /** 商品id */
  itemId?: number
  /** 尺寸 */
  itemSizes?: string[]
  /** 参加聚划算标识 1-参与 */
  jhsStatus?: number
  /** 环比上期的新品预售收藏数 */
  lastPreRangeItemCollectSum?: number
  /** 环比上期的新品预售商品数 */
  lastPreRangeItemCountMetric?: number
  /** 同比上期的新品预售收藏数 */
  lastYearPreRangeItemCollectSum?: number
  /** 同比上期的新品预售商品数 */
  lastYearPreRangeItemCountMetric?: number
  /** 参加直播标识 1-参与 */
  liveStatus?: number
  /** 面料材质 */
  material?: string[]
  /** 材质成分 */
  materialComposition?: string
  /** 最大促销价 */
  maxCPrice?: number
  /** 最大划线价 */
  maxSPrice?: number
  /** 最小价格 */
  minPrice?: string
  /** 最近上架时间 */
  nearlySaleTime?: string
  /** 本期上新数 */
  newItemCount?: number
  /** 上期上新数 */
  newItemCountLast?: number
  /** 去年同期上新数 */
  newItemCountLastYear?: number
  /** 本期上新数环比 */
  newItemCountMtmRatio?: number
  /** 本期上新数同比 */
  newItemCountYtyRatio?: number
  /** 上新占比 */
  newItemPercent?: number
  /** 最近一次定金预售活动 总销售额 */
  orderedItemAmount?: number
  /** 预售预定销量 */
  orderedItemVolume?: number
  /** 原属性 */
  originProperties?: object
  /** 时间范围内 最后价格 */
  periodLatestPrice?: number
  /** 时间范围内 最后库存数 */
  periodLatestStock?: number
  /** 时间范围内 最大价格 */
  periodMaxPrice?: number
  /** 时间范围内 最小成交价格 */
  periodMinCouponPrice?: number
  /** 时间范围内 最小价格 */
  periodMinPrice?: number
  /** 图片 */
  picUrl?: string
  /** 滚动图列表 */
  picUrlList?: string[]
  /** 预热天数 */
  preHeatDay?: number
  /** 本期新品预售收藏数 */
  preRangeItemCollectSum?: number
  /** 本期新品预售收藏数环比 */
  preRangeItemCollectSumMtmRatio?: number
  /** 新品预售收藏数占比 */
  preRangeItemCollectSumPercent?: number
  /** 本期新品预售商品数 */
  preRangeItemCountMetric?: number
  /** 本期新品预售商品数环比 */
  preRangeItemCountMetricMtmRatio?: number
  /** 新品预售商品数占比 */
  preRangeItemCountMetricPercent?: number
  /** 本期新品预售商品数趋势图 */
  preRangeItemCountTrendMetric?: number[]
  /** 预售结束时间 */
  preSaleEndTime?: string
  /** 预售状态 */
  preSaleFlag?: boolean
  /** 预售价格 */
  preSalePrice?: number
  /** 预售等级 */
  preSalePromotion?: string
  /** 预售开始时间 */
  preSaleStartTime?: string
  /** 预售状态 */
  preSaleStatus?: number
  /** 属性 */
  properties?: string[]
  /** 属性名 */
  propertyName?: string
  /** 属性值 */
  propertyValue?: string
  /** 排行名次 */
  rank?: string
  /** 排行名称 */
  rankName?: string
  /** 推荐人数 */
  recommendCount?: number
  /** 推荐度 */
  recommendScore?: number
  /** 是否已收录 1-已收录 0-未收录 */
  recordStatus?: number
  /** 昨日补货sku数 */
  restockSkuNum?: number
  /** 一级类目id */
  rootCategoryId?: number
  /** 一级类目名称 */
  rootCategoryName?: string
  /** 最近30天退货后销量 */
  sale30DayAfterReturns?: number
  /** 最近30天销量 */
  sale30day?: number
  /** 近30天销量计算时间 (数据更新时间)  */
  sale30dayInsertTime?: string
  /** 最近7天销量 */
  sale7day?: number
  /** 月销售额 */
  saleAmount30day?: number
  /** 销售转化率 */
  saleCollectRate?: number
  /** 上新时间 */
  saleTime?: string
  /** 上新14天收藏 */
  saleTime14dayCollect?: number
  /** 上新30天收藏 */
  saleTime30dayCollect?: number
  /** 上新3天收藏量 */
  saleTime3dayCollect?: number
  /** 上新7天收藏 */
  saleTime7dayCollect?: number
  /** 本期销量占比 */
  saleVolumeRate?: number
  /** 环比销售额 */
  salesAmountMtmRatio?: number
  /** 同比销售额 */
  salesAmountYtyRatio?: number
  /** 环比销量 */
  salesVolumeMtmRatio?: number
  /** 同比销量 */
  salesVolumeYtyRatio?: number
  /** 销售渠道 */
  sellPlatform?: string
  /** 店铺掌柜名 */
  sellerName?: string
  /** 上架状态 */
  shelves?: number
  /** 店铺等级 */
  shopGrade?: number
  /** 店铺id */
  shopId?: number
  /** 店铺标签 */
  shopLabel?: string
  /** 店铺logo */
  shopLogo?: string
  /** 店铺logo */
  shopLogoUrl?: string
  /** 店铺名称 */
  shopName?: string
  /** 店铺风格 */
  shopStyle?: string
  /** 店铺总销售额 */
  shopTotalItemCount?: number
  /** 店铺种类（0-淘宝，1-天猫） */
  shopType?: number
  sortValues?: object[]
  sprice?: number
  /** 开卖首日销售额 */
  startSellAmount?: number
  /** 开卖日期 */
  startSellDate?: string
  /** 开卖首日SKU数 */
  startSellSkuNum?: number
  /** 开卖当日库存 */
  startSellStock?: number
  /** 开卖当天销量 */
  startSellVolume?: number
  /** 库存 */
  stock?: number
  /** 款号 */
  styleNo?: string
  teamMonitorInfo?: MonitorInfo
  /** 商品标题 */
  title?: string
  /** 总销售额 */
  totalSaleAmount?: number
  /** 总销量 */
  totalSaleVolume?: number
  /** 上架次数 */
  totalShelvesCount?: number
  /** 本期收藏量趋势 */
  trendCollection?: number[]
  /** 本期定金预售商品数趋势图 */
  trendPreSaleCount?: number[]
  /** 本期定金预售销量趋势图 */
  trendPreSaleVolume?: number[]
  /** 本期销售额趋势 */
  trendSaleAmountList?: TrendNode[]
  /** 本期销量趋势 */
  trendSaleVolumeList?: TrendNode[]
  /** 滞销天数 */
  unsalableDayNum?: number
  /** 视频 */
  videoUrl?: string
  /** 销量占比 */
  volumePercent?: number
  /** withdraw_time */
  withdrawTime?: string
  /** 季度标签 */
  yearSeason?: string
  /** 昨日销量 */
  yesSalesVolume?: number
  /** 昨日在售 */
  yesterdaySale?: number
  /** 上期昨日在售 */
  yesterdaySaleLast?: number
  /** 去年同期昨日在售 */
  yesterdaySaleLastYear?: number
  /** 昨日在售环比 */
  yesterdaySaleMtmRatio?: number
  /** 昨日在售同比 */
  yesterdaySaleYtyRatio?: number
}

/**
 * ApiResult_int接口类型
 */
export interface ApiResult_int {
  errorCode?: string
  errorDesc?: string
  result?: number
  success?: boolean
}

/**
 * 用户筛选条件模版
 */
export interface UserQueryTemplate {
  /** 筛选条件 */
  content?: string
  /** id */
  id?: number
  /** 顺序 */
  rankIndex?: number
  /** 备注 */
  remark?: string
  /** 名称 */
  title?: string
}

/**
 * 用户筛选条件模版请求参数
 */
export interface UserQueryTemplateRequest {
  /** 筛选条件 */
  content?: string
  /** id，删除时必传 */
  id?: number
  /** id数组，调整顺序时必传 */
  idList?: number[]
  /** 来源 */
  source?: string
  /** 名称 */
  title?: string
}

/**
 * ApiResult_List_UserQueryTemplate接口类型
 */
export interface ApiResult_List_UserQueryTemplate {
  errorCode?: string
  errorDesc?: string
  result?: UserQueryTemplate[]
  success?: boolean
}

/**
 * 监控数量信息
 */
export interface UserMonitorNumResponse {
  /** 导入失败数量 */
  errorNum?: number
  /** 导入收录中数量 */
  includingNum?: number
  /** 批量操作成功返回样例 */
  monitorSampleName?: string
  /** 本次操作监控数量 */
  recentAddMonitorNum?: number
  /** 批量操作成功ID列表 */
  successIds?: string[]
  /** 导入成功数量 */
  successNum?: number
  /** 团队监控上限 */
  teamMonitorLimit?: number
  /** 团队已监控数量 */
  teamMonitorNum?: number
  /** 个人已监控数量 */
  userMonitorNum?: number
}

/**
 * PaginationResult_UserGroupResponse接口类型
 */
export interface PaginationResult_UserGroupResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: UserGroupResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * 保存用户分组顺序请求参数
 */
export interface UserGroupOrderEditRequest {
  /** 排好序的分组id数组 */
  groupIdList?: string[]
}

/**
 * 笔记分组列表返回信息
 */
export interface UserNoteGroupListResponse {
  /** 全部分组 */
  allGroupList?: UserGroupResponse[]
  /** 我的分组 */
  myGroupList?: UserGroupResponse[]
  myMonitor?: UserGroupResponse
  myMonitorNoGroup?: UserGroupResponse
  noGroup?: UserGroupResponse
  /** 团队分组 */
  teamGroupList?: UserGroupResponse[]
  teamMonitor?: UserGroupResponse
}

/**
 * 用户分组返回信息
 */
export interface UserGroupResponse {
  /** 创建时间 */
  createdAt?: string
  /** 分组id */
  groupId?: string
  /** 分组名称 */
  groupName?: string
  /** 是否最近使用 0否  1是 */
  isLatest?: number
  /** 分组下的监控对象id列表 */
  monitorIdList?: string[]
  /** 分组下的监控对象数量 */
  monitorNum?: number
  /** 分组顺序 */
  order?: number
  /** 共享设置：1-全员共享，2-不共享，3-部分共享 */
  share?: number
  /** 分组共享成员id列表 */
  shareUserIdList?: number[]
  /** 分组的共享成员数量 */
  shareUserNum?: number
  /** 团队id */
  teamId?: number
  /** 用户id */
  userId?: number
  /** 用户姓名 */
  userName?: string
}

/**
 * ApiResult_string接口类型
 */
export interface ApiResult_string {
  errorCode?: string
  errorDesc?: string
  result?: string
  success?: boolean
}

/**
 * 用户监控分组弹窗设置
 */
export interface UserGroupSettingRequest {
  /** 分组类型：1-店铺，2-商品 */
  groupType: number
  /** 弹窗状态：0-不弹框，1-弹框 */
  popStatus?: number
}

/**
 * 团队管理-用户分组查询请求参数
 */
export interface TeamManageUserGroupQueryRequest {
  /** 模糊搜索分组名 */
  fuzzyGroupName?: string
  /** 分组类型：1-店铺，2-商品 */
  groupType?: number
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 分组创建人id */
  userId?: number
}

/**
 * 用户分组编辑请求参数（新增、修改、删除时用）
 */
export interface UserGroupEditRequest {
  /** 分组id，修改、删除时必传 */
  groupId?: string
  /** 分组id列表 */
  groupIdList?: string[]
  /** 分组名称 */
  groupName?: string
  /** 分组类型：1-店铺，2-商品 */
  groupType?: number
  /** 加入分组的监控对象id数组 */
  monitorIdList?: string[]
  /** 共享设置：1-全员共享，2-不共享，3-部分共享 */
  share?: number
  /** 共享成员id数组 */
  shareUserIdList?: number[]
}

/**
 * ApiResult_PaginationResult_UserGroupResponse接口类型
 */
export interface ApiResult_PaginationResult_UserGroupResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_UserGroupResponse
  success?: boolean
}

/**
 * ApiResult_UserMonitorNumResponse接口类型
 */
export interface ApiResult_UserMonitorNumResponse {
  errorCode?: string
  errorDesc?: string
  result?: UserMonitorNumResponse
  success?: boolean
}

/**
 * ApiResult_UserGroupListResponse接口类型
 */
export interface ApiResult_UserGroupListResponse {
  errorCode?: string
  errorDesc?: string
  result?: UserGroupListResponse
  success?: boolean
}

/**
 * 用户分组查询请求参数
 */
export interface UserGroupQueryRequest {
  /** 分组类型：1-店铺 2-商品 */
  groupType?: number
}

/**
 * ApiResult_List_UserGroupPopSettingResponse接口类型
 */
export interface ApiResult_List_UserGroupPopSettingResponse {
  errorCode?: string
  errorDesc?: string
  result?: UserGroupPopSettingResponse[]
  success?: boolean
}

/**
 * ApiResult_UserNoteGroupListResponse接口类型
 */
export interface ApiResult_UserNoteGroupListResponse {
  errorCode?: string
  errorDesc?: string
  result?: UserNoteGroupListResponse
  success?: boolean
}

/**
 * 用户监控编辑请求参数（新增监控、取消监控时用）
 */
export interface UserMonitorEditRequest {
  /** 分组id */
  groupIdList?: string[]
  /** 行业 */
  industry?: number
  /** 监控对象id */
  monitorId?: string
  /** 监控对象id数组 */
  monitorIdList?: string[]
  /** 监控类型：1-店铺，2-商品 */
  monitorType?: number
}

/**
 * 设置监控对象加入分组请求参数
 */
export interface UserGroupMonitorEditRequest {
  /** 加入分组id */
  groupIdList?: string[]
  /** 分组类型：1-店铺，2-商品 */
  groupType?: number
  /** 监控对象id */
  monitorId?: string
}

/**
 * 用户分组列表返回信息
 */
export interface UserGroupListResponse {
  /** 我的分组 */
  myGroupList?: UserGroupResponse[]
  /** 团队分组 */
  teamGroupList?: UserGroupResponse[]
}

/**
 * 用户弹窗设置状态
 */
export interface UserGroupPopSettingResponse {
  /** 分组类型：1-店铺，2-商品 */
  groupType: number
  /** 弹窗状态：0-不弹框，1-弹框 */
  popStatus: number
}

/**
 * FabricProductAssociation接口类型
 */
export interface FabricProductAssociation {
  /** id */
  id?: number
  /** 团队id */
  teamId?: number
  /** 面料id */
  fabricId?: string
  /** 用户id */
  userId?: number
  /** 来源 */
  sourceChannel?: string
  sourceChannelValue?: number
  /** 商品/款式id */
  entityId?: string
  /** 商品/款式名称 */
  entityName?: string
  /** 商品/款式图片 */
  picUrl?: string
  /** 店铺id */
  groupId?: string
  /** 发布时间 */
  sourceTime?: string
  /** 关联状态 0已取消；1关联中 */
  status?: string
  /** 推广状态 */
  promotionStatus?: string
  promotionStatusValue?: number
  /** 浏览量 */
  viewCount?: number
  /** 咨询量 */
  consumeCount?: number
  /** 详情页访问量 */
  detailCount?: number
  /** 询价量 */
  inquiryCount?: number
  /** 关联时间 */
  createdAt?: string
  fabricName?: string
  price?: string
  shopName?: string
  shopType?: number
  dataFrom?: string
  currency?: string
  /** 订单消费次数 */
  orderConsumeCount?: number
  fabricIdList?: string[]
}

/**
 * ApiResultFabricPromotionResponse接口类型
 */
export interface ApiResultFabricPromotionResponse {
  result?: FabricPromotionResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料推广返回
 */
export interface FabricPromotionResponse {
  /** 面料审核id */
  fabricReviewId?: string
}

/**
 * PaginationResultFabricPromotionInfo接口类型
 */
export interface PaginationResultFabricPromotionInfo {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricPromotionInfo[]
}

/**
 * 布匹推广审核信息
 */
export interface FabricPromotionReviewInfo {
  /** 申请时间 */
  applyTime?: string
  /** 申请人id */
  applyUserId?: number
  /** 申请人姓名 */
  applyUserName?: string
  /** 申请人手机号 */
  applyUserPhone?: string
  /** 公司名称 */
  companyName?: string
  /** 布匹关联商品/图片 */
  entityList?: FabricAssociateInfo[]
  /** 布匹id */
  fabricId?: string
  /** 布匹名称 */
  fabricName?: string
  /** 布匹推广审核id */
  fabricReviewId?: string
  /** 操作人ID */
  operatorId?: number
  /** 操作人姓名 */
  operatorName?: string
  /** 拒绝理由 */
  rejectReason?: string
  /** 布匹推广审核状态 1-待审核 2-审核通过 3-审核拒绝 4-取消推广 */
  reviewStatus?: number
  /** 审核时间 */
  reviewTime?: string
  /** 审核人ID */
  reviewerId?: number
  /** 审核人姓名 */
  reviewerName?: string
  /** 更新时间 */
  updatedAt?: string
}

/**
 * ApiResultPaginationResultFabricPromotionInfo接口类型
 */
export interface ApiResultPaginationResultFabricPromotionInfo {
  result?: PaginationResultFabricPromotionInfo
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 布匹推广概览
 */
export interface PromotionOverviewResponse {
  /** 精准投放-近30天推广趋势 */
  accurateTrendNodes?: TrendNode[]
  /** 客户线索数量 */
  adminCount?: number
  /** 消费次数 */
  consumeCount?: number
  /** 打招呼次数 */
  greetingCount?: number
  /** 商品/款式推广中数量 */
  inPromotionEntityCount?: number
  /** 布匹推广中数量 */
  inPromotionFabricCount?: number
  /** 系统商品/款式推广中数量 */
  inPromotionSystemEntityCount?: number
  /** 咨询次数 */
  inquiryCount?: number
  /** 咨询记录 */
  inquiryDetailRecordList?: FabricPromotionRecordStatisticBO[]
  /** 咨询商家次数 */
  inquirySellerCount?: number
  /** 咨询商家记录 */
  inquirySellerDetailRecordList?: FabricSellerRecordStatisticBO[]
  /** 智能投放-近30天推广趋势 */
  intelligentTrendNodes?: TrendNode[]
  /** 最近更新时间 */
  latestUpdateTime?: string
  /** 剩余消费次数 */
  restConsumeCount?: number
  /** 查看商家详情和咨询商家趋势 */
  sellerTrendNodes?: SellerTrendNode[]
  /** 剩余打招呼次数 */
  surplusGreetingCount?: number
  /** 消费次数 */
  totalConsumeCount?: number
  /** 展示次数 */
  viewCount?: number
  /** 查看详情次数 */
  viewDetailCount?: number
  /** 查看详情记录 */
  viewDetailRecordList?: FabricPromotionRecordStatisticBO[]
  /** 查看商家详情次数 */
  viewSellerDetailCount?: number
  /** 查看商家详情记录 */
  viewSellerDetailRecordList?: FabricSellerRecordStatisticBO[]
}

/**
 * PaginationResult_FabricAssociateInfo接口类型
 */
export interface PaginationResult_FabricAssociateInfo {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricAssociateInfo[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResultPromotionOverviewResponse接口类型
 */
export interface ApiResultPromotionOverviewResponse {
  result?: PromotionOverviewResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 取消面料推广接口
 */
export interface CancelFabricPromotionRequest {
  /** 面料id */
  fabricId: string
}

/**
 * ApiResultQueryFabricPromotionTrendResponse接口类型
 */
export interface ApiResultQueryFabricPromotionTrendResponse {
  result?: QueryFabricPromotionTrendResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料关联返回
 */
export interface FabricAssociateResponse {
  /** 本次新增的面料ID列表 */
  addedFabricIds?: string[]
  /** 面料id */
  fabricId?: string
  /** 是否推广成功 */
  promotionDesc?: string
  /** 本次取消关联的面料ID列表 */
  removedFabricIds?: string[]
  /** 关联成功数量 */
  successCount?: number
  /** 本次不变的面料ID列表 */
  unchangedFabricIds?: string[]
}

/**
 * PaginationResult_FabricPromotionReviewInfo接口类型
 */
export interface PaginationResult_FabricPromotionReviewInfo {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricPromotionReviewInfo[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_PaginationResult_FabricAssociateInfo接口类型
 */
export interface ApiResult_PaginationResult_FabricAssociateInfo {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricAssociateInfo
  success?: boolean
}

/**
 * ApiResult_FabricReviewResponse接口类型
 */
export interface ApiResult_FabricReviewResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricReviewResponse
  success?: boolean
}

/**
 * 布匹推广审核请求参数
 */
export interface ReviewFabricPromotionRequest {
  /** 附加信息 */
  additionalNotes?: string
  /** 布匹推广审核id */
  fabricReviewId: string
  /** 拒绝理由 */
  rejectReasons?: number[]
  /** 布匹推广审核状态 1-通过 2-拒绝 */
  reviewStatus: number
}

/**
 * 面料关联信息
 */
export interface FabricAssociateInfo {
  /** id */
  id?: number
  /** 面料id */
  fabricId?: string
  /** 来源渠道 */
  sourceChannel?: number
  /** 商品/款式id */
  entityId?: string
  /** 商品/款式名称 */
  entityName?: string
  /** 商品/款式图片 */
  picUrl?: string
  /** 关联状态 0-未关联 1-已关联 */
  associationStatus?: number
  /** 渠道额外信息-关联结构 */
  extraInfo?: IStyle
  /** 关联面料 */
  associatedFabrics?: AssociatedFabric[]
  promotionStatus?: number
}

/**
 * ApiResult_PaginationResult_FabricPromotionReviewInfo接口类型
 */
export interface ApiResult_PaginationResult_FabricPromotionReviewInfo {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricPromotionReviewInfo
  success?: boolean
}

/**
 * 布匹推广信息
 */
export interface FabricPromotionInfo {
  /** 关联面料 */
  associatedFabrics?: AssociatedFabric[]
  /** 关联状态 0-未关联 1-已关联 */
  associationStatus?: number
  /** 消费次数 */
  consumeCount?: number
  /** 商品/款式id */
  entityId?: string
  /** 商品/款式名称 */
  entityName?: string
  extraInfo?: IStyle
  /** 面料id */
  fabricId?: string
  /** id */
  id?: number
  /** 咨询次数 */
  inquiryCount?: number
  /** 商品/款式图片 */
  picUrl?: string
  /** 推广状态 0-已关联已投放 1-已关联未投放 2-未关联未投放 */
  promotionStatus?: number
  /** 来源渠道 */
  sourceChannel?: number
  /** 展示次数 */
  viewCount?: number
}

/**
 * FabricReviewResponse接口类型
 */
export interface FabricReviewResponse {
  /** 布匹id */
  fabricId?: string
  /** 布匹推广审核id */
  fabricReviewId?: string
  /** 审核状态 */
  reviewStatus?: number
}

/**
 * ApiResultQueryFabricPromotionInfoResponse接口类型
 */
export interface ApiResultQueryFabricPromotionInfoResponse {
  result?: QueryFabricPromotionInfoResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料推广信息
 */
export interface QueryFabricPromotionInfoResponse {
  /** 消费次数 */
  consumeCount?: number
  /** 面料id */
  fabricId?: string
  /** 咨询次数 */
  inquiryCount?: number
  /** 展现次数 */
  viewCount?: number
}

/**
 * 面料推广接口
 */
export interface FabricPromotionRequest {
  /** 面料id */
  fabricId: string
  /** 推广信息 */
  promotionInfoList: PromotionInfo[]
}

/**
 * 关联信息
 */
export interface AssociateInfo {
  /** 商品/款式id */
  entityIdList?: string[]
  /** 来源渠道 */
  sourceChannel?: number
}

/**
 * 面料推广信息
 */
export interface QueryFabricPromotionTrendResponse {
  /** 面料id */
  fabricId?: string
  /** 推广趋势 */
  trendNodes?: TrendNode[]
}

/**
 * 查询面料关联请求
 */
export interface QueryFabricAssociationRequest {
  /** 关联状态 1-关联中 0-已取消 */
  associateStatus?: number
  /** 面料id */
  fabricId: string
  /** 面料id集合 */
  fabricIdList: string[]
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 搜索关键字 */
  search?: string
  /** 来源渠道 */
  sourceChannelList?: number[]
  /** 分页参数 - 开始记录 */
  start?: number
}

/**
 * IStyle接口类型
 */
export interface IStyle {
  
}

/**
 * ApiResult_FabricAssociateResponse接口类型
 */
export interface ApiResult_FabricAssociateResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricAssociateResponse
  success?: boolean
}

/**
 * 面料关联接口
 */
export interface FabricAssociateRequest {
  /** 关联信息 */
  associateInfoList: AssociateInfo[]
  /** 面料id */
  fabricId?: string
  /** 面料id */
  fabricIdList?: string[]
  /** 是否推广 1是 0否 */
  isPromotion?: number
}

/**
 * 推广信息
 */
export interface PromotionInfo {
  /** 商品/款式id */
  entityIdList?: string[]
  /** 来源渠道 */
  sourceChannel?: number
}

/**
 * 面料详情返回信息
 */
export interface FabricInfoDetailResponse {
  /** id */
  id?: number
  /** 商家id */
  teamId?: number
  /** 商家名称 */
  teamName?: string
  /** 面料id */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 货号 */
  articleNo?: string
  /** 发货地 */
  city?: string
  /** 面料类型 1现货 2期货 */
  fabricType?: number
  /** 面料售价 -1为面议 */
  price?: string
  /** 面料最小售价 */
  priceMin?: string
  /** 面料最大售价 */
  priceMax?: string
  /** 面料销售单位 */
  priceUnit?: string
  /** 起批量 */
  bulkOrder?: string
  /** 起批量最大阈值（超过面议 */
  maxOrderQuantity?: string
  /** 备注 */
  remark?: string
  /** 面料细节图 */
  fabricDetailPic?: string
  /** 面料视频 */
  fabricVideo?: string
  /** 面料规格图（颜色,图片url英文逗号隔开） */
  fabricSpecificationPic?: string[]
  /** 面料色卡图 */
  fabricColorPic?: string
  /** 成衣展示图 */
  garmentDisplayPic?: string
  garmentDisplayList?: GarmentDisplay[]
  /** 面料详情图 */
  fabricParticularsPic?: string
  /** 面料案例图 */
  fabricCasePicList?: string[]
  /** 款式id */
  styleId?: string
  /** 品类 */
  category?: string
  /** 图案 */
  pattern?: string
  /** 适用季节 */
  suitableSeason?: string
  /** 工艺 */
  craft?: string
  /** 成分 */
  compositionList?: Composition[]
  /** 不在面料中心详情页显示  0否；1是 */
  isComposition?: number
  /** 主要用途 */
  mainPurpose?: string
  /** 用途 */
  purpose?: string
  /** 克重 */
  gramWeight?: string
  /** 最小克重 */
  gramWeightMin?: string
  /** 最大克重 */
  gramWeightMax?: string
  /** 门幅 */
  fabricWidth?: string
  /** 特性 */
  fabricFeature?: string
  /** 经缩 */
  warpShrinkage?: string
  /** 纬缩 */
  weftShrinkage?: string
  /** 支数 */
  threadCount?: string
  /** 出布率 */
  fabricYield?: string
  /** 色牢度 */
  colorFastness?: string
  /** 顶破度 */
  burstingStrength?: string
  /** 功能性 */
  functionalityList?: Functionality[]
  /** 厚度 */
  thickness?: string
  /** 弹力 */
  elasticity?: string
  /** 透气 */
  ventilate?: string
  /** 吸湿 */
  hygroscopic?: string
  /** 柔软 */
  softness?: string
  /** 悬垂 */
  drapeability?: string
  /** 保暖 */
  thermalInsulation?: string
  /** 状态 1未推广；2审核中；3推广中；4已结束；5不通过 */
  status?: number
  /** 上下架状态 1审核驳回；2已下架；3在售；4审核中 */
  shelfStatus?: number
  /** 展现次数 */
  viewCount?: number
  /** 咨询次数 */
  inquiryCount?: number
  /** 版本号 */
  version?: number
  /** 创建时间 */
  createdAt?: string
  /** 更新时间 */
  updatedAt?: string
  /** 删除时间 */
  deletedAt?: string
  /** 创建人id */
  creatorId?: number
  /** 创建人姓名 */
  creatorName?: string
  /** 创建人手机号 */
  creatorPhone?: string
  /** 修改人id */
  updaterId?: number
  /** 修改人姓名 */
  updaterName?: string
  /** 修改人手机号 */
  updaterPhone?: string
  /** 面料关联商品 */
  fabricProductAssociationList?: FabricProductAssociation[]
  /** 企业地址 */
  contactAddress?: string
  /** 主营产品 */
  primaryProducts?: string
  /** 简介 */
  profile?: string
  /** 企业logo */
  companyLogo?: string
  /** 微信二维码 */
  wechatQrCode?: string
  /** 联系电话 */
  contactPhone?: string
  /** 店铺装修面料分类 */
  shopClassifyNames?: string[]
  /** 运营后台面料标签 */
  fabricTags?: string[]
  /** 加入面料清单信息 */
  collectInfo?: FabricCollectInfoResponse
  /** 是否有操作权限 0无；1有 */
  isAuthorized?: number
  /** 适用季节（文本值） */
  seasonValueList?: string[]
  /** 工艺（文本值） */
  craftValueList?: string[]
  /** 成分（文本值） */
  compositionValueList?: string[]
  /** 用途（文本值） */
  purposeValueList?: string[]
  /** 功能性（文本值） */
  functionalityValueList?: string[]
}

/**
 * 笔记榜单-请求参数
 */
export interface BlogRankingListParam {
  /** 关联面料过滤 */
  associatedFabricFilter?: number
  /** 笔记id列表 */
  blogIdList?: string[]
  /** 发布时间结束 格式 yyyy-MM-dd HH:mm:SS */
  blogPublishTimeEnd?: string
  /** 发布时间开始 格式 yyyy-MM-dd HH:mm:SS */
  blogPublishTimeStart?: string
  /** 结束时间 格式 yyyy-MM-dd */
  blogTimeEnd: string
  /** 开始时间 格式 yyyy-MM-dd */
  blogTimeStart: string
  /** 二级品类 */
  category?: string
  /** 地区列表 */
  cityList?: string[]
  /** 面料 */
  fabricList?: string[]
  /** 过滤内部屏蔽的博主 */
  filterInnerFiledBlogger?: boolean
  /** 行业：女装 男装 男童 女童 童装 */
  gender: string
  /** 最大粉丝数 */
  maxFansNum?: number
  /** 最大价格 单位：分 */
  maxPrice?: number
  /** 最小粉丝数 */
  minFansNum?: number
  /** 最小价格 单位：分 */
  minPrice?: number
  /** 笔记类型 (xhs:1-图文 2-视频) (ins:1-仅含图片 2-含视频 3-仅含视频 4-含图片) */
  noteType?: number
  /** pageSize */
  pageSize?: number
  /** 平台id */
  platformId: number
  /** 投放状态 0:未投放；1: 投放中 */
  promotedFabricFilter?: number
  /** 1-款式榜 2-飙升榜 3-新款榜 4-赞粉比榜 */
  rankType: number
  /** 地区 */
  region?: string
  /** 一级品类 */
  rootCategory?: string
  sourceChannel?: string
  /** start */
  start?: number
  /** 风格 */
  style?: string
  /** 博主风格 */
  styleList?: string[]
}

/**
 * ApiResultFabricInfoDetailResponse接口类型
 */
export interface ApiResultFabricInfoDetailResponse {
  result?: FabricInfoDetailResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料咨询
 */
export interface FabricInquiry {
  /** 创建时间 */
  createdAt?: string
  /** 用户id */
  userId?: number
  /** 用户手机号 */
  userPhone?: string
  /** 用户名 */
  username?: string
}

/**
 * ApiResultListFabricInquiry接口类型
 */
export interface ApiResultListFabricInquiry {
  result?: FabricInquiry[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResultQueryPromotionFabricResponse接口类型
 */
export interface ApiResultQueryPromotionFabricResponse {
  result?: QueryPromotionFabricResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResultQueryPromotionCompanyResponse接口类型
 */
export interface ApiResultQueryPromotionCompanyResponse {
  result?: QueryPromotionCompanyResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 查询关联推广面料
 */
export interface QueryPromotionFabricResponse {
  /** 关联推广面料 */
  promotionFabrics?: PromotionFabric[]
  /** 关联推广面料总数 */
  total?: number
}

/**
 * ApiResultFabricInquiryResponse接口类型
 */
export interface ApiResultFabricInquiryResponse {
  result?: FabricInquiryResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 查询推广公司信息
 */
export interface QueryPromotionCompanyResponse {
  /** 供应商公司地址 */
  address?: string
  /** 面料联系人 */
  fabricContactPerson?: string
  /** 面料联系人电话 */
  fabricContactPhone?: string
  /** 供应商公司logo */
  logo?: string
  /** 供应商公司主营业务 */
  mainBusiness?: string
  /** 简介 */
  profile?: string
  /** 供应商公司商品信息 */
  promotionFabricItems?: PromotionFabricItem[]
  /** 供应商公司id */
  teamId?: number
  /** 供应商公司名称 */
  teamName?: string
  /** 微信二维码 */
  wechatQrCode?: string
}

/**
 * 关联推广面料
 */
export interface PromotionFabric {
  /** 联系地址 */
  address?: string
  /** 面料分类 */
  categoryName?: string
  /** 面料公司 */
  company?: string
  /** 企业logo */
  companyLogo?: string
  /** 面料成分 */
  compositionList?: Composition[]
  /** 投放方式 1 精准投放；2 智能投放 */
  deliveryType?: number
  /** 面料联系人 */
  fabricContactPerson?: string
  /** 面料联系人电话 */
  fabricContactPhone?: string
  /** 面料id */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 面料关联标签 */
  fabricTagList?: FabricTag[]
  /** 面料门幅 */
  fabricWidth?: string
  /** 成衣展示图 */
  garmentDisplayPic?: string
  /** 面料最大克重 */
  gramWeightMax?: string
  /** 面料最小克重 */
  gramWeightMin?: string
  /** 是否在线 0否 1是 */
  onlineStatus?: number
  /** 面料图片 */
  picUrl?: string
  /** 面料售价 -1为面议 */
  price?: string
  /** 面料最大售价 */
  priceMax?: string
  /** 面料最小售价 */
  priceMin?: string
  /** 面料销售单位 */
  priceUnit?: string
  /** 主营产品 */
  primaryProducts?: string
  /** 简介 */
  profile?: string
  /** 项目id 可为空 */
  projectId?: string
  /** 是否特定商家 0否 1是 */
  specific?: number
  teamId?: number
  /** 微信二维码 */
  wechatQrCode?: string
}

/**
 * 关联面料商品信息
 */
export interface PromotionFabricItem {
  /** 关联推广id */
  entityId?: string
  /** 关联面料id */
  fabricId?: string
  /** 关联面料名称 */
  fabricName?: string
  /** 关联推广商品图 */
  picUrl?: string
  /** 关联推广来源 */
  sourceChannel?: number
  styleOriginObj?: IStyle
}

/**
 * 查询结果
 */
export interface FabricInquiryResponse {
  /** 咨询记录id */
  id?: number
  /** 查询结果 */
  result?: boolean
}

/**
 * 查询面料咨询
 */
export interface FabricInquiryRequest {
  /** 投放方式 1 精准投放；2 智能投放 */
  deliveryType?: number
  /** 商品id */
  entityId?: string
  /** 面料id */
  fabricId?: string
  /** 面料渠道来源 */
  fabricSourceChannel?: number
  /** 是否推广  0否  1是 */
  isPromotion?: number
  /** 项目id 可为空 */
  projectId?: string
  /** 提交渠道来源 */
  sourceChannel?: number
  /** 提交页面url */
  submitPageUrl?: string
}

/**
 * Composition接口类型
 */
export interface Composition {
  /** 成分名称(传字典id) */
  name?: string
  /** 成分含量 */
  composition?: string
}

/**
 * 款式列表返回
 */
export interface StyleListResponse {
  /** 关联面料 */
  associatedFabrics?: AssociatedFabric[]
  /** 商品ID */
  entityId?: string
  /** 商品名称 */
  entityName?: string
  extraInfo?: IStyle
  /** 上架时间 */
  nearlySaleTime?: string
  /** 图源 */
  sourceChannel?: number
  /** 款式ID */
  styleId?: string
  /** 款式名称 */
  styleName?: string
  /** 款式图片 */
  stylePic?: string
  /** 团队id */
  teamId?: number
  /** 款式类型 */
  type?: number
  /** 上传用户名称 */
  uploadUserName?: string
  /** 用户id */
  userId?: number
}

/**
 * 查询款式列表请求
 */
export interface QueryStyleListRequest {
  /** 面料ID */
  fabricId?: string
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 结束时间 */
  nearlySaleTimeEnd?: string
  /** 开始时间 */
  nearlySaleTimeStart?: string
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 排序方式：1正序 2倒序 */
  sortType?: number
  /** 图源 */
  sourceChannel?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 文本搜索 */
  styleNameLike?: string
  /** 款式类型：0不限 1关联商品 2自主上传 */
  type?: number
}

/**
 * 批量上传款式请求
 */
export interface BatchUploadStyleRequest {
  /** 款式列表 */
  styleList?: StyleInfo[]
}

/**
 * ApiResult_PaginationResult_StyleListResponse接口类型
 */
export interface ApiResult_PaginationResult_StyleListResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_StyleListResponse
  success?: boolean
}

/**
 * StyleInfo接口类型
 */
export interface StyleInfo {
  /** 款式名称 */
  styleName?: string
  /** 款式图 */
  stylePic?: string
}

/**
 * PaginationResult_StyleListResponse接口类型
 */
export interface PaginationResult_StyleListResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: StyleListResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * 面料详情查询请求参数
 */
export interface FabricInfoDetailRequest {
  /** 投放方式 1 精准投放；2 智能投放 */
  deliveryType?: number
  /** 关联实体id */
  entityId?: string
  /** 面料id */
  fabricId?: string
  /** 是否推广  0否  1是 */
  isPromotion?: number
  /** 项目id 可为空 */
  projectId?: string
  /** 提交来源渠道 */
  sourceChannel?: number
}

/**
 * 商家信息
 */
export interface FabricTeamInfoResponse {
  /** 供应商公司地址 */
  address?: string
  /** 企业logo */
  companyLogo?: string
  /** 地址 */
  contactAddress?: string
  /** 面料联系人 */
  fabricContactPerson?: string
  /** 面料联系人电话 */
  fabricContactPhone?: string
  /** 商家介绍视频 */
  introductionVideo?: string
  /** 是否在运营 */
  operating?: boolean
  /** 主营产品 */
  primaryProducts?: string
  /** 到期时间 */
  productEndTime?: string
  /** 是否有商品 */
  products?: boolean
  /** 简介 */
  profile?: string
  /** 是否有推荐面料 */
  recommendFabric?: boolean
  /** 团队简称 */
  simpleName?: string
  /** 商家id */
  teamId?: number
  /** 团队名称 */
  teamName?: string
  /** 微信二维码 */
  wechatQrCode?: string
}

/**
 * ApiResultFabricTeamInfoResponse接口类型
 */
export interface ApiResultFabricTeamInfoResponse {
  result?: FabricTeamInfoResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 咨询记录查询请求参数
 */
export interface PromotionRecordQueryRequest {
  /** 动作 2查看详情 3咨询 */
  action?: number
  /** 面料id */
  fabricId?: string
  /** 面料名 */
  fabricName?: string
  /** 面料商id */
  fabricTeamId?: number
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 开始记录 */
  start?: number
}

/**
 * ApiResultPaginationResultPromotionRecordListResponse接口类型
 */
export interface ApiResultPaginationResultPromotionRecordListResponse {
  result?: PaginationResultPromotionRecordListResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 咨询记录
 */
export interface PromotionRecordListResponse {
  /** 用户微信 */
  authWechat?: string
  /** 咨询时间 */
  createdAt?: string
  /** 面料ID */
  fabricId?: string
  id?: number
  /** 是否授权  0否  1是 */
  isAuth?: number
  /** 是否对该用户打招呼 */
  isGreeted?: number
  /** 性别 1-男，2-女，3-未知 */
  sex?: number
  /** 团队id */
  teamId?: number
  /** 用户id */
  userId?: number
  userName?: string
  /** 用户手机 */
  userPhone?: string
}

/**
 * PaginationResultPromotionRecordListResponse接口类型
 */
export interface PaginationResultPromotionRecordListResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: PromotionRecordListResponse[]
}

/**
 * garmentDisplay接口类型
 */
export interface garmentDisplay {
  /** 图片url */
  garmentDisplayPic?: string
  /** 款式id */
  styleId?: string
}

/**
 * ApiResult_List_StyleListResponse接口类型
 */
export interface ApiResult_List_StyleListResponse {
  errorCode?: string
  errorDesc?: string
  result?: StyleListResponse[]
  success?: boolean
}

/**
 * PaginationResultQueryPromotionCompanyResponse接口类型
 */
export interface PaginationResultQueryPromotionCompanyResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: QueryPromotionCompanyResponse[]
}

/**
 * 查询关联企业
 */
export interface QueryPromotionCompanyRequest {
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** shopId */
  shopId?: string
  /** 来源渠道 */
  sourceChannel?: number
  /** 分页参数 - 开始记录 */
  start?: number
}

/**
 * ApiResultPaginationResultQueryPromotionCompanyResponse接口类型
 */
export interface ApiResultPaginationResultQueryPromotionCompanyResponse {
  result?: PaginationResultQueryPromotionCompanyResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * PaginationResult_RunwayData接口类型
 */
export interface PaginationResult_RunwayData {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: RunwayData[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_PaginationResult_ImageEntity接口类型
 */
export interface ApiResult_PaginationResult_ImageEntity {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_ImageEntity
  success?: boolean
}

/**
 * PaginationResult_RpcWindowDailyGoods接口类型
 */
export interface PaginationResult_RpcWindowDailyGoods {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: RpcWindowDailyGoods[]
  start?: number
  totalPageCount?: number
}

/**
 * PaginationResult_ImageEntity接口类型
 */
export interface PaginationResult_ImageEntity {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: ImageEntity[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_PaginationResult_RunwayData接口类型
 */
export interface ApiResult_PaginationResult_RunwayData {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_RunwayData
  success?: boolean
}

/**
 * ApiResult_PaginationResult_RpcWindowDailyGoods接口类型
 */
export interface ApiResult_PaginationResult_RpcWindowDailyGoods {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_RpcWindowDailyGoods
  success?: boolean
}

/**
 * AssociatedFabric接口类型
 */
export interface AssociatedFabric {
  fabricId?: string
  fabricName?: string
  fabricDetailPic?: string
}

/**
 * 监控商品
 */
export interface MonitorItem {
  /** 加购数 */
  addPurchaseNum?: number
  /** 适用年龄 */
  age?: string
  /** 本期收藏量 */
  aggCollection?: number
  /** 商品数 */
  aggItemCount?: number
  /** 本期定金预售商品数 */
  aggLastPreSaleCount?: number
  /** 上期定金预售销量 */
  aggLastPreSaleVolume?: number
  /** 上期销售额 */
  aggLastSaleAmount?: number
  /** 上期销量 */
  aggLastSaleVolume?: number
  /** 去年同期销售额 */
  aggLastYearSaleAmount?: number
  /** 去年同期销售额 */
  aggLastYearSaleVolume?: number
  /** 本期定金预售销售额 */
  aggPreSaleAmount?: number
  /** 本期定金预售商品数 */
  aggPreSaleCount?: number
  /** 本期定金预售商品数 */
  aggPreSaleCountMtmRatio?: number
  /** 定金预售商品数占比 */
  aggPreSaleCountPercent?: number
  /** 本期定金预售销量 */
  aggPreSaleVolume?: number
  /** 本期定金预售销量环比 */
  aggPreSaleVolumeMtmRatio?: number
  /** 定金预售销量占比 */
  aggPreSaleVolumePercent?: number
  /** 本期销售额 */
  aggSaleAmount?: number
  /** 本期销量 */
  aggSaleVolume?: number
  /** 销售额占比 */
  amountPercent?: number
  /** 应用标签 */
  applyTags?: string[]
  /** 货号 */
  articleNo?: string
  /** 关联面料列表 */
  associatedFabrics?: AssociatedFabric[]
  /** 差评数 */
  badCommentCount?: number
  /** 差评率 */
  badRate?: number
  /** 品牌名称 */
  brand?: string
  /** 回收时间, 最近下架时间 */
  cancelTime?: string
  /** 详细类目 */
  categoryDetail?: string
  /** 二级类目id */
  categoryId?: number
  /** 二级类目名称 */
  categoryName?: string
  /** 面料 */
  cloth?: string
  /** 折叠数量 */
  collapseDocCount?: number
  /** 总收藏量 */
  collect?: number
  /** 近30天收藏 */
  collect30day?: number
  /** 收藏量环比 */
  collectionMtmRatio?: number
  /** 颜色 */
  colors?: string
  /** 总评论数 */
  commentCount?: number
  /** 评论最多sku */
  commentTopOne?: string
  /** 对比清单标志 */
  contrastFlag?: boolean
  /** 预估到手价（券后价） */
  couponCprice?: number
  cprice?: number
  /** 是否降级， 1-非降级，0--降级 */
  crawlImportantStatus?: number
  /** 日销峰值日期 */
  dailyTopSaleDate?: string
  /** 日销峰值 */
  dailyTopSaleVolume?: number
  /** 发货地 */
  delivery?: string
  /** 参加抖音标识 1-参与 */
  dyStatus?: number
  /** 材质组合 */
  fabric?: string
  /** 上新14天销量 */
  first14daySalesVolume?: number
  /** 上新3天销售额 */
  first3daySale?: number
  /** 上新3天销量 */
  first3daySalesVolume?: number
  /** 首天收藏量 */
  firstDayCollect?: number
  /** 首天销售额 */
  firstDaySale?: number
  /** 首天销量 */
  firstDaySalesVolume?: number
  /** 上新首日sku */
  firstDaySkuNum?: number
  /** 上新首日库存量 */
  firstDayStock?: number
  /** 爬取时间 */
  firstInsertTime?: string
  /** 首月销售额 */
  firstMonthSale?: number
  /** 首月销量 */
  firstMonthSalesVolume?: number
  /** 首次上新当天 价格 */
  firstSaletimePrice?: number
  /** 首周销售额 */
  firstWeekSale?: number
  /** 首周销量 */
  firstWeekSalesVolume?: number
  /** 全款预售状态 */
  fullAdvanceSale?: number
  /** 性别 */
  gender?: string
  /** 分组列表 */
  groupList?: string[]
  /** 参考身高 */
  height?: string
  /** 历史高价左区间 */
  historyMaxLeftCprice?: number
  /** 历史最低价时间 */
  historyMinCpriceDate?: string
  /** 历史低价左区间 */
  historyMinLeftCprice?: number
  /** 历史低价右区间 */
  historyMinRightCprice?: number
  /** 本期热度 */
  hot?: number
  /** 监控状态(用户） */
  isMonitored?: number
  /** 商品id */
  itemId?: number
  /** 尺寸 */
  itemSizes?: string[]
  /** 参加聚划算标识 1-参与 */
  jhsStatus?: number
  /** 环比上期的新品预售收藏数 */
  lastPreRangeItemCollectSum?: number
  /** 环比上期的新品预售商品数 */
  lastPreRangeItemCountMetric?: number
  /** 同比上期的新品预售收藏数 */
  lastYearPreRangeItemCollectSum?: number
  /** 同比上期的新品预售商品数 */
  lastYearPreRangeItemCountMetric?: number
  /** 参加直播标识 1-参与 */
  liveStatus?: number
  /** 面料材质 */
  material?: string[]
  /** 材质成分 */
  materialComposition?: string
  /** 最大促销价 */
  maxCPrice?: number
  /** 最大划线价 */
  maxSPrice?: number
  /** 最小价格 */
  minPrice?: string
  /** 最近上架时间 */
  nearlySaleTime?: string
  /** 本期上新数 */
  newItemCount?: number
  /** 上期上新数 */
  newItemCountLast?: number
  /** 去年同期上新数 */
  newItemCountLastYear?: number
  /** 本期上新数环比 */
  newItemCountMtmRatio?: number
  /** 本期上新数同比 */
  newItemCountYtyRatio?: number
  /** 上新占比 */
  newItemPercent?: number
  /** 最近一次定金预售活动 总销售额 */
  orderedItemAmount?: number
  /** 预售预定销量 */
  orderedItemVolume?: number
  /** 原属性 */
  originProperties?: object
  /** 时间范围内 最后价格 */
  periodLatestPrice?: number
  /** 时间范围内 最后库存数 */
  periodLatestStock?: number
  /** 时间范围内 最大价格 */
  periodMaxPrice?: number
  /** 时间范围内 最小成交价格 */
  periodMinCouponPrice?: number
  /** 时间范围内 最小价格 */
  periodMinPrice?: number
  /** 图片 */
  picUrl?: string
  /** 滚动图列表 */
  picUrlList?: string[]
  /** 预热天数 */
  preHeatDay?: number
  /** 本期新品预售收藏数 */
  preRangeItemCollectSum?: number
  /** 本期新品预售收藏数环比 */
  preRangeItemCollectSumMtmRatio?: number
  /** 新品预售收藏数占比 */
  preRangeItemCollectSumPercent?: number
  /** 本期新品预售商品数 */
  preRangeItemCountMetric?: number
  /** 本期新品预售商品数环比 */
  preRangeItemCountMetricMtmRatio?: number
  /** 新品预售商品数占比 */
  preRangeItemCountMetricPercent?: number
  /** 本期新品预售商品数趋势图 */
  preRangeItemCountTrendMetric?: number[]
  /** 预售结束时间 */
  preSaleEndTime?: string
  /** 预售状态 */
  preSaleFlag?: boolean
  /** 预售价格 */
  preSalePrice?: number
  /** 预售等级 */
  preSalePromotion?: string
  /** 预售开始时间 */
  preSaleStartTime?: string
  /** 预售状态 */
  preSaleStatus?: number
  /** 属性 */
  properties?: string[]
  /** 属性名 */
  propertyName?: string
  /** 属性值 */
  propertyValue?: string
  /** 排行名次 */
  rank?: string
  /** 排行名称 */
  rankName?: string
  /** 推荐人数 */
  recommendCount?: number
  /** 推荐度 */
  recommendScore?: number
  /** 是否已收录 1-已收录 0-未收录 */
  recordStatus?: number
  /** 昨日补货sku数 */
  restockSkuNum?: number
  /** 一级类目id */
  rootCategoryId?: number
  /** 一级类目名称 */
  rootCategoryName?: string
  /** 最近30天退货后销量 */
  sale30DayAfterReturns?: number
  /** 最近30天销量 */
  sale30day?: number
  /** 近30天销量计算时间 (数据更新时间)  */
  sale30dayInsertTime?: string
  /** 最近7天销量 */
  sale7day?: number
  /** 月销售额 */
  saleAmount30day?: number
  /** 销售转化率 */
  saleCollectRate?: number
  /** 上新时间 */
  saleTime?: string
  /** 上新14天收藏 */
  saleTime14dayCollect?: number
  /** 上新30天收藏 */
  saleTime30dayCollect?: number
  /** 上新3天收藏量 */
  saleTime3dayCollect?: number
  /** 上新7天收藏 */
  saleTime7dayCollect?: number
  /** 本期销量占比 */
  saleVolumeRate?: number
  /** 环比销售额 */
  salesAmountMtmRatio?: number
  /** 同比销售额 */
  salesAmountYtyRatio?: number
  /** 环比销量 */
  salesVolumeMtmRatio?: number
  /** 同比销量 */
  salesVolumeYtyRatio?: number
  /** 销售渠道 */
  sellPlatform?: string
  /** 店铺掌柜名 */
  sellerName?: string
  /** 上架状态 */
  shelves?: number
  /** 店铺等级 */
  shopGrade?: number
  /** 店铺id */
  shopId?: number
  /** 店铺标签 */
  shopLabel?: string
  /** 店铺logo */
  shopLogo?: string
  /** 店铺logo */
  shopLogoUrl?: string
  /** 店铺名称 */
  shopName?: string
  /** 店铺风格 */
  shopStyle?: string
  /** 店铺总销售额 */
  shopTotalItemCount?: number
  /** 店铺种类（0-淘宝，1-天猫） */
  shopType?: number
  sortValues?: object[]
  sprice?: number
  /** 开卖首日销售额 */
  startSellAmount?: number
  /** 开卖日期 */
  startSellDate?: string
  /** 开卖首日SKU数 */
  startSellSkuNum?: number
  /** 开卖当日库存 */
  startSellStock?: number
  /** 开卖当天销量 */
  startSellVolume?: number
  /** 库存 */
  stock?: number
  /** 款号 */
  styleNo?: string
  teamMonitorInfo?: MonitorInfo
  /** 商品标题 */
  title?: string
  /** 总销售额 */
  totalSaleAmount?: number
  /** 总销量 */
  totalSaleVolume?: number
  /** 上架次数 */
  totalShelvesCount?: number
  /** 本期收藏量趋势 */
  trendCollection?: number[]
  /** 本期定金预售商品数趋势图 */
  trendPreSaleCount?: number[]
  /** 本期定金预售销量趋势图 */
  trendPreSaleVolume?: number[]
  /** 本期销售额趋势 */
  trendSaleAmountList?: TrendNode[]
  /** 本期销量趋势 */
  trendSaleVolumeList?: TrendNode[]
  /** 滞销天数 */
  unsalableDayNum?: number
  /** 视频 */
  videoUrl?: string
  /** 销量占比 */
  volumePercent?: number
  /** withdraw_time */
  withdrawTime?: string
  /** 季度标签 */
  yearSeason?: string
  /** 昨日销量 */
  yesSalesVolume?: number
  /** 昨日在售 */
  yesterdaySale?: number
  /** 上期昨日在售 */
  yesterdaySaleLast?: number
  /** 去年同期昨日在售 */
  yesterdaySaleLastYear?: number
  /** 昨日在售环比 */
  yesterdaySaleMtmRatio?: number
  /** 昨日在售同比 */
  yesterdaySaleYtyRatio?: number
}

/**
 * MonitorInfo接口类型
 */
export interface MonitorInfo {
  monitorTime?: string
  userId?: number
  username?: string
}

/**
 * ApiResult_PaginationResult_MonitorItem接口类型
 */
export interface ApiResult_PaginationResult_MonitorItem {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_MonitorItem
  success?: boolean
}

/**
 * PaginationResult_MonitorItem接口类型
 */
export interface PaginationResult_MonitorItem {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: MonitorItem[]
  start?: number
  totalPageCount?: number
}

/**
 * MonitorItemRequest接口类型
 */
export interface MonitorItemRequest {
  /** 参与活动类型 1- 淘宝直播 2-聚划算 */
  activityType?: number
  /** 新的适用年龄，只限女装、男装 */
  ageLevelList?: string[]
  /** 关联面料过滤 */
  associatedFabricFilter?: number
  /** 只看低于常卖价商品 */
  belowUsualCprice?: number
  /** 品牌匹配 */
  brandList?: string[]
  /** 品类折叠 1 */
  categoryCollapse?: number
  /** 二级类目匹配(单个) */
  categoryId?: number
  /** 二级类目匹配数组（多选） */
  categoryIdList?: number[]
  /** 发货地省份匹配，传入该参数将覆盖deliveryLocationList */
  city?: string
  /** 经典标志位 */
  classicFilter?: number
  /** 面料 */
  cloth?: string
  /** 折叠字段 */
  collapseFields?: string
  /** 折叠展开 1 */
  collapseUnfold?: number
  /** 是否有搭配商品，选中则传'collocation_item' */
  collocationTag?: string
  /** 颜色匹配 */
  colors?: string[]
  commentNumFilterFlag?: number
  crawlImportantStatus?: number
  /** 发货地匹配 */
  deliveryLocationList?: string[]
  /** 连衣裙市场热卖 销量过滤, 1-过滤 */
  dressMarketHotFilter?: number
  /** 抖音热销标志位 1-是抖音热销 非抖音热销传0 */
  dyFlag?: number
  /** 本期的结束时间，只有用到本期字段才需要传入 */
  endDate: string
  /** 是否隐藏用户采集的商品：0-不限 1-隐藏，默认不隐藏 */
  excludeCollectedItemFlag?: number
  /** 是否隐藏用户监控的商品：0-不限 1-隐藏，默认不隐藏 */
  excludeMonitoredItemFlag?: number
  /** 是否隐藏用户监控的店铺：0-不限 1-隐藏，默认不隐藏 */
  excludeMonitoredShopFlag?: number
  /** 不看正在预售类型：1-新品预热，2-定金预售，3-全款预售 */
  excludePreSaleTypes?: number[]
  /** 隐藏用户今日浏览的商品 1-隐藏，默认-不隐藏 */
  excludeViewedItemFlag?: number
  /** 过滤本商品ID */
  excludedItemId?: number
  excludedRankListBlackFilterFlag?: number
  /** 商品库导出类型 1 全部， 2-热销， 3 -品牌热销， 4-首发热销  */
  exportType?: number
  extraFilterTerms?: object
  /** 材质组合 */
  fabric?: string
  /** 面料标志 */
  fabricFlag?: number
  /** 商品特征标签：持续热卖、持续滞销、新品持续热卖、新品持续滞销 */
  featureTag?: string
  /** 上新14天收藏量最大匹配 */
  first14dayMaxCollect?: number
  /** 上新14天销量最大匹配 */
  first14dayMaxVolume?: number
  /** 上新14天收藏量最小匹配 */
  first14dayMinCollect?: number
  /** 上新14天销量最小匹配 */
  first14dayMinVolume?: number
  /** 上新3天收藏量最大匹配 */
  first3dayMaxCollect?: number
  /** 上新3天销量最大匹配 */
  first3dayMaxVolume?: number
  /** 上新3天收藏量最小匹配 */
  first3dayMinCollect?: number
  /** 上新3天销量最小匹配 */
  first3dayMinVolume?: number
  /** 上新首日收藏量最大匹配 */
  firstDayMaxCollect?: number
  /** 上新首日销量最大匹配 */
  firstDayMaxVolume?: number
  /** 上新首日收藏量最小匹配 */
  firstDayMinCollect?: number
  /** 上新首日销量最小匹配 */
  firstDayMinVolume?: number
  /** 首发热销初筛过滤字段 商品库-首发热销传 1 */
  firstDayVolumeSortFilter?: number
  /** 上新30天收藏量最大匹配 */
  firstMonthMaxCollect?: number
  /** 上新30天销量最大匹配 */
  firstMonthMaxVolume?: number
  /** 上新30天收藏量最小匹配 */
  firstMonthMinCollect?: number
  /** 上新30天销量最小匹配 */
  firstMonthMinVolume?: number
  /** 上新7天收藏量最大匹配 */
  firstWeekMaxCollect?: number
  /** 上新7天销量最大匹配 */
  firstWeekMaxVolume?: number
  /** 上新7天收藏量最小匹配 */
  firstWeekMinCollect?: number
  /** 上新7天销量最小匹配 */
  firstWeekMinVolume?: number
  /** 适用性别 */
  genders?: string
  groupIdList?: string[]
  /** 高库存新品 选中传1 */
  highSkuNewFlag?: number
  /** 是否行业洞察范围 */
  hydcFlag?: number
  /** 智能搜索-文字 */
  imgSearchText?: string
  /** 智能搜索-图片 */
  imgSearchUrl?: string
  /** 标记是否导出 0-非导出 1-导出 */
  isExport?: number
  /** 参与过聚划算标记 选中传1， 非聚划算传0 */
  isJhsItem?: number
  /** 参与过直播商品标记 选中传1， 非直播传0 */
  isLiveItem?: number
  /** 商场标记: 商场同款:1, 线上专供:2 */
  isMallItem?: number
  /** 非参与过聚划算标记 选中传1 */
  isNotJhsItem?: number
  /** 非参与过直播商品标记 选中传1 */
  isNotLiveItem?: number
  /** 非商场同款标记 选中传1 */
  isNotMallItem?: number
  /** 高售罄商品 选中传1 */
  isOutStockItem?: number
  /** 商品ID匹配 */
  itemIdList?: number[]
  /** 商品名匹配 */
  itemLikeName?: string
  /** 商品名过滤 */
  itemNameFilters?: string[]
  /** 上一页最后一个itemId */
  lastItemId?: number
  /** 上期收藏最大匹配 */
  lastPeriodMaxCollect?: number
  /** 上期销量最大匹配 */
  lastPeriodMaxSalesVolume?: number
  /** 上期收藏最小匹配 */
  lastPeriodMinCollect?: number
  /** 上期销量最小匹配 */
  lastPeriodMinSalesVolume?: number
  /** 粗排限制 */
  limit: number
  /** 面料材质 */
  material?: string
  /** 面料材质百分比-结束 */
  materialPercentEnd?: number
  /** 面料材质百分比-开始 */
  materialPercentStart?: number
  /** 最大加购数 */
  maxAddPurchaseNum?: number
  /** 总收藏最大匹配 */
  maxCollect?: number
  /** 总评论数最大匹配 */
  maxComment?: number
  /** 预估到手价(券后价)最大匹配 */
  maxCouponCprice?: number
  /** 第一天售卖最高价格 (元) */
  maxFirstSaleTimePrice?: number
  /** 历史最低价最大匹配 */
  maxHistoryMinLeftCprice?: number
  /** 新品预售结束 不包含 */
  maxNewPresaleTime?: string
  /** 本期平均到手价最大匹配（单位：元） */
  maxPeriodAvgCouponCPrice?: number
  /** 促销价最大匹配（单位：元） */
  maxPrice?: number
  /** 销售转化率区间max */
  maxSaleCollectRate?: number
  /** 总销量最大匹配 */
  maxVolume?: number
  /** 最小加购数 */
  minAddPurchaseNum?: number
  /** 总收藏最小匹配 */
  minCollect?: number
  /** 总评论数最小匹配 */
  minComment?: number
  /** 预估到手价(券后价)最小匹配 */
  minCouponCprice?: number
  /** 第一天售卖最低价格 (元) */
  minFirstSaleTimePrice?: number
  /** 历史最低价最小匹配 */
  minHistoryMinLeftCprice?: number
  /** 新品预售开始 包含 */
  minNewPresaleTime?: string
  /** 本期平均到手价最小匹配（单位：元） */
  minPeriodAvgCouponCPrice?: number
  /** 促销价最小匹配（单位：元） */
  minPrice?: number
  /** 销售转化率区间min */
  minSaleCollectRate?: number
  /** 总销量最小匹配 */
  minVolume?: number
  /** 竞店新品 首日热卖过滤 */
  monitorFirstDayHotFilter?: number
  /** 30日销量最大匹配 */
  monthMaxVolume?: number
  /** 30日销量最小匹配 */
  monthMinVolume?: number
  /** 最新上架时间结束 */
  nearlySaleEndDate?: string
  /** 最新上架时间开始 */
  nearlySaleStartDate?: string
  /** 新品标记 选中传1 */
  newFlag?: number
  /** 当季新品过滤 1-当季新品 */
  newItemFilter?: number
  /** 降级传1 */
  notCrawlImportantStatus?: number
  /** 非首次上架 筛选-商品库新品模块 0-非首次 */
  onlyFirstNewFlag?: number
  /** 活动名 */
  originActivityName?: string
  /** 活动名数组 */
  originActivityNameList?: string[]
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 本期收藏最大匹配 */
  periodMaxCollect?: number
  /** 本期销量最大匹配 */
  periodMaxSalesVolume?: number
  /** 本期收藏最小匹配 */
  periodMinCollect?: number
  /** 本期销量最小匹配 */
  periodMinSalesVolume?: number
  /** 本期销量过滤 */
  periodVolumeFilter?: number
  /** 投放状态 0:未投放；1: 投放中 */
  promotedFabricFilter?: number
  /** 属性匹配 */
  propertyList?: ItemPropertyRequest[]
  /** 属性匹配 字符串 逗号分割 k:v,k:v  */
  propertyString?: string
  /** 发货地省份匹配，传入该参数将覆盖deliveryLocationList */
  province?: string
  /** 搜索标题 */
  queryTitle?: string
  /** 商品标题仅模糊搜索，多个 */
  queryTitleList?: string[]
  /** 店铺等级（ 一红心 11 ,二红心 12 ,三红心 13 ,四红心 14 ,五红心 15 ,六红心 16 ,一钻石 21 ,二钻石 22 ,三钻石 23 ,四钻石 24 ,五钻石 25 ,六钻石 26 ,一皇冠 31 ,二皇冠 32 ,三皇冠 33 ,四皇冠 34 ,五皇冠 35 ,六皇冠 36 ,一金冠 41 ,二金冠 42 ,三金冠 43 ,四金冠 44 ,五金冠 45 ，六金冠 46 ） */
  rankTypeList?: number
  /** 店铺等级（多选） */
  rankTypes?: number[]
  /** 一级类目匹配 */
  rootCategoryId?: number
  /** 一级类目匹配数组（多选） */
  rootCategoryIdList?: number[]
  /** 上架时间-结束 */
  saleEndDate?: string
  /** 上架时间-开始 */
  saleStartDate?: string
  /** 销售状态匹配（2- 在售， 3- 已下架） */
  saleTypeStatus?: number
  /** 上下架当日收藏右区间 */
  shelfMaxCollect?: number
  /** 上下架当日销量右区间 */
  shelfMaxVolume?: number
  /** 上下架当日收藏左区间 */
  shelfMinCollect?: number
  /** 上下架当日销量左区间 */
  shelfMinVolume?: number
  /** 上下架类型 1- 上架 2-非首次上架，3-下架 */
  shelfType?: number
  /** 店铺id */
  shopId?: number
  /** 店铺ID匹配 */
  shopIdList?: number[]
  /** shopLabel匹配 */
  shopLabelList?: string[]
  /** 店铺名过滤 */
  shopNameFilters?: string[]
  /** shopStyle匹配 */
  shopStyleList?: string[]
  /** shopType匹配（淘宝天猫标记） */
  shopType?: number
  /** 小众店铺过滤 选中传1 */
  smallShopFilter?: number
  /** 排序字段 */
  sortField: string
  /** 排序方式 */
  sortType: string
  sourceChannel?: string
  /** 清仓/福袋商品, 1-只看, 0-不看， null-不限 */
  specialItem?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 本期的开始时间，只有用到本期字段才需要传入 */
  startDate: string
  /** 是否年度宝藏店铺top240店铺, 1-是 */
  treasureShopFlag?: number
  /** 用户屏蔽店铺商品过滤 1-过滤 */
  userBlacklistFilterFlag?: number
  /** 商品是否有视频：true-只看有视频，false-只看无视频，null-不限 */
  videoUrlFlag?: number
  /** 是否白底图 1-只看白底图 0-不看白底图 */
  whiteBgFlag?: number
  /** 智能过滤 选中传1 */
  wiseFilterFlag?: number
  /** 下架时间筛选 max */
  withdrawTimeEnd?: string
  /** 下架时间筛选 min */
  withdrawTimeStart?: string
  /** 年份季节筛选 */
  yearSeason?: string
  /** 年份季节数组（多选） */
  yearSeasonList?: string[]
}

/**
 * MonitorShopItemRequest接口类型
 */
export interface MonitorShopItemRequest {
  /** 参与活动类型 1- 淘宝直播 2-聚划算 */
  activityType?: number
  /** 新的适用年龄，只限女装、男装 */
  ageLevelList?: string[]
  /** 关联面料过滤 */
  associatedFabricFilter?: number
  /** 只看低于常卖价商品 */
  belowUsualCprice?: number
  /** 品牌匹配 */
  brandList?: string[]
  /** 品类折叠 1 */
  categoryCollapse?: number
  /** 二级类目匹配(单个) */
  categoryId?: number
  /** 二级类目匹配数组（多选） */
  categoryIdList?: number[]
  /** 发货地省份匹配，传入该参数将覆盖deliveryLocationList */
  city?: string
  /** 经典标志位 */
  classicFilter?: number
  /** 面料 */
  cloth?: string
  /** 折叠字段 */
  collapseFields?: string
  /** 折叠展开 1 */
  collapseUnfold?: number
  /** 是否有搭配商品，选中则传'collocation_item' */
  collocationTag?: string
  /** 颜色匹配 */
  colors?: string[]
  commentNumFilterFlag?: number
  crawlImportantStatus?: number
  /** 发货地匹配 */
  deliveryLocationList?: string[]
  /** 连衣裙市场热卖 销量过滤, 1-过滤 */
  dressMarketHotFilter?: number
  /** 抖音热销标志位 1-是抖音热销 非抖音热销传0 */
  dyFlag?: number
  /** 本期的结束时间，只有用到本期字段才需要传入 */
  endDate: string
  /** 是否隐藏用户采集的商品：0-不限 1-隐藏，默认不隐藏 */
  excludeCollectedItemFlag?: number
  /** 是否隐藏用户监控的商品：0-不限 1-隐藏，默认不隐藏 */
  excludeMonitoredItemFlag?: number
  /** 是否隐藏用户监控的店铺：0-不限 1-隐藏，默认不隐藏 */
  excludeMonitoredShopFlag?: number
  /** 不看正在预售类型：1-新品预热，2-定金预售，3-全款预售 */
  excludePreSaleTypes?: number[]
  /** 隐藏用户今日浏览的商品 1-隐藏，默认-不隐藏 */
  excludeViewedItemFlag?: number
  /** 过滤本商品ID */
  excludedItemId?: number
  excludedRankListBlackFilterFlag?: number
  /** 商品库导出类型 1 全部， 2-热销， 3 -品牌热销， 4-首发热销  */
  exportType?: number
  extraFilterTerms?: object
  /** 材质组合 */
  fabric?: string
  /** 面料标志 */
  fabricFlag?: number
  /** 商品特征标签：持续热卖、持续滞销、新品持续热卖、新品持续滞销 */
  featureTag?: string
  /** 上新14天收藏量最大匹配 */
  first14dayMaxCollect?: number
  /** 上新14天销量最大匹配 */
  first14dayMaxVolume?: number
  /** 上新14天收藏量最小匹配 */
  first14dayMinCollect?: number
  /** 上新14天销量最小匹配 */
  first14dayMinVolume?: number
  /** 上新3天收藏量最大匹配 */
  first3dayMaxCollect?: number
  /** 上新3天销量最大匹配 */
  first3dayMaxVolume?: number
  /** 上新3天收藏量最小匹配 */
  first3dayMinCollect?: number
  /** 上新3天销量最小匹配 */
  first3dayMinVolume?: number
  /** 上新首日收藏量最大匹配 */
  firstDayMaxCollect?: number
  /** 上新首日销量最大匹配 */
  firstDayMaxVolume?: number
  /** 上新首日收藏量最小匹配 */
  firstDayMinCollect?: number
  /** 上新首日销量最小匹配 */
  firstDayMinVolume?: number
  /** 首发热销初筛过滤字段 商品库-首发热销传 1 */
  firstDayVolumeSortFilter?: number
  /** 上新30天收藏量最大匹配 */
  firstMonthMaxCollect?: number
  /** 上新30天销量最大匹配 */
  firstMonthMaxVolume?: number
  /** 上新30天收藏量最小匹配 */
  firstMonthMinCollect?: number
  /** 上新30天销量最小匹配 */
  firstMonthMinVolume?: number
  /** 上新7天收藏量最大匹配 */
  firstWeekMaxCollect?: number
  /** 上新7天销量最大匹配 */
  firstWeekMaxVolume?: number
  /** 上新7天收藏量最小匹配 */
  firstWeekMinCollect?: number
  /** 上新7天销量最小匹配 */
  firstWeekMinVolume?: number
  /** 适用性别 */
  genders?: string
  /** 团队id匹配，如果传入该参数，将覆盖shopType和shopIdList */
  groupId?: string
  /** 团队id匹配，如果传入该参数，将覆盖shopType和shopIdList */
  groupIdList?: string[]
  /** 高库存新品 选中传1 */
  highSkuNewFlag?: number
  /** 是否行业洞察范围 */
  hydcFlag?: number
  /** 智能搜索-文字 */
  imgSearchText?: string
  /** 智能搜索-图片 */
  imgSearchUrl?: string
  /** 标记是否导出 0-非导出 1-导出 */
  isExport?: number
  /** 参与过聚划算标记 选中传1， 非聚划算传0 */
  isJhsItem?: number
  /** 参与过直播商品标记 选中传1， 非直播传0 */
  isLiveItem?: number
  /** 商场标记: 商场同款:1, 线上专供:2 */
  isMallItem?: number
  /** 非参与过聚划算标记 选中传1 */
  isNotJhsItem?: number
  /** 非参与过直播商品标记 选中传1 */
  isNotLiveItem?: number
  /** 非商场同款标记 选中传1 */
  isNotMallItem?: number
  /** 高售罄商品 选中传1 */
  isOutStockItem?: number
  /** 商品ID匹配 */
  itemIdList?: number[]
  /** 商品名匹配 */
  itemLikeName?: string
  /** 商品名过滤 */
  itemNameFilters?: string[]
  /** 上一页最后一个itemId */
  lastItemId?: number
  /** 上期收藏最大匹配 */
  lastPeriodMaxCollect?: number
  /** 上期销量最大匹配 */
  lastPeriodMaxSalesVolume?: number
  /** 上期收藏最小匹配 */
  lastPeriodMinCollect?: number
  /** 上期销量最小匹配 */
  lastPeriodMinSalesVolume?: number
  /** 粗排限制 */
  limit: number
  /** 面料材质 */
  material?: string
  /** 面料材质百分比-结束 */
  materialPercentEnd?: number
  /** 面料材质百分比-开始 */
  materialPercentStart?: number
  /** 最大加购数 */
  maxAddPurchaseNum?: number
  /** 总收藏最大匹配 */
  maxCollect?: number
  /** 总评论数最大匹配 */
  maxComment?: number
  /** 预估到手价(券后价)最大匹配 */
  maxCouponCprice?: number
  /** 第一天售卖最高价格 (元) */
  maxFirstSaleTimePrice?: number
  /** 历史最低价最大匹配 */
  maxHistoryMinLeftCprice?: number
  /** 新品预售结束 不包含 */
  maxNewPresaleTime?: string
  /** 本期平均到手价最大匹配（单位：元） */
  maxPeriodAvgCouponCPrice?: number
  /** 促销价最大匹配（单位：元） */
  maxPrice?: number
  /** 销售转化率区间max */
  maxSaleCollectRate?: number
  /** 总销量最大匹配 */
  maxVolume?: number
  /** 最小加购数 */
  minAddPurchaseNum?: number
  /** 总收藏最小匹配 */
  minCollect?: number
  /** 总评论数最小匹配 */
  minComment?: number
  /** 预估到手价(券后价)最小匹配 */
  minCouponCprice?: number
  /** 第一天售卖最低价格 (元) */
  minFirstSaleTimePrice?: number
  /** 历史最低价最小匹配 */
  minHistoryMinLeftCprice?: number
  /** 新品预售开始 包含 */
  minNewPresaleTime?: string
  /** 本期平均到手价最小匹配（单位：元） */
  minPeriodAvgCouponCPrice?: number
  /** 促销价最小匹配（单位：元） */
  minPrice?: number
  /** 销售转化率区间min */
  minSaleCollectRate?: number
  /** 总销量最小匹配 */
  minVolume?: number
  /** 竞店新品 首日热卖过滤 */
  monitorFirstDayHotFilter?: number
  /** 30日销量最大匹配 */
  monthMaxVolume?: number
  /** 30日销量最小匹配 */
  monthMinVolume?: number
  /** 最新上架时间结束 */
  nearlySaleEndDate?: string
  /** 最新上架时间开始 */
  nearlySaleStartDate?: string
  /** 新品标记 选中传1 */
  newFlag?: number
  /** 当季新品过滤 1-当季新品 */
  newItemFilter?: number
  /** 降级传1 */
  notCrawlImportantStatus?: number
  /** 非首次上架 筛选-商品库新品模块 0-非首次 */
  onlyFirstNewFlag?: number
  /** 活动名 */
  originActivityName?: string
  /** 活动名数组 */
  originActivityNameList?: string[]
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 本期收藏最大匹配 */
  periodMaxCollect?: number
  /** 本期销量最大匹配 */
  periodMaxSalesVolume?: number
  /** 本期收藏最小匹配 */
  periodMinCollect?: number
  /** 本期销量最小匹配 */
  periodMinSalesVolume?: number
  /** 本期销量过滤 */
  periodVolumeFilter?: number
  /** 投放状态 0:未投放；1: 投放中 */
  promotedFabricFilter?: number
  /** 属性匹配 */
  propertyList?: ItemPropertyRequest[]
  /** 属性匹配 字符串 逗号分割 k:v,k:v  */
  propertyString?: string
  /** 发货地省份匹配，传入该参数将覆盖deliveryLocationList */
  province?: string
  /** 是否查询时间范围内价格 */
  queryTimeRangePriceFlag?: boolean
  /** 是否查询时间范围内最后库存数 */
  queryTimeRangeStockFlag?: boolean
  /** 搜索标题 */
  queryTitle?: string
  /** 商品标题仅模糊搜索，多个 */
  queryTitleList?: string[]
  /** 店铺等级（ 一红心 11 ,二红心 12 ,三红心 13 ,四红心 14 ,五红心 15 ,六红心 16 ,一钻石 21 ,二钻石 22 ,三钻石 23 ,四钻石 24 ,五钻石 25 ,六钻石 26 ,一皇冠 31 ,二皇冠 32 ,三皇冠 33 ,四皇冠 34 ,五皇冠 35 ,六皇冠 36 ,一金冠 41 ,二金冠 42 ,三金冠 43 ,四金冠 44 ,五金冠 45 ，六金冠 46 ） */
  rankTypeList?: number
  /** 店铺等级（多选） */
  rankTypes?: number[]
  /** 一级类目匹配 */
  rootCategoryId?: number
  /** 一级类目匹配数组（多选） */
  rootCategoryIdList?: number[]
  /** 上架时间-结束 */
  saleEndDate?: string
  /** 上架时间-开始 */
  saleStartDate?: string
  /** 销售状态匹配（2- 在售， 3- 已下架） */
  saleTypeStatus?: number
  /** 上下架当日收藏右区间 */
  shelfMaxCollect?: number
  /** 上下架当日销量右区间 */
  shelfMaxVolume?: number
  /** 上下架当日收藏左区间 */
  shelfMinCollect?: number
  /** 上下架当日销量左区间 */
  shelfMinVolume?: number
  /** 上下架类型 1- 上架 2-非首次上架，3-下架 */
  shelfType?: number
  /** 店铺id */
  shopId?: number
  /** 店铺ID匹配 */
  shopIdList?: number[]
  /** shopLabel匹配 */
  shopLabelList?: string[]
  /** 店铺名过滤 */
  shopNameFilters?: string[]
  /** shopStyle匹配 */
  shopStyleList?: string[]
  /** shopType匹配（淘宝天猫标记） */
  shopType?: number
  /** 小众店铺过滤 选中传1 */
  smallShopFilter?: number
  /** 排序字段 */
  sortField: string
  /** 排序方式 */
  sortType: string
  sourceChannel?: string
  /** 清仓/福袋商品, 1-只看, 0-不看， null-不限 */
  specialItem?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 本期的开始时间，只有用到本期字段才需要传入 */
  startDate: string
  /** 店铺销量top筛选 */
  topItem?: number
  /** 是否年度宝藏店铺top240店铺, 1-是 */
  treasureShopFlag?: number
  /** 用户屏蔽店铺商品过滤 1-过滤 */
  userBlacklistFilterFlag?: number
  /** 商品是否有视频：true-只看有视频，false-只看无视频，null-不限 */
  videoUrlFlag?: number
  /** 是否白底图 1-只看白底图 0-不看白底图 */
  whiteBgFlag?: number
  /** 智能过滤 选中传1 */
  wiseFilterFlag?: number
  /** 下架时间筛选 max */
  withdrawTimeEnd?: string
  /** 下架时间筛选 min */
  withdrawTimeStart?: string
  /** 年份季节筛选 */
  yearSeason?: string
  /** 年份季节数组（多选） */
  yearSeasonList?: string[]
}

/**
 * Functionality接口类型
 */
export interface Functionality {
  /** 功能性(传字典id) */
  name?: string
  /** 备注（选择其他时传入） */
  remark?: string
}

/**
 * PaginationResult_MonitorShop接口类型
 */
export interface PaginationResult_MonitorShop {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: MonitorShop[]
  start?: number
  totalPageCount?: number
}

/**
 * 监控店铺信息
 */
export interface MonitorShop {
  /** 上期销售额 */
  aggLastSaleAmount?: number
  /** 上期销售额 */
  aggLastSaleVolume?: number
  /** 去年同期销售额 */
  aggLastYearSaleAmount?: number
  /** 去年同期销售额 */
  aggLastYearSaleVolume?: number
  /** 本期销售额 */
  aggSaleAmount?: number
  /** 本期销量 */
  aggSaleVolume?: number
  /** 取消监控时间 */
  cancelFollowTime?: string
  /** 近30天热卖面料 */
  clothTop3?: string[]
  /** 近30天热卖材质组合 */
  fabricTop3?: string[]
  /** 粉丝数 */
  fansCount?: string
  /** 粉丝数数值 */
  fansNumNoUnit?: number
  /** 店铺分组标签,最多3个 */
  groupList?: string[]
  /** 是否已监控 */
  isMonitored?: number
  /** 主营行业 */
  labelIndustry?: string[]
  /** 店铺类型 */
  labelType?: string[]
  /** 店铺主营行业 */
  mainIndustry?: string
  /** 近30天热卖面料材质 */
  materialTop3?: string[]
  /** 本期上新数 */
  newItemCount?: number
  /** 近30天上新 */
  newItemCount30day?: number
  /** 上期上新数 */
  newItemCountLast?: number
  /** 去年同期上新数 */
  newItemCountLastYear?: number
  /** 本期上新数环比 */
  newItemCountMtmRatio?: number
  /** 本期上新数同比 */
  newItemCountYtyRatio?: number
  /** 在售商品数 */
  onSaleItemCount?: number
  /** 店铺等级类型 */
  rankType?: number
  /** 近30天销售额 */
  saleAmount30day?: number
  /** 近30天销量 */
  saleVolume30day?: number
  /** 环比销售额 */
  salesAmountMtmRatio?: number
  /** 同比销售额 */
  salesAmountYtyRatio?: number
  /** 环比销量 */
  salesVolumeMtmRatio?: number
  /** 同比销量 */
  salesVolumeYtyRatio?: number
  /** 卖家名 */
  sellerName?: string
  /** 店铺id */
  shopId?: number
  /** 店铺logo */
  shopLogoUrl?: string
  /** 店铺名称 */
  shopName?: string
  /** 店铺风格 */
  shopStyle?: string[]
  /** 店铺总销售额 */
  shopTotalItemCount?: number
  /** 店铺类型 */
  shopType?: number
  /** 店铺地址 */
  shopUrl?: string
  teamMonitorInfo?: MonitorInfo
  /** 上新商品 */
  topNewItemList?: ItemInfo[]
  /** 店铺商品总销售额 */
  totalSaleAmount?: number
  /** 店铺商品总销量 */
  totalSaleVolume?: number
  /** 本期上新数趋势 */
  trendNewItemList?: TrendNode[]
  /** 本期销售额趋势 */
  trendSaleAmountList?: TrendNode[]
  /** 本期销量趋势 */
  trendSaleVolumeList?: TrendNode[]
}

/**
 * PaginationResultShop接口类型
 */
export interface PaginationResultShop {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: Shop[]
}

/**
 * 店铺信息
 */
export interface Shop {
  /** 上期销售额 */
  aggLastSaleAmount?: number
  /** 上期销售额 */
  aggLastSaleVolume?: number
  /** 去年同期销售额 */
  aggLastYearSaleAmount?: number
  /** 去年同期销售额 */
  aggLastYearSaleVolume?: number
  /** 本期销售额 */
  aggSaleAmount?: number
  /** 本期销量 */
  aggSaleVolume?: number
  /** 取消监控时间 */
  cancelFollowTime?: string
  /** 近30天热卖面料 */
  clothTop3?: string[]
  /** 近30天热卖材质组合 */
  fabricTop3?: string[]
  /** 粉丝数 */
  fansCount?: string
  /** 粉丝数数值 */
  fansNumNoUnit?: number
  /** 店铺分组标签,最多3个 */
  groupList?: string[]
  /** 是否已监控 */
  isMonitored?: number
  /** 主营行业 */
  labelIndustry?: string[]
  /** 店铺类型 */
  labelType?: string[]
  /** 店铺主营行业 */
  mainIndustry?: string
  /** 近30天热卖面料材质 */
  materialTop3?: string[]
  /** 本期上新数 */
  newItemCount?: number
  /** 近30天上新 */
  newItemCount30day?: number
  /** 上期上新数 */
  newItemCountLast?: number
  /** 去年同期上新数 */
  newItemCountLastYear?: number
  /** 本期上新数环比 */
  newItemCountMtmRatio?: number
  /** 本期上新数同比 */
  newItemCountYtyRatio?: number
  /** 在售商品数 */
  onSaleItemCount?: number
  /** 店铺等级类型 */
  rankType?: number
  /** 近30天销售额 */
  saleAmount30day?: number
  /** 近30天销量 */
  saleVolume30day?: number
  /** 环比销售额 */
  salesAmountMtmRatio?: number
  /** 同比销售额 */
  salesAmountYtyRatio?: number
  /** 环比销量 */
  salesVolumeMtmRatio?: number
  /** 同比销量 */
  salesVolumeYtyRatio?: number
  /** 卖家名 */
  sellerName?: string
  /** 店铺id */
  shopId?: number
  /** 店铺logo */
  shopLogoUrl?: string
  /** 店铺名称 */
  shopName?: string
  /** 店铺风格 */
  shopStyle?: string[]
  /** 店铺总销售额 */
  shopTotalItemCount?: number
  /** 店铺类型 */
  shopType?: number
  /** 店铺地址 */
  shopUrl?: string
  teamMonitorInfo?: MonitorInfo
  /** 上新商品 */
  topNewItemList?: ItemInfo[]
  /** 店铺商品总销售额 */
  totalSaleAmount?: number
  /** 店铺商品总销量 */
  totalSaleVolume?: number
  /** 本期上新数趋势 */
  trendNewItemList?: TrendNode[]
  /** 本期销售额趋势 */
  trendSaleAmountList?: TrendNode[]
  /** 本期销量趋势 */
  trendSaleVolumeList?: TrendNode[]
}

/**
 * 商品概要信息
 */
export interface ItemInfo {
  /** 商品id */
  itemId?: number
  /** 图片 */
  picUrl?: string
  /** 商品标题 */
  title?: string
}

/**
 * ApiResult_PaginationResult_MonitorShop接口类型
 */
export interface ApiResult_PaginationResult_MonitorShop {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_MonitorShop
  success?: boolean
}

/**
 * 店铺列表请求
 */
export interface ShopListRequest {
  /** 店铺均价 */
  averagePrice?: string
  /** 用户已监控过滤 */
  blockFollowedShop?: boolean
  /** 用户已看过滤 */
  blockViewedShop?: boolean
  /** 店铺所属行业 */
  business?: string
  /** 主营品类 */
  categoryId?: number
  /** 市 */
  city?: string
  /** 统计结束日期 */
  endDate?: string
  /** 排除店铺id */
  excludeShopIdList?: number[]
  /** 是否面料专区：0-不是，1-是 */
  fabricCubeFlag?: number
  /** 是否知衣合作客户: 0-不是，1-是 */
  isTeamwork?: number
  /** 主营商品风格 */
  itemProperty?: string
  /** 店铺类型 */
  labelType?: string
  /** 店铺类型 */
  labelTypeList?: string[]
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 粉丝数区间max */
  maxFansNum?: number
  /** 店铺商品均价-最大值（单位分） */
  maxItemAvgPrice?: number
  /** 本期销售额区间min */
  maxSaleAmount?: number
  /** 近30天销售额区间max */
  maxSaleAmount30Day?: number
  /** 本期销量区间max */
  maxSaleVolume?: number
  /** 粉丝数区间min */
  minFansNum?: number
  /** 店铺商品均价-最小值（单位分） */
  minItemAvgPrice?: number
  /** 本期销售额区间min */
  minSaleAmount?: number
  /** 近30天销售额区间min */
  minSaleAmount30Day?: number
  /** 本期销量区间min */
  minSaleVolume?: number
  needNewItems?: boolean
  needShopTopCategory?: boolean
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 省 */
  province?: string
  /** 店铺等级 */
  rankType?: number
  /** 主营行业 */
  rootCategoryId?: number
  /** 店铺id */
  shopIdList?: number[]
  /** 查询店铺名 */
  shopLikeName?: string
  /** 店铺名 */
  shopName?: string
  /** 店铺风格 */
  shopStyle?: string
  /** 店铺风格 */
  shopStyleList?: string[]
  /** 市场类型：0-淘宝，1-天猫 */
  shopType?: number
  /** 排序字段 aggSaleVolume aggSaleAmount newItemCount aggSaleVolumeRingRate monitorTime */
  sortField?: string
  /** 排序方式 */
  sortType?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 统计开始日期 */
  startDate?: string
  /** 热卖面料 */
  topCloth?: string
  topClothList?: string[]
  /** 热卖材质组合 */
  topFabric?: string
  /** 热卖面料材质 */
  topMaterial?: string
}

/**
 * MonitorShopRequest接口类型
 */
export interface MonitorShopRequest {
  /** 店铺均价 */
  averagePrice?: string
  /** 用户已监控过滤 */
  blockFollowedShop?: boolean
  /** 用户已看过滤 */
  blockViewedShop?: boolean
  /** 店铺所属行业 */
  business?: string
  /** 主营品类 */
  categoryId?: number
  /** 市 */
  city?: string
  /** 统计结束日期 */
  endDate?: string
  /** 排除店铺id */
  excludeShopIdList?: number[]
  /** 是否面料专区：0-不是，1-是 */
  fabricCubeFlag?: number
  /** 分组id */
  groupId?: string
  /** 分组列表 */
  groupIdList?: string[]
  /** 是否知衣合作客户: 0-不是，1-是 */
  isTeamwork?: number
  /** 主营商品风格 */
  itemProperty?: string
  /** 店铺类型 */
  labelType?: string
  /** 店铺类型 */
  labelTypeList?: string[]
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 粉丝数区间max */
  maxFansNum?: number
  /** 店铺商品均价-最大值（单位分） */
  maxItemAvgPrice?: number
  /** 本期销售额区间min */
  maxSaleAmount?: number
  /** 近30天销售额区间max */
  maxSaleAmount30Day?: number
  /** 本期销量区间max */
  maxSaleVolume?: number
  /** 粉丝数区间min */
  minFansNum?: number
  /** 店铺商品均价-最小值（单位分） */
  minItemAvgPrice?: number
  /** 本期销售额区间min */
  minSaleAmount?: number
  /** 近30天销售额区间min */
  minSaleAmount30Day?: number
  /** 本期销量区间min */
  minSaleVolume?: number
  needNewItems?: boolean
  needShopTopCategory?: boolean
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 省 */
  province?: string
  /** 店铺等级 */
  rankType?: number
  /** 主营行业 */
  rootCategoryId?: number
  /** 店铺id */
  shopIdList?: number[]
  /** 查询店铺名 */
  shopLikeName?: string
  /** 店铺名 */
  shopName?: string
  /** 店铺风格 */
  shopStyle?: string
  /** 店铺风格 */
  shopStyleList?: string[]
  /** 市场类型：0-淘宝，1-天猫 */
  shopType?: number
  /** 排序字段 aggSaleVolume aggSaleAmount newItemCount aggSaleVolumeRingRate monitorTime */
  sortField?: string
  /** 排序方式 */
  sortType?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 统计开始日期 */
  startDate?: string
  /** 热卖面料 */
  topCloth?: string
  topClothList?: string[]
  /** 热卖材质组合 */
  topFabric?: string
  /** 热卖面料材质 */
  topMaterial?: string
}

/**
 * ApiResultPaginationResultShop接口类型
 */
export interface ApiResultPaginationResultShop {
  result?: PaginationResultShop
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * TrendNode接口类型
 */
export interface TrendNode {
  /** 日期 */
  date?: string
  /** 值 */
  value?: number
}

/**
 * 用户店铺监控返回
 */
export interface UserGroupMonitorResponse {
  /** 监控列表 */
  monitorInfos?: GroupMonitor[]
}

/**
 * ApiResult_UserGroupMonitorResponse接口类型
 */
export interface ApiResult_UserGroupMonitorResponse {
  errorCode?: string
  errorDesc?: string
  result?: UserGroupMonitorResponse
  success?: boolean
}

/**
 * 监控信息
 */
export interface GroupMonitor {
  /** 是否在分组中 */
  inGroup?: number
  /** 监控id */
  monitorId?: string
  /** 监控名 */
  monitorName?: string
  /** 监控图片 */
  monitorPicUrl?: string
}

/**
 * MapString接口类型
 */
export interface MapString {
  key?: string
}

/**
 * Object接口类型
 */
export interface Object {
  
}

/**
 * key接口类型
 */
export interface key {
  
}

/**
 * MapListObject接口类型
 */
export interface MapListObject {
  key?: key[]
}

/**
 * PaginationResult_Shop接口类型
 */
export interface PaginationResult_Shop {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: Shop[]
  start?: number
  totalPageCount?: number
}

/**
 * PaginationResult_Item接口类型
 */
export interface PaginationResult_Item {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: Item[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_PaginationResult_Item接口类型
 */
export interface ApiResult_PaginationResult_Item {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_Item
  success?: boolean
}

/**
 * ApiResult_PaginationResult_Shop接口类型
 */
export interface ApiResult_PaginationResult_Shop {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_Shop
  success?: boolean
}

/**
 * ApiResult_List_Shop接口类型
 */
export interface ApiResult_List_Shop {
  errorCode?: string
  errorDesc?: string
  result?: Shop[]
  success?: boolean
}

/**
 * ApiResultFabricInfoCountResponse接口类型
 */
export interface ApiResultFabricInfoCountResponse {
  result?: FabricInfoCountResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResult_FabricShelfResponse接口类型
 */
export interface ApiResult_FabricShelfResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricShelfResponse
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricShelfReviewInfo接口类型
 */
export interface ApiResult_PaginationResult_FabricShelfReviewInfo {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricShelfReviewInfo
  success?: boolean
}

/**
 * PaginationResult_FabricShelfReviewInfo接口类型
 */
export interface PaginationResult_FabricShelfReviewInfo {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricShelfReviewInfo[]
  start?: number
  totalPageCount?: number
}

/**
 * FabricInfoCountResponse接口类型
 */
export interface FabricInfoCountResponse {
  /** 全部 */
  count?: number
  /** 草稿箱 */
  draftCount?: number
  /** 审核中 */
  inReviewCount?: number
  /** 已下架 */
  offShelfCount?: number
  /** 在售 */
  onSaleCount?: number
  /** 审核拒绝 */
  rejectedCount?: number
}

/**
 * 面料上下架审核信息
 */
export interface FabricShelfReviewInfo {
  /** 附加说明 */
  additionalNotes?: string
  /** 申请时间 */
  applyTime?: string
  /** 申请人id */
  applyUserId?: number
  /** 申请人姓名 */
  applyUserName?: string
  /** 申请人手机号 */
  applyUserPhone?: string
  /** 公司名称 */
  companyName?: string
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 面料审核id */
  fabricReviewId?: string
  /** 下架原因 1、用户主动下架 2、后台手动下架 3、用户到期 */
  offShelfReason?: string
  /** 操作人id */
  operatorId?: number
  /** 操作人姓名 */
  operatorName?: string
  /** 拒绝理由1:商品和商品/图片不关联; 2:面料信息不全; 3：面料信息违规; 4:其他 */
  rejectReason?: string
  /** 审核状态 0待审核； 1审核通过；2审核拒绝；3取消 */
  reviewStatus?: number
  /** 审核时间 */
  reviewTime?: string
  /** 审核人id */
  reviewerId?: number
  /** 审核人姓名 */
  reviewerName?: string
  /** 上下架状态  1审核驳回；2已下架；3在售；4审核中 */
  shelfStatus?: number
  /** 公司id */
  submitterTeamId?: number
  /** 更新时间 */
  updatedAt?: string
}

/**
 * 面料上下架返回
 */
export interface FabricShelfResponse {
  /** 面料id */
  fabricId?: string
  /** 面料审核id */
  fabricReviewId?: string
  /** 审核状态 */
  reviewStatus?: number
  /** 上下架状态 */
  shelfStatus?: number
}

/**
 * FabricShelfReviewRequest接口类型
 */
export interface FabricShelfReviewRequest {
  /** 附加说明 */
  additionalNotes?: string
  /** 面料id */
  fabricId?: string
  /** 面料id集合 */
  fabricIdList?: string[]
  /** 面料审核id */
  fabricReviewId?: string
  /** 下架原因 1、用户主动下架 2、后台手动下架 3、用户到期 4、取消上架申请 */
  offShelfReason?: string
  /** 拒绝原因 */
  rejectReasons?: number[]
  /** 布匹推广审核状态 1-通过 2-拒绝 */
  reviewStatus?: number
}

/**
 * ApiResultPaginationResultFabricMerchantDetailsResponse接口类型
 */
export interface ApiResultPaginationResultFabricMerchantDetailsResponse {
  result?: PaginationResultFabricMerchantDetailsResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料详情
 */
export interface FabricMerchantDetailsResponse {
  /** 品类 */
  category?: string
  /** 面料品类 */
  categoryName?: string
  collectInfo?: FabricCollectInfoResponse
  /** 商家logo */
  companyLogo?: string
  /** 面料细节图 */
  fabricDetailPic?: string
  /** 面料id */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 布匹关联商品/图片 */
  fabricProductAssociationList?: FabricAssociateInfo[]
  /** 运营后台面料标签 */
  fabricTags?: string[]
  /** 成衣展示图 */
  garmentDisplayPicList?: string[]
  /** 面料关联商品数 */
  itemNum?: number
  /** 面料关联商品销售量(近7天) */
  itemSaleVolumeWeekly?: number
  /** 面料图片 */
  mainUrl?: string
  /** 面料最大售价 */
  priceMax?: string
  /** 面料最小售价 */
  priceMin?: string
  /** 面料销售单位 */
  priceUnit?: string
  /** 上下架状态 1审核驳回；2已下架；3在售；4审核中 */
  shelfStatus?: number
  /** 店铺装修面料分类 */
  shopClassifyNames?: string[]
  /** 是否店铺推荐面料：0-不是，1-是 */
  shopRecommendStatus?: number
  /** 卖家来源 0-入驻商家 1-淘宝商家 ... 6-小红书商家 */
  sourceChannel?: number
  /** 面料主推色 */
  specificationPicList?: string[]
  /** 状态 1未推广；2审核中；3推广中；4已结束；5不通过 */
  status?: number
  /** 商家id */
  teamId?: number
  /** 商家名称 */
  teamName?: string
}

/**
 * PaginationResultFabricMerchantDetailsResponse接口类型
 */
export interface PaginationResultFabricMerchantDetailsResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricMerchantDetailsResponse[]
}

/**
 * GarmentDisplay接口类型
 */
export interface GarmentDisplay {
  /** 款式id */
  styleId?: string
  /** 图片url */
  garmentDisplayPic?: string
}

/**
 * ApiResultFabricSelectXhs接口类型
 */
export interface ApiResultFabricSelectXhs {
  result?: FabricSelectXhs
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * PaginationResultFabricSelect接口类型
 */
export interface PaginationResultFabricSelect {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricSelect[]
}

/**
 * 查询面料列表返回参数
 */
export interface FabricSelect {
  /** 面料id */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 面料品类 */
  fabric?: string
  /** 面料品类(完整路径) */
  fabricPath?: string
  /** 面料来源 */
  sourceChannel?: number
  /** 面料渠道来源 */
  fabricSourceChannel?: number
  /** 面料价格 */
  price?: string
  priceMin?: string
  priceMax?: string
  priceUnit?: string
  sourceTime?: string
  /** 面料图片 */
  mainUrl?: string
  /** 商家id */
  sellerId?: string
  /** 商家名称 */
  sellerName?: string
  /** 商家logo */
  sellerLogo?: string
  /** 成衣展示图 */
  garmentDisplayPicList?: string[]
  /** 面料细节图 */
  detailUrls?: string[]
  /** 面料主推色 */
  specificationPicList?: string[]
  /** 布匹关联商品/图片 */
  entityList?: FabricAssociateInfo[]
  /** 话题列表 */
  topicList?: string[]
  /** 上下架状态 1审核驳回；2已下架；3在售；4审核中 */
  shelfStatus?: number
  /** 面料关联商品数 */
  itemNum?: number
  /** 面料关联商品销售量(近7天) */
  itemSaleVolumeWeekly?: number
  /** 置顶推广信息 */
  topSettingInfo?: FabricSelectTopSettingResponse
  /** 店铺装修面料分类 */
  shopClassifyNames?: string[]
  /** 运营后台面料标签 */
  fabricTags?: string[]
  /** 加入面料清单信息 */
  collectInfo?: FabricCollectInfoResponse
}

/**
 * 查询面料列表请求参数
 */
export interface ListFabricSelectRequest {
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 面料类型id */
  fabricList?: number[]
  /** 面料类型名称(叶子节点) */
  fabricCategoryList?: string[]
  /** 适用品类名 */
  purposeList?: string[]
  /** 面料成分id */
  compositionList?: string[]
  /** 适用季节 */
  seasonList?: string[]
  /** 颜色 */
  colorList?: string[]
  /** 图案 */
  patternList?: string[]
  /** 最低价格 */
  minPrice?: number
  /** 最高价格 */
  maxPrice?: number
  /** 克重min */
  minGramWeight?: number
  /** 克重max */
  maxGramWeight?: number
  /** 商家 */
  sellerId?: string
  /** 关键词 */
  searchWord?: string
  /** 多个关键词，仅匹配店铺装修+运营标签 */
  searchTagList?: string[]
  /** 置顶推广面料过滤：0-无置顶，1-置顶 */
  fabricTopSettingFilter?: number
  /** 排序字段: new(最新上架),item_num(关联商品数),item_sales(关联商品周销量/热度),price(价格) */
  sortField?: string
  /** 排序方式 */
  sortType?: string
  /** 推广范围 1:不限 2:国内 3：跨境 （非置顶权限账号传空） */
  promotionType?: number
  /** 已浏览的过面料 0:看 1:不看 */
  isBrowse?: number
}

/**
 * ApiResultPaginationResultFabricSelect接口类型
 */
export interface ApiResultPaginationResultFabricSelect {
  result?: PaginationResultFabricSelect
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResultFabricSelectSeller接口类型
 */
export interface ApiResultFabricSelectSeller {
  result?: FabricSelectSeller
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 查询小红书布匹信息返回参数
 */
export interface FabricSelectXhs {
  /** 笔记收藏数 */
  collectNum?: number
  /** 颜色 */
  colorList?: string[]
  /** 笔记评论数 */
  commentNum?: number
  /** 面料成分 */
  compositionList?: string[]
  /** 小红书内容 */
  content?: string
  /** 创建时间 */
  createdAt?: string
  /** 小红书详情图片 */
  detailUrls?: string[]
  /** 布匹关联商品/图片 */
  entityList?: FabricAssociateInfo[]
  /** 面料 */
  fabric?: string
  /** 布匹id */
  fabricId?: string
  /** 面料(完整路径) */
  fabricPath?: string
  /** 笔记点赞数 */
  likeNum?: number
  /** 小红书图片 */
  mainUrl?: string
  /** 主图质量：high-高质量 low-低质量 */
  mainUrlQuality?: string
  /** 笔记类型：normal/video */
  noteType?: string
  /** 小红书笔记 */
  originId?: string
  /** 图案标签合并列表 */
  patternLabelMergeList?: string[]
  /** 适用品类 */
  purposeList?: string[]
  /** 适用季节 */
  seasonList?: string[]
  /** 小红书商家id */
  sellerId?: string
  /** 小红书商家行业主营 */
  sellerIndustry?: string
  /** 小红书商家简介 */
  sellerIntroduction?: string
  /** 小红书商家地区 */
  sellerLocation?: string
  /** 小红书商家logo */
  sellerLogo?: string
  /** 小红书商家名称 */
  sellerName?: string
  /** 来源时间(笔记发布时间) */
  sourceTime?: string
  /** 小红书标题 */
  title?: string
  /** 话题 */
  topicList?: string[]
  /** 小红书视频 */
  videoUrl?: string
}

/**
 * 查询布匹信息返回参数
 */
export interface FabricSelectSeller {
  /** 卖家来源 0-入驻商家 1-淘宝商家 ... 6-小红书商家 */
  sourceChannel?: number
  /** 卖家ID */
  sellerId?: string
  /** 卖家名称 */
  sellerName?: string
  /** 卖家logo */
  sellerLogo?: string
  /** 所在地 */
  location?: string
  /** 简介 */
  introduction?: string
  /** 行业 */
  industry?: string
  /** 联系人 */
  contactPerson?: string
  /** 联系电话 */
  contactPhone?: string
  /** 联系电话区域 */
  contactRegion?: string
  /** 注册时间 */
  registerTime?: string
  /** 状态 0=取消 1=正常 */
  status?: number
  /** 是否有面料 0=无 1=有 */
  hasFabric?: number
  /** 主图 */
  mainUrl?: string[]
  /** 置顶推广信息 */
  topSettingInfo?: FabricSelectTopSettingResponse
  /** 是否有操作权限 0无；1有 */
  isAuthorized?: number
  /** 面料详情 */
  fabricInfoList?: FabricInfo[]
}

/**
 * ApiResultPaginationResultRecommendCaseInfo接口类型
 */
export interface ApiResultPaginationResultRecommendCaseInfo {
  result?: PaginationResultRecommendCaseInfo
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 推荐案例信息
 */
export interface RecommendCaseInfo {
  /** 关联面料 */
  associatedFabrics?: AssociatedFabric[]
  /** 关联状态 0-未关联 1-已关联 */
  associationStatus?: number
  /** 商品/款式id */
  entityId?: string
  /** 商品/款式名称 */
  entityName?: string
  extraInfo?: IStyle
  /** 是否推广 */
  isPromoted?: number
  /** 商品/款式图片 */
  picUrl?: string
  /** 来源渠道 */
  sourceChannel?: number
}

/**
 * 面料案例-淘宝
 */
export interface SellerRecommendCaseRequest {
  /** 二级分类id */
  categoryIdList?: number[]
  /** 服装版型 */
  clothingTypeList?: string[]
  /** 面料 */
  fabricList?: string[]
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 价格 */
  maxPrice?: number
  /** 价格 */
  minPrice?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 图案 */
  patternList?: string[]
  /** 流行元素 */
  popularElementList?: string[]
  /** 一级分类id */
  rootCategoryIdList?: number[]
  /** 上架时间 */
  saleTimeEnd?: string
  /** 上架时间 */
  saleTimeStart?: string
  /** 搜索词 */
  searchWord?: string
  /** 面料商家id */
  sellerId?: string
  /** 店铺类型 */
  shopType?: number
  /** 排序字段 saleTime price monthSaleVolume */
  sortField?: string
  /** 排序方式 */
  sortType?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 风格 */
  styleList?: string[]
  /** 服装款式 */
  styleTypeList?: string[]
}

/**
 * PaginationResultRecommendCaseInfo接口类型
 */
export interface PaginationResultRecommendCaseInfo {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: RecommendCaseInfo[]
}

/**
 * ApiResultListRecommendCaseInfo接口类型
 */
export interface ApiResultListRecommendCaseInfo {
  result?: RecommendCaseInfo[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * FabricInfo接口类型
 */
export interface FabricInfo {
  /** 面料id */
  fabricId?: string
  /** 主图 */
  mainUrl?: string
}

/**
 * 推荐面料信息
 */
export interface FabricRecommendationResponse {
  /** 热门面料 */
  popularFabricsList?: FabricInfo[]
  /** 相关面料 */
  relatedFabricList?: FabricInfo[]
}

/**
 * ApiResultFabricRecommendationResponse接口类型
 */
export interface ApiResultFabricRecommendationResponse {
  result?: FabricRecommendationResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 查询面料咨询
 */
export interface FabricSellerInquiryRequest {
  /** 辅料id，辅料详情咨询时传入 */
  accessoryId?: string
  /** 商家id */
  sellerId?: string
  /** 提交渠道来源 */
  sourceChannel?: number
  /** 提交页面url */
  submitPageUrl?: string
}

/**
 * GoodsMetricInfoVO接口类型
 */
export interface GoodsMetricInfoVO {
  /** 总差评数 */
  badCommentTotal?: number
  /** 博主数量30天 */
  bloggerNum30day?: number
  /** 博主数量90天 */
  bloggerNum90day?: number
  /** 博主数量30天 */
  bloggerNumAmazon30day?: number
  /** 博主数量90天 */
  bloggerNumAmazon90day?: number
  /** 博主数量昨日 */
  bloggerNumAmazonYesterday?: number
  /** 博主数量30天 */
  bloggerNumLtk30day?: number
  /** 博主数量90天 */
  bloggerNumLtk90day?: number
  /** 博主数量昨日 */
  bloggerNumLtkYesterday?: number
  /** 博主数量昨日 */
  bloggerNumYesterday?: number
  /** 本期评论 */
  commentNum?: number
  /** 近30天评论 */
  commentNum30day?: number
  /** 近7天评论数 */
  commentNum7day?: number
  /** 近90天评论 */
  commentNum90day?: number
  /** 30天评论增速 */
  commentNumGrowth30day?: number
  /** 7天评论增速 */
  commentNumGrowth7day?: number
  /** 90天评论增速 */
  commentNumGrowth90day?: number
  commentNumYesterday?: number
  /** 留评率 */
  commentRetentionRate?: number
  /** 币种 */
  currency?: string
  /** 折扣率 */
  discount?: number
  /** 本期收藏数 */
  favedCount?: number
  /** 30天收藏数 */
  favedCount30day?: number
  /** 7天收藏数 */
  favedCount7day?: number
  /** 90天收藏数 */
  favedCount90day?: number
  /** 总收藏数 */
  favedCountTotal?: number
  /** 近30日最终折扣变化 */
  finalDiscountDiff30day?: number
  /** 近90日最终折扣变化 */
  finalDiscountDiff90day?: number
  /** 昨日最终折扣变化 */
  finalDiscountDiffYesterday?: number
  /** 近30日跟卖家数 */
  followSellerNum30day?: number
  /** 近90日跟卖卖家数 */
  followSellerNum90day?: number
  /** 昨日跟卖买家数 */
  followSellerNumYesterday?: number
  /** 近30日跟卖skc数 */
  followSkcNum30day?: number
  /** 近90日跟卖skc数 */
  followSkcNum90day?: number
  /** 昨日跟卖skc数 */
  followSkcNumYesterday?: number
  /** 近30日跟卖sku数 */
  followSkuNum30day?: number
  /** 近90日跟卖sku数 */
  followSkuNum90day?: number
  /** 昨日跟卖sku数 */
  followSkuNumYesterday?: number
  /** 近30日最终价格变化 */
  fpriceDiff30day?: number
  /** 近90日最终价格变化 */
  fpriceDiff90day?: number
  /** 昨日最终价格变化 */
  fpriceDiffYesterday?: number
  /** 首次库存变动日期 */
  fstStockChangeDate?: string
  /** 近30天热度值 */
  hotDegree30day?: number
  /** 本期大类排名变化 */
  mainCategoryDiff?: number
  /** 近30日大类排名变化 */
  mainCategoryDiff30day?: number
  /** 7日大类排名变化 */
  mainCategoryDiff7day?: number
  /** 近90日大类排名变化 */
  mainCategoryDiff90day?: number
  /** 昨日大类排名变化 */
  mainCategoryDiffYesterday?: number
  metricEndDate?: string
  metricStartDate?: string
  /** 最低价格 */
  minPrice?: number
  /** 最低价格时间 */
  minPriceDate?: string
  /** 昨日上新颜色数 */
  newInColorNumYesterday?: number
  /** 7日上新评论数 */
  newInCommentNum7day?: number
  /** 地区上新7日销售额 */
  newInSaleAmount7dayArea?: number
  /** 上新7日销量 */
  newInSaleVolume7day?: number
  /** 地区上新7日销量 */
  newInSaleVolume7dayArea?: number
  /** 近30天上新skc数量 */
  newInSkcNum30day?: number
  /** 近7天上新skc数量 */
  newInSkcNum7day?: number
  /** 近30天上新skc数量 */
  newInSkcNum90day?: number
  /** 昨日上新skc数量 */
  newInSkcNumYesterday?: number
  /** 近7天上新sku数量 */
  newInSkuNum30day?: number
  /** 近7天上新sku数量 */
  newInSkuNum7day?: number
  /** 近7天上新sku数量 */
  newInSkuNum90day?: number
  /** 近7天上新sku数量 */
  newInSkuNumYesterday?: number
  /** 上新7天库存变化次数 */
  newInStockChangeCount7day?: number
  /** 近30天上新库存 */
  newInStockNum30day?: number
  /** 近7天上新库存 */
  newInStockNum7day?: number
  /** 近90天上新库存 */
  newInStockNum90day?: number
  /** 昨日上新库存 */
  newInStockNumYesterday?: number
  /** 帖子数量30天 */
  postCount30day?: number
  /** 帖子数量90天 */
  postCount90day?: number
  /** 帖子数量30天 */
  postCountAmazon30day?: number
  /** 帖子数量90天 */
  postCountAmazon90day?: number
  /** 帖子数量昨日 */
  postCountAmazonYesterday?: number
  /** 帖子数量30天 */
  postCountLtk30day?: number
  /** 帖子数量90天 */
  postCountLtk90day?: number
  /** 帖子数量昨日 */
  postCountLtkYesterday?: number
  /** 带货帖子数 */
  postCountTotal?: number
  /** 帖子数量昨日 */
  postCountYesterday?: number
  /** 价格变动3/7/15/30日 */
  priceChangeDays?: number
  /** 评分数 */
  ratingNum?: number
  /** 本期销售额 */
  saleAmount?: number
  /** 近15天销售额 */
  saleAmount15day?: number
  /** 地区15日销售额 */
  saleAmount15dayArea?: number
  /** 近30天销售额 */
  saleAmount30day?: number
  /** 地区月销售额 */
  saleAmount30dayArea?: number
  /** 近7天销售额 */
  saleAmount7day?: number
  /** 地区7日销售额 */
  saleAmount7dayArea?: number
  /** 近90天销售额 */
  saleAmount90day?: number
  /** 30天销售额增速 */
  saleAmountGrowth30day?: number
  /** 7天销售额增速 */
  saleAmountGrowth7day?: number
  /** 90天销售额增速 */
  saleAmountGrowth90day?: number
  /** 总销售额 */
  saleAmountTotal?: number
  /** 地区总销售额 */
  saleAmountTotalArea?: number
  /** 昨日销售额 */
  saleAmountYesterday?: number
  /** 地区昨日销售额 */
  saleAmountYesterdayArea?: number
  /** 本期销量 */
  saleVolume?: number
  /** 近15天销量 */
  saleVolume15day?: number
  /** 地区月15日销量 */
  saleVolume15dayArea?: number
  /** 月销量 */
  saleVolume30day?: number
  /** 地区月销量 */
  saleVolume30dayArea?: number
  /** 30天地区销量环比 */
  saleVolume30dayAreaMom?: number
  /** 30天销量环比 */
  saleVolume30dayMom?: number
  /** 近7天销量 */
  saleVolume7day?: number
  /** 地区7日销量 */
  saleVolume7dayArea?: number
  /** 7天地区销量环比 */
  saleVolume7dayAreaMom?: number
  /** 7天销量环比 */
  saleVolume7dayMom?: number
  /** 近90天销量 */
  saleVolume90day?: number
  /** 30天销量增速 */
  saleVolumeGrowth30day?: number
  /** 7天销量增速 */
  saleVolumeGrowth7day?: number
  /** 90天销量增速 */
  saleVolumeGrowth90day?: number
  /** 本期销量环比 */
  saleVolumeRatio?: number
  /** 总销量 */
  saleVolumeTotal?: number
  /** 地区总销量 */
  saleVolumeTotalArea?: number
  /** 昨日销量 */
  saleVolumeYesterday?: number
  /** 地区昨日销量 */
  saleVolumeYesterdayArea?: number
  /** 近30日评分变化 */
  scoreDiff30day?: number
  /** 近90日评分变化 */
  scoreDiff90day?: number
  /** 昨日评分变化 */
  scoreDiffYesterday?: number
  /** 卖家数 */
  sellerNum?: number
  /** skc数量 */
  skcNum?: number
  /** sku数量 */
  skuNum?: number
  /** spu近30天销量 */
  spuSaleVolume30day?: number
  /** spu近7天销量 */
  spuSaleVolume7day?: number
  /** spu总销量 */
  spuSaleVolumeTotal?: number
  /** 近30天库存变化次数 */
  stockChangeCount30day?: number
  /** 近7天库存变化次数 */
  stockChangeCount7day?: number
  /** 昨日库存 */
  stockYesterday?: number
}

/**
 * PlatformInfoVO接口类型
 */
export interface PlatformInfoVO {
  /** 是否被个人监控 */
  boolMonitored?: boolean
  /** 是否在收录中 */
  boolRecording?: boolean
  /** 货币单位 */
  currency?: string
  /** 站点是否异常状态 NORMAL-正常 EXCEPTION-异常 */
  exceptionStatus?: string
  /** 粉丝数 */
  fansNum?: number
  /** 站点特色 */
  feature?: string[]
  /** 是否首次监控 */
  firstMonitored?: boolean
  /** 销量开始时间 */
  firstSaleDay?: string
  /** 分组ids */
  groupIds?: number[]
  /** id */
  id?: number
  /** 覆盖行业 */
  industry?: string[]
  /** 用户最近访问时间 */
  lastVisitTime?: string
  /** 分级 */
  level?: string
  /** 月内点赞数 */
  likeNum30Day?: number
  /** 是否有meta投放动态，1-有 */
  metaActivity?: number
  monitorTeamNum?: number
  /** 监控时间 */
  monitorTime?: string
  /** 月内上新数 */
  newInCount30Day?: number
  /** 昨日上新数 */
  newInCountYesterday?: number
  /** 昨日在售数 */
  onSaleYesterday?: number
  /** 站点简介 */
  platformBrief?: string
  /** 站点详情 */
  platformContent?: string
  /** 站点logo */
  platformLogo?: string
  /** 站点名 */
  platformName?: string
  /** 站点状态 */
  platformStatus?: string
  /** 站点编号 */
  platformType?: number
  /** 站点链接 */
  platformUrl?: string
  /** 站点是否支持推广特征 True-支持 False-不支持 */
  promotionFeatureFlag?: boolean
  /** 收录日期 */
  recordDate?: string
  /** 热销地区 */
  region?: string
  /** 站点地区 */
  regionId?: string
  /** 月内销量 */
  saleVolume30Day?: number
  /** 站点作用域:PUBLIC-共有站点，PRIVATE-我的站点 */
  scope?: string
  /** 风格 */
  style?: string[]
  /** 是否被团队监控 */
  teamMonitored?: boolean
  /** 是否被用户监控 */
  userMonitored?: boolean
}

/**
 * GoodsSellerPO接口类型
 */
export interface GoodsSellerPO {
  sellerArea?: string
  sellerCity?: string
  sellerCompanyAddress?: string
  sellerCompanyName?: string
  sellerName?: string
  sellerUrl?: string
}

/**
 * GoodsZoneListRequest接口类型
 */
export interface GoodsZoneListRequest {
  /** 艺术家筛选项 */
  artistList?: string[]
  /** 供应面料过滤 */
  associatedFabricFilter?: number
  /** 大码 */
  bodyType?: string[]
  /** 品牌 */
  brand?: string[]
  /** 类目id集合，输入统一，不管原站还是知衣类目，以站点和业务为准 */
  categoryIdList?: unknown[]
  /** 类目类型，origin/normal */
  categoryType?: string
  /** 色彩 */
  color?: string[]
  /** 颜色上架标识 */
  colorOnSaleStatus?: boolean
  /** 站点国家 */
  countryList?: string[]
  /** 价格货币单位: USD、AUD、GBP、EUR、AED、BRL、INR、JPY */
  currency?: string
  /** 设计要素行业 */
  designElementIndustry?: string
  /** 结束时间 */
  endDate?: string
  /** 排除的品牌 */
  excludeBrandList?: string[]
  /** 排除的平台列表 */
  excludePlatformTypeList?: number[]
  /** 站点特色 */
  feature?: string[]
  /** 过滤关键词 */
  filterText?: string
  /** 商品专区类型枚举 ALL-全部商品,NA_ZONE-北美专区,EU_ZONE-欧洲专区,PLUS_SIZE_ZONE-大码专区,SPORTS_ZONE-运动专区,UNDERWEAR_ZONE-内衣专区,SHORT_IN_SIZE_ZONE-断码专区 */
  goodsZoneType?: string
  /** 是否已采集 */
  hasCollected?: boolean
  /** 是否已浏览 */
  hasDetailViewed?: boolean
  /** 过滤下架商品 */
  hasOffShelves?: boolean
  /** true-只看纯色 */
  hasPlainType?: boolean
  /** 包含关键词 */
  includeText?: string
  /** 行业 */
  industry?: string
  /** 是否套装 */
  isSuit?: boolean
  /** 设计要素 */
  label?: unknown[]
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 最高评论数 */
  maxCommentNum?: number
  /** 近30天评论数最大值 */
  maxCommentNum30Day?: number
  /** 上新7日销量最大值 */
  maxNewInSaleVolume7Day?: number
  /** 最高月销量 */
  maxSaleVolume30Day?: number
  /** 总销量最大值 */
  maxSaleVolumeTotal?: number
  /** 最高评分 */
  maxScore?: number
  /** 最高售价 */
  maxSprice?: number
  /** 30天库存变化最大值 */
  maxStockChangeCount30Day?: number
  /** meta关联商品标识(或的关系)：ADVERTISEMENT_FLAG--参与过meta投放，POST_FLAG--参与过meta动态，SHOP_PRODUCT_FLAG--参与过公共主页 */
  metaFlagList?: string[]
  /** 最低评论数 */
  minCommentNum?: number
  /** 近30天评论数最小值 */
  minCommentNum30Day?: number
  /** 上新7日销量最小值 */
  minNewInSaleVolume7Day?: number
  /** 最低月销量 */
  minSaleVolume30Day?: number
  /** 总销量最小值 */
  minSaleVolumeTotal?: number
  /** 最低评分 */
  minScore?: number
  /** 最低售价 */
  minSprice?: number
  /** 30天库存变化最小值 */
  minStockChangeCount30Day?: number
  /** 是否复色 */
  multiColor?: boolean
  /** 排除查询的平台列表 */
  neqRelatedPlatform?: number[]
  /** 只看新色勾选 */
  newColor?: boolean
  /** 是否首次上架 0-否 1-是 */
  onSaleFlag?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 单站点筛选 */
  platformType?: number
  /** 平台列表 */
  platformTypeList?: number[]
  /** 近30天价格变动类型:0-只看无变化,1-只看涨价过,2-只看降价过,3-只看还有变化 */
  priceChangeType?: number
  /** 投放状态 0:未投放；1: 投放中 */
  promotedFabricFilter?: number
  /** 肤色，黄种人-1,黑人-2,白人-3,中东-4,印度-5 */
  raceType?: string[]
  /** 地区id */
  regionId?: string
  /** 地区ids */
  regionIds?: string[]
  /** 合并不同地区 */
  regionUnique?: boolean
  /** 智能合并 */
  smartUnique?: boolean
  /** 排序方式 0-综合 1-最新上架 2-评分最高 3-评价最多 4-价格降序 5-价格升序 6-最早上架（上架时间正序） 8-月销量降序 14-月评最多 25-美元计价倒序 26-美元计价正序 */
  sortType?: number
  sourceChannel?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 开始时间 */
  startDate?: string
  /** 风格 */
  style?: string[]
  /** 搜索文本 */
  text?: string
}

/**
 * 商品列表通用dto
 */
export interface CommonGoodsListVO {
  /** 关联的布料 */
  associatedFabrics?: AssociatedFabric[]
  /** 商品品牌 */
  brand?: string
  /** 品牌id */
  brandId?: string
  /** 品牌图标LOGO */
  brandPicUrl?: string
  /** 类目ID */
  categoryId?: string
  /** 类目IDs */
  categoryIdList?: number[]
  /** 类目名称 */
  categoryName?: string
  /** 类目路径 */
  categoryNameList?: string[]
  /** 商品评论数 */
  commentNum?: number
  /** 币种 */
  currency?: string
  /** 图像识别返回的相似度，值越小越相似 */
  distance?: number
  /** 收录时间 */
  firstCrawlTime?: string
  /** 商品标签 */
  goodsTags?: string[]
  height?: number
  /** 热销排名/BSR排名 */
  hotsellRank?: number
  /** 最后一级类目id */
  lastCategoryIds?: number[]
  /** 最近上架时间 */
  lastOnSaleDate?: string
  metricInfo?: GoodsMetricInfoVO
  /** 历史最低价 */
  minPrice?: number
  /** 美念站点ID，和跨境一对一 */
  mnPlatformType?: number
  /** 上架时间 */
  onSaleDate?: string
  /** 售价 */
  oprice?: string
  /** 类目名称 */
  originCategoryEnName?: string
  /** 原站类目name列表 */
  originCategoryEnNameList?: string[]
  /** 类目名称 */
  originCategoryName?: string
  /** 原站类目name列表 */
  originCategoryNameList?: string[]
  /** 商品主图 */
  picUrl?: string
  /** 站点类型 */
  platformBizType?: string
  /** 站点名称 */
  platformLogo?: string
  /** 站点名称 */
  platformName?: string
  /** 来源站点ID */
  platformType?: number
  /** 商品ID */
  productId?: string
  productKey?: string
  /** 商品名称 */
  productName?: string
  /** 商品地址 */
  productUrl?: string
  /** 智能合并+地区合并id */
  regionSmartUniqueId?: string
  /** 地区合并站点信息 */
  relatePlatformInfos?: PlatformInfoVO[]
  /** 在售状态 0下架 1在售 -1售罄 */
  saleStatus?: number
  /** 月销量 */
  saleVolume30day?: number
  /** 总销量 */
  saleVolumeTotal?: number
  /** 商品评分 */
  score?: number
  /** 卖家列表 */
  sellerInfoList?: GoodsSellerPO[]
  /** 店铺评价数 */
  shopCommentNum?: number
  /** 店铺id */
  shopId?: string
  /** 店铺logo */
  shopLogo?: string
  /** 店铺名字 */
  shopName?: string
  /** 店铺收录时间 */
  shopRecordDate?: string
  /** 店铺评分 */
  shopScore?: number
  /** 店铺链接 */
  shopUrl?: string
  /** 智能合并id */
  smartUniqueId?: string
  /** 智能合并的商品数量 */
  smartUniqueProductNum?: number
  /** 售价 */
  sprice?: string
  /** 售价-统一货币单位 */
  spriceUnified?: number
  /** 数据更新时间 */
  updateTime?: string
  /** 售价-美元计价 */
  usdSprice?: number
  /** 宽 */
  width?: number
}

/**
 * ApiResult_PaginationResult_CommonGoodsListVO接口类型
 */
export interface ApiResult_PaginationResult_CommonGoodsListVO {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_CommonGoodsListVO
  success?: boolean
}

/**
 * PaginationResult_CommonGoodsListVO接口类型
 */
export interface PaginationResult_CommonGoodsListVO {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: CommonGoodsListVO[]
  start?: number
  totalPageCount?: number
}

/**
 * PaginationResultFabricSelectSeller接口类型
 */
export interface PaginationResultFabricSelectSeller {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricSelectSeller[]
}

/**
 * ApiResultPaginationResultFabricSelectSeller接口类型
 */
export interface ApiResultPaginationResultFabricSelectSeller {
  result?: PaginationResultFabricSelectSeller
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 查询精选商家请求参数
 */
export interface ListSellerSelectRequest {
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 动作 2查看详情 3咨询(查询精选商家时不传) */
  action?: number
  /** 搜索商家（商家名、简介、主营、地址） */
  fuzzySearch?: string
  /** 置顶推广商家过滤：0-无置顶，1-置顶 */
  sellerTopSettingFilter?: number
  /** 推广范围 1:不限 2:国内 3：跨境 （非置顶权限账号传空） */
  promotionType?: number
}

/**
 * ApiResult_PaginationResult_RecommendCaseInfo接口类型
 */
export interface ApiResult_PaginationResult_RecommendCaseInfo {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_RecommendCaseInfo
  success?: boolean
}

/**
 * PaginationResult_RecommendCaseInfo接口类型
 */
export interface PaginationResult_RecommendCaseInfo {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: RecommendCaseInfo[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_List_RecommendCaseInfo接口类型
 */
export interface ApiResult_List_RecommendCaseInfo {
  errorCode?: string
  errorDesc?: string
  result?: RecommendCaseInfo[]
  success?: boolean
}

/**
 * 面料推荐
 */
export interface FabricRecommendRequest {
  /** 品类id */
  categoryIdList?: number[]
  /** 面料品类名称 */
  fabricCategoryList?: string[]
  /** 面料id */
  fabricId?: string
  /** 关键词 */
  keywordList?: string
  /** 最高售价 */
  maxPrice?: number
  /** 最低售价 */
  minPrice?: number
  /** 推荐类型 */
  recommendSourceChannel?: number
  /** 行业id */
  rootCategoryIdList?: number[]
  /** 面料来源渠道 */
  sourceChannel?: number
  /** 风格 */
  style?: string
}

/**
 * TrendNode1接口类型
 */
export interface TrendNode1 {
  /** 日期 */
  date?: string
  /** 展示日期 */
  displayDate?: string
  /** 投放方式 1 精准投放；2 智能投放 */
  deliveryType?: number
  /** 展示次数 */
  viewCount?: number
  /** 咨询次数 */
  inquiryCount?: number
  /** 消费次数 */
  consumeCount?: number
  /** 查看详情次数 */
  viewDetailCount?: number
  /** 布匹推广中数量 */
  inPromotionFabricCount?: number
  /** 商品/款式推广中数量 */
  inPromotionEntityCount?: number
  /** 系统商品/款式推广中数量 */
  inPromotionSystemEntityCount?: number
}

/**
 * FabricPromotionRecordStatisticBO接口类型
 */
export interface FabricPromotionRecordStatisticBO {
  action?: number
  authWechat?: string
  count?: number
  isAuth?: number
  isGreeted?: number
  teamId?: number
  teamName?: string
  userId?: number
  userPhone?: string
  username?: string
}

/**
 * ApiResult接口类型
 */
export interface ApiResult {
  result?: null
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResultBoolean接口类型
 */
export interface ApiResultBoolean {
  result?: boolean
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResult_QueryPromotionFabricResponse接口类型
 */
export interface ApiResult_QueryPromotionFabricResponse {
  errorCode?: string
  errorDesc?: string
  result?: QueryPromotionFabricResponse
  success?: boolean
}

/**
 * ApiResult_FabricPromotionResponse接口类型
 */
export interface ApiResult_FabricPromotionResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricPromotionResponse
  success?: boolean
}

/**
 * PaginationResult_FabricPromotionInfo接口类型
 */
export interface PaginationResult_FabricPromotionInfo {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricPromotionInfo[]
  start?: number
  totalPageCount?: number
}

/**
 * PaginationResult_FabricSelect接口类型
 */
export interface PaginationResult_FabricSelect {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricSelect[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_PaginationResult_FabricPromotionInfo接口类型
 */
export interface ApiResult_PaginationResult_FabricPromotionInfo {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricPromotionInfo
  success?: boolean
}

/**
 * FabricPromotionProjectStyle接口类型
 */
export interface FabricPromotionProjectStyle {
  createdAt?: string
  entityId?: string
  entityName?: string
  extraInfo?: IStyle
  fabricId?: string
  groupId?: string
  picUrl?: string
  sourceChannel?: number
  sourceTime?: string
}

/**
 * ApiResult_PromotionOverviewResponse接口类型
 */
export interface ApiResult_PromotionOverviewResponse {
  errorCode?: string
  errorDesc?: string
  result?: PromotionOverviewResponse
  success?: boolean
}

/**
 * ApiResult_QueryFabricPromotionTrendResponse接口类型
 */
export interface ApiResult_QueryFabricPromotionTrendResponse {
  errorCode?: string
  errorDesc?: string
  result?: QueryFabricPromotionTrendResponse
  success?: boolean
}

/**
 * 面料项目推广编辑请求参数（新增、修改、删除时用）
 */
export interface FabricPromotionEditRequest {
  /** 投放行业子集 */
  category?: string
  /** 货币类型（shein必传） */
  currency?: string
  /** 投放结束时间 */
  deliveryAtEnd?: string
  /** 投放开始时间 */
  deliveryAtStart?: string
  /** 投放时间类型 1 无限制；2 有限制 */
  deliveryAtType?: number
  /** 投放次数 */
  deliveryCount?: number
  /** 投放行业（智能投放时必传） */
  deliveryIndustry?: string
  /** 投放区域 */
  deliveryRegion?: string
  /** 投放方式 1 精准投放；2 智能投放 */
  deliveryType?: number
  /** 推广信息 */
  fabricPromotionStyleList?: FabricPromotionStyle[]
  /** 最大价格 */
  maxPrice?: number
  /** 最小价格 */
  minPrice?: number
  /** 操作 1提交审核；2取消审核；3暂停；4开启；5结束 */
  operation?: number
  operator?: number
  /** 项目id */
  projectId?: string
  /** 项目名称 */
  projectName?: string
  /** 投放渠道（智能投放时必传） */
  sourceChannel?: string
  /** 状态 1未审核；2审核中；3不通过；4进行中；5已暂停；6已结束; 7未开始 */
  status?: number
  /** 商家id */
  teamId?: number
  /** 商家名称 */
  teamName?: string
}

/**
 * ApiResult_List_FabricInquiry接口类型
 */
export interface ApiResult_List_FabricInquiry {
  errorCode?: string
  errorDesc?: string
  result?: FabricInquiry[]
  success?: boolean
}

/**
 * ApiResult_QueryFabricPromotionInfoResponse接口类型
 */
export interface ApiResult_QueryFabricPromotionInfoResponse {
  errorCode?: string
  errorDesc?: string
  result?: QueryFabricPromotionInfoResponse
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricSelect接口类型
 */
export interface ApiResult_PaginationResult_FabricSelect {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricSelect
  success?: boolean
}

/**
 * 推广信息
 */
export interface FabricPromotionStyle {
  /** 推广面料id */
  fabricId?: string
  /** 推广商品信息 */
  promotionInfoList?: PromotionInfo[]
}

/**
 * ApiResultFabricPromotionProjectResponse接口类型
 */
export interface ApiResultFabricPromotionProjectResponse {
  result?: FabricPromotionProjectResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 推广项目信息返回
 */
export interface FabricPromotionProjectResponse {
  /** 投放行业子集 */
  category?: string
  /** 消耗次数 */
  consumeCount?: number
  /** 创建时间 */
  createdAt?: string
  /** 创建人id */
  creatorId?: number
  /** 创建人姓名 */
  creatorName?: string
  /** 创建人手机号 */
  creatorPhone?: string
  /** 货币类型 */
  currency?: string
  /** 删除时间 */
  deletedAt?: string
  /** 投放结束时间 */
  deliveryAtEnd?: string
  /** 投放开始时间 */
  deliveryAtStart?: string
  /** 投放时间类型 1 无限制；2 有限制 */
  deliveryAtType?: number
  /** 投放次数 */
  deliveryCount: number
  /** 投放行业 */
  deliveryIndustry?: string
  /** 投放区域 */
  deliveryRegion?: string
  /** 投放方式 1 精准投放；2 智能投放 */
  deliveryType?: number
  /** 结束原因 1:项目消费次数用尽 2:团队消费次数用尽 3、项目到期  4、面料下架 5、团队到期 6、管理员取消 7、用户取消 */
  endReason?: string
  fabricIdList?: string[]
  /** 关联面料信息 */
  fabricInfoDetailResponses?: FabricInfoDetailResponse[]
  /** 关联商品信息 */
  fabricPromotionStyleList?: FabricPromotionProjectStyle[]
  /** 主键ID */
  id?: number
  /** 咨询次数 */
  inquiryCount?: number
  /** 是否有操作权限 0无；1有 */
  isAuthorized?: number
  /** 是否运营创建 0否；1是； */
  isOperation?: number
  /** 最大价格 */
  maxPrice?: number
  /** 最小价格 */
  minPrice?: number
  /** 暂停原因 1:手动暂停 2:系统暂停 */
  pauseReason?: number
  /** 项目id */
  projectId: string
  /** 项目名称 */
  projectName: string
  /** 投放渠道 */
  sourceChannel?: string
  /** 状态 1未审核；2审核中；3不通过；4进行中；5已暂停；6已结束; 7未开始 */
  status?: number
  /** 商家id */
  teamId: number
  /** 商家名称 */
  teamName?: string
  /** 更新时间 */
  updatedAt?: string
  /** 修改人id */
  updaterId?: number
  /** 修改人姓名 */
  updaterName?: string
  /** 修改人手机号 */
  updaterPhone?: string
  /** 展现次数 */
  viewCount?: number
}

/**
 * ApiResultInteger接口类型
 */
export interface ApiResultInteger {
  result?: number
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResultString接口类型
 */
export interface ApiResultString {
  result?: string
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * PaginationResult_QueryPromotionCompanyResponse接口类型
 */
export interface PaginationResult_QueryPromotionCompanyResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: QueryPromotionCompanyResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_QueryPromotionCompanyResponse接口类型
 */
export interface ApiResult_QueryPromotionCompanyResponse {
  errorCode?: string
  errorDesc?: string
  result?: QueryPromotionCompanyResponse
  success?: boolean
}

/**
 * ApiResult_FabricInquiryResponse接口类型
 */
export interface ApiResult_FabricInquiryResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricInquiryResponse
  success?: boolean
}

/**
 * ApiResult_PaginationResult_PromotionRecordListResponse接口类型
 */
export interface ApiResult_PaginationResult_PromotionRecordListResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_PromotionRecordListResponse
  success?: boolean
}

/**
 * 项目推广查询请求参数
 */
export interface FabricProjectQueryRequest {
  /** 投放方式 1 精准投放；2 智能投放 */
  deliveryType?: number
  /** 投放方式 1 精准投放；2 智能投放 */
  deliveryTypeList?: number[]
  /** 创建时间-结束 */
  endTime?: string
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 推广项目id */
  projectId?: string
  /** 项目名称/id搜索框 */
  searchField?: string
  /** sortField */
  sortField?: string
  /** 排序方式：asc/desc */
  sortOrder?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 创建时间-开始 */
  startTime?: string
  /** 状态 1未审核；2审核中；3不通过；4进行中；5已暂停；6已结束; 7未开始 */
  statusList?: number[]
  /** 团队id */
  teamId?: number
}

/**
 * ApiResult_PaginationResult_QueryPromotionCompanyResponse接口类型
 */
export interface ApiResult_PaginationResult_QueryPromotionCompanyResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_QueryPromotionCompanyResponse
  success?: boolean
}

/**
 * ApiResultPaginationResultFabricPromotionProjectResponse接口类型
 */
export interface ApiResultPaginationResultFabricPromotionProjectResponse {
  result?: PaginationResultFabricPromotionProjectResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * PaginationResultFabricPromotionProjectResponse接口类型
 */
export interface PaginationResultFabricPromotionProjectResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricPromotionProjectResponse[]
}

/**
 * PaginationResult_PromotionRecordListResponse接口类型
 */
export interface PaginationResult_PromotionRecordListResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: PromotionRecordListResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_FabricInfoDetailResponse接口类型
 */
export interface ApiResult_FabricInfoDetailResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricInfoDetailResponse
  success?: boolean
}

/**
 * 团队消费次数
 */
export interface TeamFabricPromotionResponse {
  /** 剩余消费次数 */
  restConsumeCount?: number
}

/**
 * ApiResultTeamFabricPromotionResponse接口类型
 */
export interface ApiResultTeamFabricPromotionResponse {
  result?: TeamFabricPromotionResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResult_FabricProjectReviewResponse接口类型
 */
export interface ApiResult_FabricProjectReviewResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricProjectReviewResponse
  success?: boolean
}

/**
 * 项目推广审核请求参数
 */
export interface ReviewFabricProjectRequest {
  /** 附加信息 */
  additionalNotes?: string
  /** 推广审核id */
  fabricProjectReviewId: string
  /** 拒绝理由 */
  rejectReasons?: number[]
  /** 推广审核状态 1-通过 2-拒绝 */
  reviewStatus?: number
}

/**
 * 面料项目推广审核信息
 */
export interface FabricProjectReviewInfo {
  /** 补充说明 */
  additionalNotes?: string
  /** 提交审核人ID */
  applyUserId?: number
  /** 提交人姓名 */
  applyUserName?: string
  /** 提交人手机号 */
  applyUserPhone?: string
  /** 提交公司名称 */
  companyName?: string
  /** 申请时间 */
  createdAt?: string
  /** 面料项目审核ID */
  fabricProjectReviewId?: string
  /** 操作人ID */
  operatorId?: number
  /** 操作人姓名 */
  operatorName?: string
  /** 项目ID */
  projectId?: string
  /** 项目名称 */
  projectName?: string
  /** 项目状态 */
  projectStatus?: number
  /** 拒绝理由（1:商品和图片不关联；2:面料信息不全；3:面料信息违规；4:其他） */
  rejectReason?: string
  /** 审核时间 */
  reviewTime?: string
  /** 审核人ID */
  reviewerId?: number
  /** 审核人姓名 */
  reviewerName?: string
  /** 审核状态（0:待审核；1:审核通过；2:审核拒绝 3:已取消） */
  status?: number
  /** 提交团队ID */
  submitterTeamId?: number
  /** 更新时间 */
  updatedAt?: string
}

/**
 * PaginationResult_FabricProjectReviewInfo接口类型
 */
export interface PaginationResult_FabricProjectReviewInfo {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricProjectReviewInfo[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_PaginationResult_FabricProjectReviewInfo接口类型
 */
export interface ApiResult_PaginationResult_FabricProjectReviewInfo {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricProjectReviewInfo
  success?: boolean
}

/**
 * FabricProjectReviewResponse接口类型
 */
export interface FabricProjectReviewResponse {
  /** 面料项目审核ID */
  fabricProjectReviewId?: string
  /** 项目ID */
  projectId?: string
  /** 审核状态 */
  reviewStatus?: number
}

/**
 * 刷新每日统计
 */
export interface RefreshDailyPromotionRequest {
  /** 结束日期 */
  endDate?: string
  /** 开始日期 */
  startDate?: string
}

/**
 * ApiResult_PaginationResult_TemuGoodsListVO接口类型
 */
export interface ApiResult_PaginationResult_TemuGoodsListVO {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_TemuGoodsListVO
  success?: boolean
}

/**
 * 监控实体_监控用户信息接口类型
 */
export interface 监控实体_监控用户信息 {
  /** 手机号 */
  phone?: string
  /** 团队id */
  teamId?: number
  /** 用户id */
  userId?: number
  /** 用户名 */
  userName?: string
}

/**
 * AmazonGoodsListSelectRequest接口类型
 */
export interface AmazonGoodsListSelectRequest {
  /** 亚马逊词 */
  amazonWord?: string
  /** 供应面料过滤 */
  associatedFabricFilter?: number
  /** 大码 */
  bodyType?: string[]
  /** 品牌列表 */
  brandList?: string[]
  bsrRankChange?: number
  /** 类目id集合，输入统一，不管原站还是知衣类目，以站点和业务为准 */
  categoryIdList?: unknown[]
  /** 类目类型，origin/normal */
  categoryType?: string
  /** 色彩 */
  color?: string[]
  /** 颜色上架标识 */
  colorOnSaleStatus?: boolean
  /** 评价高频词情感 */
  emotion?: string
  /** 结束时间 */
  endDate?: string
  /** 排除的品牌列表 */
  excludeBrandList?: string[]
  /** 商品标签 1.Best Seller 2.Amazon's Choice 3.New Release */
  goodsTags?: string[]
  /** 有无优惠券 */
  hasCoupon?: boolean
  /** 是否看过（未看过：false） */
  hasSeen?: boolean
  /** 包含关键字 逗号分隔 */
  includeKeywords?: string
  /** 行业 */
  industry?: string
  /** sku在多站点上架 */
  isMultiSkuOnSaleRegion?: boolean
  /** 是否在售 0-否 1-是 */
  isOnSale?: number
  /** 是否套装 */
  isSuit?: boolean
  /** 设计要素 */
  label?: unknown[]
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 物流配送类型 */
  logisticDeliveryType?: string[]
  /** 属性筛选 */
  mappedProperties?: unknown[]
  maxBadCommentRate?: number
  /** 最高评论数值 */
  maxCommentNum?: number
  /** 近30天评论数最大值 */
  maxCommentNum30Day?: number
  maxCommentRetentionRate?: number
  /** 最高折扣率（传负值乘以100） */
  maxDiscount?: number
  /** 折扣率最大 */
  maxDiscountRate?: number
  /** 大类排名最大值 */
  maxMainCategoryRank?: number
  /** 上新7日销量最大值 */
  maxNewInSaleVolume7Day?: number
  /** 最大在售SKU数 */
  maxOnSaleSkuNum?: number
  /** 评分数最大值 */
  maxRatingNum?: number
  /** 30日销售额最小值 */
  maxSaleAmount30Day?: number
  /** 7日销售额最大值 */
  maxSaleAmount7Day?: number
  /** 90日销售额最小值 */
  maxSaleAmount90Day?: number
  /** 30日销量最小值 */
  maxSaleVolume30Day?: number
  /** 7日销量最大值 */
  maxSaleVolume7Day?: number
  /** 90日销量最小值 */
  maxSaleVolume90Day?: number
  /** 总销量最大值 */
  maxSaleVolumeTotal?: number
  /** 最高评分 */
  maxScore?: number
  /** 最大skc数 */
  maxSkcNum?: number
  /** 最高售价 */
  maxSprice?: number
  /** meta关联商品标识(或的关系)：ADVERTISEMENT_FLAG--参与过meta投放，POST_FLAG--参与过meta动态，SHOP_PRODUCT_FLAG--参与过公共主页 */
  metaFlagList?: string[]
  /** 差评率 */
  minBadCommentRate?: number
  /** 最低评论数值 */
  minCommentNum?: number
  /** 近30天评论数最小值 */
  minCommentNum30Day?: number
  /** 评论留存率，留评率 */
  minCommentRetentionRate?: number
  /** 最低折扣率（传负值乘以100，【25%以下】为【minDiscount=-25，maxDiscount=0】） */
  minDiscount?: number
  /** 折扣率最小 */
  minDiscountRate?: number
  /** 大类排名最小值 */
  minMainCategoryRank?: number
  /** 上新7日销量最小值 */
  minNewInSaleVolume7Day?: number
  /** 最小在售SKU数 */
  minOnSaleSkuNum?: number
  /** 评分数最小值 */
  minRatingNum?: number
  /** 30日销售额最小值 */
  minSaleAmount30Day?: number
  /** 7日销售额最小值 */
  minSaleAmount7Day?: number
  /** 90日销售额最小值 */
  minSaleAmount90Day?: number
  /** 30日销量最小值 */
  minSaleVolume30Day?: number
  /** 7日销量最小值 */
  minSaleVolume7Day?: number
  /** 90日销量最小值 */
  minSaleVolume90Day?: number
  /** 总销量最小值 */
  minSaleVolumeTotal?: number
  /** 最低评分 */
  minScore?: number
  /** 最小skc数量 */
  minSkcNum?: number
  /** 最低售价 */
  minSprice?: number
  /** 是否查询复色 1是复色 0非复色 */
  multiColor?: boolean
  /** 只看新色勾选 */
  newColor?: boolean
  /** 新品补货 */
  newProductReplenishment?: boolean
  /** 是否首次上架 0-否 1-是 */
  onSaleFlag?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 图片类型 1-平铺图 2-模特图 */
  picType?: number
  /** 平台编号 */
  platformType?: number
  priceChangeType?: number
  /** 商品粒度 */
  productGranularity?: string
  /** 投放状态 0:未投放；1: 投放中 */
  promotedFabricFilter?: number
  /** 上架动作（默认过滤） */
  putOnSaleDateEffective?: boolean
  /** 上架时间范围-结束 （与统计时间分离） */
  putOnSaleEndDate?: string
  /** 上架时间范围-开始 （与统计时间分离） */
  putOnSaleStartDate?: string
  /** 肤色，黄种人-1,黑人-2,白人-3,中东-4,印度-5 */
  raceType?: string[]
  /** 卖家名称 */
  sellerNameList?: string[]
  /** 卖家地区 */
  shopArea?: unknown[]
  /** 卖家城市 */
  shopCity?: string[]
  /** 店铺id */
  shopId?: string
  /** 查询断码商品 */
  shortInSizeFlag?: number
  /** 全部sku首次上架时间满足（默认不过滤） */
  skuFirstOnSaleDateAllEffective?: boolean
  /** sku首次上架（默认不过滤） */
  skuFirstOnSaleDateEffective?: boolean
  /** 排序方式 1-最新上架 6-最早上架 2-评分最高 3-评价最多 4-价格降序 5-价格升序 8-30日销量最多 12-7日销量最多 13-7日评价最多 14-30日评价最多 17-总销量最多 27-差评数最多 */
  sortType?: number
  sourceChannel?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 开始时间 */
  startDate?: string
  /** 风格 */
  style?: string[]
  text?: string
  /** 评价高频词筛选 */
  vocKeywordList?: string[]
}

/**
 * AmazonGoodsMetricInfoVO接口类型
 */
export interface AmazonGoodsMetricInfoVO {
  /** 总差评数 */
  badCommentTotal?: number
  /** 博主数量30天 */
  bloggerNum30day?: number
  /** 博主数量90天 */
  bloggerNum90day?: number
  /** 博主数量30天 */
  bloggerNumAmazon30day?: number
  /** 博主数量90天 */
  bloggerNumAmazon90day?: number
  /** 博主数量昨日 */
  bloggerNumAmazonYesterday?: number
  /** 博主数量30天 */
  bloggerNumLtk30day?: number
  /** 博主数量90天 */
  bloggerNumLtk90day?: number
  /** 博主数量昨日 */
  bloggerNumLtkYesterday?: number
  /** 博主数量昨日 */
  bloggerNumYesterday?: number
  /** 本期评论 */
  commentNum?: number
  /** 近30天评论 */
  commentNum30day?: number
  /** 近7天评论数 */
  commentNum7day?: number
  /** 近90天评论 */
  commentNum90day?: number
  /** 30天评论增速 */
  commentNumGrowth30day?: number
  /** 7天评论增速 */
  commentNumGrowth7day?: number
  /** 90天评论增速 */
  commentNumGrowth90day?: number
  commentNumYesterday?: number
  /** 留评率 */
  commentRetentionRate?: number
  /** 币种 */
  currency?: string
  /** 折扣率 */
  discount?: number
  /** 本期收藏数 */
  favedCount?: number
  /** 30天收藏数 */
  favedCount30day?: number
  /** 7天收藏数 */
  favedCount7day?: number
  /** 90天收藏数 */
  favedCount90day?: number
  /** 总收藏数 */
  favedCountTotal?: number
  /** 最终折扣变动 */
  finalDiscountDiff?: number
  /** 近30日最终折扣变化 */
  finalDiscountDiff30day?: number
  /** 近90日最终折扣变化 */
  finalDiscountDiff90day?: number
  /** 昨日最终折扣变化 */
  finalDiscountDiffYesterday?: number
  /** 近30日跟卖家数 */
  followSellerNum30day?: number
  /** 近90日跟卖卖家数 */
  followSellerNum90day?: number
  /** 昨日跟卖买家数 */
  followSellerNumYesterday?: number
  /** 近30日跟卖skc数 */
  followSkcNum30day?: number
  /** 近90日跟卖skc数 */
  followSkcNum90day?: number
  /** 昨日跟卖skc数 */
  followSkcNumYesterday?: number
  /** 近30日跟卖sku数 */
  followSkuNum30day?: number
  /** 近90日跟卖sku数 */
  followSkuNum90day?: number
  /** 昨日跟卖sku数 */
  followSkuNumYesterday?: number
  /** 价格变动 */
  fpriceDiff?: number
  /** 近30日最终价格变化 */
  fpriceDiff30day?: number
  /** 近90日最终价格变化 */
  fpriceDiff90day?: number
  /** 昨日最终价格变化 */
  fpriceDiffYesterday?: number
  /** 首次库存变动日期 */
  fstStockChangeDate?: string
  /** 近30天热度值 */
  hotDegree30day?: number
  /** 上期优惠券 */
  lastCoupon?: number
  /** 上期折扣 */
  lastDiscount?: number
  /** 上期价格 */
  lastSprice?: number
  /** 本期大类排名变化 */
  mainCategoryDiff?: number
  /** 近30日大类排名变化 */
  mainCategoryDiff30day?: number
  /** 7日大类排名变化 */
  mainCategoryDiff7day?: number
  /** 近90日大类排名变化 */
  mainCategoryDiff90day?: number
  /** 昨日大类排名变化 */
  mainCategoryDiffYesterday?: number
  metricEndDate?: string
  metricStartDate?: string
  /** 最低价格 */
  minPrice?: number
  /** 最低价格时间 */
  minPriceDate?: string
  /** 昨日上新颜色数 */
  newInColorNumYesterday?: number
  /** 7日上新评论数 */
  newInCommentNum7day?: number
  /** 地区上新7日销售额 */
  newInSaleAmount7dayArea?: number
  /** 上新7日销量 */
  newInSaleVolume7day?: number
  /** 地区上新7日销量 */
  newInSaleVolume7dayArea?: number
  /** 本期首次上新skc数量 */
  newInSkcNum?: number
  /** 近30天上新skc数量 */
  newInSkcNum30day?: number
  /** 近7天上新skc数量 */
  newInSkcNum7day?: number
  /** 近30天上新skc数量 */
  newInSkcNum90day?: number
  /** 昨日上新skc数量 */
  newInSkcNumYesterday?: number
  /** 本期首次上新sku数量 */
  newInSkuNum?: number
  /** 近7天上新sku数量 */
  newInSkuNum30day?: number
  /** 近7天上新sku数量 */
  newInSkuNum7day?: number
  /** 近7天上新sku数量 */
  newInSkuNum90day?: number
  /** 近7天上新sku数量 */
  newInSkuNumYesterday?: number
  /** 上新7天库存变化次数 */
  newInStockChangeCount7day?: number
  /** 本期首次上新库存数量 */
  newInStockNum?: number
  /** 近30天上新库存 */
  newInStockNum30day?: number
  /** 近7天上新库存 */
  newInStockNum7day?: number
  /** 近90天上新库存 */
  newInStockNum90day?: number
  /** 昨日上新库存 */
  newInStockNumYesterday?: number
  /** 本期带货博主数 */
  periodBloggerNum?: number
  /** 本期带货博主数-Amazon */
  periodBloggerNumAmazon?: number
  /** 本期带货博主数-Ltk */
  periodBloggerNumLtk?: number
  /** 本期优惠券 */
  periodCoupon?: number
  /** 本期折扣 */
  periodDiscount?: number
  /** 本期跟卖卖家数 */
  periodFollowSellerNum?: number
  /** 本期跟卖skc数 */
  periodFollowSkcNum?: number
  /** 本期跟卖sku数 */
  periodFollowSkuNum?: number
  /** 本期带货帖子数 */
  periodPostCount?: number
  /** 本期带货帖子数-Amazon */
  periodPostCountAmazon?: number
  /** 本期带货帖子数-Ltk */
  periodPostCountLtk?: number
  /** 本期价格 */
  periodSprice?: number
  /** 帖子数量30天 */
  postCount30day?: number
  /** 帖子数量90天 */
  postCount90day?: number
  /** 帖子数量30天 */
  postCountAmazon30day?: number
  /** 帖子数量90天 */
  postCountAmazon90day?: number
  /** 帖子数量昨日 */
  postCountAmazonYesterday?: number
  /** 帖子数量30天 */
  postCountLtk30day?: number
  /** 帖子数量90天 */
  postCountLtk90day?: number
  /** 帖子数量昨日 */
  postCountLtkYesterday?: number
  /** 带货帖子数 */
  postCountTotal?: number
  /** 帖子数量昨日 */
  postCountYesterday?: number
  /** 价格变动3/7/15/30日 */
  priceChangeDays?: number
  /** 异动类型 */
  rankChangeType?: number
  /** 上期排名 */
  rankLastValue?: number
  /** 本期排名 */
  rankValue?: number
  /** 排名变动 */
  rankValueChange?: number
  /** 评分数 */
  ratingNum?: number
  /** 本期销售额 */
  saleAmount?: number
  /** 近15天销售额 */
  saleAmount15day?: number
  /** 地区15日销售额 */
  saleAmount15dayArea?: number
  /** 近30天销售额 */
  saleAmount30day?: number
  /** 地区月销售额 */
  saleAmount30dayArea?: number
  /** 近7天销售额 */
  saleAmount7day?: number
  /** 地区7日销售额 */
  saleAmount7dayArea?: number
  /** 近90天销售额 */
  saleAmount90day?: number
  /** 30天销售额增速 */
  saleAmountGrowth30day?: number
  /** 7天销售额增速 */
  saleAmountGrowth7day?: number
  /** 90天销售额增速 */
  saleAmountGrowth90day?: number
  /** 总销售额 */
  saleAmountTotal?: number
  /** 地区总销售额 */
  saleAmountTotalArea?: number
  /** 昨日销售额 */
  saleAmountYesterday?: number
  /** 地区昨日销售额 */
  saleAmountYesterdayArea?: number
  /** 本期销量 */
  saleVolume?: number
  /** 近15天销量 */
  saleVolume15day?: number
  /** 地区月15日销量 */
  saleVolume15dayArea?: number
  /** 月销量 */
  saleVolume30day?: number
  /** 地区月销量 */
  saleVolume30dayArea?: number
  /** 30天地区销量环比 */
  saleVolume30dayAreaMom?: number
  /** 30天销量环比 */
  saleVolume30dayMom?: number
  /** 近7天销量 */
  saleVolume7day?: number
  /** 地区7日销量 */
  saleVolume7dayArea?: number
  /** 7天地区销量环比 */
  saleVolume7dayAreaMom?: number
  /** 7天销量环比 */
  saleVolume7dayMom?: number
  /** 近90天销量 */
  saleVolume90day?: number
  /** 30天销量增速 */
  saleVolumeGrowth30day?: number
  /** 7天销量增速 */
  saleVolumeGrowth7day?: number
  /** 90天销量增速 */
  saleVolumeGrowth90day?: number
  /** 本期销量环比 */
  saleVolumeRatio?: number
  /** 总销量 */
  saleVolumeTotal?: number
  /** 地区总销量 */
  saleVolumeTotalArea?: number
  /** 昨日销量 */
  saleVolumeYesterday?: number
  /** 地区昨日销量 */
  saleVolumeYesterdayArea?: number
  /** 评分变化 */
  scoreDiff?: number
  /** 近30日评分变化 */
  scoreDiff30day?: number
  /** 近90日评分变化 */
  scoreDiff90day?: number
  /** 昨日评分变化 */
  scoreDiffYesterday?: number
  /** 卖家数 */
  sellerNum?: number
  /** skc数量 */
  skcNum?: number
  /** sku数量 */
  skuNum?: number
  /** spu近30天销量 */
  spuSaleVolume30day?: number
  /** spu近7天销量 */
  spuSaleVolume7day?: number
  /** spu总销量 */
  spuSaleVolumeTotal?: number
  /** 近30天库存变化次数 */
  stockChangeCount30day?: number
  /** 近7天库存变化次数 */
  stockChangeCount7day?: number
  /** 昨日库存 */
  stockYesterday?: number
}

/**
 * temu商品列表通用VO
 */
export interface TemuGoodsListVO {
  /** 关联的布料 */
  associatedFabrics?: AssociatedFabric[]
  /** 商品品牌 */
  brand?: string
  /** 品牌id */
  brandId?: string
  /** 品牌图标LOGO */
  brandPicUrl?: string
  /** 类目ID */
  categoryId?: string
  /** 类目IDs */
  categoryIdList?: number[]
  /** 类目名称 */
  categoryName?: string
  /** 类目路径 */
  categoryNameList?: string[]
  /** 商品评论数 */
  commentNum?: number
  /** 币种 */
  currency?: string
  /** 商品标签 is_bestseller-BR is_amazon_choice-AC is_new_rank-NR */
  goodsTags?: string[]
  /** 高 */
  height?: number
  /** 热销排名/BSR排名 */
  hotsellRank?: number
  /** 商品正在收录标识 false-已存在 true-正在收录 */
  includingFlag?: boolean
  /** 最后一级类目id */
  lastCategoryIds?: number[]
  metricInfo?: GoodsMetricInfoVO
  /** 历史最低价 */
  minPrice?: number
  /** 美念站点ID，和跨境一对一 */
  mnPlatformType?: number
  monitorFlag?: boolean
  /** 监控时间 */
  monitorTime?: string
  /** 监控用户信息 */
  monitorUserInfo?: 监控实体_监控用户信息[]
  /** 上架时间 */
  onSaleDate?: string
  /** 售价 */
  oprice?: string
  /** 类目名称 */
  originCategoryEnName?: string
  /** 原站类目name列表 */
  originCategoryEnNameList?: string[]
  /** 类目名称 */
  originCategoryName?: string
  /** 原站类目name列表 */
  originCategoryNameList?: string[]
  /** 商品主图 */
  picUrl?: string
  /** 站点名称 */
  platformLogo?: string
  /** 站点名称 */
  platformName?: string
  /** 来源站点ID */
  platformType?: number
  /** 商品ID */
  productId?: string
  productKey?: string
  /** 商品名称 */
  productName?: string
  /** 商品地址 */
  productUrl?: string
  /** 月销量 */
  saleVolume30day?: number
  /** 总销量 */
  saleVolumeTotal?: number
  /** 商品评分 */
  score?: number
  /** 店铺评价数 */
  shopCommentNum?: number
  /** 店铺id */
  shopId?: string
  /** 店铺logo */
  shopLogo?: string
  /** 店铺名字 */
  shopName?: string
  /** 店铺收录时间 */
  shopRecordDate?: string
  /** 店铺评分 */
  shopScore?: number
  /** 店铺链接 */
  shopUrl?: string
  /** 售价 */
  sprice?: string
  /** 是否团队监控 */
  teamMonitored?: boolean
  /** 数据更新时间 */
  updateTime?: string
  /** 售价-美元计价 */
  usdSprice?: number
  /** 是否个人监控 */
  userMonitored?: boolean
  /** 宽 */
  width?: number
}

/**
 * ApiResult_PaginationResult_亚马逊商品列表通用VO接口类型
 */
export interface ApiResult_PaginationResult_亚马逊商品列表通用VO {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_亚马逊商品列表通用VO
  success?: boolean
}

/**
 * PaginationResult_亚马逊商品列表通用VO接口类型
 */
export interface PaginationResult_亚马逊商品列表通用VO {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: 亚马逊商品列表通用VO[]
  start?: number
  totalPageCount?: number
}

/**
 * PaginationResult_TemuGoodsListVO接口类型
 */
export interface PaginationResult_TemuGoodsListVO {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: TemuGoodsListVO[]
  start?: number
  totalPageCount?: number
}

/**
 * 亚马逊商品列表通用VO接口类型
 */
export interface 亚马逊商品列表通用VO {
  /** 关联的布料 */
  associatedFabrics?: AssociatedFabric[]
  /** 商品品牌 */
  brand?: string
  /** 品牌id */
  brandId?: string
  /** 品牌图标LOGO */
  brandPicUrl?: string
  /** 类目ID */
  categoryId?: string
  /** 类目IDs */
  categoryIdList?: number[]
  /** 类目名称 */
  categoryName?: string
  /** 类目路径 */
  categoryNameList?: string[]
  /** 商品评论数 */
  commentNum?: number
  /** 币种 */
  currency?: string
  /** 商品标签 is_bestseller-BR is_amazon_choice-AC is_new_rank-NR */
  goodsTags?: string[]
  /** 高 */
  height?: number
  /** 热销排名/BSR排名 */
  hotsellRank?: number
  /** 商品正在收录标识 false-已存在 true-正在收录 */
  includingFlag?: boolean
  /** 最后一级类目id */
  lastCategoryIds?: number[]
  metricInfo?: AmazonGoodsMetricInfoVO
  /** 历史最低价 */
  minPrice?: number
  /** 美念站点ID，和跨境一对一 */
  mnPlatformType?: number
  monitorFlag?: boolean
  /** 监控时间 */
  monitorTime?: string
  /** 监控用户信息 */
  monitorUserInfo?: 监控实体_监控用户信息[]
  /** 上架时间 */
  onSaleDate?: string
  /** 售价 */
  oprice?: string
  /** 类目名称 */
  originCategoryEnName?: string
  /** 原站类目name列表 */
  originCategoryEnNameList?: string[]
  /** 类目名称 */
  originCategoryName?: string
  /** 原站类目name列表 */
  originCategoryNameList?: string[]
  /** 原站属性 */
  originProperties?: string[]
  /** 商品主图 */
  picUrl?: string
  /** 站点名称 */
  platformLogo?: string
  /** 站点名称 */
  platformName?: string
  /** 来源站点ID */
  platformType?: number
  /** 商品ID */
  productId?: string
  productKey?: string
  /** 商品名称 */
  productName?: string
  /** 商品地址 */
  productUrl?: string
  /** 在售状态 0下架 1在售 -1售罄 */
  saleStatus?: number
  /** 月销量 */
  saleVolume30day?: number
  /** 总销量 */
  saleVolumeTotal?: number
  /** 商品评分 */
  score?: number
  /** 店铺评价数 */
  shopCommentNum?: number
  /** 店铺id */
  shopId?: string
  /** 店铺logo */
  shopLogo?: string
  /** 店铺名字 */
  shopName?: string
  /** 店铺收录时间 */
  shopRecordDate?: string
  /** 店铺评分 */
  shopScore?: number
  /** 店铺链接 */
  shopUrl?: string
  /** 售价 */
  sprice?: string
  /** 是否团队监控（商品） */
  teamMonitored?: boolean
  /** 是否团队监控（店铺） */
  teamMonitoredForShop?: boolean
  /** 数据更新时间 */
  updateTime?: string
  /** 售价-美元计价 */
  usdSprice?: number
  /** 是否个人监控（商品） */
  userMonitored?: boolean
  /** 是否个人监控（店铺） */
  userMonitoredForShop?: boolean
  /** 宽 */
  width?: number
}

/**
 * TemuGoodsListRequest接口类型
 */
export interface TemuGoodsListRequest {
  /** 供应面料过滤 */
  associatedFabricFilter?: number
  /** 大码 */
  bodyType?: string[]
  /** 品牌 */
  brand?: string
  /** 类目id集合，输入统一，不管原站还是知衣类目，以站点和业务为准 */
  categoryIdList?: unknown[]
  /** 类目类型，origin/normal */
  categoryType?: string
  /** 色彩 */
  color?: string[]
  /** 设计要素行业 */
  designElementIndustry?: string
  /** 结束时间 */
  endDate?: string
  /** 1-只看纯色 */
  hasPlainType?: boolean
  /** 托管状态 0-半托管 1-全托管 */
  hostType?: number
  /** 包含关键字 逗号分隔 */
  includeKeywords?: string
  /** 行业 */
  industry?: string
  /** 是否在售 0-否 1-是 */
  isOnSale?: number
  /** 是否套装 */
  isSuit?: boolean
  /** 设计要素 */
  label?: unknown[]
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 最高评论数 */
  maxCommentNum?: number
  /** 近30天评论数最大值 */
  maxCommentNum30Day?: number
  /** 最高月销量 */
  maxSaleVolume30Day?: number
  /** 7日销量最大值 */
  maxSaleVolume7Day?: number
  /** 总销量最大值 */
  maxSaleVolumeTotal?: number
  /** 最高评分 */
  maxScore?: number
  /** 最高售价 */
  maxSprice?: number
  /** 最低评论数 */
  minCommentNum?: number
  /** 近30天评论数最小值 */
  minCommentNum30Day?: number
  /** 最低月销量 */
  minSaleVolume30Day?: number
  /** 7日销量最小值 */
  minSaleVolume7Day?: number
  /** 总销量最小值 */
  minSaleVolumeTotal?: number
  /** 最低评分 */
  minScore?: number
  /** 最低售价 */
  minSprice?: number
  /** 是否复色 */
  multiColor?: boolean
  /** 是否首次上架 0-否 1-是 */
  onSaleFlag?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 平台编号 */
  platformType?: number
  /** 价格变动，3、7、15、30日 */
  priceChangeDays?: number
  /** 商品粒度 */
  productGranularity?: string
  /** 投放状态 0:未投放；1: 投放中 */
  promotedFabricFilter?: number
  /** 上架结束时间 */
  putOnSaleEndDate?: string
  /** 上架开始时间 */
  putOnSaleStartDate?: string
  /** 肤色，黄种人-1,黑人-2,白人-3,中东-4,印度-5 */
  raceType?: string[]
  /** 卖家地区 */
  shopArea?: unknown[]
  /** 店铺ID */
  shopId?: string
  /** 排序方式 1-最新上架 6-最早上架 2-评分最高 3-评价最多 4-价格降序 5-价格升序 8-30日销量最多 12-7日销量最多 13-7日评价最多 14-30日评价最多 17-总销量最多 27-差评数最多 */
  sortType?: number
  sourceChannel?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 开始时间 */
  startDate?: string
  /** 风格 */
  style?: string[]
  /** temu榜单 */
  temuRankTypeList?: number[]
  text?: string
}

/**
 * ApiResult_TeamFabricPromotionResponse接口类型
 */
export interface ApiResult_TeamFabricPromotionResponse {
  errorCode?: string
  errorDesc?: string
  result?: TeamFabricPromotionResponse
  success?: boolean
}

/**
 * PaginationResultFabricAdminListResponse接口类型
 */
export interface PaginationResultFabricAdminListResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricAdminListResponse[]
}

/**
 * ApiResultPaginationResultFabricAdminListResponse接口类型
 */
export interface ApiResultPaginationResultFabricAdminListResponse {
  result?: PaginationResultFabricAdminListResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResultEditFabricLabelResponse接口类型
 */
export interface ApiResultEditFabricLabelResponse {
  result?: EditFabricLabelResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 后台面料管理查询请求参数
 */
export interface FabricAdminQueryRequest {
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 创建时间-开始 */
  startTime?: string
  /** 创建时间-结束 */
  endTime?: string
  /** 面料ID */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 企业名称 */
  teamName?: string
  /** 品类确认状态(1:待确认模型标签, 2:人工确认或修改标签) */
  status?: number
  /** 淘宝人工确认状态(1:待确认模型标签, 2:人工确认或修改标签) */
  statusTaobao?: number
  /** Shein人工确认状态(1:待确认模型标签, 2:人工确认或修改标签) */
  statusShein?: number
}

/**
 * 后台面料管理列表响应
 */
export interface FabricAdminListResponse {
  /** 创建时间 */
  createdAt?: string
  /** 面料ID */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 企业id */
  teamId?: string
  /** 企业名称 */
  teamName?: string
  /** 面料细节图 */
  fabricDetailPic?: string
  /** 面料色卡图 */
  fabricColorPic?: string
  /** 成衣展示图 */
  garmentDisplayPic?: string
  /** 品类 */
  category?: string
  /** 服装品类 */
  labelCategoryName?: string
  /** 关键词 */
  keyword?: string
  /** 关键词-shein */
  keywordShein?: string
  /** 品类人工确认状态(1:待确认模型标签, 2:人工确认或修改标签) */
  labelStatus?: number
  /** taobao人工确认状态(1:待确认模型标签, 2:人工确认或修改标签) */
  labelStatusTaobao?: number
  /** Shein人工确认状态(1:待确认模型标签, 2:人工确认或修改标签) */
  labelStatusShein?: number
  /** 最近编辑时间 */
  editTime?: string
  /** 编辑人id */
  editUserId?: number
  /** 编辑人名称 */
  editUserName?: string
}

/**
 * 编辑面料标签信息响应
 */
export interface EditFabricLabelResponse {
  /** 面料ID */
  fabricId?: string
  /** 服装品类 */
  categoryName?: string
  /** 关键词 */
  keyword?: string
  /** Shein关键词 */
  keywordShein?: string
  /** 品类确认状态(1:待确认模型标签, 2:人工确认或修改标签) */
  status?: number
  /** 淘宝确认状态(1:待确认模型标签, 2:人工确认或修改标签) */
  statusTaobao?: number
  /** Shein人工确认状态(1:待确认模型标签, 2:人工确认或修改标签) */
  statusShein?: number
  /** 编辑时间 */
  editTime?: string
  /** 编辑用户ID */
  editUserId?: number
  /** 编辑用户名称 */
  editUserName?: string
}

/**
 * 编辑面料标签信息请求参数
 */
export interface EditFabricLabelRequest {
  /** 面料ID */
  fabricId: string
  /** 服装品类 */
  categoryName?: string
  /** 服装品类确认状态(1:待确认模型标签, 2:人工确认或修改标签) */
  status?: number
  /** 淘宝关键词 */
  keyword?: string
  /** 淘宝确认状态(1:待确认模型标签, 2:人工确认或修改标签) */
  statusTaobao?: number
  /** shein关键词 */
  keywordShein?: string
  /** shein人工确认状态(1:待确认模型标签, 2:人工确认或修改标签) */
  statusShein?: number
}

/**
 * ApiResultListString接口类型
 */
export interface ApiResultListString {
  result?: string[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 推荐行业ID列表返回信息
 */
export interface IndustryIdListResponse {
  /** 行业ID列表 */
  industryIdList?: string[]
}

/**
 * ApiResultIndustryIdListResponse接口类型
 */
export interface ApiResultIndustryIdListResponse {
  result?: IndustryIdListResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 图源信息
 */
export interface SourceChannelInfo {
  /** 图源渠道值 */
  sourceChannel?: number
  /** 图源渠道名称 */
  sourceChannelName?: string
}

/**
 * 面料图源响应
 */
export interface FabricSourceChannelResponse {
  /** 图源列表 */
  sourceChannelList?: SourceChannelInfo[]
}

/**
 * ApiResultFabricSourceChannelResponse接口类型
 */
export interface ApiResultFabricSourceChannelResponse {
  result?: FabricSourceChannelResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料图源查询请求
 */
export interface FabricSourceChannelRequest {
  /** 面料id */
  fabricId: string
}

/**
 * PaginationResult_FabricAdminListResponse接口类型
 */
export interface PaginationResult_FabricAdminListResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricAdminListResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_EditFabricLabelResponse接口类型
 */
export interface ApiResult_EditFabricLabelResponse {
  errorCode?: string
  errorDesc?: string
  result?: EditFabricLabelResponse
  success?: boolean
}

/**
 * ApiResult_IndustryIdListResponse接口类型
 */
export interface ApiResult_IndustryIdListResponse {
  errorCode?: string
  errorDesc?: string
  result?: IndustryIdListResponse
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricAdminListResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricAdminListResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricAdminListResponse
  success?: boolean
}

/**
 * ApiResult_FabricSourceChannelResponse接口类型
 */
export interface ApiResult_FabricSourceChannelResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricSourceChannelResponse
  success?: boolean
}

/**
 * 授权请求参数
 */
export interface FabricUserAuthRequest {
  /** 授权ID */
  authId?: string
  /** 团队ID */
  teamId?: number
  /** 团队名称 */
  teamName?: string
  /** 用户ID */
  userId?: number
  /** 用户名称 */
  userName?: string
  /** 用户手机号 */
  userPhone?: string
  /** 授权手机号 */
  authPhone?: string
  /** 授权微信号 */
  authWechat?: string
  /** 授权类型  1面料中心授权；2大知衣端授权； 3咨询商家授权； 4手动录入； */
  authType?: number
  /** 是否授权 */
  isAuth?: number
  /** 创建时间 */
  createdAt?: string
  /** 更新时间 */
  updatedAt?: string
  /** 删除时间 */
  deletedAt?: string
  /** 运营平台 */
  operationPlatformList?: string[]
  /** 主营行业 */
  mainIndustry?: string[]
  /** 面料类型集合 */
  fabricTypeDictList?: string[]
  /** 价格区间 */
  priceRangeList?: string[]
  /** 面料类型 - 其他信息（如果选择了'其他'） */
  fabricTypeOther?: string
  /** 用户填写最大价格 */
  maxPrice?: number
  /** 用户填写最低价格 */
  minPrice?: number
  /** 分配商家 */
  assignTeamId?: string[]
  /** 分配商家 */
  assignTeamName?: string[]
  /** 客户来源 1:智能推荐 2:咨询面料 3:咨询商家 */
  customerOrigin?: number
  /** 面料id */
  fabricId?: string
  /** 渠道 */
  sourceChannel?: number
  /** 商品 */
  entityId?: string
  /** 备注 */
  remark?: string
  /** 备注来源  1咨询面料；2咨询商家； 3智能推荐；4找布需求 */
  remarkSource?: number
}

/**
 * 咨询记录请求参数
 */
export interface FabricPromotionRecordRequest {
  /** 记录id */
  recordId?: number
  /** 授权手机号 */
  authPhone?: string
  /** 授权微信号 */
  authWechat?: string
  /** 授权类型  1面料中心授权；2大知衣端授权； 3咨询商家授权； 4手动录入 */
  authType?: number
  /** 是否记住选择 */
  isSelect?: number
  /** 面料id */
  fabricId?: string
  /** 提交页面url */
  submitPageUrl?: string
  /** 商品id */
  entityId?: string
  /** 商品渠道来源 */
  sourceChannel?: number
  /** 授权渠道来源 1:商品页; 2:面料详情页 3:商家页 */
  channel?: number
  /** 咨询商家id */
  teamId?: number
}

/**
 * 商家授权返回信息
 */
export interface FabricUserAuthResponse {
  /** 是否授权 */
  isAuth?: number
  /** 授权id */
  authId?: string
  /** 团队id */
  teamId?: number
  /** 用户id */
  userId?: number
  /** 用户名 */
  userName?: string
  /** 授权电话 */
  authPhone?: string
  /** 默认电话 */
  userPhone?: string
  /** 联系微信号 */
  authWechat?: string
  /** 授权类型  1面料中心授权；2大知衣端授权； 3咨询商家授权； 4手动录入 */
  authType?: number
  /** 面料类型集合 */
  fabricTypeDictList?: string[]
  /** 可选价格区间 */
  priceRangeList?: string[]
  /** 面料类型 - 其他信息（如果选择了'其他'） */
  fabricTypeOther?: string
  /** 用户填写最大价格 */
  maxPrice?: number
  /** 用户填写最低价格 */
  minPrice?: number
  /** 所属团队 */
  teamName?: string
  /** 运营平台 */
  operationPlatformList?: string[]
  /** 主营行业 */
  mainIndustry?: string[]
  /** 分配商家 */
  assignTeamId?: string[]
  /** 分配商家 */
  assignTeamName?: string[]
  /** 创建时间 */
  createdAt?: string
  /** 修改人id */
  updaterId?: number
  /** 修改人姓名 */
  updaterName?: string
  /** 编辑时间 */
  updatedAt?: string
  /** 客户来源 1:智能推荐 2:咨询面料 3:咨询商家 */
  customerOrigin?: number
  /** 咨询面料 */
  fabricInfo?: FabricInfo
  /** 咨询来源 */
  inquirySource?: InquirySource
  /** 备注 */
  remark?: string
  /** 投放方式 1 精准投放；2 智能投放 */
  deliveryType?: number
  /** 是否对该用户打招呼。0.为建联  1.已建联  2.次数耗尽 */
  isGreeted?: number
}

/**
 * ApiResultFabricUserAuthResponse接口类型
 */
export interface ApiResultFabricUserAuthResponse {
  result?: FabricUserAuthResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 关注信息请求参数
 */
export interface FabricUserAuthExtensionRequest {
  /** 授权id */
  authId?: string
  /** 面料类型集合 */
  fabricTypeDictList?: string[]
  /** 价格区间 */
  priceRangeList?: string[]
  /** 面料类型 - 其他信息（如果选择了'其他'） */
  fabricTypeOther?: string
  /** 用户填写最大价格 */
  maxPrice?: number
  /** 用户填写最低价格 */
  minPrice?: number
  /** 运营平台 */
  operationPlatformList?: string[]
  /** 主营行业 */
  mainIndustry?: string[]
  /** 分配商家 */
  assignTeamId?: string[]
  /** 分配商家 */
  assignTeamName?: string[]
  /** 分配面料ID列表 */
  assignFabricId?: string[]
  /** 分配面料详情JSON列表（与 assignFabricId 顺序对应） */
  assignFabricInfo?: string[]
  /** 分配系统外面料图片URL列表（面料不在系统中时使用） */
  assignFabricPicList?: string[]
}

/**
 * PaginationResultFabricSelectXhs接口类型
 */
export interface PaginationResultFabricSelectXhs {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricSelectXhs[]
}

/**
 * ApiResultPaginationResultFabricSelectXhs接口类型
 */
export interface ApiResultPaginationResultFabricSelectXhs {
  result?: PaginationResultFabricSelectXhs
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 查询小红书面料列表请求参数
 */
export interface ListXhsFabricSelectRequest {
  /** 颜色 */
  colorList?: string[]
  /** 面料成分id */
  compositionList?: string[]
  /** 面料类型名称 */
  fabricCategoryList?: string[]
  /** 面料类型id */
  fabricList?: number[]
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 小红书笔记发布时间max */
  maxSourceTime?: string
  /** 小红书笔记发布时间min */
  minSourceTime?: string
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 图案 */
  patternList?: string[]
  /** 适用品类名 */
  purposeList?: string[]
  /** 关键词 */
  searchWord?: string
  /** 适用季节 */
  seasonList?: string[]
  /** 商家 */
  sellerId?: string
  /** 排序字段: xhs_publish_time(发布时间), xhs_like_num(点赞数), xhs_collect_num(收藏数), xhs_comment_num(评论数) */
  sortField?: string
  /** 排序方式 */
  sortType?: string
  /** 分页参数 - 开始记录 */
  start?: number
}

/**
 * PaginationResult_FabricSelectSeller接口类型
 */
export interface PaginationResult_FabricSelectSeller {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricSelectSeller[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_FabricSelectXhs接口类型
 */
export interface ApiResult_FabricSelectXhs {
  errorCode?: string
  errorDesc?: string
  result?: FabricSelectXhs
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricSelectSeller接口类型
 */
export interface ApiResult_PaginationResult_FabricSelectSeller {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricSelectSeller
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricSelectXhs接口类型
 */
export interface ApiResult_PaginationResult_FabricSelectXhs {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricSelectXhs
  success?: boolean
}

/**
 * ApiResult_List_DataDictResponse接口类型
 */
export interface ApiResult_List_DataDictResponse {
  errorCode?: string
  errorDesc?: string
  result?: DataDictResponse[]
  success?: boolean
}

/**
 * PaginationResult_FabricSelectXhs接口类型
 */
export interface PaginationResult_FabricSelectXhs {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricSelectXhs[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_FabricSelectSeller接口类型
 */
export interface ApiResult_FabricSelectSeller {
  errorCode?: string
  errorDesc?: string
  result?: FabricSelectSeller
  success?: boolean
}

/**
 * ApiResultPaginationResultFabricUserAuthResponse接口类型
 */
export interface ApiResultPaginationResultFabricUserAuthResponse {
  result?: PaginationResultFabricUserAuthResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResultPaginationResultFabricCaseInfoQueryDetailResponse接口类型
 */
export interface ApiResultPaginationResultFabricCaseInfoQueryDetailResponse {
  result?: PaginationResultFabricCaseInfoQueryDetailResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料案例分页响应参数
 */
export interface FabricCaseInfoQueryResponse {
  /** 面料货号 */
  articleNo?: string
  /** 面料案例id */
  caseId?: string
  /** 品类 */
  category?: string
  /** 面料品类名 */
  categoryName?: string
  /** 创建时间 */
  createdAt?: string
  /** 创建时间(只有年月日) */
  createdAtCut?: string
  /** 创建人姓名 */
  creatorName?: string
  /** 面料案例图 */
  fabricCasePic?: string
  /** 面料细节图 */
  fabricDetailPic?: string
  /** 面料id */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 商家id */
  teamId?: number
  /** 商家名称 */
  teamName?: string
}

/**
 * ApiResultPaginationResultFabricCaseInfoQueryResponse接口类型
 */
export interface ApiResultPaginationResultFabricCaseInfoQueryResponse {
  result?: PaginationResultFabricCaseInfoQueryResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 案例合集分页响应参数
 */
export interface FabricCaseInfoListResponse {
  /** 面料货号 */
  articleNo?: string
  /** 最新两个面料案例 */
  caseDetails?: string[]
  /** 品类 */
  category?: string
  /** 面料品类名 */
  categoryName?: string
  /** 创建人姓名 */
  creatorName?: string
  /** 面料细节图 */
  fabricDetailPic?: string
  /** 面料id */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 最近更新时间 */
  latestUpdateTime?: string
  /** 最近更新用户姓名 */
  latestUpdaterName?: string
  /** 面料案例数 */
  totalCount?: number
}

/**
 * FabricUserAuthQueryRequest接口类型
 */
export interface FabricUserAuthQueryRequest {
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 编辑时间-开始 */
  startTime?: string
  /** 编辑时间-结束 */
  endTime?: string
  /** 用户名 */
  userName?: string
  /** 手机号 */
  userPhone?: string
  /** 微信号 */
  authWechat?: string
  /** 客户来源 1客户授权；4手动录入 */
  authTypeList?: number[]
  /** 所在企业名称 */
  teamName?: string
  /** 分配商家名称 */
  assignTeamName?: string
  /** 用户名/联系方式搜索框 */
  searchField?: string
  /** sortField：createdAt/updatedAt */
  sortField?: string
  /** 排序方式：asc/desc */
  sortOrder?: string
  /** 授权手机号 */
  authPhone?: string
}

/**
 * ApiResultPaginationResultFabricCaseInfoListResponse接口类型
 */
export interface ApiResultPaginationResultFabricCaseInfoListResponse {
  result?: PaginationResultFabricCaseInfoListResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * PaginationResultFabricCaseInfoQueryDetailResponse接口类型
 */
export interface PaginationResultFabricCaseInfoQueryDetailResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricCaseInfoQueryDetailResponse[]
}

/**
 * 面料案例请求参数
 */
export interface FabricCaseInfoRequest {
  /** 面料案例id */
  caseId?: string
  /** 面料案例图 */
  fabricCasePic?: string
  /** 面料id */
  fabricId?: string
}

/**
 * 面料案例分页请求参数
 */
export interface FabricCaseInfoQueryRequest {
  /** 面料ID */
  fabricId?: string
  /** 面料名称或货号 */
  fabricNameOrArticleNo?: string
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** sortField：createTime，updateTime */
  sortField?: string
  /** sortOrder：asc/desc */
  sortOrder?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 面料商家id */
  teamId?: string
}

/**
 * PaginationResultFabricCaseInfoListResponse接口类型
 */
export interface PaginationResultFabricCaseInfoListResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricCaseInfoListResponse[]
}

/**
 * PaginationResultFabricUserAuthResponse接口类型
 */
export interface PaginationResultFabricUserAuthResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricUserAuthResponse[]
}

/**
 * PaginationResultFabricCaseInfoQueryResponse接口类型
 */
export interface PaginationResultFabricCaseInfoQueryResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricCaseInfoQueryResponse[]
}

/**
 * 案例合集详情分页响应参数
 */
export interface FabricCaseInfoQueryDetailResponse {
  /** 面料案例id */
  caseId?: string
  /** 创建时间(只有年月日) */
  createdAtCut?: string
  /** 面料案例图 */
  fabricCasePic?: string
}

/**
 * 面料灵感标签写入参数
 */
export interface FabricInspirationLabelEditRequest {
  /** 标签id */
  id?: number
  /** 标签名 */
  label?: string
}

/**
 * 面料灵感标签
 */
export interface FabricInspirationLabel {
  /** 标签id */
  id?: number
  /** 标签名 */
  label?: string
  /** 创建时间 */
  createdAt?: string
  /** 修改时间 */
  updatedAt?: string
}

/**
 * PaginationResultFabricInspirationLabel接口类型
 */
export interface PaginationResultFabricInspirationLabel {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricInspirationLabel[]
}

/**
 * ApiResultPaginationResultFabricInspirationLabel接口类型
 */
export interface ApiResultPaginationResultFabricInspirationLabel {
  result?: PaginationResultFabricInspirationLabel
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料灵感标签查询参数
 */
export interface FabricInspirationLabelQryRequest {
  /** 模糊搜索 */
  fuzzySearch?: string
  /** 限制个数，默认100 */
  limit?: number
}

/**
 * 上传面料案例请求参数
 */
export interface FabricCaseInfoAddListRequest {
  /** 上传面料案例合集 */
  fabricCaseInfoRequestList?: FabricCaseInfoRequest[]
}

/**
 * InquirySource接口类型
 */
export interface InquirySource {
  /** 渠道 */
  sourceChannel?: number
  /** 商品 */
  entityId?: string
  /** 提交页面url */
  submitPageUrl?: string
  /** 商品/款式名称 */
  entityName?: string
  /** 商品/款式图片 */
  picUrl?: string
  /** 价格 */
  price?: string
  /** 店铺名字 */
  shopName?: string
  /** 店铺类型 */
  shopType?: number
  /** 服饰站点 */
  dataFrom?: string
}

/**
 * 面料灵感图组
 */
export interface FabricInspirationImageRequest {
  /** 款式图链接 */
  clothPicLink?: string
  /** 款式图url */
  clothPicUrl?: string
  /** 面料id */
  fabricId?: string
  /** 面料图链接 */
  fabricPicLink?: string
  /** 面料图url */
  fabricPicUrl?: string
  /** 面料商家id */
  fabricSellerId?: string
  /** 面料商家url */
  fabricSellerLink?: string
  /** 面料商家名 */
  fabricSellerName?: string
  /** 图组唯一id */
  id?: number
  /** 灵感id */
  inspirationId?: number
  /** 是否可咨询：0-否，1-能 */
  isInquiry?: number
  /** 权重 */
  weight?: number
}

/**
 * 面料灵感写入参数
 */
export interface FabricInspirationEditRequest {
  /** 描述 */
  description?: string
  /** 灵感id */
  id?: number
  /** 图组样式类型：1-款式面料组合，2-单氛围图组合 */
  imageGroupType?: number
  /** 面料图组信息 */
  imageList?: FabricInspirationImageRequest[]
  /** 是否草稿：0-否，1-是 */
  isDraft?: number
  /** 标签id */
  labelIdList?: string[]
  /** 主图（氛围图） */
  mainUrl?: string
  /** 状态：0-停用，1-启用 */
  status?: number
  /** 标题 */
  title?: string
  /** 权重，默认0 */
  weight?: number
}

/**
 * 面料灵感图组
 */
export interface FabricInspirationImage {
  /** 图组唯一id */
  id?: number
  /** 灵感id */
  inspirationId?: number
  /** 款式图url */
  clothPicUrl?: string
  /** 款式图链接 */
  clothPicLink?: string
  /** 面料图url */
  fabricPicUrl?: string
  /** 面料图链接 */
  fabricPicLink?: string
  /** 面料id */
  fabricId?: string
  /** 是否可咨询：0-否，1-能 */
  isInquiry?: number
  /** 面料商家id */
  fabricSellerId?: string
  /** 面料商家名 */
  fabricSellerName?: string
  /** 面料商家url */
  fabricSellerLink?: string
  /** 面料商家信息 */
  fabricSellerInfo?: FabricSelectSeller
  /** 权重 */
  weight?: number
  /** 面料信息 */
  fabricInfo?: FabricInfoDetailResponse
}

/**
 * 面料灵感
 */
export interface FabricInspiration {
  /** 灵感id */
  id?: number
  /** 标题 */
  title?: string
  /** 描述 */
  description?: string
  /** 主图（氛围图） */
  mainUrl?: string
  /** 标签id */
  labelIdList?: string[]
  /** 标签信息 */
  labelList?: FabricInspirationLabel[]
  /** 图组样式类型：1-款式面料组合，2-单氛围图组合 */
  imageGroupType?: number
  /** 权重，默认0 */
  weight?: number
  /** 状态：0-禁用，1-启用 */
  status?: number
  /** 面料图组信息 */
  imageList?: FabricInspirationImage[]
  /** 创建人id */
  creatorId?: number
  /** 创建人 */
  creatorName?: string
  /** 创建时间 */
  createdAt?: string
  /** 是否草稿数据 0否；1是 */
  isDraft?: number
}

/**
 * PaginationResultFabricInspiration接口类型
 */
export interface PaginationResultFabricInspiration {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricInspiration[]
}

/**
 * ApiResultPaginationResultFabricInspiration接口类型
 */
export interface ApiResultPaginationResultFabricInspiration {
  result?: PaginationResultFabricInspiration
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料灵感查询参数
 */
export interface FabricInspirationQryRequest {
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 状态：0-停用，1-启用 */
  status?: number
  /** 模糊搜索 */
  fuzzySearch?: string
  /** 排序：CREATE_TIME(创建时间)，WEIGHT(权重) */
  sortField?: string
}

/**
 * ApiResultFabricInspiration接口类型
 */
export interface ApiResultFabricInspiration {
  result?: FabricInspiration
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResultListFabricInspirationLabel接口类型
 */
export interface ApiResultListFabricInspirationLabel {
  result?: FabricInspirationLabel[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResult_FabricInspiration接口类型
 */
export interface ApiResult_FabricInspiration {
  errorCode?: string
  errorDesc?: string
  result?: FabricInspiration
  success?: boolean
}

/**
 * ApiResult_List_FabricInspirationLabel接口类型
 */
export interface ApiResult_List_FabricInspirationLabel {
  errorCode?: string
  errorDesc?: string
  result?: FabricInspirationLabel[]
  success?: boolean
}

/**
 * PaginationResult_FabricInspiration接口类型
 */
export interface PaginationResult_FabricInspiration {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricInspiration[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_PaginationResult_FabricInspiration接口类型
 */
export interface ApiResult_PaginationResult_FabricInspiration {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricInspiration
  success?: boolean
}

/**
 * FabricSellerRecordStatisticBO接口类型
 */
export interface FabricSellerRecordStatisticBO {
  action?: number
  authPhone?: string
  authWechat?: string
  count?: number
  isAuth?: number
  isGreeted?: number
  maxCreatedAt?: string
  teamId?: number
  teamName?: string
  userId?: number
  userPhone?: string
  username?: string
}

/**
 * 查看商家详情和咨询商家趋势
 */
export interface SellerTrendNode {
  /** 日期 */
  date?: string
  /** 展示日期 */
  displayDate?: string
  /** 咨询次数 */
  inquiryCount?: number
  /** 查看详情次数 */
  viewDetailCount?: number
}

/**
 * ApiResult_long接口类型
 */
export interface ApiResult_long {
  errorCode?: string
  errorDesc?: string
  result?: number
  success?: boolean
}

/**
 * 客户面料需求写入请求
 */
export interface FabricCustomerRequirementRequest {
  id?: number
  /** 找布需求id */
  requirementId?: string
  /** 找布需求描述 */
  referenceDesc?: string
  /** 面料参考图url */
  referencePicList?: string[]
  /** 面料品类 */
  referenceCategory?: string
  /** 面料类别 */
  referenceClassify?: string
  /** 面料克重 */
  referenceWeight?: string
  /** 面料颜色 */
  referenceColor?: string
  /** 面料成分 */
  referenceComposition?: string
  /** 采购数量 */
  referenceVolume?: string
  /** 期望价格 */
  referencePrice?: string
  /** 是否现货: 1-现货，2-可定做 */
  referenceStock?: number
  /** 联系手机号 */
  phone?: string
  /** 联系微信号 */
  wechat?: string
  /** 团队开通产品类型：跨境/国内 */
  teamProductType?: string
  /** 用户ID */
  userId?: number
  /** 用户名 */
  userName?: string
  /** 团队ID */
  teamId?: number
  /** 团队名称 */
  teamName?: string
  /** 来源：1-用户授权，2-手动录入 */
  sourceType?: number
  /** 客服账号 */
  serviceAccount?: string
}

/**
 * 面料客户需求记录
 */
export interface FabricCustomerRequirementResponse {
  /** 记录id */
  id?: number
  /** 找布需求id */
  requirementId?: string
  /** 找布需求描述 */
  referenceDesc?: string
  /** 面料参考图url */
  referencePicList?: string[]
  /** 面料品类 */
  referenceCategory?: string
  /** 面料类别 */
  referenceClassify?: string
  /** 面料克重 */
  referenceWeight?: string
  /** 面料颜色 */
  referenceColor?: string
  /** 面料成分 */
  referenceComposition?: string
  /** 采购数量 */
  referenceVolume?: string
  /** 期望价格 */
  referencePrice?: string
  /** 是否现货: 1-现货，2-可定做 */
  referenceStock?: number
  /** 联系手机号 */
  phone?: string
  /** 联系微信号 */
  wechat?: string
  /** 团队开通产品类型：跨境/国内 */
  teamProductType?: string
  /** 来源：1-用户授权(pc端)，2-手动录入，3-用户授权(小程序) */
  sourceType?: number
  /** 创建时间 */
  createdAt?: string
  /** 客户团队ID */
  teamId?: number
  /** 客户团队名称 */
  teamName?: string
  /** 客户ID */
  userId?: number
  /** 客户名称 */
  userName?: string
  /** 客服账号 */
  serviceAccount?: string
  /** 修改人id */
  updaterId?: number
  /** 修改人姓名 */
  updaterName?: string
  /** 编辑时间 */
  updatedAt?: string
  /** 备注 */
  remark?: string
  /** 需求状态：0-待分配 1-待确认 2-已完成 */
  status?: number
  /** 管理员分配操作：0-未操作 1-已分配 2-不分配 */
  assignType?: number
  /** 客户最新反馈结果：0-未反馈 1-满意 2-不满意 */
  feedbackValue?: number
  /** 客户最新反馈时间 */
  feedbackAt?: string
  /** 分配商家 */
  assignTeamId?: string[]
  /** 分配商家 */
  assignTeamName?: string[]
  /** 分配商家 */
  assignTeamList?: FabricSeller[]
  /** 分配面料ID列表 */
  assignFabricId?: string[]
  /** 分配面料详情列表 */
  assignFabricList?: FabricSelect[]
  /** 分配上传面料图片URL列表 */
  assignFabricPicList?: string[]
  /** 分配补充说明 */
  assignRemark?: string
  /** 是否历史分配过：true-是 */
  assignLogFlag?: boolean
}

/**
 * PaginationResultFabricCustomerRequirementResponse接口类型
 */
export interface PaginationResultFabricCustomerRequirementResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricCustomerRequirementResponse[]
}

/**
 * ApiResultPaginationResultFabricCustomerRequirementResponse接口类型
 */
export interface ApiResultPaginationResultFabricCustomerRequirementResponse {
  result?: PaginationResultFabricCustomerRequirementResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResult_PaginationResult_FabricCaseInfoQueryDetailResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricCaseInfoQueryDetailResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricCaseInfoQueryDetailResponse
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricCaseInfoQueryResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricCaseInfoQueryResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricCaseInfoQueryResponse
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricCustomerRequirementResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricCustomerRequirementResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricCustomerRequirementResponse
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricCaseInfoListResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricCaseInfoListResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricCaseInfoListResponse
  success?: boolean
}

/**
 * PaginationResult_FabricCaseInfoQueryDetailResponse接口类型
 */
export interface PaginationResult_FabricCaseInfoQueryDetailResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricCaseInfoQueryDetailResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_FabricConversationResponse接口类型
 */
export interface ApiResult_FabricConversationResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricConversationResponse
  success?: boolean
}

/**
 * FabricConversationResponse接口类型
 */
export interface FabricConversationResponse {
  /** 联系地址 */
  address?: string
  /** 联系微信号 */
  authWechat?: string
  /** 对方头像 */
  avatar?: string
  /** 企业logo */
  companyLogo?: string
  /** 消息内容 */
  content?: string
  /** 会话ID */
  conversationId?: string
  /** 未读消息 */
  countMessage?: number
  /** 会话创建时间 */
  createdAt?: string
  /** 商品id */
  entityId?: string
  /** 商品详情页 */
  entitySubmitUrl?: string
  /** 面料id */
  fabricId?: string
  fabricInfo?: FabricInfo
  /** 面料渠道来源 0自主上传 6小红书 */
  fabricSourceChannel?: number
  /** 商家状态 0、关闭；1、活跃 */
  fabricStatus?: number
  /** 面料详情页 */
  fabricSubmitUrl?: string
  /** 面料团队id */
  fabricTeamId?: number
  /** 面料团队名称 */
  fabricTeamName?: string
  /** 面料用户id */
  fabricUserId?: number
  /** 是否客服 0:否 1:是 */
  isCustomer?: number
  /** 已读 0、否；1、是 */
  isRead?: number
  /** 是否系统消息 0、否；1、是 */
  isSystem?: number
  /** 是否置顶 0、否；1、是 */
  isTop?: number
  /** 最后联系时间 */
  lastMessageTime?: string
  /** 消息创建时间 */
  messageCreatedAt?: string
  productInfo?: ProductInfo
  /** 未读消息 */
  remark?: string
  /** 来源 1、商品；2、面料 */
  source?: number
  /** 商品渠道来源 */
  sourceChannel?: number
  /** 用户状态 0、关闭；1、活跃 */
  status?: number
  /** 团队id */
  teamId?: number
  teamInfo?: TeamInfo
  /** 团队名称 */
  teamName?: string
  /** 商家详情页 */
  teamSubmitUrl?: string
  /** 消息类型 1、文本；2、图片；3、面料；4、商品；5、面料案例；6、联系方式；7、找布需求；8、找布需求分配结果；9、辅料 */
  type?: number
  /** 用户id */
  userId?: number
  /** 用户名称 */
  userName?: string
  /** 用户手机号 */
  userPhone?: string
}

/**
 * ApiResult_PaginationResult_FabricPromotionProjectResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricPromotionProjectResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricPromotionProjectResponse
  success?: boolean
}

/**
 * ApiResult_FabricPromotionProjectResponse接口类型
 */
export interface ApiResult_FabricPromotionProjectResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricPromotionProjectResponse
  success?: boolean
}

/**
 * PaginationResult_FabricCaseInfoListResponse接口类型
 */
export interface PaginationResult_FabricCaseInfoListResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricCaseInfoListResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * PaginationResult_FabricCustomerRequirementResponse接口类型
 */
export interface PaginationResult_FabricCustomerRequirementResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricCustomerRequirementResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * PaginationResult_FabricCaseInfoQueryResponse接口类型
 */
export interface PaginationResult_FabricCaseInfoQueryResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricCaseInfoQueryResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * PaginationResult_FabricPromotionProjectResponse接口类型
 */
export interface PaginationResult_FabricPromotionProjectResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricPromotionProjectResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * 用户会话请求参数（新增、修改、删除时用）
 */
export interface FabricConversationEditRequest {
  /** 会话ID */
  conversationId?: string
  /** 商品id */
  entityId?: string
  /** 商品详情页 */
  entitySubmitUrl?: string
  /** 面料id */
  fabricId?: string
  /** 面料渠道来源 0自主上传 6小红书 */
  fabricSourceChannel?: number
  /** 商家状态 0、关闭；1、活跃 */
  fabricStatus?: number
  /** 面料详情页 */
  fabricSubmitUrl?: string
  /** 面料团队id */
  fabricTeamId?: number
  /** 面料用户id */
  fabricUserId?: number
  /** id */
  id?: number
  /** 置顶 0、否；1、是 */
  isTop?: number
  /** 备注 */
  remark?: string
  /** 来源 1、商品；2、面料；3、商家；4、智能推荐 */
  source?: number
  /** 商品渠道来源 */
  sourceChannel?: number
  /** 用户状态 0、关闭；1、活跃 */
  status?: number
  /** 团队id */
  teamId?: number
  /** 商家详情页 */
  teamSubmitUrl?: string
  /** 1、直接聊 2、打招呼 */
  type?: number
  /** 只看未读 0、否；1、是 */
  unreadOnly?: number
  /** 用户id */
  userId?: number
}

/**
 * FabricMessageResponse接口类型
 */
export interface FabricMessageResponse {
  /** 消息内容 */
  content?: string
  /** 会话ID */
  conversationId?: string
  /** 创建时间 */
  createdAt?: string
  /** 删除时间 */
  deletedAt?: string
  /** 发送方团队id */
  fromTeamId?: number
  /** 发送方用户id */
  fromUserId?: number
  /** 主键ID */
  id?: number
  /** 已读 0、否；1、是 */
  isRead?: number
  /** 是否系统消息 0、否；1、是 */
  isSystem?: number
  /** 发送时间 */
  sendTime?: number
  /** 接收方团队id */
  toTeamId?: number
  /** 接收方用户id */
  toUserId?: number
  /** 消息类型 1、文本；2、图片；3、面料；4、商品；5、面料案例；6、联系方式；7、找布需求；8、找布需求分配结果；9、辅料 */
  type?: number
  /** 更新时间 */
  updatedAt?: string
}

/**
 * ApiResult_PaginationResult_FabricMessageResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricMessageResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricMessageResponse
  success?: boolean
}

/**
 * PaginationResult_FabricMessageResponse接口类型
 */
export interface PaginationResult_FabricMessageResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricMessageResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_List_FabricConversationResponse接口类型
 */
export interface ApiResult_List_FabricConversationResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricConversationResponse[]
  success?: boolean
}

/**
 * ApiResult_FabricMessageResponse接口类型
 */
export interface ApiResult_FabricMessageResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricMessageResponse
  success?: boolean
}

/**
 * FabricMessageQueryRequest接口类型
 */
export interface FabricMessageQueryRequest {
  /** 会话ID */
  conversationId?: string
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 开始记录 */
  start?: number
}

/**
 * 用户聊天请求参数（新增、修改、删除时用）
 */
export interface FabricMessageEditRequest {
  /** 消息内容 */
  content?: string
  /** 会话ID */
  conversationId?: string
  /** 发送方团队id */
  fromTeamId?: number
  /** 发送方用户id */
  fromUserId?: number
  /** 主键ID */
  id?: number
  /** 已读 0、否；1、是 */
  isRead?: number
  /** 是否系统消息 0、否；1、是 */
  isSystem?: number
  /** 接收方团队id */
  toTeamId?: number
  /** 接收方用户id */
  toUserId?: number
  /** 消息类型 1、文本；2、图片；3、面料；4、商品；5、面料案例；6、联系方式；7、找布需求；8、找布需求分配结果；9、辅料 */
  type?: number
}

/**
 * ProductInfo接口类型
 */
export interface ProductInfo {
  /** 货币单位 */
  currency?: string
  /** 服饰站点 */
  dataFrom?: string
  /** 商品ID */
  entityId?: string
  /** 商品名称 */
  entityName?: string
  /** 商品图片 */
  picUrl?: string
  /** 商品价格 */
  price?: string
  /** 店铺名称 */
  shopName?: string
  /** 店铺类型 */
  shopType?: number
  /** 来源渠道 */
  sourceChannel?: number
  /** 提交页面URL */
  submitPageUrl?: string
}

/**
 * ApiResult_FabricUserSettingResponse接口类型
 */
export interface ApiResult_FabricUserSettingResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricUserSettingResponse
  success?: boolean
}

/**
 * 用户消息免打扰
 */
export interface FabricUserMassagesSettingRequest {
  /** 商家端状态：是否免打扰 0、否；1、是 */
  fabricStatus?: number
  /** 用户端状态：是否免打扰 0、否；1、是 */
  status?: number
}

/**
 * FabricUserSettingResponse接口类型
 */
export interface FabricUserSettingResponse {
  /** 商家端状态：是否免打扰 0、否；1、是 */
  fabricStatus?: number
  /** 主键ID */
  id?: number
  /** 用户端状态：是否免打扰 0、否；1、是 */
  status?: number
  /** 团队id */
  teamId?: number
  /** 团队名称 */
  teamName?: string
  /** 用户id */
  userId?: number
  /** 用户名称 */
  userName?: string
}

/**
 * 查询关联推广面料
 */
export interface QueryPromotionFabricRequest {
  /** 关联实体id */
  entityId?: string
  /** 排除的面料列表 */
  excludeFabricIdList?: string[]
  /** 来源渠道 */
  sourceChannel?: number
}

/**
 * ApiResult_FabricProductAssociation接口类型
 */
export interface ApiResult_FabricProductAssociation {
  errorCode?: string
  errorDesc?: string
  result?: FabricProductAssociation
  success?: boolean
}

/**
 * ApiResult_FabricMessageLimitResponse接口类型
 */
export interface ApiResult_FabricMessageLimitResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricMessageLimitResponse
  success?: boolean
}

/**
 * FabricMessageLimitResponse接口类型
 */
export interface FabricMessageLimitResponse {
  /** 未读消息数量 */
  messageCount?: number
  /** 打招呼剩余次数 */
  messageLimit?: number
  /** 打招呼权限 0无；1有 */
  messageSetting?: number
}

/**
 * ApiResult_PaginationResult_FabricMerchantDetailsResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricMerchantDetailsResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricMerchantDetailsResponse
  success?: boolean
}

/**
 * ApiResult_FabricTeamInfoResponse接口类型
 */
export interface ApiResult_FabricTeamInfoResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricTeamInfoResponse
  success?: boolean
}

/**
 * PaginationResult_FabricMerchantDetailsResponse接口类型
 */
export interface PaginationResult_FabricMerchantDetailsResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricMerchantDetailsResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * FabricRequirementQueryRequest接口类型
 */
export interface FabricRequirementQueryRequest {
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 编辑时间-开始 */
  createTimeStart?: string
  /** 编辑时间-结束 */
  createTimeEnd?: string
  /** 录入时间-开始 */
  updateTimeStart?: string
  /** 录入时间-结束 */
  updateTimeEnd?: string
  /** 用户名 */
  userName?: string
  /** 手机号 */
  phone?: string
  /** 微信号 */
  wechat?: string
  /** 客户来源 1-用户授权，2-手动录入 */
  sourceTypeList?: number[]
  /** 状态：1-待分配，2-待确认，3-完成 */
  status?: number
  /** 客户反馈结果：0-未反馈 1-满意 2-不满意 */
  feedbackValue?: number
  /** 所在企业名称 */
  teamName?: string
  /** 分配商家名称 */
  assignTeamName?: string
  /** 用户名/联系方式搜索框 */
  searchField?: string
  /** sortField */
  sortField?: string
  /** 排序方式：asc/desc */
  sortOrder?: string
}

/**
 * 记录推广面料曝光参数
 */
export interface QueryPromotionFabricRecordRequest {
  /** 关联实体id */
  entityId?: string
  /** 推广面料 */
  promotionFabrics?: PromotionFabric[]
  /** 来源渠道 */
  sourceChannel?: number
}

/**
 * 商家推广数据
 */
export interface SellerPromotionData {
  /** 客户线索数量 */
  adminCount?: number
  /** 咨询商家记录 */
  inquirySellerDetailRecordList?: FabricSellerRecordStatisticBO[]
  /** 商家显示趋势图 */
  sellerNodes?: Node[]
  /** 咨询量 */
  totalInquiryCount?: number
  /** 访客数 */
  totalViewDetailByUserCount?: number
  /** 浏览量 */
  totalViewDetailCount?: number
  /** 查看商家详情记录 */
  viewSellerDetailRecordList?: FabricSellerRecordStatisticBO[]
}

/**
 * 推广趋势节点
 */
export interface Node {
  /** 消费次数 */
  consumeCount?: number
  /** 日期 */
  date?: string
  /** 展示日期 */
  displayDate?: string
  /** 咨询次数 */
  inquiryCount?: number
  /** 访客数 */
  viewDetailByUserCount?: number
  /** 浏览次数 */
  viewDetailCount?: number
}

/**
 * ApiResult_PromotionSellerDataResponse接口类型
 */
export interface ApiResult_PromotionSellerDataResponse {
  errorCode?: string
  errorDesc?: string
  result?: PromotionSellerDataResponse
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricRankListResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricRankListResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricRankListResponse
  success?: boolean
}

/**
 * 面料列表查询请求参数
 */
export interface FabricInfoRankQueryRequest {
  /** 统计结束时间 */
  endDate?: string
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** sortField */
  sortField?: string
  /** 排序方式：asc/desc */
  sortOrder?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 统计开始时间 */
  startDate?: string
}

/**
 * 面料排行列表返回信息
 */
export interface FabricRankListResponse {
  /** 货号 */
  articleNo?: string
  /** 品类 */
  category?: string
  /** 面料细节图 */
  fabricDetailPic?: string
  /** 面料id */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 面料最大售价 */
  priceMax?: string
  /** 面料最小售价 */
  priceMin?: string
  /** 面料销售单位 */
  priceUnit?: string
  /** 咨询量 */
  rankInquiryCount?: number
  /** 访客数 */
  rankViewDetailByUserCount?: number
  /** 浏览量 */
  rankViewDetailCount?: number
  /** 上下架状态 1审核驳回；2已下架；3在售；4审核中 */
  shelfStatus?: number
  /** 状态 1未推广；2审核中；3推广中；4已结束；5不通过 */
  status?: number
}

/**
 * PaginationResult_FabricRankListResponse接口类型
 */
export interface PaginationResult_FabricRankListResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricRankListResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * 面料和商家的访问及咨询数据，不区分是否为推广产生的数据
 */
export interface PromotionSellerDataResponse {
  fabricPromotionData?: FabricPromotionData
  /** 最近更新时间 */
  latestUpdateTime?: string
  sellerPromotionData?: SellerPromotionData
}

/**
 * 面料推广数据
 */
export interface FabricPromotionData {
  /** 面料显示趋势图 */
  fabricNodes?: Node[]
  /** 咨询记录 */
  inquiryDetailRecordList?: FabricPromotionRecordStatisticBO[]
  /** 咨询量 */
  totalInquiryCount?: number
  /** 访客数 */
  totalViewDetailByUserCount?: number
  /** 浏览量 */
  totalViewDetailCount?: number
  /** 查看详情记录 */
  viewDetailRecordList?: FabricPromotionRecordStatisticBO[]
}

/**
 * 推广动态
 */
export interface FabricPromotionStatistic {
  /** 环比时间 */
  chainEndDate?: string
  /** 环比时间 */
  chainStartDate?: string
  /** 上期消费咨询转化率 */
  comparisonConsultationConversionRate?: number
  /** 上期面料消费次数 */
  comparisonConsumeCount?: number
  /** 上期面料咨询次数 */
  comparisonInquiryCount?: number
  /** 消费咨询转化率 */
  consultationConversionRate?: number
  /** 面料消费次数 */
  consumeCount?: number
  /** 即将结束推广项目数 */
  endProjectCount?: number
  /** 面料咨询次数 */
  inquiryCount?: number
  /** 进行中推广项目数 */
  projectCount?: number
}

/**
 * 数据概览
 */
export interface FabricOverviewStatistic {
  /** 环比时间 */
  chainEndDate?: string
  /** 环比时间 */
  chainStartDate?: string
  /** 上期面料咨询次数 */
  comparisonInquiryCount?: number
  /** 上期商家咨询次数 */
  comparisonSellerInquiryCount?: number
  /** 上期商家主页浏览次数 */
  comparisonSellerViewCount?: number
  /** 上期面料浏览次数 */
  comparisonViewCount?: number
  /** 面料数 */
  fabricCount?: number
  /** 在售面料数 */
  fabricOnSaleCount?: number
  /** 面料咨询次数 */
  inquiryCount?: number
  /** 商家咨询次数 */
  sellerInquiryCount?: number
  /** 商家主页浏览次数 */
  sellerViewCount?: number
  /** 面料浏览次数 */
  viewCount?: number
}

/**
 * PromotionDetailResponse接口类型
 */
export interface PromotionDetailResponse {
  /** 推广动态趋势 */
  accurateTrendNodes?: TrendNode[]
  fabricOverviewStatistic?: FabricOverviewStatistic
  fabricPromotionStatistic?: FabricPromotionStatistic
  fabricTeamInfoResponse?: FabricTeamInfoResponse
  /** 打招呼次数 */
  greetingCount?: number
  /** 打招呼权限 0无；1有 */
  messageSetting?: number
  /** 剩余消费次数 */
  restConsumeCount?: number
  /** 剩余打招呼次数 */
  surplusGreetingCount?: number
  /** 已用消费次数 */
  totalConsumeCount?: number
}

/**
 * ApiResult_PromotionDetailResponse接口类型
 */
export interface ApiResult_PromotionDetailResponse {
  errorCode?: string
  errorDesc?: string
  result?: PromotionDetailResponse
  success?: boolean
}

/**
 * ApiResult_FabricPromotionDataResponse接口类型
 */
export interface ApiResult_FabricPromotionDataResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricPromotionDataResponse
  success?: boolean
}

/**
 * 布匹推广概览
 */
export interface FabricPromotionDataResponse {
  accurateData?: AccurateData
  /** 布匹推广中数量 */
  inPromotionFabricCount?: number
  /** 智能投放数据 */
  inquiryDetailRecordList?: FabricPromotionRecordStatisticBO[]
  intelligentData?: IntelligentData
  /** 最近更新时间 */
  latestUpdateTime?: string
  /** 剩余消费次数 */
  restConsumeCount?: number
  /** 消费次数 */
  totalConsumeCount?: number
  /** 查看详情记录 */
  viewDetailRecordList?: FabricPromotionRecordStatisticBO[]
}

/**
 * 精准投放数据
 */
export interface AccurateData {
  /** 面料显示趋势图 */
  accurateNodes?: Node[]
  /** 消费次数 */
  consumeCount?: number
  /** 商品/款式推广中数量 */
  inPromotionEntityCount?: number
  /** 咨询量 */
  totalInquiryCount?: number
  /** 浏览量 */
  totalViewDetailCount?: number
}

/**
 * ApiResult_PaginationResult_FabricProjectRankListResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricProjectRankListResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricProjectRankListResponse
  success?: boolean
}

/**
 * 推广项目下对应面料数据请求数据
 */
export interface FabricProjectRankFabricListRequest {
  /** 统计结束时间 */
  endDate?: string
  /** 面料id集合 */
  ids?: string[]
  /** 项目id */
  projectId: string
  /** sortField */
  sortField?: string
  /** 排序方式：asc/desc */
  sortOrder?: string
  /** 统计开始时间 */
  startDate?: string
}

/**
 * 智能投放数据
 */
export interface IntelligentData {
  /** 消费次数 */
  consumeCount?: number
  /** 系统商品/款式推广中数量 */
  inPromotionSystemEntityCount?: number
  /** 面料显示趋势图 */
  intelligentNodes?: Node[]
  /** 进度 */
  progress?: number
  /** 咨询量 */
  totalInquiryCount?: number
  /** 浏览量 */
  totalViewDetailCount?: number
}

/**
 * PaginationResult_FabricProjectRankListResponse接口类型
 */
export interface PaginationResult_FabricProjectRankListResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricProjectRankListResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * 推广项目下对应面料数据响应数据
 */
export interface FabricProjectRankFabricListResponse {
  /** 面料数据集合 */
  fabricRankListResponseList?: FabricRankListResponse[]
}

/**
 * ApiResult_FabricProjectRankFabricListResponse接口类型
 */
export interface ApiResult_FabricProjectRankFabricListResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricProjectRankFabricListResponse
  success?: boolean
}

/**
 * 推广项目排行列表返回信息
 */
export interface FabricProjectRankListResponse {
  /** 消耗次数 */
  consumeCount?: number
  /** 投放方式 1 精准投放；2 智能投放 */
  deliveryType?: number
  /** 主键ID */
  id?: number
  /** 推广项目下的面料集合id */
  ids?: string[]
  /** 咨询次数 */
  inquiryCount?: number
  /** 项目id */
  projectId: string
  /** 项目名称 */
  projectName: string
  /** 状态 1未审核；2审核中；3不通过；4进行中；5已暂停；6已结束; 7未开始 */
  status?: number
}

/**
 * PromotionProject接口类型
 */
export interface PromotionProject {
  /** 创建时间 */
  createdAt?: string
  /** 投放方式 1 精准投放；2 智能投放 */
  deliveryType?: number
  /** 项目id */
  projectId?: string
  /** 项目名称 */
  projectName?: string
  /** 状态 1未审核；2审核中；3不通过；4进行中；5已暂停；6已结束; 7未开始 */
  status?: number
}

/**
 * 面料精选标签管理
 */
export interface FabricSelectKeywordEditRequest {
  /** id */
  id?: number
  /** 搜索关键词 */
  keyword?: string
  /** 关联链接 */
  link?: string
  /** 关联多个搜索词，逗号分隔 */
  relatedWords?: string
  /** 状态：0-下架，1-上架 */
  status?: number
  /** 权重，越大越靠前 */
  weight?: number
}

/**
 * 面料精选标签管理
 */
export interface FabricSelectKeywordResponse {
  /** 创建时间 */
  createdAt?: string
  /** 创建人 */
  creator?: string
  /** 创建人id */
  creatorId?: number
  /** 修改人 */
  editor?: string
  /** 修改人id */
  editorId?: number
  /** id */
  id?: number
  /** 搜索关键词 */
  keyword?: string
  /** 关联链接 */
  link?: string
  /** 关联多个搜索词，逗号分隔 */
  relatedWords?: string
  /** 状态：0-下架，1-上架 */
  status?: number
  /** 修改时间 */
  updatedAt?: string
  /** 权重，越大越靠前 */
  weight?: number
}

/**
 * PaginationResultFabricSelectKeywordResponse接口类型
 */
export interface PaginationResultFabricSelectKeywordResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricSelectKeywordResponse[]
}

/**
 * ApiResultPaginationResultFabricSelectKeywordResponse接口类型
 */
export interface ApiResultPaginationResultFabricSelectKeywordResponse {
  result?: PaginationResultFabricSelectKeywordResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料精选标签管理查询参数
 */
export interface FabricSelectKeywordQryRequest {
  /** 搜索关键词 */
  keyword?: string
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 状态：0-下架，1-上架 */
  status?: number
}

/**
 * ApiResultListFabricSelectKeywordResponse接口类型
 */
export interface ApiResultListFabricSelectKeywordResponse {
  result?: FabricSelectKeywordResponse[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResultLong接口类型
 */
export interface ApiResultLong {
  result?: number
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料中心置顶推广参数
 */
export interface FabricSelectTopSettingEditRequest {
  /** 跨境生效时间结束 */
  abroadEffectiveTimeEnd?: string
  /** 跨境生效时间开始 */
  abroadEffectiveTimeStart?: string
  /** 跨境排序 */
  abroadSort?: number
  /** 国内生效时间结束 */
  domesticEffectiveTimeEnd?: string
  /** 国内生效时间开始 */
  domesticEffectiveTimeStart?: string
  /** 国内排序 */
  domesticSort?: number
  /** 生效时间结束 */
  effectiveTimeEnd?: string
  /** 生效时间开始 */
  effectiveTimeStart?: string
  /** 面料id */
  fabricId?: string
  /** 推广数据id */
  id?: number
  /** 排序 */
  sort?: number
}

/**
 * 面料中心置顶推广信息
 */
export interface FabricSelectTopSettingResponse {
  /** 置顶推广数据id */
  topSettingId?: number
  /** 置顶推广生效时间start */
  effectiveTimeStart?: string
  /** 置顶推广生效时间end */
  effectiveTimeEnd?: string
  /** 排序 */
  sort?: number
  /** 国内生效时间开始 */
  domesticEffectiveTimeStart?: string
  /** 国内生效时间结束 */
  domesticEffectiveTimeEnd?: string
  /** 国内排序 */
  domesticSort?: number
  /** 跨境生效时间开始 */
  abroadEffectiveTimeStart?: string
  /** 跨境生效时间结束 */
  abroadEffectiveTimeEnd?: string
  /** 跨境排序 */
  abroadSort?: number
}

/**
 * PaginationResult_FabricTagRelationResponse接口类型
 */
export interface PaginationResult_FabricTagRelationResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricTagRelationResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * FabricTagDictResponse接口类型
 */
export interface FabricTagDictResponse {
  /** 创建时间 */
  createdAt?: string
  /** 创建人id */
  creatorId?: number
  /** 创建人姓名 */
  creatorName?: string
  /** 关联面料数 */
  fabricCount?: number
  id?: number
  /** 是否显示热门icon 0否；1是； */
  isIcon?: number
  /** 备注 */
  remark?: string
  /** 状态 0未启用；1启用； */
  status?: number
  /** 标签颜色 */
  tagColor?: string
  /** 标签id */
  tagId?: string
  /** 标签名称 */
  tagName?: string
  /** 更新时间 */
  updatedAt?: string
  /** 修改人id */
  updaterId?: number
  /** 修改人姓名 */
  updaterName?: string
}

/**
 * ApiResult_PaginationResult_FabricTagDictResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricTagDictResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricTagDictResponse
  success?: boolean
}

/**
 * UserFabricTagReferenceResponse接口类型
 */
export interface UserFabricTagReferenceResponse {
  /** id */
  id?: number
  /** 是否显示热门icon 0否；1是； */
  isIcon?: number
  /** 排序 */
  sort?: number
  /** 标签颜色 */
  tagColor?: string
  /** 标签id */
  tagId?: string
  /** 标签名称 */
  tagName?: string
  /** 商家id */
  teamId?: number
  /** 商家名称 */
  teamName?: string
}

/**
 * ApiResult_List_UserFabricTagReferenceResponse接口类型
 */
export interface ApiResult_List_UserFabricTagReferenceResponse {
  errorCode?: string
  errorDesc?: string
  result?: UserFabricTagReferenceResponse[]
  success?: boolean
}

/**
 * ApiResult_List_FabricTagDictResponse接口类型
 */
export interface ApiResult_List_FabricTagDictResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricTagDictResponse[]
  success?: boolean
}

/**
 * FabricTagQueryRequest接口类型
 */
export interface FabricTagQueryRequest {
  /** 创建人名称 */
  creatorName?: string
  /** 创建时间-结束 */
  endTime?: string
  /** 分页参数 - 查询上限 */
  limit?: number
  operator?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 创建时间-开始 */
  startTime?: string
  /** 状态 0未启用；1启用； */
  status?: number
  /** 标签id */
  tagId?: string
  /** 标签名称 */
  tagName?: string
  /** 商家id 运营操作必传 */
  teamId?: number
}

/**
 * PaginationResult_FabricTagDictResponse接口类型
 */
export interface PaginationResult_FabricTagDictResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricTagDictResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * FabricTagReferenceEditRequest接口类型
 */
export interface FabricTagReferenceEditRequest {
  /** 面料id */
  fabricId?: string
  /** 面料id集合 */
  fabricIdList?: string[]
  operator?: number
  /** 标签id */
  tagId?: string
  /** 引用标签数组 */
  tagIdList?: string[]
  /** 商家id 运营操作必传 */
  teamId?: number
}

/**
 * FabricTagDictEditRequest接口类型
 */
export interface FabricTagDictEditRequest {
  /** 是否显示热门icon 0否；1是； */
  isIcon?: number
  /** 备注 */
  remark?: string
  /** 状态 0未启用；1启用； */
  status?: number
  /** 标签颜色 */
  tagColor?: string
  /** 标签id(修改删除时传入) */
  tagId?: string
  /** 标签名称 */
  tagName?: string
}

/**
 * FabricTag接口类型
 */
export interface FabricTag {
  /** 是否显示热门icon 0否；1是； */
  isIcon?: number
  /** 标签颜色 */
  tagColor?: string
  /** 标签id */
  tagId?: string
  /** 标签名称 */
  tagName?: string
}

/**
 * ApiResult_PaginationResult_FabricTagRelationResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricTagRelationResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricTagRelationResponse
  success?: boolean
}

/**
 * FabricTagRelationResponse接口类型
 */
export interface FabricTagRelationResponse {
  /** 货号 */
  articleNo?: string
  /** 品类 */
  category?: string
  /** 面料细节图 */
  fabricDetailPic?: string
  /** 面料id */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 面料关联标签 */
  fabricTagList?: FabricTag[]
  /** id */
  id?: number
  /** 面料最大售价 */
  priceMax?: string
  /** 面料最小售价 */
  priceMin?: string
  /** 面料销售单位 */
  priceUnit?: string
}

/**
 * 面料中心商家置顶推广参数
 */
export interface FabricSelectSellerTopSettingEditRequest {
  /** 跨境生效时间结束 */
  abroadEffectiveTimeEnd?: string
  /** 跨境生效时间开始 */
  abroadEffectiveTimeStart?: string
  /** 跨境排序 */
  abroadSort?: number
  /** 国内生效时间结束 */
  domesticEffectiveTimeEnd?: string
  /** 国内生效时间开始 */
  domesticEffectiveTimeStart?: string
  /** 国内排序 */
  domesticSort?: number
  /** 生效时间结束 */
  effectiveTimeEnd?: string
  /** 生效时间开始 */
  effectiveTimeStart?: string
  /** 推广数据id */
  id?: number
  /** 面料商家id */
  sellerId?: string
  /** 排序 */
  sort?: number
}

/**
 * Composition2接口类型
 */
export interface Composition2 {
  /** 成分名称(传字典id) */
  name?: string
  /** 成分含量 */
  composition?: string
}

/**
 * FirstLevelClassifyVO接口类型
 */
export interface FirstLevelClassifyVO {
  classifyId?: string
  classifyName?: string
  fabricIdList?: string[]
  secondLevelClassifyList?: SecondLevelClassifyVO[]
  sort?: number
}

/**
 * FabricShopClassifyResponse接口类型
 */
export interface FabricShopClassifyResponse {
  /** 面料分类列表 */
  firstLevelClassifyList?: FirstLevelClassifyVO[]
  /** 是否草稿数据 0否；1是 */
  isDraft?: number
  /** 最新编辑时间 */
  updatedAt?: string
}

/**
 * FabricShopSettingEditRequest接口类型
 */
export interface FabricShopSettingEditRequest {
  /** 分类页状态 0未启用；1启用； */
  classifyStatus?: number
  operator?: number
  /** 推荐页状态 0未启用；1启用； */
  recommendStatus?: number
  /** 商家id 运营操作必传 */
  teamId?: number
}

/**
 * ApiResult_FabricShopSettingResponse接口类型
 */
export interface ApiResult_FabricShopSettingResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricShopSettingResponse
  success?: boolean
}

/**
 * FabricShopClassifySaveRequest接口类型
 */
export interface FabricShopClassifySaveRequest {
  /** 一级分类列表 */
  firstLevelClassifyList?: FirstLevelClassify[]
  operator?: number
  /** 商家id 运营操作必传 */
  teamId?: number
}

/**
 * ApiResult_FabricShopClassifyResponse接口类型
 */
export interface ApiResult_FabricShopClassifyResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricShopClassifyResponse
  success?: boolean
}

/**
 * SecondLevelClassify接口类型
 */
export interface SecondLevelClassify {
  /** 分类名称 */
  classifyName?: string
  /** 直接关联的面料ID列表 */
  fabricIdList?: string[]
}

/**
 * FabricShopSettingResponse接口类型
 */
export interface FabricShopSettingResponse {
  /** 分类页状态 0未启用；1启用； */
  classifyStatus?: number
  /** 推荐页是否草稿数据 0否；1是 */
  isDraftRecommend?: number
  /** 推荐页状态 0未启用；1启用； */
  recommendStatus?: number
  teamId?: number
  /** 推荐页最新编辑时间 */
  updatedAtRecommend?: string
}

/**
 * FirstLevelClassify接口类型
 */
export interface FirstLevelClassify {
  /** 分类名称 */
  classifyName?: string
  /** 直接关联的面料ID列表 */
  fabricIdList?: string[]
  /** 二级分类列表 */
  secondLevelClassifyList?: SecondLevelClassify[]
}

/**
 * SecondLevelClassifyVO接口类型
 */
export interface SecondLevelClassifyVO {
  classifyId?: string
  classifyName?: string
  fabricIdList?: string[]
  sort?: number
}

/**
 * ApiResultListFirstLevelClassifyVO接口类型
 */
export interface ApiResultListFirstLevelClassifyVO {
  result?: FirstLevelClassifyVO[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 商家记录
 */
export interface FabricSeller {
  /** 商家ID */
  sellerId?: number
  /** 团队ID */
  teamId?: number
  /** 商家名称 */
  sellerName?: string
  /** 商家logo */
  sellerLogo?: string
  /** 主要产品 */
  primaryProducts?: string
  /** 国家 */
  country?: string
  /** 省份 */
  province?: string
  /** 城市 */
  city?: string
  /** 区县 */
  district?: string
  /** 详细地址 */
  address?: string
  /** 商家介绍 */
  profile?: string
  /** 成立时间 */
  establishAt?: string
  /** 工厂面积 */
  factoryArea?: number
  /** 员工数量 */
  staffNum?: number
  /** 联系人 */
  contactPerson?: string
  /** 联系电话 */
  contactPhone?: string
  /** 微信二维码 */
  wechatQrCode?: string
  /** 商家介绍视频 */
  introductionVideo?: string
  /** 是否有操作权限 0无；1有 */
  isAuthorized?: number
  /** 超管id */
  userId?: number
  /** 操作人名称 */
  operatorName?: string
  /** 操作时间 */
  operateTime?: string
}

/**
 * ApiResultFabricSeller接口类型
 */
export interface ApiResultFabricSeller {
  result?: FabricSeller
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 商家记录
 */
export interface FabricSellerReview {
  /** 详细地址 */
  address?: string
  /** 城市 */
  city?: string
  /** 联系人 */
  contactPerson?: string
  /** 联系电话 */
  contactPhone?: string
  /** 国家 */
  country?: string
  /** 区县 */
  district?: string
  /** 成立时间 */
  establishAt?: string
  /** 工厂面积 */
  factoryArea?: number
  /** 商家介绍视频 */
  introductionVideo?: string
  /** 主要产品 */
  primaryProducts?: string
  /** 商家介绍 */
  profile?: string
  /** 省份 */
  province?: string
  /** 拒绝原因 */
  rejectReason?: string
  /** 审核时间 */
  reviewAt?: string
  /** 审核ID */
  reviewId?: string
  /** 审核状态 */
  reviewStatus?: number
  /** 审核人ID */
  reviewer?: number
  /** 审核人姓名 */
  reviewerName?: string
  /** 商家ID */
  sellerId?: number
  /** 商家logo */
  sellerLogo?: string
  /** 商家名称 */
  sellerName?: string
  /** 员工数量 */
  staffNum?: number
  /** 提交时间 */
  submitAt?: string
  /** 提交人ID */
  submitter?: number
  /** 提交人姓名 */
  submitterName?: string
  /** 提交人手机号 */
  submitterPhone?: string
  /** 团队ID */
  teamId?: number
  /** 微信二维码 */
  wechatQrCode?: string
}

/**
 * ApiResultFabricSellerReview接口类型
 */
export interface ApiResultFabricSellerReview {
  result?: FabricSellerReview
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 商家审核请求
 */
export interface SellerReviewRequest {
  /** 详细地址 */
  address?: string
  /** 城市 */
  city?: string
  /** 联系人 */
  contactPerson?: string
  /** 联系电话 */
  contactPhone?: string
  /** 国家 */
  country?: string
  /** 区县 */
  district?: string
  /** 成立时间 */
  establishAt?: string
  /** 工厂面积 */
  factoryArea?: number
  /** 商家介绍视频 */
  introductionVideo?: string
  /** 主要产品 */
  primaryProducts?: string
  /** 商家介绍 */
  profile?: string
  /** 省份 */
  province?: string
  /** 商家ID */
  reviewId?: string
  /** 商家logo */
  sellerLogo?: string
  /** 商家名称 */
  sellerName?: string
  /** 员工数量 */
  staffNum?: number
  /** 微信二维码 */
  wechatQrCode?: string
}

/**
 * 取消商家审核请求
 */
export interface CancelSellerReviewRequest {
  /** 审核ID */
  reviewId?: string
}

/**
 * PaginationResultFabricSellerReview接口类型
 */
export interface PaginationResultFabricSellerReview {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricSellerReview[]
}

/**
 * ApiResultPaginationResultFabricSellerReview接口类型
 */
export interface ApiResultPaginationResultFabricSellerReview {
  result?: PaginationResultFabricSellerReview
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 查询商家审核记录请求
 */
export interface ListFabricSellerReviewRequest {
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 审核时间结束 */
  reviewAtEnd?: string
  /** 审核时间开始 */
  reviewAtStart?: string
  /** 审核状态 0-待审核 1-审核取消 2-审核通过 3-审核拒绝 */
  reviewStatus?: number
  /** 企业ID */
  sellerId?: number
  /** 企业名称 */
  sellerName?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 提交时间结束 */
  submitAtEnd?: string
  /** 提交时间开始 */
  submitAtStart?: string
  /** 提交人名称 */
  submitterName?: string
  /** 提交人手机号 */
  submitterPhone?: string
}

/**
 * 审核商家请求
 */
export interface ReviewSellerRequest {
  /** 拒绝原因 */
  rejectReason?: string
  /** 审核ID */
  reviewId?: string
  /** 审核状态 2-通过 3-拒绝 */
  reviewStatus?: number
}

/**
 * ApiResult_PaginationResult_FabricSelectKeywordResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricSelectKeywordResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricSelectKeywordResponse
  success?: boolean
}

/**
 * ApiResult_FabricSeller接口类型
 */
export interface ApiResult_FabricSeller {
  errorCode?: string
  errorDesc?: string
  result?: FabricSeller
  success?: boolean
}

/**
 * PaginationResult_FabricSelectKeywordResponse接口类型
 */
export interface PaginationResult_FabricSelectKeywordResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricSelectKeywordResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_List_FirstLevelClassifyVO接口类型
 */
export interface ApiResult_List_FirstLevelClassifyVO {
  errorCode?: string
  errorDesc?: string
  result?: FirstLevelClassifyVO[]
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricSellerReview接口类型
 */
export interface ApiResult_PaginationResult_FabricSellerReview {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricSellerReview
  success?: boolean
}

/**
 * ApiResult_List_FabricSelectKeywordResponse接口类型
 */
export interface ApiResult_List_FabricSelectKeywordResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricSelectKeywordResponse[]
  success?: boolean
}

/**
 * PaginationResult_FabricSellerReview接口类型
 */
export interface PaginationResult_FabricSellerReview {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricSellerReview[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_FabricSellerReview接口类型
 */
export interface ApiResult_FabricSellerReview {
  errorCode?: string
  errorDesc?: string
  result?: FabricSellerReview
  success?: boolean
}

/**
 * 商家推荐相似面料
 */
export interface FabricSelectSimilar {
  /** 面料id */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 面料品类 */
  fabric?: string
  /** 面料价格 */
  price?: string
  priceMin?: string
  priceMax?: string
  priceUnit?: string
  /** 面料图片 */
  mainUrl?: string
  /** 商家id */
  sellerId?: string
  /** 商家名称 */
  sellerName?: string
  /** 成衣展示图 */
  garmentDisplayPicList?: string[]
  /** 面料主推色 */
  specificationPicList?: string[]
  /** 上下架状态 1审核驳回；2已下架；3在售；4审核中 */
  shelfStatus?: number
  /** 上架时间 */
  shelfAt?: string
  /** 运营后台面料标签 */
  fabricTags?: string[]
}

/**
 * ApiResultListFabricSelectSimilar接口类型
 */
export interface ApiResultListFabricSelectSimilar {
  result?: FabricSelectSimilar[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResult_List_FabricSelectSimilar接口类型
 */
export interface ApiResult_List_FabricSelectSimilar {
  errorCode?: string
  errorDesc?: string
  result?: FabricSelectSimilar[]
  success?: boolean
}

/**
 * ApiResult_List_FabricInfoDetailResponse接口类型
 */
export interface ApiResult_List_FabricInfoDetailResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricInfoDetailResponse[]
  success?: boolean
}

/**
 * PromotedFabric接口类型
 */
export interface PromotedFabric {
  fabricId?: string
  fabricName?: string
}

/**
 * 面料推广淘系商品
 */
export interface FabricPromotionTbItem {
  /** 货号 */
  articleNo?: string
  /** 二级类目id */
  categoryId?: number
  /** 总收藏量 */
  collect?: number
  /** 近30天收藏 */
  collect30day?: number
  /** 近7天收藏 */
  collect7day?: number
  /** 总评论数 */
  commentCount?: number
  cprice?: number
  /** 历史最低价 */
  historyMinLeftCprice?: number
  /** 是否推广 */
  isPromoted?: number
  /** 商品id */
  itemId?: number
  /** 主图 */
  picUrl?: string
  /** 推广面料 */
  promotedFabrics?: PromotedFabric[]
  /** 一级类目id */
  rootCategoryId?: number
  /** 最近30天销量 */
  sale30day?: number
  /** 最近7天销量 */
  sale7day?: number
  /** 最近30天销售额 */
  saleAmount30day?: number
  /** 近7天销售额 */
  saleAmount7day?: number
  /** 上新时间 */
  saleTime?: string
  /** 店铺掌柜名 */
  sellerName?: string
  /** 店铺id */
  shopId?: number
  /** 店铺logo */
  shopLogo?: string
  /** 店铺logo */
  shopLogoUrl?: string
  /** 店铺名称 */
  shopName?: string
  /** 店铺种类（0-淘宝，1-天猫） */
  shopType?: number
  sprice?: number
  /** 款号 */
  styleNo?: string
  /** 商品标题 */
  title?: string
  /** 总销售额 */
  totalSaleAmount?: number
  /** 总销量 */
  totalSaleVolume?: number
  /** 视频 */
  videoUrl?: string
}

/**
 * PaginationResultFabricPromotionTbItem接口类型
 */
export interface PaginationResultFabricPromotionTbItem {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricPromotionTbItem[]
}

/**
 * ApiResultPaginationResultFabricPromotionTbItem接口类型
 */
export interface ApiResultPaginationResultFabricPromotionTbItem {
  result?: PaginationResultFabricPromotionTbItem
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料推广跨境商品
 */
export interface FabricPromotionAbroadItem {
  /** 总评论数 */
  commentNum?: number
  /** 月评论数 */
  commentNum30day?: number
  /** 是否推广 */
  isPromoted?: number
  /** 最近上架时间 */
  lastOnSaleDate?: string
  /** 历史最低价 */
  minPrice?: number
  /** 上架时间 */
  onSaleDate?: string
  /** 商品主图 */
  picUrl?: string
  /** 站点类型 */
  platformBizType?: string
  /** 站点名称 */
  platformLogo?: string
  /** 站点名称 */
  platformName?: string
  /** 来源站点ID */
  platformType?: number
  /** 商品ID */
  productId?: string
  productKey?: string
  /** 商品名称 */
  productName?: string
  /** 商品地址 */
  productUrl?: string
  /** 推广面料 */
  promotedFabrics?: PromotedFabric[]
  /** 月销量 */
  saleVolume30day?: number
  /** 总销量 */
  saleVolumeTotal?: number
  /** 店铺id */
  shopId?: string
  /** 店铺logo */
  shopLogo?: string
  /** 店铺名字 */
  shopName?: string
  /** 店铺链接 */
  shopUrl?: string
  /** skc数量 */
  skcNum?: number
  /** sku数量 */
  skuNum?: number
  /** 来源渠道 */
  sourceChannel?: string
  /** 售价 */
  sprice?: string
}

/**
 * PaginationResultFabricPromotionAbroadItem接口类型
 */
export interface PaginationResultFabricPromotionAbroadItem {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: FabricPromotionAbroadItem[]
}

/**
 * ApiResultPaginationResultFabricPromotionAbroadItem接口类型
 */
export interface ApiResultPaginationResultFabricPromotionAbroadItem {
  result?: PaginationResultFabricPromotionAbroadItem
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料推广跨境商品查询参数
 */
export interface FabricPromotionAbroadItemRequest {
  /** 类目id集合，需要传类目完整的路径 */
  categoryIdList?: unknown[]
  /** 设计要素 */
  label?: unknown[]
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 最高售价（单位：元） */
  maxSprice?: number
  /** 最低售价（单位：元） */
  minSprice?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 站点类型：SHEIN,TEMU,AMAZON */
  platformBizTypeList?: string[]
  /** 独立上架时间区间 */
  putOnSaleEndDate?: string
  /** 独立上架时间区间 */
  putOnSaleStartDate?: string
  /** 排序字段:最新上架：ON_SALE_DATE_DESC近7天热销：SALE_VOLUME_7DAY_DESC，近30天热销：SALE_VOLUME_30DAY_DESC，上新7天热销：NEW_IN_SALE_VOLUME_7DAY_DESC，总销量：SALE_VOLUME_DESC近7天热评：COMMENT_NUM_7DAY_DESC，近30天热评：COMMENT_NUM_30DAY_DESC，总评价：COMMENT_NUM_DESC价格：SPRICE_DESC/SPRICE_ASC */
  sortType?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 搜索匹配 */
  text?: string
}

/**
 * ApiResultFabricUserAuthGreetingCountResponse接口类型
 */
export interface ApiResultFabricUserAuthGreetingCountResponse {
  result?: FabricUserAuthGreetingCountResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 打招呼次数
 */
export interface FabricUserAuthGreetingCountResponse {
  /** 打招呼次数 */
  count?: number
  /** 剩余打招呼次数 */
  surplusGreetingCount?: number
  /** 0 无权限，1 有权限 */
  status?: number
}

/**
 * ApiResultListFabricUserPreferenceResponse接口类型
 */
export interface ApiResultListFabricUserPreferenceResponse {
  result?: FabricUserPreferenceResponse[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 用户偏好设置
 */
export interface FabricUserPreferenceResponse {
  /** 用户id */
  userId?: number
  /** 偏好键名 */
  preferenceKey?: string
  /** 偏好值 0未选择  1已选择 */
  preferenceValue?: number
}

/**
 * FabricUserPreferenceRequest接口类型
 */
export interface FabricUserPreferenceRequest {
  /** 偏好键名 */
  preferenceKey?: string
  /** 偏好值 0未选择  1已选择 */
  preferenceValue?: number
}

/**
 * ApiResultFabricUserPreferenceResponse接口类型
 */
export interface ApiResultFabricUserPreferenceResponse {
  result?: FabricUserPreferenceResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 面料推广淘系商品查询参数
 */
export interface FabricPromotionTbItemRequest {
  /** 二级类目 */
  categoryIdList?: number[]
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 售价max（单位：元） */
  maxPrice?: number
  /** 售价min（单位：元） */
  minPrice?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 设计要素（面料、风格、属性等） */
  propertys?: unknown[]
  /** 搜索匹配 */
  queryTitle?: string
  /** 一级类目 */
  rootCategoryIdList?: number[]
  /** 上架时间max */
  saleEndDate?: string
  /** 上架时间min */
  saleStartDate?: string
  /** 市场类型：0-淘宝，1-天猫 */
  shopType?: number
  /** 排序字段:total_sale_volume-总销量，sale_30day-近30天销量，sale_7day-近7天销量
total_sale_amount-总销售额，sale_30day_amount-近30天销售额，sale_amount_7day-近7天销售额
collect-总收藏，collect_count_30day-近30天收藏， collect_count_7day-近7天收藏
comment_count-总评论，
cprice-促销价，
sale_time-上架时间 */
  sortField?: string
  /** 排序方式：desc-降序、asc-升序 */
  sortType?: string
  /** 分页参数 - 开始记录 */
  start?: number
}

/**
 * FabricTeamTrustQueryRequest接口类型
 */
export interface FabricTeamTrustQueryRequest {
  /** 联系人 */
  contactPerson?: string
  /** 手机号 */
  contactPhone?: string
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 托管运营姓名 */
  operatorName?: string
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** sortField */
  sortField?: string
  /** 排序方式：asc/desc */
  sortOrder?: string
  /** 分页参数 - 开始记录 */
  start?: number
  /** 商家名 */
  teamName?: string
  /** 托管权限类型 1:全店托管；2:面料托管 3:推广项目托管 4：店铺管理托管 */
  trustType?: number
}

/**
 * FabricTeamTrustResponse接口类型
 */
export interface FabricTeamTrustResponse {
  /** 联系人 */
  contactPerson?: string
  /** 手机号 */
  contactPhone?: string
  /** 创建时间 */
  createdAt?: string
  /** 创建人姓名 */
  creatorName?: string
  id?: number
  /** 托管运营id */
  operatorIdList?: number[]
  /** 托管运营姓名 */
  operatorNameList?: string[]
  /** 商家id */
  teamId?: number
  /** 商家名 */
  teamName?: string
  /** 托管权限类型列表 1:全店托管；2:面料托管 3:推广项目托管 4：店铺管理托管 */
  trustTypeList?: number[]
  /** 更新时间 */
  updatedAt?: string
  /** 修改人姓名 */
  updaterName?: string
}

/**
 * PaginationResult_FabricPromotionTbItem接口类型
 */
export interface PaginationResult_FabricPromotionTbItem {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricPromotionTbItem[]
  start?: number
  totalPageCount?: number
}

/**
 * PaginationResult_FabricPromotionAbroadItem接口类型
 */
export interface PaginationResult_FabricPromotionAbroadItem {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricPromotionAbroadItem[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_List_FabricSelectSeller接口类型
 */
export interface ApiResult_List_FabricSelectSeller {
  errorCode?: string
  errorDesc?: string
  result?: FabricSelectSeller[]
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricPromotionTbItem接口类型
 */
export interface ApiResult_PaginationResult_FabricPromotionTbItem {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricPromotionTbItem
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricPromotionAbroadItem接口类型
 */
export interface ApiResult_PaginationResult_FabricPromotionAbroadItem {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricPromotionAbroadItem
  success?: boolean
}

/**
 * PaginationResult_FabricTeamTrustResponse接口类型
 */
export interface PaginationResult_FabricTeamTrustResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricTeamTrustResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * FabricTeamTrustEditRequest接口类型
 */
export interface FabricTeamTrustEditRequest {
  /** id(修改删除时传入) */
  id?: number
  /** 托管运营id */
  operatorIdList?: number[]
  /** 托管运营姓名 */
  operatorNameList?: string[]
  /** 商家id */
  teamId?: number
  /** 商家id集合 */
  teamIdList?: number[]
  /** 托管权限类型列表 1:全店托管；2:面料托管 3:推广项目托管 4：店铺管理托管 */
  trustTypeList?: number[]
}

/**
 * ApiResult_PaginationResult_FabricTeamTrustResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricTeamTrustResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricTeamTrustResponse
  success?: boolean
}

/**
 * FabricTeamTrustTypeResponse接口类型
 */
export interface FabricTeamTrustTypeResponse {
  /** 商家id */
  teamId?: number
  /** 托管类型 1:全店托管；2:面料托管 3:推广项目托管 4：店铺管理托管 */
  trustType?: number[]
}

/**
 * ApiResult_FabricTeamTrustTypeResponse接口类型
 */
export interface ApiResult_FabricTeamTrustTypeResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricTeamTrustTypeResponse
  success?: boolean
}

/**
 * ApiResult_PaginationResult_FabricUserOperationResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricUserOperationResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricUserOperationResponse
  success?: boolean
}

/**
 * FabricUserOperationQueryRequest接口类型
 */
export interface FabricUserOperationQueryRequest {
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 操作模块 */
  operationModule?: number
  /** 多个操作模块 */
  operationModuleList?: number[]
  /** 操作类型 */
  operationType?: number
  /** 操作方  1：运营  2：商家 */
  operator?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 目标id */
  targetId?: string
  /** 团队id */
  teamId?: number
}

/**
 * FabricUserOperationResponse接口类型
 */
export interface FabricUserOperationResponse {
  /** 创建时间 */
  createdAt?: string
  id?: number
  /** 操作描述 */
  operationDescription?: string
  /** 操作模块 */
  operationModule?: number
  /** 操作类型 */
  operationType?: number
  /** 操作方  1：运营  2：商家 */
  operator?: number
  /** 目标id */
  targetId?: string
  /** 商家id */
  teamId?: number
  /** 操作人id */
  userId?: number
  /** 操作人名称 */
  userName?: string
}

/**
 * PaginationResult_FabricUserOperationResponse接口类型
 */
export interface PaginationResult_FabricUserOperationResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricUserOperationResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_FabricPromotionProjectCountResponse接口类型
 */
export interface ApiResult_FabricPromotionProjectCountResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricPromotionProjectCountResponse
  success?: boolean
}

/**
 * FabricPromotionProjectCountResponse接口类型
 */
export interface FabricPromotionProjectCountResponse {
  /** 全部 */
  count?: number
  /** 已结束 */
  endedCount?: number
  /** 未开始 */
  notStartedCount?: number
  /** 已暂停 */
  pausedCount?: number
  /** 推广中 */
  promotingCount?: number
}

/**
 * LoginResponse接口类型
 */
export interface LoginResponse {
  /** 访问令牌 */
  token?: string
  /** 用户ID */
  userId?: number
}

/**
 * ApiResultLoginResponse接口类型
 */
export interface ApiResultLoginResponse {
  result?: LoginResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * WechatPhoneLoginRequest接口类型
 */
export interface WechatPhoneLoginRequest {
  /** etPhoneNumber 返回的 code 与 wx.login 返回的 code 作用是不一样的，不能混用。 */
  code?: string
  /** 页面类型：fabric-detail；seller-detail */
  page?: string
  /** 参数 */
  param?: string
  /** 小程序网页链接 */
  url?: string
}

/**
 * WechatPhoneLoginV1Request接口类型
 */
export interface WechatPhoneLoginV1Request {
  /** 微信登录凭证code wx.login获取的 */
  code?: string
  /** etPhoneNumber 返回的 code 与 wx.login 返回的 code 作用是不一样的，不能混用。 */
  phoneNumber?: string
}

/**
 * UserPhoneBindingResponse接口类型
 */
export interface UserPhoneBindingResponse {
  /** 用户openid */
  openid?: string
  /** 用户ID */
  userId?: number
  /** 手机号 */
  phoneNumber?: string
  /** 是否为默认手机号 */
  isDefault?: boolean
  /** 绑定时间 */
  createdAt?: string
}

/**
 * ApiResultListUserPhoneBindingResponse接口类型
 */
export interface ApiResultListUserPhoneBindingResponse {
  result?: UserPhoneBindingResponse[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResultUserPhoneBindingResponse接口类型
 */
export interface ApiResultUserPhoneBindingResponse {
  result?: UserPhoneBindingResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * BindPhoneRequest接口类型
 */
export interface BindPhoneRequest {
  /** 用户openid */
  openid?: string
  /** 手机号 */
  phoneNumber?: string
}

/**
 * ApiResult_LoginResponse接口类型
 */
export interface ApiResult_LoginResponse {
  errorCode?: string
  errorDesc?: string
  result?: LoginResponse
  success?: boolean
}

/**
 * Functionality3接口类型
 */
export interface Functionality3 {
  /** 功能性(传字典id) */
  name?: string
  /** 备注（选择其他时传入） */
  remark?: string
}

/**
 * Composition4接口类型
 */
export interface Composition4 {
  /** 成分名称(传字典id) */
  name?: string
  /** 成分含量 */
  composition?: string
}

/**
 * Functionality5接口类型
 */
export interface Functionality5 {
  /** 功能性(传字典id) */
  name?: string
  /** 备注（选择其他时传入） */
  remark?: string
}

/**
 * ApiResult_PaginationResult_FabricInfoListResponse接口类型
 */
export interface ApiResult_PaginationResult_FabricInfoListResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricInfoListResponse
  success?: boolean
}

/**
 * ApiResult_FabricInfoCountResponse接口类型
 */
export interface ApiResult_FabricInfoCountResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricInfoCountResponse
  success?: boolean
}

/**
 * PaginationResult_FabricInfoListResponse接口类型
 */
export interface PaginationResult_FabricInfoListResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricInfoListResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_FabricInfoListResponse接口类型
 */
export interface ApiResult_FabricInfoListResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricInfoListResponse
  success?: boolean
}

/**
 * ApiResult_FabricRecommendationResponse接口类型
 */
export interface ApiResult_FabricRecommendationResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricRecommendationResponse
  success?: boolean
}

/**
 * 用户面料清单参数
 */
export interface UserFabricCollectRequest {
  /** 收藏面料在清单中的唯一id，删除时传 */
  collectId?: number
  /** 收藏面料在清单中的唯一id，删除时传，批量 */
  collectIdList?: number[]
  /** 收藏面料id */
  fabricId?: string
  /** 收藏面料id，批量 */
  fabricIdList?: string[]
}

/**
 * 用户面料清单
 */
export interface UserFabricCollectResponse {
  /** 收藏id */
  collectId?: number
  /** 收藏时间 */
  collectTime?: string
  /** 面料id */
  fabricId?: string
  fabricSelectInfo?: FabricSelect
}

/**
 * PaginationResultUserFabricCollectResponse接口类型
 */
export interface PaginationResultUserFabricCollectResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: UserFabricCollectResponse[]
}

/**
 * ApiResultPaginationResultUserFabricCollectResponse接口类型
 */
export interface ApiResultPaginationResultUserFabricCollectResponse {
  result?: PaginationResultUserFabricCollectResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 用户面料清单查询参数
 */
export interface UserFabricCollectQueryRequest {
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 排序字段：collectTime(收藏时间)，fabricPrice(面料价格) */
  sortField?: string
  /** 排序方式：asc/desc */
  sortOrder?: string
  /** 分页参数 - 开始记录 */
  start?: number
}

/**
 * ShareContain接口类型
 */
export interface ShareContain {
  /** 分享内容id */
  containId?: string
  /** 分享内容标题 */
  containTitle?: string
}

/**
 * 用户分享记录
 */
export interface UserShareRecordResponse {
  /** 分享内容 */
  containEntityList?: ShareContain[]
  /** 分享内容id */
  containIdList?: string[]
  /** 分享id */
  shareId?: string
  /** 分享时间 */
  shareTime?: string
  /** 分享类型：1-面料，2-商家，3-清单 */
  shareType?: number
  /** 团队id */
  teamId?: number
  /** 用户id */
  userId?: number
  /** 用户手机号 */
  userPhone?: string
}

/**
 * PaginationResultUserShareRecordResponse接口类型
 */
export interface PaginationResultUserShareRecordResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: UserShareRecordResponse[]
}

/**
 * ApiResultPaginationResultUserShareRecordResponse接口类型
 */
export interface ApiResultPaginationResultUserShareRecordResponse {
  result?: PaginationResultUserShareRecordResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 后台查询分享参数
 */
export interface UserFabricShareQueryRequest {
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分享时间max */
  shareTimeMax?: string
  /** 分享时间min */
  shareTimeMin?: string
  /** 分享类型：1-面料，2-商家，3-清单 */
  shareType?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 用户手机号 */
  userPhone?: string
}

/**
 * 保存用户分享记录
 */
export interface UserShareRecordRequest {
  /** 分享内容id列表 */
  containIdList?: string[]
  /** 分享类型 */
  shareType?: string
}

/**
 * ApiResultUserShareRecordResponse接口类型
 */
export interface ApiResultUserShareRecordResponse {
  result?: UserShareRecordResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * ApiResultListUserFabricCollectResponse接口类型
 */
export interface ApiResultListUserFabricCollectResponse {
  result?: UserFabricCollectResponse[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * 他人分享面料清单查询参数
 */
export interface UserFabricShareCollectQueryRequest {
  /** 分享的面料id列表 */
  shareFabricIdList?: string[]
  /** 分享id */
  shareId?: string
  /** 排序字段：collectTime(收藏时间)，fabricPrice(面料价格) */
  sortField?: string
  /** 排序方式：asc/desc */
  sortOrder?: string
}

/**
 * ApiResult_List_UserFabricCollectResponse接口类型
 */
export interface ApiResult_List_UserFabricCollectResponse {
  errorCode?: string
  errorDesc?: string
  result?: UserFabricCollectResponse[]
  success?: boolean
}

/**
 * ApiResult_PaginationResult_UserShareRecordResponse接口类型
 */
export interface ApiResult_PaginationResult_UserShareRecordResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_UserShareRecordResponse
  success?: boolean
}

/**
 * PaginationResult_UserShareRecordResponse接口类型
 */
export interface PaginationResult_UserShareRecordResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: UserShareRecordResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_PaginationResult_UserFabricCollectResponse接口类型
 */
export interface ApiResult_PaginationResult_UserFabricCollectResponse {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_UserFabricCollectResponse
  success?: boolean
}

/**
 * PaginationResult_UserFabricCollectResponse接口类型
 */
export interface PaginationResult_UserFabricCollectResponse {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: UserFabricCollectResponse[]
  start?: number
  totalPageCount?: number
}

/**
 * ApiResult_UserShareRecordResponse接口类型
 */
export interface ApiResult_UserShareRecordResponse {
  errorCode?: string
  errorDesc?: string
  result?: UserShareRecordResponse
  success?: boolean
}

/**
 * 面料清单信息
 */
export interface FabricCollectInfoResponse {
  /** 面料清单中的收藏id */
  collectId?: number
  /** 加入面料清单的时间 */
  collectTime?: string
}

/**
 * ApiResult_PaginationResult_FabricSeller接口类型
 */
export interface ApiResult_PaginationResult_FabricSeller {
  errorCode?: string
  errorDesc?: string
  result?: PaginationResult_FabricSeller
  success?: boolean
}

/**
 * PaginationResult_FabricSeller接口类型
 */
export interface PaginationResult_FabricSeller {
  currentPageNo?: number
  empty?: boolean
  limit?: number
  pageSize?: number
  resultCount?: number
  resultList?: FabricSeller[]
  start?: number
  totalPageCount?: number
}

/**
 * Map_string_Link接口类型
 */
export interface Map_string_Link {
  
}

/**
 * Link接口类型
 */
export interface Link {
  href?: string
  templated?: boolean
}

/**
 * 商家列表查询请求参数
 */
export interface FabricSellerQueryRequest {
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 商家名称 */
  sellerName?: string
  /** 分页参数 - 开始记录 */
  start?: number
}

/**
 * FabricRecommendSaveRequest接口类型
 */
export interface FabricRecommendSaveRequest {
  /** 推荐面料id列表 */
  fabricIdList?: string[]
  /** 商家id */
  teamId?: number
}

/**
 * FabricUserOperationRequest接口类型
 */
export interface FabricUserOperationRequest {
  /** 创建时间-结束 */
  endTime?: string
  /** 操作模块 */
  operationModule?: number
  /** 操作类型 */
  operationType?: number
  /** 操作方  1：运营  2：商家 */
  operator?: number
  /** 创建时间-开始 */
  startTime?: string
  /** 目标id */
  targetId?: string
}

/**
 * ApiResult_List_FabricUserOperationResponse接口类型
 */
export interface ApiResult_List_FabricUserOperationResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricUserOperationResponse[]
  success?: boolean
}

/**
 * TeamInfo接口类型
 */
export interface TeamInfo {
  /** 供应商公司地址 */
  address?: string
  /** 企业logo */
  companyLogo?: string
  /** 地址 */
  contactAddress?: string
  /** 面料联系人 */
  contactPerson?: string
  /** 面料联系人电话 */
  contactPhone?: string
  /** 主营产品 */
  primaryProducts?: string
  /** 简介 */
  profile?: string
  /** 团队简称 */
  simpleName?: string
  /** 商家id */
  teamId?: number
  /** 团队名称 */
  teamName?: string
  /** 微信二维码 */
  wechatQrCode?: string
}

/**
 * ApiResult_FabricActivityResponse接口类型
 */
export interface ApiResult_FabricActivityResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricActivityResponse
  success?: boolean
}

/**
 * FabricActivityResponse接口类型
 */
export interface FabricActivityResponse {
  /** activityId */
  activityId?: number
  /** 活动要求浏览面料次数 */
  detailCount?: number
  /** id */
  id?: number
  /** 活动要求咨询面料次数 */
  inquiryCount?: number
  /** 抽奖状态，0-未抽奖，1-已抽奖 */
  isDraw?: number
  /** 活动是否结束，0-否，1-是 */
  isEnded?: number
  /** 奖品信息 */
  prizeStockList?: PrizeStock[]
}

/**
 * PrizeStock接口类型
 */
export interface PrizeStock {
  /** 奖品等级 */
  prizeLevel?: number
  /** 奖品名称 */
  prizeName?: string
  /** 剩余库存 */
  remainingStock?: number
  /** 总库存 */
  totalStock?: number
  /** 已使用库存 */
  usedStock?: number
}

/**
 * ActivityRegistrationRequest接口类型
 */
export interface ActivityRegistrationRequest {
  /** 活动id */
  activityId?: number
}

/**
 * FabricActivityTaskResponse接口类型
 */
export interface FabricActivityTaskResponse {
  /** activityId */
  activityId?: number
  /** 已浏览面料次数 */
  completedDetailCount?: number
  /** 已咨询面料次数 */
  completedInquiryCount?: number
  /** 活动要求浏览面料次数 */
  detailCount?: number
  /** 抽奖次数 */
  drawCount?: number
  /** 活动要求咨询面料次数 */
  inquiryCount?: number
}

/**
 * ApiResult_FabricActivityTaskResponse接口类型
 */
export interface ApiResult_FabricActivityTaskResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricActivityTaskResponse
  success?: boolean
}

/**
 * FabricActivityDrawResponse接口类型
 */
export interface FabricActivityDrawResponse {
  /** activityId */
  activityId?: number
  /** 奖品等级 */
  prizeLevel?: number
  /** 奖品名称 */
  prizeName?: string
}

/**
 * ApiResult_FabricActivityDrawResponse接口类型
 */
export interface ApiResult_FabricActivityDrawResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricActivityDrawResponse
  success?: boolean
}

/**
 * FabricQuickReplyRequest接口类型
 */
export interface FabricQuickReplyRequest {
  /** 内容 */
  content?: string
  id?: number
  /** 排序 */
  sort?: number
}

/**
 * ApiResult_List_FabricQuickReplyResponse接口类型
 */
export interface ApiResult_List_FabricQuickReplyResponse {
  errorCode?: string
  errorDesc?: string
  result?: FabricQuickReplyResponse[]
  success?: boolean
}

/**
 * FabricQuickReplyResponse接口类型
 */
export interface FabricQuickReplyResponse {
  /** 内容 */
  content?: string
  /** 创建时间 */
  createdAt?: string
  /** 主键ID */
  id?: number
  /** 排序 */
  sort?: number
  teamId?: number
  /** 用户id */
  userId?: number
}

/**
 * FabricRequirementAssignRequest接口类型
 */
export interface FabricRequirementAssignRequest {
  /** 找布需求ID */
  requirementId: string
  /** 分配商家ID列表 */
  assignTeamId?: string[]
  /** 分配商家名称列表（与 assignTeamId 顺序对应） */
  assignTeamName?: string[]
  /** 分配面料ID列表（系统内面料） */
  assignFabricId?: string[]
  /** 分配系统外面料图片URL列表（面料不在系统中时，上传图片后传入URL） */
  assignFabricPicList?: string[]
  /** 分配补充说明 */
  assignRemark?: string
  /** 是否选择不分配，true=不分配 */
  noAssign?: boolean
}

/**
 * FabricRequirementLogResponse接口类型
 */
export interface FabricRequirementLogResponse {
  /** 记录ID */
  id?: number
  /** 找布需求ID */
  requirementId?: string
  /** 动作类型：1-创建需求 2-分配商家/面料 3-客户反馈 4-已完成 */
  actionType?: number
  /** 动作类型描述 */
  actionTypeDesc?: string
  /** 动作详情JSON（分配时包含商家/面料信息快照） */
  actionDetail?: string
  /** 分配商家详情列表 */
  assignTeamList?: FabricSeller[]
  /** 分配面料详情列表 */
  assignFabricList?: FabricSelect[]
  /** 分配上传面料图片URL列表 */
  assignFabricPicList?: string[]
  /** 操作人ID */
  operatorId?: number
  /** 操作人姓名 */
  operatorName?: string
  /** 操作人类型：1-客户 2-管理员 */
  operatorType?: number
  /** 操作时间 */
  createdAt?: string
}

/**
 * ApiResultListFabricRequirementLogResponse接口类型
 */
export interface ApiResultListFabricRequirementLogResponse {
  result?: FabricRequirementLogResponse[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * FabricRequirementCommunicationRequest接口类型
 */
export interface FabricRequirementCommunicationRequest {
  /** 沟通记录主键（删除时必填） */
  id?: number
  /** 找布需求ID（新增时必填） */
  requirementId?: string
  /** 沟通内容/需求描述 */
  referenceDesc?: string
  /** 面料参考图URL列表 */
  referencePicList?: string[]
}

/**
 * FabricRequirementCommunicationResponse接口类型
 */
export interface FabricRequirementCommunicationResponse {
  /** 记录ID */
  id?: number
  /** 找布需求ID */
  requirementId?: string
  /** 沟通内容/需求描述 */
  referenceDesc?: string
  /** 面料参考图URL列表 */
  referencePicList?: string[]
  /** 操作人ID */
  operatorId?: number
  /** 操作人姓名 */
  operatorName?: string
  /** 创建时间 */
  createdAt?: string
}

/**
 * ApiResultListFabricRequirementCommunicationResponse接口类型
 */
export interface ApiResultListFabricRequirementCommunicationResponse {
  result?: FabricRequirementCommunicationResponse[]
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * FabricRequirementFeedbackRequest接口类型
 */
export interface FabricRequirementFeedbackRequest {
  /** 找布需求ID */
  requirementId: string
  /** 反馈结果：1-满意，2-不满意 */
  feedbackValue: number
}

/**
 * ApiResultFabricCustomerRequirementResponse接口类型
 */
export interface ApiResultFabricCustomerRequirementResponse {
  result?: FabricCustomerRequirementResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * FabricInfo6接口类型
 */
export interface FabricInfo6 {
  /** 面料id */
  fabricId?: string
  /** 主图 */
  mainUrl?: string
}

/**
 * SellerFabricResponse接口类型
 */
export interface SellerFabricResponse {
  /** 面料id */
  fabricId?: string
  /** 面料名称 */
  fabricName?: string
  /** 面料品类 */
  fabric?: string
  /** 面料品类(完整路径) */
  fabricPath?: string
  /** 面料来源 */
  sourceChannel?: number
  /** 面料渠道来源 */
  fabricSourceChannel?: number
  /** 面料价格 */
  price?: string
  priceMin?: string
  priceMax?: string
  priceUnit?: string
  sourceTime?: string
  /** 面料图片 */
  mainUrl?: string
  /** 商家id */
  sellerId?: string
  /** 商家名称 */
  sellerName?: string
  /** 商家logo */
  sellerLogo?: string
  /** 上下架状态 1审核驳回；2已下架；3在售；4审核中 */
  shelfStatus?: number
}

/**
 * PaginationResultSellerFabricResponse接口类型
 */
export interface PaginationResultSellerFabricResponse {
  /** 开始 */
  start?: number
  /** 每页的条数 */
  pageSize?: number
  /** 总共有几条 */
  resultCount?: number
  /** 限制展示条数 */
  limit?: number
  /** 请求页 */
  currentPageNo?: number
  /** 总共有几页 */
  totalPageCount?: number
  /** 当前页的记录 */
  resultList?: SellerFabricResponse[]
}

/**
 * ApiResultPaginationResultSellerFabricResponse接口类型
 */
export interface ApiResultPaginationResultSellerFabricResponse {
  result?: PaginationResultSellerFabricResponse
  success?: boolean
  errorCode?: string
  errorDesc?: string
}

/**
 * SellerFabricQueryRequest接口类型
 */
export interface SellerFabricQueryRequest {
  /** 分页参数 - 页大小 */
  pageSize?: number
  /** 分页参数 - 跳转页 */
  pageNo?: number
  /** 分页参数 - 开始记录 */
  start?: number
  /** 分页参数 - 查询上限 */
  limit?: number
  /** 模糊查询 */
  fuzzySearch?: string
}

/**
 * 获取面料信息
 * @param {object} [params] 查询参数
 * @param {number} [params.rootCategoryId] rootCategoryId
 * @param {string} [params.cloth] cloth
 * @returns {Promise<HotClothResponse>} OK
 * @api {get} /common/cloth-info
 * @apiGroup 热门面料/材质接口
 */
export async function getCommonClothInfo(params?: { rootCategoryId: number; cloth: string }): Promise<HotClothResponse> {
  const url = baseUrl + `/common/cloth-info`
  return await request.get<ApiResult_HotClothResponse>(url, { params })
}

/**
 * 获取材质组合信息
 * @param {object} [params] 查询参数
 * @param {number} [params.rootCategoryId] rootCategoryId
 * @param {string} [params.fabric] fabric
 * @returns {Promise<HotFabricResponse>} OK
 * @api {get} /common/fabric-info
 * @apiGroup 热门面料/材质接口
 */
export async function getCommonFabricInfo(params?: { rootCategoryId: number; fabric: string }): Promise<HotFabricResponse> {
  const url = baseUrl + `/common/fabric-info`
  return await request.get<ApiResult_HotFabricResponse>(url, { params })
}

/**
 * 热门面料列表
 * @param {HotFabricMaterialRequest} data 请求数据
 * @returns {Promise<HotClothResponse[]>} OK
 * @api {post} /common/hot-cloth-selector-list
 * @apiGroup 热门面料/材质接口
 */
export async function postCommonHotClothSelectorList(data: HotFabricMaterialRequest): Promise<HotClothResponse[]> {
  const url = baseUrl + `/common/hot-cloth-selector-list`
  return await request.post<ApiResult_List_HotClothResponse>(url, data, {})
}

/**
 * 热门材质组合列表
 * @param {HotFabricMaterialRequest} data 请求数据
 * @returns {Promise<HotFabricResponse[]>} OK
 * @api {post} /common/hot-fabric-selector-list
 * @apiGroup 热门面料/材质接口
 */
export async function postCommonHotFabricSelectorList(data: HotFabricMaterialRequest): Promise<HotFabricResponse[]> {
  const url = baseUrl + `/common/hot-fabric-selector-list`
  return await request.post<ApiResult_List_HotFabricResponse>(url, data, {})
}

/**
 * 热门材质列表
 * @param {HotFabricMaterialRequest} data 请求数据
 * @returns {Promise<HotMaterialResponse[]>} OK
 * @api {post} /common/hot-material-selector-list
 * @apiGroup 热门面料/材质接口
 */
export async function postCommonHotMaterialSelectorList(data: HotFabricMaterialRequest): Promise<HotMaterialResponse[]> {
  const url = baseUrl + `/common/hot-material-selector-list`
  return await request.post<ApiResult_List_HotMaterialResponse>(url, data, {})
}

/**
 * 获取材质信息
 * @param {object} [params] 查询参数
 * @param {number} [params.rootCategoryId] rootCategoryId
 * @param {string} [params.material] material
 * @returns {Promise<HotMaterialResponse>} OK
 * @api {get} /common/material-info
 * @apiGroup 热门面料/材质接口
 */
export async function getCommonMaterialInfo(params?: { rootCategoryId: number; material: string }): Promise<HotMaterialResponse> {
  const url = baseUrl + `/common/material-info`
  return await request.get<ApiResult_HotMaterialResponse>(url, { params })
}

/**
 * 行业-数据分布
 * @param {AnalysisDistributionRequest} data 请求数据
 * @returns {Promise<AnalysisDistributionResponse[]>} OK
 * @api {post} /detail/industry-distribution
 * @apiGroup 面料/材质详情页接口
 */
export async function postDetailIndustryDistribution(data: AnalysisDistributionRequest): Promise<AnalysisDistributionResponse[]> {
  const url = baseUrl + `/detail/industry-distribution`
  return await request.post<ApiResult_List_AnalysisDistributionResponse>(url, data, {})
}

/**
 * 行业-数据概览
 * @param {AnalysisSummaryRequest} data 请求数据
 * @returns {Promise<AnalysisSummaryResponse>} OK
 * @api {post} /detail/industry-summary
 * @apiGroup 面料/材质详情页接口
 */
export async function postDetailIndustrySummary(data: AnalysisSummaryRequest): Promise<AnalysisSummaryResponse> {
  const url = baseUrl + `/detail/industry-summary`
  return await request.post<ApiResult_AnalysisSummaryResponse>(url, data, {})
}

/**
 * 行业-数据趋势
 * @param {AnalysisDistributionRequest} data 请求数据
 * @returns {Promise<AnalysisTrendResponse[]>} OK
 * @api {post} /detail/industry-trend
 * @apiGroup 面料/材质详情页接口
 */
export async function postDetailIndustryTrend(data: AnalysisDistributionRequest): Promise<AnalysisTrendResponse[]> {
  const url = baseUrl + `/detail/industry-trend`
  return await request.post<ApiResult_List_AnalysisTrendResponse>(url, data, {})
}

/**
 * 竞店-数据分布
 * @param {AnalysisDistributionRequest} data 请求数据
 * @returns {Promise<AnalysisDistributionResponse[]>} OK
 * @api {post} /detail/monitor-distribution
 * @apiGroup 面料/材质详情页接口
 */
export async function postDetailMonitorDistribution(data: AnalysisDistributionRequest): Promise<AnalysisDistributionResponse[]> {
  const url = baseUrl + `/detail/monitor-distribution`
  return await request.post<ApiResult_List_AnalysisDistributionResponse>(url, data, {})
}

/**
 * 竞店-数据概览
 * @param {AnalysisSummaryRequest} data 请求数据
 * @returns {Promise<AnalysisSummaryResponse>} OK
 * @api {post} /detail/monitor-summary
 * @apiGroup 面料/材质详情页接口
 */
export async function postDetailMonitorSummary(data: AnalysisSummaryRequest): Promise<AnalysisSummaryResponse> {
  const url = baseUrl + `/detail/monitor-summary`
  return await request.post<ApiResult_AnalysisSummaryResponse>(url, data, {})
}

/**
 * 竞店-数据趋势
 * @param {AnalysisDistributionRequest} data 请求数据
 * @returns {Promise<AnalysisTrendResponse[]>} OK
 * @api {post} /detail/monitor-trend
 * @apiGroup 面料/材质详情页接口
 */
export async function postDetailMonitorTrend(data: AnalysisDistributionRequest): Promise<AnalysisTrendResponse[]> {
  const url = baseUrl + `/detail/monitor-trend`
  return await request.post<ApiResult_List_AnalysisTrendResponse>(url, data, {})
}

/**
 * 行业-数据分布
 * @param {AnalysisDistributionRequest} data 请求数据
 * @returns {Promise<AnalysisDistributionResponse[]>} OK
 * @api {post} /overview/industry-distribution
 * @apiGroup 面料/材质趋势概览接口
 */
export async function postOverviewIndustryDistribution(data: AnalysisDistributionRequest): Promise<AnalysisDistributionResponse[]> {
  const url = baseUrl + `/overview/industry-distribution`
  return await request.post<ApiResult_List_AnalysisDistributionResponse>(url, data, {})
}

/**
 * 行业-数据概览
 * @param {AnalysisSummaryRequest} data 请求数据
 * @returns {Promise<AnalysisSummaryResponse>} OK
 * @api {post} /overview/industry-summary
 * @apiGroup 面料/材质趋势概览接口
 */
export async function postOverviewIndustrySummary(data: AnalysisSummaryRequest): Promise<AnalysisSummaryResponse> {
  const url = baseUrl + `/overview/industry-summary`
  return await request.post<ApiResult_AnalysisSummaryResponse>(url, data, {})
}

/**
 * 行业-数据趋势
 * @param {AnalysisDistributionRequest} data 请求数据
 * @returns {Promise<AnalysisTrendResponse[]>} OK
 * @api {post} /overview/industry-trend
 * @apiGroup 面料/材质趋势概览接口
 */
export async function postOverviewIndustryTrend(data: AnalysisDistributionRequest): Promise<AnalysisTrendResponse[]> {
  const url = baseUrl + `/overview/industry-trend`
  return await request.post<ApiResult_List_AnalysisTrendResponse>(url, data, {})
}

/**
 * 竞店-数据分布
 * @param {AnalysisDistributionRequest} data 请求数据
 * @returns {Promise<AnalysisDistributionResponse[]>} OK
 * @api {post} /overview/monitor-distribution
 * @apiGroup 面料/材质趋势概览接口
 */
export async function postOverviewMonitorDistribution(data: AnalysisDistributionRequest): Promise<AnalysisDistributionResponse[]> {
  const url = baseUrl + `/overview/monitor-distribution`
  return await request.post<ApiResult_List_AnalysisDistributionResponse>(url, data, {})
}

/**
 * 竞店-数据概览
 * @param {AnalysisSummaryRequest} data 请求数据
 * @returns {Promise<AnalysisSummaryResponse>} OK
 * @api {post} /overview/monitor-summary
 * @apiGroup 面料/材质趋势概览接口
 */
export async function postOverviewMonitorSummary(data: AnalysisSummaryRequest): Promise<AnalysisSummaryResponse> {
  const url = baseUrl + `/overview/monitor-summary`
  return await request.post<ApiResult_AnalysisSummaryResponse>(url, data, {})
}

/**
 * 竞店-数据趋势
 * @param {AnalysisDistributionRequest} data 请求数据
 * @returns {Promise<AnalysisTrendResponse[]>} OK
 * @api {post} /overview/monitor-trend
 * @apiGroup 面料/材质趋势概览接口
 */
export async function postOverviewMonitorTrend(data: AnalysisDistributionRequest): Promise<AnalysisTrendResponse[]> {
  const url = baseUrl + `/overview/monitor-trend`
  return await request.post<ApiResult_List_AnalysisTrendResponse>(url, data, {})
}

/**
 * 单店铺-数据分布
 * @param {AnalysisDistributionRequest} data 请求数据
 * @returns {Promise<AnalysisDistributionResponse[]>} OK
 * @api {post} /overview/shop-distribution
 * @apiGroup 面料/材质趋势概览接口
 */
export async function postOverviewShopDistribution(data: AnalysisDistributionRequest): Promise<AnalysisDistributionResponse[]> {
  const url = baseUrl + `/overview/shop-distribution`
  return await request.post<ApiResult_List_AnalysisDistributionResponse>(url, data, {})
}

/**
 * 单店铺-数据概览
 * @param {AnalysisSummaryRequest} data 请求数据
 * @returns {Promise<AnalysisSummaryResponse>} OK
 * @api {post} /overview/shop-summary
 * @apiGroup 面料/材质趋势概览接口
 */
export async function postOverviewShopSummary(data: AnalysisSummaryRequest): Promise<AnalysisSummaryResponse> {
  const url = baseUrl + `/overview/shop-summary`
  return await request.post<ApiResult_AnalysisSummaryResponse>(url, data, {})
}

/**
 * 单店铺-数据趋势
 * @param {AnalysisDistributionRequest} data 请求数据
 * @returns {Promise<AnalysisTrendResponse[]>} OK
 * @api {post} /overview/shop-trend
 * @apiGroup 面料/材质趋势概览接口
 */
export async function postOverviewShopTrend(data: AnalysisDistributionRequest): Promise<AnalysisTrendResponse[]> {
  const url = baseUrl + `/overview/shop-trend`
  return await request.post<ApiResult_List_AnalysisTrendResponse>(url, data, {})
}

/**
 * 监控中心-面料分布概览
 * @param {MonitorCenterDistributionRequest} data 请求数据
 * @returns {Promise<PaginationResult_MonitorCenterDistributionResponse>} OK
 * @api {post} /monitor-center/distribution
 * @apiGroup 监控中心-面料接口
 */
export async function postMonitorCenterDistribution(data: MonitorCenterDistributionRequest): Promise<PaginationResult_MonitorCenterDistributionResponse> {
  const url = baseUrl + `/monitor-center/distribution`
  return await request.post<ApiResult_PaginationResult_MonitorCenterDistributionResponse>(url, data, {})
}

/**
 * getResult
 * @param {string} taskId taskId
 * @returns {Promise<GetResultResponse>} OK
 * @api {get} /query/task/result/{taskId}
 * @apiGroup 查询任务
 */
export async function getQueryTaskResultTaskId(taskId: string): Promise<GetResultResponse> {
  const url = baseUrl + `/query/task/result/${taskId}`
  return await request.get<ApiResult_GetResultResponse>(url)
}

/**
 * 提交查询任务
 * @param {SubmitQueryRequest} data 请求数据
 * @returns {Promise<SubmitQueryResponse>} OK
 * @api {post} /query/task/submit
 * @apiGroup 查询任务
 */
export async function postQueryTaskSubmit(data: SubmitQueryRequest): Promise<SubmitQueryResponse> {
  const url = baseUrl + `/query/task/submit`
  return await request.post<ApiResult_SubmitQueryResponse>(url, data, {})
}

/**
 * 收藏
 * @param {UserCollectFabricMaterialRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user/collect
 * @apiGroup 收藏面料/材质接口
 */
export async function postUserCollect(data: UserCollectFabricMaterialRequest): Promise<boolean> {
  const url = baseUrl + `/user/collect`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 收藏面料/材质列表
 * @returns {Promise<UserCollectFabricMaterialResponse[]>} OK
 * @api {get} /user/get-collect-list
 * @apiGroup 收藏面料/材质接口
 */
export async function getUserGetCollectList(): Promise<UserCollectFabricMaterialResponse[]> {
  const url = baseUrl + `/user/get-collect-list`
  return await request.get<ApiResult_List_UserCollectFabricMaterialResponse>(url)
}

/**
 * 取消收藏
 * @param {UserCollectFabricMaterialRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user/remove-collect
 * @apiGroup 收藏面料/材质接口
 */
export async function postUserRemoveCollect(data: UserCollectFabricMaterialRequest): Promise<boolean> {
  const url = baseUrl + `/user/remove-collect`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 商品库-抖音-新
 * @param {RpcSearchDyGoodsInfoRequest} data 请求数据
 * @returns {Promise<PaginationResult_RpcWindowDailyGoods>} OK
 * @api {post} /style/douyin/common-search
 * @apiGroup 款式中心-抖音商品
 */
export async function postStyleDouyinCommonSearch(data: RpcSearchDyGoodsInfoRequest): Promise<PaginationResult_RpcWindowDailyGoods> {
  const url = baseUrl + `/style/douyin/common-search`
  return await request.post<ApiResult_PaginationResult_RpcWindowDailyGoods>(url, data, {})
}

/**
 * 商品库-抖音-推荐
 * @param {RpcDyRecommendGoodsRequest} data 请求数据
 * @returns {Promise<PaginationResult_RpcWindowDailyGoods>} OK
 * @api {post} /style/douyin/recommend
 * @apiGroup 款式中心-抖音商品
 */
export async function postStyleDouyinRecommend(data: RpcDyRecommendGoodsRequest): Promise<PaginationResult_RpcWindowDailyGoods> {
  const url = baseUrl + `/style/douyin/recommend`
  return await request.post<ApiResult_PaginationResult_RpcWindowDailyGoods>(url, data, {})
}

/**
 * 列表查询
 * @param {ItemListRequest} data 请求数据
 * @returns {Promise<PaginationResult_Item>} OK
 * @api {post} /style/tb-item/list
 * @apiGroup 款式中心-淘系商品
 */
export async function postStyleTbItemList(data: ItemListRequest): Promise<PaginationResult_Item> {
  const url = baseUrl + `/style/tb-item/list`
  return await request.post<ApiResult_PaginationResult_Item>(url, data, {})
}

/**
 * 店铺列表查询
 * @param {ShopListRequest} data 请求数据
 * @returns {Promise<PaginationResult_Shop>} OK
 * @api {post} /style/tb-item/shop-list
 * @apiGroup 款式中心-淘系商品
 */
export async function postStyleTbItemShopList(data: ShopListRequest): Promise<PaginationResult_Shop> {
  const url = baseUrl + `/style/tb-item/shop-list`
  return await request.post<ApiResult_PaginationResult_Shop>(url, data, {})
}

/**
 * 推荐店铺列表
 * @param {ShopListRequest} data 请求数据
 * @returns {Promise<PaginationResult_Shop>} OK
 * @api {post} /style/tb-item/shop-recommend-list
 * @apiGroup 款式中心-淘系商品
 */
export async function postStyleTbItemShopRecommendList(data: ShopListRequest): Promise<PaginationResult_Shop> {
  const url = baseUrl + `/style/tb-item/shop-recommend-list`
  return await request.post<ApiResult_PaginationResult_Shop>(url, data, {})
}

/**
 * 小红书/ins/得物  热门笔记榜、笔记飙升榜、新帖榜、赞粉比榜 1.5.6新版-后端计算
 * @param {BlogRankingListParam} data 请求数据
 * @returns {Promise<PaginationResult_ImageEntity>} OK
 * @api {post} /style/zhikuan/blog/ranking-list
 * @apiGroup 款式中心-品牌款式
 */
export async function postStyleZhikuanBlogRankingList(data: BlogRankingListParam): Promise<PaginationResult_ImageEntity> {
  const url = baseUrl + `/style/zhikuan/blog/ranking-list`
  return await request.post<ApiResult_PaginationResult_ImageEntity>(url, data, {})
}

/**
 * 获取分类标签筛选项
 * @param {any} data 请求数据
 * @returns {Promise<ZKLabelMapping[]>} OK
 * @api {get} /style/zhikuan/category-label
 * @apiGroup 款式中心-品牌款式
 */
export async function getStyleZhikuanCategoryLabel(): Promise<ZKLabelMapping[]> {
  const url = baseUrl + `/style/zhikuan/category-label`
  return await request.get<ApiResult_List_ZKLabelMapping>(url)
}

/**
 * 品牌类型列表
 * @returns {Promise<BrandTypeCount[]>} OK
 * @api {get} /style/zhikuan/count-brand-type
 * @apiGroup 款式中心-品牌款式
 */
export async function getStyleZhikuanCountBrandType(): Promise<BrandTypeCount[]> {
  const url = baseUrl + `/style/zhikuan/count-brand-type`
  return await request.get<ApiResult_List_BrandTypeCount>(url)
}

/**
 * 分页查询博文列表 ins,微博,发布会,品牌精选共用
 * @param {ImageBlogRequest} data 请求数据
 * @returns {Promise<PaginationResult_ImageEntity>} OK
 * @api {post} /style/zhikuan/label-selector/list-blog
 * @apiGroup 款式中心-品牌款式
 */
export async function postStyleZhikuanLabelSelectorListBlog(data: ImageBlogRequest): Promise<PaginationResult_ImageEntity> {
  const url = baseUrl + `/style/zhikuan/label-selector/list-blog`
  return await request.post<ApiResult_PaginationResult_ImageEntity>(url, data, {})
}

/**
 * 查询菜单选项
 * @param {object} [params] 查询参数
 * @param {string} [params.menuPage] 菜单所在页面标识
 * @returns {Promise<MenuItemDO[]>} OK
 * @api {get} /style/zhikuan/list-menu-item
 * @apiGroup 款式中心-品牌款式
 */
export async function getStyleZhikuanListMenuItem(params?: { menuPage?: string }): Promise<MenuItemDO[]> {
  const url = baseUrl + `/style/zhikuan/list-menu-item`
  return await request.get<ApiResult_List_MenuItemDO>(url, { params })
}

/**
 * 获取新分类后的地区
 * @returns {Promise<MenuItemDO[]>} OK
 * @api {get} /style/zhikuan/list-new-area-menu
 * @apiGroup 款式中心-品牌款式
 */
export async function getStyleZhikuanListNewAreaMenu(): Promise<MenuItemDO[]> {
  const url = baseUrl + `/style/zhikuan/list-new-area-menu`
  return await request.get<ApiResult_List_MenuItemDO>(url)
}

/**
 * 查询当前用户品牌顺序
 * @param {UserBrandOrderListRequest} data 请求数据
 * @returns {Promise<string[]>} OK
 * @api {post} /style/zhikuan/list-user-brand-order
 * @apiGroup 款式中心-品牌款式
 */
export async function postStyleZhikuanListUserBrandOrder(data: UserBrandOrderListRequest): Promise<string[]> {
  const url = baseUrl + `/style/zhikuan/list-user-brand-order`
  return await request.post<ApiResult_List_string>(url, data, {})
}

/**
 * 查询当前用户品类顺序
 * @param {object} [params] 查询参数
 * @param {string} [params.gender] gender
 * @returns {Promise<string[]>} OK
 * @api {get} /style/zhikuan/list-user-category-order
 * @apiGroup 款式中心-品牌款式
 */
export async function getStyleZhikuanListUserCategoryOrder(params?: { gender: string }): Promise<string[]> {
  const url = baseUrl + `/style/zhikuan/list-user-category-order`
  return await request.get<ApiResult_List_string>(url, { params })
}

/**
 * 发布会成册列表
 * @param {ShowInfoParam} data 请求数据
 * @returns {Promise<PaginationResult_RunwayData>} OK
 * @api {post} /style/zhikuan/runway/list
 * @apiGroup 款式中心-品牌款式
 */
export async function postStyleZhikuanRunwayList(data: ShowInfoParam): Promise<PaginationResult_RunwayData> {
  const url = baseUrl + `/style/zhikuan/runway/list`
  return await request.post<ApiResult_PaginationResult_RunwayData>(url, data, {})
}

/**
 * 新增预设组
 * @param {UserQueryTemplateRequest} data 请求数据
 * @returns {Promise<int>} OK
 * @api {post} /user-query-template/add
 * @apiGroup 用户筛选条件模版相关接口
 */
export async function postUserQueryTemplateAdd(data: UserQueryTemplateRequest): Promise<number> {
  const url = baseUrl + `/user-query-template/add`
  return await request.post<ApiResult_int>(url, data, {})
}

/**
 * 删除预设组
 * @param {UserQueryTemplateRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user-query-template/delete
 * @apiGroup 用户筛选条件模版相关接口
 */
export async function postUserQueryTemplateDelete(data: UserQueryTemplateRequest): Promise<boolean> {
  const url = baseUrl + `/user-query-template/delete`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 获取预设组列表
 * @param {object} [params] 查询参数
 * @param {string} [params.source] 来源页面
 * @returns {Promise<UserQueryTemplate[]>} OK
 * @api {get} /user-query-template/list
 * @apiGroup 用户筛选条件模版相关接口
 */
export async function getUserQueryTemplateList(params?: { source?: string }): Promise<UserQueryTemplate[]> {
  const url = baseUrl + `/user-query-template/list`
  return await request.get<ApiResult_List_UserQueryTemplate>(url, { params })
}

/**
 * 预设组重置排序
 * @param {UserQueryTemplateRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user-query-template/reset
 * @apiGroup 用户筛选条件模版相关接口
 */
export async function postUserQueryTemplateReset(data: UserQueryTemplateRequest): Promise<boolean> {
  const url = baseUrl + `/user-query-template/reset`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 批量取消监控
 * @param {UserMonitorEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /team-manage/user/monitor/batch-remove
 * @apiGroup 团队管理-用户监控
 */
export async function postTeamManageUserMonitorBatchRemove(data: UserMonitorEditRequest): Promise<boolean> {
  const url = baseUrl + `/team-manage/user/monitor/batch-remove`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 获取监控数量信息
 * @param {object} [params] 查询参数
 * @param {string} [params.monitorType] 监控类型
 * @param {string} [params.userId] 成员id
 * @returns {Promise<UserMonitorNumResponse>} OK
 * @api {get} /team-manage/user/monitor/get-num-info
 * @apiGroup 团队管理-用户监控
 */
export async function getTeamManageUserMonitorGetNumInfo(params?: { monitorType: string; userId: string }): Promise<UserMonitorNumResponse> {
  const url = baseUrl + `/team-manage/user/monitor/get-num-info`
  return await request.get<ApiResult_UserMonitorNumResponse>(url, { params })
}

/**
 * 取消监控
 * @param {UserMonitorEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /team-manage/user/monitor/remove
 * @apiGroup 团队管理-用户监控
 */
export async function postTeamManageUserMonitorRemove(data: UserMonitorEditRequest): Promise<boolean> {
  const url = baseUrl + `/team-manage/user/monitor/remove`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 新增分组
 * @param {UserGroupEditRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /user/group/add
 * @apiGroup 用户监控分组
 */
export async function postUserGroupAdd(data: UserGroupEditRequest): Promise<string> {
  const url = baseUrl + `/user/group/add`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 批量管理分组
 * @param {UserGroupEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user/group/batch-update
 * @apiGroup 用户监控分组
 */
export async function postUserGroupBatchUpdate(data: UserGroupEditRequest): Promise<boolean> {
  const url = baseUrl + `/user/group/batch-update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 删除分组
 * @param {UserGroupEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user/group/delete
 * @apiGroup 用户监控分组
 */
export async function postUserGroupDelete(data: UserGroupEditRequest): Promise<boolean> {
  const url = baseUrl + `/user/group/delete`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询分组列表
 * @param {UserGroupQueryRequest} data 请求数据
 * @returns {Promise<UserGroupListResponse>} OK
 * @api {post} /user/group/list
 * @apiGroup 用户监控分组
 */
export async function postUserGroupList(data: UserGroupQueryRequest): Promise<UserGroupListResponse> {
  const url = baseUrl + `/user/group/list`
  return await request.post<ApiResult_UserGroupListResponse>(url, data, {})
}

/**
 * 获取分组选择器（我的监控 + 团队监控 + 未分组 + 我的分组 + 团队分组 + 全部分组）
 * @param {UserGroupQueryRequest} data 请求数据
 * @returns {Promise<UserNoteGroupListResponse>} OK
 * @api {post} /user/group/list-selector
 * @apiGroup 用户监控分组
 */
export async function postUserGroupListSelector(data: UserGroupQueryRequest): Promise<UserNoteGroupListResponse> {
  const url = baseUrl + `/user/group/list-selector`
  return await request.post<ApiResult_UserNoteGroupListResponse>(url, data, {})
}

/**
 * 用户监控列表
 * @param {object} [params] 查询参数
 * @param {number} [params.groupType] 监控类型
 * @param {string} [params.groupId] 分组ID
 * @param {string} [params.fuzzyMonitorName] 模糊搜索监控名
 * @returns {Promise<UserGroupMonitorResponse>} OK
 * @api {get} /user/group/monitor-list
 * @apiGroup 用户监控分组
 */
export async function getUserGroupMonitorList(params?: { groupType?: number; groupId?: string; fuzzyMonitorName?: string }): Promise<UserGroupMonitorResponse> {
  const url = baseUrl + `/user/group/monitor-list`
  return await request.get<ApiResult_UserGroupMonitorResponse>(url, { params })
}

/**
 * 监控对象设置分组
 * @param {UserGroupMonitorEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user/group/set-group-monitor
 * @apiGroup 用户监控分组
 */
export async function postUserGroupSetGroupMonitor(data: UserGroupMonitorEditRequest): Promise<boolean> {
  const url = baseUrl + `/user/group/set-group-monitor`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询所有分组列表
 * @param {TeamManageUserGroupQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_UserGroupResponse>} OK
 * @api {post} /user/group/team-manage/list
 * @apiGroup 用户监控分组
 */
export async function postUserGroupTeamManageList(data: TeamManageUserGroupQueryRequest): Promise<PaginationResult_UserGroupResponse> {
  const url = baseUrl + `/user/group/team-manage/list`
  return await request.post<ApiResult_PaginationResult_UserGroupResponse>(url, data, {})
}

/**
 * 修改分组
 * @param {UserGroupEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user/group/update
 * @apiGroup 用户监控分组
 */
export async function postUserGroupUpdate(data: UserGroupEditRequest): Promise<boolean> {
  const url = baseUrl + `/user/group/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 修改分组顺序
 * @param {UserGroupOrderEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user/group/update-order
 * @apiGroup 用户监控分组
 */
export async function postUserGroupUpdateOrder(data: UserGroupOrderEditRequest): Promise<boolean> {
  const url = baseUrl + `/user/group/update-order`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 获取分组弹框设置
 * @param {UserGroupSettingRequest} data 请求数据
 * @returns {Promise<int>} OK
 * @api {post} /user/group/setting/get
 * @apiGroup 用户监控分组弹窗设置
 */
export async function postUserGroupSettingGet(data: UserGroupSettingRequest): Promise<number> {
  const url = baseUrl + `/user/group/setting/get`
  return await request.post<ApiResult_int>(url, data, {})
}

/**
 * 获取全部分组弹框设置
 * @returns {Promise<UserGroupPopSettingResponse[]>} OK
 * @api {get} /user/group/setting/get-all
 * @apiGroup 用户监控分组弹窗设置
 */
export async function getUserGroupSettingGetAll(): Promise<UserGroupPopSettingResponse[]> {
  const url = baseUrl + `/user/group/setting/get-all`
  return await request.get<ApiResult_List_UserGroupPopSettingResponse>(url)
}

/**
 * 保存分组弹框设置
 * @param {UserGroupSettingRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user/group/setting/save
 * @apiGroup 用户监控分组弹窗设置
 */
export async function postUserGroupSettingSave(data: UserGroupSettingRequest): Promise<boolean> {
  const url = baseUrl + `/user/group/setting/save`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 新增监控
 * @param {UserMonitorEditRequest} data 请求数据
 * @returns {Promise<UserMonitorNumResponse>} OK
 * @api {post} /user/monitor/add
 * @apiGroup 用户监控
 */
export async function postUserMonitorAdd(data: UserMonitorEditRequest): Promise<UserMonitorNumResponse> {
  const url = baseUrl + `/user/monitor/add`
  return await request.post<ApiResult_UserMonitorNumResponse>(url, data, {})
}

/**
 * 批量新增监控
 * @param {UserMonitorEditRequest} data 请求数据
 * @returns {Promise<UserMonitorNumResponse>} OK
 * @api {post} /user/monitor/batch-add
 * @apiGroup 用户监控
 */
export async function postUserMonitorBatchAdd(data: UserMonitorEditRequest): Promise<UserMonitorNumResponse> {
  const url = baseUrl + `/user/monitor/batch-add`
  return await request.post<ApiResult_UserMonitorNumResponse>(url, data, {})
}

/**
 * 批量取消监控
 * @param {UserMonitorEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user/monitor/batch-remove
 * @apiGroup 用户监控
 */
export async function postUserMonitorBatchRemove(data: UserMonitorEditRequest): Promise<boolean> {
  const url = baseUrl + `/user/monitor/batch-remove`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 获取监控数量信息
 * @param {object} [params] 查询参数
 * @param {string} [params.monitorType] 监控类型
 * @returns {Promise<UserMonitorNumResponse>} OK
 * @api {get} /user/monitor/get-num-info
 * @apiGroup 用户监控
 */
export async function getUserMonitorGetNumInfo(params?: { monitorType: string }): Promise<UserMonitorNumResponse> {
  const url = baseUrl + `/user/monitor/get-num-info`
  return await request.get<ApiResult_UserMonitorNumResponse>(url, { params })
}

/**
 * 取消监控
 * @param {UserMonitorEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user/monitor/remove
 * @apiGroup 用户监控
 */
export async function postUserMonitorRemove(data: UserMonitorEditRequest): Promise<boolean> {
  const url = baseUrl + `/user/monitor/remove`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 监控历史
 * @param {object} [params] 查询参数
 * @param {string} [params.limit] 最近取消监控的n个店铺数据
 * @returns {Promise<Shop[]>} OK
 * @api {get} /style/tb-item/history-follow-list
 * @apiGroup 最近取消监控的n个店铺数据, 款式中心-淘系商品
 */
export async function getStyleTbItemHistoryFollowList(params?: { limit: string }): Promise<Shop[]> {
  const url = baseUrl + `/style/tb-item/history-follow-list`
  return await request.get<ApiResult_List_Shop>(url, { params })
}

/**
 * 新增面料
 * @param {FabricInfoEditRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /fabric/info/add
 * @apiGroup 面料管理-面料信息
 */
export async function postFabricInfoAdd(data: FabricInfoEditRequest): Promise<string> {
  const url = baseUrl + `/fabric/info/add`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 取消上架申请
 * @param {FabricShelfReviewRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/info/cancel/shelf
 * @apiGroup 面料管理-面料信息
 */
export async function postFabricInfoCancelShelf(data: FabricShelfReviewRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/info/cancel/shelf`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询用户面料数量
 * @returns {Promise<FabricInfoCountResponse>} OK
 * @api {get} /fabric/info/count
 * @apiGroup 面料管理-面料信息
 */
export async function getFabricInfoCount(): Promise<FabricInfoCountResponse> {
  const url = baseUrl + `/fabric/info/count`
  return await request.get<ApiResult_FabricInfoCountResponse>(url)
}

/**
 * 删除面料
 * @param {FabricInfoEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/info/delete
 * @apiGroup 面料管理-面料信息
 */
export async function postFabricInfoDelete(data: FabricInfoEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/info/delete`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询面料数据字典
 * @returns {Promise<DataDictResponse[]>} OK
 * @api {get} /fabric/info/dict/list
 * @apiGroup 面料管理-面料信息
 */
export async function getFabricInfoDictList(): Promise<DataDictResponse[]> {
  const url = baseUrl + `/fabric/info/dict/list`
  return await request.get<ApiResult_List_DataDictResponse>(url)
}

/**
 * 查询面料信息(可查询被删除的面料)
 * @param {object} [params] 查询参数
 * @param {string} [params.fabricId] 面料id
 * @returns {Promise<FabricInfoListResponse>} OK
 * @api {get} /fabric/info/find
 * @apiGroup 面料管理-面料信息
 */
export async function getFabricInfoFind(params?: { fabricId: string }): Promise<FabricInfoListResponse> {
  const url = baseUrl + `/fabric/info/find`
  return await request.get<ApiResult_FabricInfoListResponse>(url, { params })
}

/**
 * 商家详情-全部面料
 * @param {FabricInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricMerchantDetailsResponse>} OK
 * @api {post} /fabric/info/merchant/fabric
 * @apiGroup 面料管理-面料信息
 */
export async function postFabricInfoMerchantFabric(data: FabricInfoQueryRequest): Promise<PaginationResult_FabricMerchantDetailsResponse> {
  const url = baseUrl + `/fabric/info/merchant/fabric`
  return await request.post<ApiResult_PaginationResult_FabricMerchantDetailsResponse>(url, data, {})
}

/**
 * 查询商家信息
 * @param {object} [params] 查询参数
 * @param {string} [params.teamId] 商家id
 * @returns {Promise<FabricTeamInfoResponse>} OK
 * @api {get} /fabric/info/merchant/info
 * @apiGroup 面料管理-面料信息
 */
export async function getFabricInfoMerchantInfo(params?: { teamId: string }): Promise<FabricTeamInfoResponse> {
  const url = baseUrl + `/fabric/info/merchant/info`
  return await request.get<ApiResult_FabricTeamInfoResponse>(url, { params })
}

/**
 * 查询面料列表
 * @param {FabricInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricInfoListResponse>} OK
 * @api {post} /fabric/info/page/list
 * @apiGroup 面料管理-面料信息
 */
export async function postFabricInfoPageList(data: FabricInfoQueryRequest): Promise<PaginationResult_FabricInfoListResponse> {
  const url = baseUrl + `/fabric/info/page/list`
  return await request.post<ApiResult_PaginationResult_FabricInfoListResponse>(url, data, {})
}

/**
 * 查询商家推广项目数量
 * @param {object} [params] 查询参数
 * @param {number} [params.teamId] teamId
 * @returns {Promise<FabricPromotionProjectCountResponse>} OK
 * @api {get} /fabric/info/operation/count
 * @apiGroup 面料管理-面料信息
 */
export async function getFabricInfoOperationCount(params?: { teamId?: number }): Promise<FabricPromotionProjectCountResponse> {
  const url = baseUrl + `/fabric/info/operation/count`
  return await request.get<ApiResult_FabricPromotionProjectCountResponse>(url, { params })
}

/**
 * 查询面料详情
 * @param {FabricInfoDetailRequest} data 请求数据
 * @returns {Promise<FabricInfoDetailResponse>} OK
 * @api {post} /fabric/info/query/detail
 * @apiGroup 面料管理-面料信息
 */
export async function postFabricInfoQueryDetail(data: FabricInfoDetailRequest): Promise<FabricInfoDetailResponse> {
  const url = baseUrl + `/fabric/info/query/detail`
  return await request.post<ApiResult_FabricInfoDetailResponse>(url, data, {})
}

/**
 * 查询2000条推广中面料id
 * @returns {Promise<string[]>} OK
 * @api {get} /fabric/info/query/ids
 * @apiGroup 面料管理-面料信息
 */
export async function getFabricInfoQueryIds(): Promise<string[]> {
  const url = baseUrl + `/fabric/info/query/ids`
  return await request.get<ApiResult_List_string>(url)
}

/**
 * 查询面料信息
 * @param {object} [params] 查询参数
 * @param {string} [params.fabricId] 面料id
 * @returns {Promise<FabricInfoListResponse>} OK
 * @api {get} /fabric/info/query/info
 * @apiGroup 面料管理-面料信息
 */
export async function getFabricInfoQueryInfo(params?: { fabricId: string }): Promise<FabricInfoListResponse> {
  const url = baseUrl + `/fabric/info/query/info`
  return await request.get<ApiResult_FabricInfoListResponse>(url, { params })
}

/**
 * 推荐面料
 * @param {object} [params] 查询参数
 * @param {string} [params.fabricId] 面料id
 * @returns {Promise<FabricRecommendationResponse>} OK
 * @api {get} /fabric/info/related/products
 * @apiGroup 面料管理-面料信息
 */
export async function getFabricInfoRelatedProducts(params?: { fabricId: string }): Promise<FabricRecommendationResponse> {
  const url = baseUrl + `/fabric/info/related/products`
  return await request.get<ApiResult_FabricRecommendationResponse>(url, { params })
}

/**
 * 提交上架申请
 * @param {object} [params] 查询参数
 * @param {array} [params.fabricIdList] fabricIdList
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/info/shelf/application
 * @apiGroup 面料管理-面料信息
 */
export async function getFabricInfoShelfApplication(params?: { fabricIdList: string[] }): Promise<boolean> {
  const url = baseUrl + `/fabric/info/shelf/application`
  return await request.get<ApiResult_boolean>(url, { params })
}

/**
 * 查询商家信息
 * @returns {Promise<FabricTeamInfoResponse>} OK
 * @api {get} /fabric/info/team/info
 * @apiGroup 面料管理-面料信息
 */
export async function getFabricInfoTeamInfo(): Promise<FabricTeamInfoResponse> {
  const url = baseUrl + `/fabric/info/team/info`
  return await request.get<ApiResult_FabricTeamInfoResponse>(url)
}

/**
 * 编辑面料
 * @param {FabricInfoEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/info/update
 * @apiGroup 面料管理-面料信息
 */
export async function postFabricInfoUpdate(data: FabricInfoEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/info/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 客户洞察-面料动态 asyncQueryTask value = ZXB_INSIGHT_FABRIC_ANALYSIS
 * @param {MonitorCenterDistributionRequest} data 请求数据
 * @returns {Promise<PaginationResult_MonitorCenterDistributionResponse>} OK
 * @api {post} /insight/fabric/distribution
 * @apiGroup 客户洞察-面料接口
 */
export async function postInsightFabricDistribution(data: MonitorCenterDistributionRequest): Promise<PaginationResult_MonitorCenterDistributionResponse> {
  const url = baseUrl + `/insight/fabric/distribution`
  return await request.post<ApiResult_PaginationResult_MonitorCenterDistributionResponse>(url, data, {})
}

/**
 * 关联商品/款式
 * @param {FabricAssociateRequest} data 请求数据
 * @returns {Promise<FabricAssociateResponse>} OK
 * @api {post} /fabric/association/associate
 * @apiGroup 面料管理-面料关联
 */
export async function postFabricAssociationAssociate(data: FabricAssociateRequest): Promise<FabricAssociateResponse> {
  const url = baseUrl + `/fabric/association/associate`
  return await request.post<ApiResult_FabricAssociateResponse>(url, data, {})
}

/**
 * 批量关联商品/款式
 * @param {FabricAssociateRequest} data 请求数据
 * @returns {Promise<FabricAssociateResponse>} OK
 * @api {post} /fabric/association/batch/associate
 * @apiGroup 面料管理-面料关联
 */
export async function postFabricAssociationBatchAssociate(data: FabricAssociateRequest): Promise<FabricAssociateResponse> {
  const url = baseUrl + `/fabric/association/batch/associate`
  return await request.post<ApiResult_FabricAssociateResponse>(url, data, {})
}

/**
 * 取消关联商品/款式
 * @param {FabricAssociateRequest} data 请求数据
 * @returns {Promise<FabricAssociateResponse>} OK
 * @api {post} /fabric/association/cancel
 * @apiGroup 面料管理-面料关联
 */
export async function postFabricAssociationCancel(data: FabricAssociateRequest): Promise<FabricAssociateResponse> {
  const url = baseUrl + `/fabric/association/cancel`
  return await request.post<ApiResult_FabricAssociateResponse>(url, data, {})
}

/**
 * 查询商品信息
 * @param {QueryPromotionFabricRequest} data 请求数据
 * @returns {Promise<FabricProductAssociation>} OK
 * @api {post} /fabric/association/entity/info
 * @apiGroup 面料管理-面料关联
 */
export async function postFabricAssociationEntityInfo(data: QueryPromotionFabricRequest): Promise<FabricProductAssociation> {
  const url = baseUrl + `/fabric/association/entity/info`
  return await request.post<ApiResult_FabricProductAssociation>(url, data, {})
}

/**
 * 查询最近关联面料（10条）
 * @returns {Promise<FabricInfoDetailResponse[]>} OK
 * @api {get} /fabric/association/list
 * @apiGroup 面料管理-面料关联
 */
export async function getFabricAssociationList(): Promise<FabricInfoDetailResponse[]> {
  const url = baseUrl + `/fabric/association/list`
  return await request.get<ApiResult_List_FabricInfoDetailResponse>(url)
}

/**
 * 查询关联商品/款式
 * @param {QueryFabricAssociationRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricAssociateInfo>} OK
 * @api {post} /fabric/association/query
 * @apiGroup 面料管理-面料关联
 */
export async function postFabricAssociationQuery(data: QueryFabricAssociationRequest): Promise<PaginationResult_FabricAssociateInfo> {
  const url = baseUrl + `/fabric/association/query`
  return await request.post<ApiResult_PaginationResult_FabricAssociateInfo>(url, data, {})
}

/**
 * 取消推广
 * @param {ReviewFabricPromotionRequest} data 请求数据
 * @returns {Promise<FabricReviewResponse>} OK
 * @api {post} /fabric/promotion/admin/cancel
 * @apiGroup 面料管理-面料推广-后台管理
 */
export async function postFabricPromotionAdminCancel(data: ReviewFabricPromotionRequest): Promise<FabricReviewResponse> {
  const url = baseUrl + `/fabric/promotion/admin/cancel`
  return await request.post<ApiResult_FabricReviewResponse>(url, data, {})
}

/**
 * 查询审核列表
 * @param {object} [params] 查询参数
 * @param {array} [params.projectStatusList] 项目状态
 * @param {number} [params.pageSize] 分页参数 - 页大小
 * @param {number} [params.pageNo] 分页参数 - 跳转页
 * @param {number} [params.start] 分页参数 - 开始记录
 * @param {number} [params.limit] 分页参数 - 查询上限
 * @param {string} [params.applyDateStart] 申请时间-开始
 * @param {string} [params.applyDateEnd] 申请时间-结束
 * @param {string} [params.reviewDateStart] 审核时间-开始
 * @param {string} [params.reviewDateEnd] 审核时间-结束
 * @param {number} [params.reviewStatus] 布匹推广审核状态 0-待审核 1-通过 2-拒绝 3-取消
 * @param {string} [params.fabricId] 布匹id
 * @param {string} [params.fuzzyFabricName] 布匹名称
 * @param {string} [params.fuzzyCompanyName] 公司名称
 * @param {string} [params.fuzzyApplyUserName] 申请人姓名
 * @param {string} [params.fuzzyApplyUserPhone] 申请人手机号
 * @param {string} [params.projectId] 项目id
 * @param {string} [params.fuzzyProjectName] 项目名称
 * @returns {Promise<PaginationResult_FabricPromotionReviewInfo>} OK
 * @api {get} /fabric/promotion/admin/list
 * @apiGroup 面料管理-面料推广-后台管理
 */
export async function getFabricPromotionAdminList(params?: { projectStatusList?: number[]; pageSize?: number; pageNo?: number; start?: number; limit?: number; applyDateStart?: string; applyDateEnd?: string; reviewDateStart?: string; reviewDateEnd?: string; reviewStatus?: number; fabricId?: string; fuzzyFabricName?: string; fuzzyCompanyName?: string; fuzzyApplyUserName?: string; fuzzyApplyUserPhone?: string; projectId?: string; fuzzyProjectName?: string }): Promise<PaginationResult_FabricPromotionReviewInfo> {
  const url = baseUrl + `/fabric/promotion/admin/list`
  return await request.get<ApiResult_PaginationResult_FabricPromotionReviewInfo>(url, { params })
}

/**
 * 查询审核商品/图片列表
 * @param {object} [params] 查询参数
 * @param {array} [params.sourceChannelList] 来源渠道
 * @param {number} [params.pageSize] 分页参数 - 页大小
 * @param {number} [params.pageNo] 分页参数 - 跳转页
 * @param {number} [params.start] 分页参数 - 开始记录
 * @param {number} [params.limit] 分页参数 - 查询上限
 * @param {string} [params.fabricReviewId] 面料审核id
 * @returns {Promise<PaginationResult_FabricAssociateInfo>} OK
 * @api {get} /fabric/promotion/admin/list-entity
 * @apiGroup 面料管理-面料推广-后台管理
 */
export async function getFabricPromotionAdminListEntity(params?: { sourceChannelList?: number[]; pageSize?: number; pageNo?: number; start?: number; limit?: number; fabricReviewId?: string }): Promise<PaginationResult_FabricAssociateInfo> {
  const url = baseUrl + `/fabric/promotion/admin/list-entity`
  return await request.get<ApiResult_PaginationResult_FabricAssociateInfo>(url, { params })
}

/**
 * 审核
 * @param {ReviewFabricPromotionRequest} data 请求数据
 * @returns {Promise<FabricReviewResponse>} OK
 * @api {post} /fabric/promotion/admin/review
 * @apiGroup 面料管理-面料推广-后台管理
 */
export async function postFabricPromotionAdminReview(data: ReviewFabricPromotionRequest): Promise<FabricReviewResponse> {
  const url = baseUrl + `/fabric/promotion/admin/review`
  return await request.post<ApiResult_FabricReviewResponse>(url, data, {})
}

/**
 * 取消推广
 * @param {CancelFabricPromotionRequest} data 请求数据
 * @returns {Promise<FabricPromotionResponse>} OK
 * @api {post} /fabric/promotion/cancel
 * @apiGroup 面料管理-面料推广
 */
export async function postFabricPromotionCancel(data: CancelFabricPromotionRequest): Promise<FabricPromotionResponse> {
  const url = baseUrl + `/fabric/promotion/cancel`
  return await request.post<ApiResult_FabricPromotionResponse>(url, data, {})
}

/**
 * 取消推广申请
 * @param {CancelFabricPromotionRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/promotion/cancel/apply
 * @apiGroup 面料管理-面料推广
 */
export async function postFabricPromotionCancelApply(data: CancelFabricPromotionRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/promotion/cancel/apply`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 数据统计-推广数据
 * @param {object} [params] 查询参数
 * @param {string} [params.projectId] 项目id
 * @param {string} [params.startDate] 统计开始时间
 * @param {string} [params.endDate] 统计结束时间
 * @returns {Promise<FabricPromotionDataResponse>} OK
 * @api {get} /fabric/promotion/data-statistical/promotion-data
 * @apiGroup 面料管理-面料推广
 */
export async function getFabricPromotionDataStatisticalPromotionData(params?: { projectId?: string; startDate?: string; endDate?: string }): Promise<FabricPromotionDataResponse> {
  const url = baseUrl + `/fabric/promotion/data-statistical/promotion-data`
  return await request.get<ApiResult_FabricPromotionDataResponse>(url, { params })
}

/**
 * 数据统计-商家数据
 * @param {object} [params] 查询参数
 * @param {string} [params.projectId] 项目id
 * @param {string} [params.startDate] 统计开始时间
 * @param {string} [params.endDate] 统计结束时间
 * @returns {Promise<PromotionSellerDataResponse>} OK
 * @api {get} /fabric/promotion/data-statistical/seller-data
 * @apiGroup 面料管理-面料推广
 */
export async function getFabricPromotionDataStatisticalSellerData(params?: { projectId?: string; startDate?: string; endDate?: string }): Promise<PromotionSellerDataResponse> {
  const url = baseUrl + `/fabric/promotion/data-statistical/seller-data`
  return await request.get<ApiResult_PromotionSellerDataResponse>(url, { params })
}

/**
 * 面料详情-推广信息
 * @param {object} [params] 查询参数
 * @param {string} [params.fabricId] 面料id
 * @param {string} [params.startDate] 开始日期
 * @param {string} [params.endDate] 结束日期
 * @returns {Promise<QueryFabricPromotionInfoResponse>} OK
 * @api {get} /fabric/promotion/fabric-info
 * @apiGroup 面料管理-面料推广
 */
export async function getFabricPromotionFabricInfo(params?: { fabricId: string; startDate: string; endDate: string }): Promise<QueryFabricPromotionInfoResponse> {
  const url = baseUrl + `/fabric/promotion/fabric-info`
  return await request.get<ApiResult_QueryFabricPromotionInfoResponse>(url, { params })
}

/**
 * 面料详情-推广信息-趋势
 * @param {object} [params] 查询参数
 * @param {string} [params.fabricId] 面料id
 * @param {string} [params.startDate] 开始日期
 * @param {string} [params.endDate] 结束日期
 * @param {number} [params.granularity] 粒度 1-日 2-周 3-月
 * @returns {Promise<QueryFabricPromotionTrendResponse>} OK
 * @api {get} /fabric/promotion/fabric-trend
 * @apiGroup 面料管理-面料推广
 */
export async function getFabricPromotionFabricTrend(params?: { fabricId: string; startDate: string; endDate: string; granularity?: number }): Promise<QueryFabricPromotionTrendResponse> {
  const url = baseUrl + `/fabric/promotion/fabric-trend`
  return await request.get<ApiResult_QueryFabricPromotionTrendResponse>(url, { params })
}

/**
 * 用户查看/咨询面料历史记录
 * @param {PromotionRecordQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricSelect>} OK
 * @api {post} /fabric/promotion/fabric/list-record
 * @apiGroup 面料管理-面料推广
 */
export async function postFabricPromotionFabricListRecord(data: PromotionRecordQueryRequest): Promise<PaginationResult_FabricSelect> {
  const url = baseUrl + `/fabric/promotion/fabric/list-record`
  return await request.post<ApiResult_PaginationResult_FabricSelect>(url, data, {})
}

/**
 * 查询首页数据
 * @param {object} [params] 查询参数
 * @param {number} [params.overviewTimeType] 数据概览时间类型 1-实时 2-昨日 3-近7日 4-近30天 9-自定义
 * @param {string} [params.overviewStartDate] 数据概览统计开始时间
 * @param {string} [params.overviewEndDate] 数据概览统计结束时间
 * @param {number} [params.promotionTimeType] 推广动态时间类型 1-实时 2-昨日 3-近7日 4-近30天 9-自定义
 * @param {string} [params.promotionStartDate] 统计开始时间
 * @param {string} [params.promotionEndDate] 统计结束时间
 * @param {number} [params.timeType] 
 * @param {string} [params.startDate] 
 * @param {string} [params.endDate] 
 * @param {string} [params.chainStartDate] 
 * @param {string} [params.chainEndDate] 
 * @returns {Promise<PromotionDetailResponse>} OK
 * @api {get} /fabric/promotion/homepage
 * @apiGroup 面料管理-面料推广
 */
export async function getFabricPromotionHomepage(params?: { overviewTimeType?: number; overviewStartDate?: string; overviewEndDate?: string; promotionTimeType?: number; promotionStartDate?: string; promotionEndDate?: string; timeType?: number; startDate?: string; endDate?: string; chainStartDate?: string; chainEndDate?: string }): Promise<PromotionDetailResponse> {
  const url = baseUrl + `/fabric/promotion/homepage`
  return await request.get<ApiResult_PromotionDetailResponse>(url, { params })
}

/**
 * 面料咨询记录
 * @param {object} [params] 查询参数
 * @param {string} [params.fabricId] 布料id
 * @returns {Promise<FabricInquiry[]>} OK
 * @api {get} /fabric/promotion/inquiry-list
 * @apiGroup 面料管理-面料推广
 */
export async function getFabricPromotionInquiryList(params?: { fabricId?: string }): Promise<FabricInquiry[]> {
  const url = baseUrl + `/fabric/promotion/inquiry-list`
  return await request.get<ApiResult_List_FabricInquiry>(url, { params })
}

/**
 * 面料详情-推广信息-投放列表
 * @param {object} [params] 查询参数
 * @param {array} [params.sourceChannelList] 推广渠道
 * @param {number} [params.pageSize] 分页参数 - 页大小
 * @param {number} [params.pageNo] 分页参数 - 跳转页
 * @param {number} [params.start] 分页参数 - 开始记录
 * @param {number} [params.limit] 分页参数 - 查询上限
 * @param {string} [params.fabricId] 布匹id
 * @param {string} [params.sortField] 排序字段
 * @param {string} [params.sortType] 排序方式
 * @returns {Promise<PaginationResult_FabricPromotionInfo>} OK
 * @api {get} /fabric/promotion/list
 * @apiGroup 面料管理-面料推广
 */
export async function getFabricPromotionList(params?: { sourceChannelList?: number[]; pageSize?: number; pageNo?: number; start?: number; limit?: number; fabricId?: string; sortField?: string; sortType?: string }): Promise<PaginationResult_FabricPromotionInfo> {
  const url = baseUrl + `/fabric/promotion/list`
  return await request.get<ApiResult_PaginationResult_FabricPromotionInfo>(url, { params })
}

/**
 * 面料推广
 * @param {object} [params] 查询参数
 * @param {string} [params.projectId] 项目id
 * @param {string} [params.startDate] 统计开始时间
 * @param {string} [params.endDate] 统计结束时间
 * @returns {Promise<PromotionOverviewResponse>} OK
 * @api {get} /fabric/promotion/overview
 * @apiGroup 面料管理-面料推广
 */
export async function getFabricPromotionOverview(params?: { projectId?: string; startDate?: string; endDate?: string }): Promise<PromotionOverviewResponse> {
  const url = baseUrl + `/fabric/promotion/overview`
  return await request.get<ApiResult_PromotionOverviewResponse>(url, { params })
}

/**
 * 申请推广
 * @param {FabricPromotionRequest} data 请求数据
 * @returns {Promise<FabricPromotionResponse>} OK
 * @api {post} /fabric/promotion/promote
 * @apiGroup 面料管理-面料推广
 */
export async function postFabricPromotionPromote(data: FabricPromotionRequest): Promise<FabricPromotionResponse> {
  const url = baseUrl + `/fabric/promotion/promote`
  return await request.post<ApiResult_FabricPromotionResponse>(url, data, {})
}

/**
 * 查询面料排行列表
 * @param {FabricInfoRankQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricRankListResponse>} OK
 * @api {post} /fabric/promotion/rank/list
 * @apiGroup 面料管理-面料推广
 */
export async function postFabricPromotionRankList(data: FabricInfoRankQueryRequest): Promise<PaginationResult_FabricRankListResponse> {
  const url = baseUrl + `/fabric/promotion/rank/list`
  return await request.post<ApiResult_PaginationResult_FabricRankListResponse>(url, data, {})
}

/**
 * 查询推广项目排行列表
 * @param {FabricProjectQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricProjectRankListResponse>} OK
 * @api {post} /fabric/promotion/rank/project-list
 * @apiGroup 面料管理-面料推广
 */
export async function postFabricPromotionRankProjectList(data: FabricProjectQueryRequest): Promise<PaginationResult_FabricProjectRankListResponse> {
  const url = baseUrl + `/fabric/promotion/rank/project-list`
  return await request.post<ApiResult_PaginationResult_FabricProjectRankListResponse>(url, data, {})
}

/**
 * 查询推广项目下面料排行列表
 * @param {FabricProjectRankFabricListRequest} data 请求数据
 * @returns {Promise<FabricProjectRankFabricListResponse>} OK
 * @api {post} /fabric/promotion/rank/project-list-fabric
 * @apiGroup 面料管理-面料推广
 */
export async function postFabricPromotionRankProjectListFabric(data: FabricProjectRankFabricListRequest): Promise<FabricProjectRankFabricListResponse> {
  const url = baseUrl + `/fabric/promotion/rank/project-list-fabric`
  return await request.post<ApiResult_FabricProjectRankFabricListResponse>(url, data, {})
}

/**
 * 面料咨询记录
 * @param {RefreshDailyPromotionRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/promotion/refresh-daily-record
 * @apiGroup 面料管理-面料推广
 */
export async function postFabricPromotionRefreshDailyRecord(data: RefreshDailyPromotionRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/promotion/refresh-daily-record`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询关联推广面料
 * @param {object} [params] 查询参数
 * @param {array} [params.excludeFabricIdList] 排除的面料列表
 * @param {number} [params.sourceChannel] 来源渠道
 * @param {string} [params.entityId] 关联实体id
 * @returns {Promise<QueryPromotionFabricResponse>} OK
 * @api {get} /fabric/promotion/related-fabrics
 * @apiGroup 面料管理-面料推广
 */
export async function getFabricPromotionRelatedFabrics(params?: { excludeFabricIdList?: string[]; sourceChannel?: number; entityId?: string }): Promise<QueryPromotionFabricResponse> {
  const url = baseUrl + `/fabric/promotion/related-fabrics`
  return await request.get<ApiResult_QueryPromotionFabricResponse>(url, { params })
}

/**
 * 上架消费次数
 * @param {object} [params] 查询参数
 * @param {number} [params.teamId] teamId
 * @returns {Promise<TeamFabricPromotionResponse>} OK
 * @api {get} /fabric/promotion/team/consume
 * @apiGroup 面料管理-面料推广
 */
export async function getFabricPromotionTeamConsume(params?: { teamId?: number }): Promise<TeamFabricPromotionResponse> {
  const url = baseUrl + `/fabric/promotion/team/consume`
  return await request.get<ApiResult_TeamFabricPromotionResponse>(url, { params })
}

/**
 * 批量上传款式
 * @param {BatchUploadStyleRequest} data 请求数据
 * @returns {Promise<StyleListResponse[]>} OK
 * @api {post} /fabric/style/batch/upload
 * @apiGroup 面料管理-我的款式
 */
export async function postFabricStyleBatchUpload(data: BatchUploadStyleRequest): Promise<StyleListResponse[]> {
  const url = baseUrl + `/fabric/style/batch/upload`
  return await request.post<ApiResult_List_StyleListResponse>(url, data, {})
}

/**
 * 查询款式列表
 * @param {QueryStyleListRequest} data 请求数据
 * @returns {Promise<PaginationResult_StyleListResponse>} OK
 * @api {post} /fabric/style/list
 * @apiGroup 面料管理-我的款式
 */
export async function postFabricStyleList(data: QueryStyleListRequest): Promise<PaginationResult_StyleListResponse> {
  const url = baseUrl + `/fabric/style/list`
  return await request.post<ApiResult_PaginationResult_StyleListResponse>(url, data, {})
}

/**
 * 监控商品列表
 * @param {MonitorItemRequest} data 请求数据
 * @returns {Promise<PaginationResult_MonitorItem>} OK
 * @api {post} /insight/monitor/item-list
 * @apiGroup 客户洞察-客户商品
 */
export async function postInsightMonitorItemList(data: MonitorItemRequest): Promise<PaginationResult_MonitorItem> {
  const url = baseUrl + `/insight/monitor/item-list`
  return await request.post<ApiResult_PaginationResult_MonitorItem>(url, data, {})
}

/**
 * 监控店铺列表
 * @param {MonitorShopRequest} data 请求数据
 * @returns {Promise<PaginationResult_MonitorShop>} OK
 * @api {post} /insight/monitor/shop-list
 * @apiGroup 客户洞察-客户商品
 */
export async function postInsightMonitorShopList(data: MonitorShopRequest): Promise<PaginationResult_MonitorShop> {
  const url = baseUrl + `/insight/monitor/shop-list`
  return await request.post<ApiResult_PaginationResult_MonitorShop>(url, data, {})
}

/**
 * 客户热销/客户新品
 * @param {MonitorShopItemRequest} data 请求数据
 * @returns {Promise<PaginationResult_Item>} OK
 * @api {post} /insight/monitor/shop/item-list
 * @apiGroup 客户洞察-客户商品
 */
export async function postInsightMonitorShopItemList(data: MonitorShopItemRequest): Promise<PaginationResult_Item> {
  const url = baseUrl + `/insight/monitor/shop/item-list`
  return await request.post<ApiResult_PaginationResult_Item>(url, data, {})
}

/**
 * errorHtml
 * @returns {Promise<any>} OK
 * @api {get} /error
 * @apiGroup basic-error-controller
 */
export async function getError(): Promise<any> {
  const url = baseUrl + `/error`
  return await request.get<any>(url)
}

/**
 * errorHtml
 * @returns {Promise<any>} OK
 * @api {post} /error
 * @apiGroup basic-error-controller
 */
export async function postError(): Promise<any> {
  const url = baseUrl + `/error`
  return await request.post<any>(url, {})
}

/**
 * errorHtml
 * @returns {Promise<any>} OK
 * @api {put} /error
 * @apiGroup basic-error-controller
 */
export async function putError(): Promise<any> {
  const url = baseUrl + `/error`
  return await request.put<any>(url, {})
}

/**
 * errorHtml
 * @returns {Promise<any>} OK
 * @api {delete} /error
 * @apiGroup basic-error-controller
 */
export async function deleteError(): Promise<any> {
  const url = baseUrl + `/error`
  return await request.delete<any>(url)
}

/**
 * errorHtml
 * @returns {Promise<any>} OK
 * @api {patch} /error
 * @apiGroup basic-error-controller
 */
export async function patchError(): Promise<any> {
  const url = baseUrl + `/error`
  return await request.patch<any>(url, {})
}

/**
 * getUserInfo
 * @returns {Promise<RequestContext>} OK
 * @api {get} /system/user-info
 * @apiGroup system-controller
 */
export async function getSystemUserInfo(): Promise<RequestContext> {
  const url = baseUrl + `/system/user-info`
  return await request.get<ApiResult_RequestContext>(url)
}

/**
 * 查询审核列表
 * @param {object} [params] 查询参数
 * @param {array} [params.projectStatusList] 项目状态
 * @param {number} [params.pageSize] 分页参数 - 页大小
 * @param {number} [params.pageNo] 分页参数 - 跳转页
 * @param {number} [params.start] 分页参数 - 开始记录
 * @param {number} [params.limit] 分页参数 - 查询上限
 * @param {string} [params.applyDateStart] 申请时间-开始
 * @param {string} [params.applyDateEnd] 申请时间-结束
 * @param {string} [params.reviewDateStart] 审核时间-开始
 * @param {string} [params.reviewDateEnd] 审核时间-结束
 * @param {number} [params.reviewStatus] 布匹推广审核状态 0-待审核 1-通过 2-拒绝 3-取消
 * @param {string} [params.fabricId] 布匹id
 * @param {string} [params.fuzzyFabricName] 布匹名称
 * @param {string} [params.fuzzyCompanyName] 公司名称
 * @param {string} [params.fuzzyApplyUserName] 申请人姓名
 * @param {string} [params.fuzzyApplyUserPhone] 申请人手机号
 * @param {string} [params.projectId] 项目id
 * @param {string} [params.fuzzyProjectName] 项目名称
 * @returns {Promise<PaginationResult_FabricShelfReviewInfo>} OK
 * @api {get} /fabric/shelf/admin/list
 * @apiGroup 面料管理-商品审核-后台管理
 */
export async function getFabricShelfAdminList(params?: { projectStatusList?: number[]; pageSize?: number; pageNo?: number; start?: number; limit?: number; applyDateStart?: string; applyDateEnd?: string; reviewDateStart?: string; reviewDateEnd?: string; reviewStatus?: number; fabricId?: string; fuzzyFabricName?: string; fuzzyCompanyName?: string; fuzzyApplyUserName?: string; fuzzyApplyUserPhone?: string; projectId?: string; fuzzyProjectName?: string }): Promise<PaginationResult_FabricShelfReviewInfo> {
  const url = baseUrl + `/fabric/shelf/admin/list`
  return await request.get<ApiResult_PaginationResult_FabricShelfReviewInfo>(url, { params })
}

/**
 * 下架
 * @param {FabricShelfReviewRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/shelf/admin/off/shelf
 * @apiGroup 面料管理-商品审核-后台管理
 */
export async function postFabricShelfAdminOffShelf(data: FabricShelfReviewRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/shelf/admin/off/shelf`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 批量下架
 * @param {FabricShelfReviewRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/shelf/admin/off/shelf/batch
 * @apiGroup 面料管理-商品审核-后台管理
 */
export async function postFabricShelfAdminOffShelfBatch(data: FabricShelfReviewRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/shelf/admin/off/shelf/batch`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 审核
 * @param {FabricShelfReviewRequest} data 请求数据
 * @returns {Promise<FabricShelfResponse>} OK
 * @api {post} /fabric/shelf/admin/review
 * @apiGroup 面料管理-商品审核-后台管理
 */
export async function postFabricShelfAdminReview(data: FabricShelfReviewRequest): Promise<FabricShelfResponse> {
  const url = baseUrl + `/fabric/shelf/admin/review`
  return await request.post<ApiResult_FabricShelfResponse>(url, data, {})
}

/**
 * 查询面料筛选项
 * @returns {Promise<DataDictResponse[]>} OK
 * @api {get} /fabric/select/dict/list
 * @apiGroup 精选面料
 */
export async function getFabricSelectDictList(): Promise<DataDictResponse[]> {
  const url = baseUrl + `/fabric/select/dict/list`
  return await request.get<ApiResult_List_DataDictResponse>(url)
}

/**
 * 获取面料商家详情
 * @param {object} [params] 查询参数
 * @param {number} [params.sourceChannel] sourceChannel
 * @param {string} [params.sellerId] sellerId
 * @returns {Promise<FabricSelectSeller>} OK
 * @api {get} /fabric/select/fabric-seller-detail
 * @apiGroup 精选面料
 */
export async function getFabricSelectFabricSellerDetail(params?: { sourceChannel: number; sellerId: string }): Promise<FabricSelectSeller> {
  const url = baseUrl + `/fabric/select/fabric-seller-detail`
  return await request.get<ApiResult_FabricSelectSeller>(url, { params })
}

/**
 * 查询商家更多面料
 * @param {object} [params] 查询参数
 * @param {number} [params.teamId] teamId
 * @param {string} [params.fabricId] fabricId
 * @param {number} [params.limit] limit
 * @returns {Promise<FabricSelectSimilar[]>} OK
 * @api {get} /fabric/select/fabric-similar-list
 * @apiGroup 精选面料
 */
export async function getFabricSelectFabricSimilarList(params?: { teamId: number; fabricId: string; limit: number }): Promise<FabricSelectSimilar[]> {
  const url = baseUrl + `/fabric/select/fabric-similar-list`
  return await request.get<ApiResult_List_FabricSelectSimilar>(url, { params })
}

/**
 * 获取小红书面料详情
 * @param {object} [params] 查询参数
 * @param {string} [params.fabricId] fabricId
 * @returns {Promise<FabricSelectXhs>} OK
 * @api {get} /fabric/select/fabric-xhs-detail
 * @apiGroup 精选面料
 */
export async function getFabricSelectFabricXhsDetail(params?: { fabricId: string }): Promise<FabricSelectXhs> {
  const url = baseUrl + `/fabric/select/fabric-xhs-detail`
  return await request.get<ApiResult_FabricSelectXhs>(url, { params })
}

/**
 * 查询商家推荐面料
 * @param {object} [params] 查询参数
 * @param {number} [params.teamId] teamId
 * @param {number} [params.limit] limit
 * @returns {Promise<FabricSelectSimilar[]>} OK
 * @api {get} /fabric/select/fabric/recommend/list
 * @apiGroup 精选面料
 */
export async function getFabricSelectFabricRecommendList(params?: { teamId: number; limit: number }): Promise<FabricSelectSimilar[]> {
  const url = baseUrl + `/fabric/select/fabric/recommend/list`
  return await request.get<ApiResult_List_FabricSelectSimilar>(url, { params })
}

/**
 * 查询精选布匹列表
 * @param {ListFabricSelectRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricSelect>} OK
 * @api {post} /fabric/select/list-fabric
 * @apiGroup 精选面料
 */
export async function postFabricSelectListFabric(data: ListFabricSelectRequest): Promise<PaginationResult_FabricSelect> {
  const url = baseUrl + `/fabric/select/list-fabric`
  return await request.post<ApiResult_PaginationResult_FabricSelect>(url, data, {})
}

/**
 * 查询精选商家列表
 * @param {ListSellerSelectRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricSelectSeller>} OK
 * @api {post} /fabric/select/list-seller
 * @apiGroup 精选面料
 */
export async function postFabricSelectListSeller(data: ListSellerSelectRequest): Promise<PaginationResult_FabricSelectSeller> {
  const url = baseUrl + `/fabric/select/list-seller`
  return await request.post<ApiResult_PaginationResult_FabricSelectSeller>(url, data, {})
}

/**
 * 查询小红书面料列表
 * @param {ListXhsFabricSelectRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricSelectXhs>} OK
 * @api {post} /fabric/select/list-xhs-fabric
 * @apiGroup 精选面料
 */
export async function postFabricSelectListXhsFabric(data: ListXhsFabricSelectRequest): Promise<PaginationResult_FabricSelectXhs> {
  const url = baseUrl + `/fabric/select/list-xhs-fabric`
  return await request.post<ApiResult_PaginationResult_FabricSelectXhs>(url, data, {})
}

/**
 * 查询面料精准推广跨境商品
 * @param {FabricPromotionAbroadItemRequest} [data] 请求数据
 * @returns {Promise<ApiResultPaginationResultFabricPromotionAbroadItem>} 响应数据
 * @api {get} /fabric/select/precise-promotion-abroad-products
 */
export async function getFabricSelectPrecisePromotionAbroadProducts(): Promise<ApiResultPaginationResultFabricPromotionAbroadItem> {
  const url = baseUrl + `/fabric/select/precise-promotion-abroad-products`
  return await request.get<ApiResultPaginationResultFabricPromotionAbroadItem>(url)
}

/**
 * 查询面料精准推广跨境商品
 * @param {FabricPromotionAbroadItemRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricPromotionAbroadItem>} OK
 * @api {post} /fabric/select/precise-promotion-abroad-products
 * @apiGroup 精选面料
 */
export async function postFabricSelectPrecisePromotionAbroadProducts(data: FabricPromotionAbroadItemRequest): Promise<PaginationResult_FabricPromotionAbroadItem> {
  const url = baseUrl + `/fabric/select/precise-promotion-abroad-products`
  return await request.post<ApiResult_PaginationResult_FabricPromotionAbroadItem>(url, data, {})
}

/**
 * 查询面料精准推广知衣商品
 * @param {FabricPromotionTbItemRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricPromotionTbItem>} OK
 * @api {post} /fabric/select/precise-promotion-tb-products
 * @apiGroup 精选面料
 */
export async function postFabricSelectPrecisePromotionTbProducts(data: FabricPromotionTbItemRequest): Promise<PaginationResult_FabricPromotionTbItem> {
  const url = baseUrl + `/fabric/select/precise-promotion-tb-products`
  return await request.post<ApiResult_PaginationResult_FabricPromotionTbItem>(url, data, {})
}

/**
 * 查询面料精准+智能推广知衣商品
 * @param {FabricPromotionTbItemRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricPromotionTbItem>} OK
 * @api {post} /fabric/select/promotion-tb-products
 * @apiGroup 精选面料
 */
export async function postFabricSelectPromotionTbProducts(data: FabricPromotionTbItemRequest): Promise<PaginationResult_FabricPromotionTbItem> {
  const url = baseUrl + `/fabric/select/promotion-tb-products`
  return await request.post<ApiResult_PaginationResult_FabricPromotionTbItem>(url, data, {})
}

/**
 * 获取商家企业档案
 * 根据商家ID查询商家记录
 * @param {object} [params] 查询参数
 * @param {number} [params.sellerId] sellerId
 * @returns {Promise<FabricSeller>} OK
 * @api {get} /fabric/select/seller-info
 * @apiGroup 精选面料
 */
export async function getFabricSelectSellerInfo(params?: { sellerId: number }): Promise<FabricSeller> {
  const url = baseUrl + `/fabric/select/seller-info`
  return await request.get<ApiResult_FabricSeller>(url, { params })
}

/**
 * 面料推荐案例列表
 * @param {object} [params] 查询参数
 * @param {array} [params.rootCategoryIdList] 行业id
 * @param {array} [params.categoryIdList] 品类id
 * @param {array} [params.fabricCategoryList] 面料品类名称
 * @param {number} [params.sourceChannel] 面料来源渠道
 * @param {string} [params.fabricId] 面料id
 * @param {number} [params.recommendSourceChannel] 推荐类型
 * @param {string} [params.style] 风格
 * @param {string} [params.keywordList] 关键词
 * @param {number} [params.minPrice] 最低售价
 * @param {number} [params.maxPrice] 最高售价
 * @returns {Promise<RecommendCaseInfo[]>} OK
 * @api {get} /recommend/case-list
 * @apiGroup 推荐面料案例
 */
export async function getRecommendCaseList(params?: { rootCategoryIdList?: number[]; categoryIdList?: number[]; fabricCategoryList?: string[]; sourceChannel?: number; fabricId?: string; recommendSourceChannel?: number; style?: string; keywordList?: string; minPrice?: number; maxPrice?: number }): Promise<RecommendCaseInfo[]> {
  const url = baseUrl + `/recommend/case-list`
  return await request.get<ApiResult_List_RecommendCaseInfo>(url, { params })
}

/**
 * 面料详情页推荐商品
 * @param {FabricRecommendRequest} data 请求数据
 * @returns {Promise<RecommendCaseInfo[]>} OK
 * @api {post} /recommend/case-list-detail-page
 * @apiGroup 推荐面料案例
 */
export async function postRecommendCaseListDetailPage(data: FabricRecommendRequest): Promise<RecommendCaseInfo[]> {
  const url = baseUrl + `/recommend/case-list-detail-page`
  return await request.post<ApiResult_List_RecommendCaseInfo>(url, data, {})
}

/**
 * 面料推荐商品测试
 * @param {FabricRecommendRequest} data 请求数据
 * @returns {Promise<RecommendCaseInfo[]>} OK
 * @api {post} /recommend/case-list-v1
 * @apiGroup 推荐面料案例
 */
export async function postRecommendCaseListV1(data: FabricRecommendRequest): Promise<RecommendCaseInfo[]> {
  const url = baseUrl + `/recommend/case-list-v1`
  return await request.post<ApiResult_List_RecommendCaseInfo>(url, data, {})
}

/**
 * 面料案例-淘宝商品
 * @param {SellerRecommendCaseRequest} data 请求数据
 * @returns {Promise<PaginationResult_RecommendCaseInfo>} OK
 * @api {post} /recommend/case/tb-item-list
 * @apiGroup 推荐面料案例
 */
export async function postRecommendCaseTbItemList(data: SellerRecommendCaseRequest): Promise<PaginationResult_RecommendCaseInfo> {
  const url = baseUrl + `/recommend/case/tb-item-list`
  return await request.post<ApiResult_PaginationResult_RecommendCaseInfo>(url, data, {})
}

/**
 * 获取面料关联商品图源列表
 * @param {FabricSourceChannelRequest} data 请求数据
 * @returns {Promise<FabricSourceChannelResponse>} OK
 * @api {post} /recommend/fabric-source-channels
 * @apiGroup 推荐面料案例
 */
export async function postRecommendFabricSourceChannels(data: FabricSourceChannelRequest): Promise<FabricSourceChannelResponse> {
  const url = baseUrl + `/recommend/fabric-source-channels`
  return await request.post<ApiResult_FabricSourceChannelResponse>(url, data, {})
}

/**
 * 根据面料来源获取适合推荐的行业id列表
 * @param {FabricRecommendRequest} data 请求数据
 * @returns {Promise<IndustryIdListResponse>} OK
 * @api {post} /recommend/industry-id-list
 * @apiGroup 推荐面料案例
 */
export async function postRecommendIndustryIdList(data: FabricRecommendRequest): Promise<IndustryIdListResponse> {
  const url = baseUrl + `/recommend/industry-id-list`
  return await request.post<ApiResult_IndustryIdListResponse>(url, data, {})
}

/**
 * 咨询面料
 * @param {FabricInquiryRequest} data 请求数据
 * @returns {Promise<FabricInquiryResponse>} OK
 * @api {post} /fabric/inquiry/fabric
 * @apiGroup 面料推广-咨询
 */
export async function postFabricInquiryFabric(data: FabricInquiryRequest): Promise<FabricInquiryResponse> {
  const url = baseUrl + `/fabric/inquiry/fabric`
  return await request.post<ApiResult_FabricInquiryResponse>(url, data, {})
}

/**
 * 咨询商家
 * @param {FabricSellerInquiryRequest} data 请求数据
 * @returns {Promise<FabricInquiryResponse>} OK
 * @api {post} /fabric/inquiry/seller
 * @apiGroup 面料推广-咨询
 */
export async function postFabricInquirySeller(data: FabricSellerInquiryRequest): Promise<FabricInquiryResponse> {
  const url = baseUrl + `/fabric/inquiry/seller`
  return await request.post<ApiResult_FabricInquiryResponse>(url, data, {})
}

/**
 * 用户查看/咨询商家历史记录
 * @param {ListSellerSelectRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricSelectSeller>} OK
 * @api {post} /fabric/inquiry/seller/list-seller
 * @apiGroup 面料推广-咨询
 */
export async function postFabricInquirySellerListSeller(data: ListSellerSelectRequest): Promise<PaginationResult_FabricSelectSeller> {
  const url = baseUrl + `/fabric/inquiry/seller/list-seller`
  return await request.post<ApiResult_PaginationResult_FabricSelectSeller>(url, data, {})
}

/**
 * 查询亚马逊商品
 * @param {AmazonGoodsListSelectRequest} data 请求数据
 * @returns {Promise<PaginationResult_亚马逊商品列表通用VO>} OK
 * @api {post} /style/aborad/amazon
 * @apiGroup 款式中心-跨境
 */
export async function postStyleAboradAmazon(data: AmazonGoodsListSelectRequest): Promise<PaginationResult_亚马逊商品列表通用VO> {
  const url = baseUrl + `/style/aborad/amazon`
  return await request.post<ApiResult_PaginationResult_亚马逊商品列表通用VO>(url, data, {})
}

/**
 * 查询shein商品
 * @param {GoodsZoneListRequest} data 请求数据
 * @returns {Promise<PaginationResult_CommonGoodsListVO>} OK
 * @api {post} /style/aborad/shein
 * @apiGroup 款式中心-跨境
 */
export async function postStyleAboradShein(data: GoodsZoneListRequest): Promise<PaginationResult_CommonGoodsListVO> {
  const url = baseUrl + `/style/aborad/shein`
  return await request.post<ApiResult_PaginationResult_CommonGoodsListVO>(url, data, {})
}

/**
 * 查询temu商品
 * @param {TemuGoodsListRequest} data 请求数据
 * @returns {Promise<PaginationResult_TemuGoodsListVO>} OK
 * @api {post} /style/aborad/temu
 * @apiGroup 款式中心-跨境
 */
export async function postStyleAboradTemu(data: TemuGoodsListRequest): Promise<PaginationResult_TemuGoodsListVO> {
  const url = baseUrl + `/style/aborad/temu`
  return await request.post<ApiResult_PaginationResult_TemuGoodsListVO>(url, data, {})
}

/**
 * 生成演示账号面料浏览数据
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/syn/create/promotion/record
 * @apiGroup 面料管理-数据同步
 */
export async function getFabricSynCreatePromotionRecord(): Promise<boolean> {
  const url = baseUrl + `/fabric/syn/create/promotion/record`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 刷找布需求数据
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/syn/customer/requirement
 * @apiGroup 面料管理-数据同步
 */
export async function getFabricSynCustomerRequirement(): Promise<boolean> {
  const url = baseUrl + `/fabric/syn/customer/requirement`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 刷面料价格
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/syn/price/surfing
 * @apiGroup 面料管理-数据同步
 */
export async function getFabricSynPriceSurfing(): Promise<boolean> {
  const url = baseUrl + `/fabric/syn/price/surfing`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 刷推广中面料的商品推广状态
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/syn/promotion/product
 * @apiGroup 面料管理-数据同步
 */
export async function getFabricSynPromotionProduct(): Promise<boolean> {
  const url = baseUrl + `/fabric/syn/promotion/product`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 刷咨询面料用户信息
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/syn/promotion/user
 * @apiGroup 面料管理-数据同步
 */
export async function getFabricSynPromotionUser(): Promise<boolean> {
  const url = baseUrl + `/fabric/syn/promotion/user`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 刷咨询商家用户信息
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/syn/seller/record
 * @apiGroup 面料管理-数据同步
 */
export async function getFabricSynSellerRecord(): Promise<boolean> {
  const url = baseUrl + `/fabric/syn/seller/record`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 刷上架信息
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/syn/shelf
 * @apiGroup 面料管理-数据同步
 */
export async function getFabricSynShelf(): Promise<boolean> {
  const url = baseUrl + `/fabric/syn/shelf`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 刷用户授权信息
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/syn/user/auth
 * @apiGroup 面料管理-数据同步
 */
export async function getFabricSynUserAuth(): Promise<boolean> {
  const url = baseUrl + `/fabric/syn/user/auth`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 新建推广项目
 * @param {FabricPromotionEditRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /fabric/promotion/project/add
 * @apiGroup 面料管理-面料项目推广
 */
export async function postFabricPromotionProjectAdd(data: FabricPromotionEditRequest): Promise<string> {
  const url = baseUrl + `/fabric/promotion/project/add`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 删除推广项目
 * @param {FabricPromotionEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/promotion/project/delete
 * @apiGroup 面料管理-面料项目推广
 */
export async function postFabricPromotionProjectDelete(data: FabricPromotionEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/promotion/project/delete`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询推广项目列表
 * @param {FabricProjectQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricPromotionProjectResponse>} OK
 * @api {post} /fabric/promotion/project/page/list
 * @apiGroup 面料管理-面料项目推广
 */
export async function postFabricPromotionProjectPageList(data: FabricProjectQueryRequest): Promise<PaginationResult_FabricPromotionProjectResponse> {
  const url = baseUrl + `/fabric/promotion/project/page/list`
  return await request.post<ApiResult_PaginationResult_FabricPromotionProjectResponse>(url, data, {})
}

/**
 * 查询推广项目信息
 * @param {object} [params] 查询参数
 * @param {string} [params.projectId] 推广项目id
 * @returns {Promise<FabricPromotionProjectResponse>} OK
 * @api {get} /fabric/promotion/project/query/info
 * @apiGroup 面料管理-面料项目推广
 */
export async function getFabricPromotionProjectQueryInfo(params?: { projectId: string }): Promise<FabricPromotionProjectResponse> {
  const url = baseUrl + `/fabric/promotion/project/query/info`
  return await request.get<ApiResult_FabricPromotionProjectResponse>(url, { params })
}

/**
 * 编辑推广项目
 * @param {FabricPromotionEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/promotion/project/update
 * @apiGroup 面料管理-面料项目推广
 */
export async function postFabricPromotionProjectUpdate(data: FabricPromotionEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/promotion/project/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 修改推广项目状态
 * @param {FabricPromotionEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/promotion/project/update/status
 * @apiGroup 面料管理-面料项目推广
 */
export async function postFabricPromotionProjectUpdateStatus(data: FabricPromotionEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/promotion/project/update/status`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询关联面料供应商
 * @param {QueryPromotionCompanyRequest} data 请求数据
 * @returns {Promise<PaginationResult_QueryPromotionCompanyResponse>} OK
 * @api {post} /fabric/promotion/provide/companies
 * @apiGroup 面料推广提供-大知衣端
 */
export async function postFabricPromotionProvideCompanies(data: QueryPromotionCompanyRequest): Promise<PaginationResult_QueryPromotionCompanyResponse> {
  const url = baseUrl + `/fabric/promotion/provide/companies`
  return await request.post<ApiResult_PaginationResult_QueryPromotionCompanyResponse>(url, data, {})
}

/**
 * 查询面料详情
 * @param {FabricInfoDetailRequest} data 请求数据
 * @returns {Promise<FabricInfoDetailResponse>} OK
 * @api {post} /fabric/promotion/provide/fabric-detail
 * @apiGroup 面料推广提供-大知衣端
 */
export async function postFabricPromotionProvideFabricDetail(data: FabricInfoDetailRequest): Promise<FabricInfoDetailResponse> {
  const url = baseUrl + `/fabric/promotion/provide/fabric-detail`
  return await request.post<ApiResult_FabricInfoDetailResponse>(url, data, {})
}

/**
 * 查询关联推广面料
 * @param {object} [params] 查询参数
 * @param {array} [params.excludeFabricIdList] 排除的面料列表
 * @param {number} [params.sourceChannel] 来源渠道
 * @param {string} [params.entityId] 关联实体id
 * @returns {Promise<QueryPromotionFabricResponse>} OK
 * @api {get} /fabric/promotion/provide/fabrics
 * @apiGroup 面料推广提供-大知衣端
 */
export async function getFabricPromotionProvideFabrics(params?: { excludeFabricIdList?: string[]; sourceChannel?: number; entityId?: string }): Promise<QueryPromotionFabricResponse> {
  const url = baseUrl + `/fabric/promotion/provide/fabrics`
  return await request.get<ApiResult_QueryPromotionFabricResponse>(url, { params })
}

/**
 * 根据跨境platformType获取知款platformId
 * @param {object} [params] 查询参数
 * @param {number} [params.abroadPlatformId] abroadPlatformId
 * @returns {Promise<int>} OK
 * @api {get} /fabric/promotion/provide/get-website-platform-id
 * @apiGroup 面料推广提供-大知衣端
 */
export async function getFabricPromotionProvideGetWebsitePlatformId(params?: { abroadPlatformId: number }): Promise<number> {
  const url = baseUrl + `/fabric/promotion/provide/get-website-platform-id`
  return await request.get<ApiResult_int>(url, { params })
}

/**
 * 咨询
 * @param {FabricInquiryRequest} data 请求数据
 * @returns {Promise<FabricInquiryResponse>} OK
 * @api {post} /fabric/promotion/provide/inquiry
 * @apiGroup 面料推广提供-大知衣端
 */
export async function postFabricPromotionProvideInquiry(data: FabricInquiryRequest): Promise<FabricInquiryResponse> {
  const url = baseUrl + `/fabric/promotion/provide/inquiry`
  return await request.post<ApiResult_FabricInquiryResponse>(url, data, {})
}

/**
 * 查询咨询二维码
 * @returns {Promise<string>} OK
 * @api {get} /fabric/promotion/provide/inquiry-qr-code
 * @apiGroup 面料推广提供-大知衣端
 */
export async function getFabricPromotionProvideInquiryQrCode(): Promise<string> {
  const url = baseUrl + `/fabric/promotion/provide/inquiry-qr-code`
  return await request.get<ApiResult_string>(url)
}

/**
 * 查询咨询记录
 * @param {PromotionRecordQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_PromotionRecordListResponse>} OK
 * @api {post} /fabric/promotion/provide/query-consultation-record
 * @apiGroup 面料推广提供-大知衣端
 */
export async function postFabricPromotionProvideQueryConsultationRecord(data: PromotionRecordQueryRequest): Promise<PaginationResult_PromotionRecordListResponse> {
  const url = baseUrl + `/fabric/promotion/provide/query-consultation-record`
  return await request.post<ApiResult_PaginationResult_PromotionRecordListResponse>(url, data, {})
}

/**
 * 查询面料供应商信息
 * @param {object} [params] 查询参数
 * @param {string} [params.fabricId] fabricId
 * @returns {Promise<QueryPromotionCompanyResponse>} OK
 * @api {get} /fabric/promotion/provide/query-promotion-company
 * @apiGroup 面料推广提供-大知衣端
 */
export async function getFabricPromotionProvideQueryPromotionCompany(params?: { fabricId: string }): Promise<QueryPromotionCompanyResponse> {
  const url = baseUrl + `/fabric/promotion/provide/query-promotion-company`
  return await request.get<ApiResult_QueryPromotionCompanyResponse>(url, { params })
}

/**
 * 查询面料供应商信息
 * @param {object} [params] 查询参数
 * @param {number} [params.sellerId] sellerId
 * @returns {Promise<QueryPromotionCompanyResponse>} OK
 * @api {get} /fabric/promotion/provide/query-promotion-company-by-seller-id
 * @apiGroup 面料推广提供-大知衣端
 */
export async function getFabricPromotionProvideQueryPromotionCompanyBySellerId(params?: { sellerId: number }): Promise<QueryPromotionCompanyResponse> {
  const url = baseUrl + `/fabric/promotion/provide/query-promotion-company-by-seller-id`
  return await request.get<ApiResult_QueryPromotionCompanyResponse>(url, { params })
}

/**
 * 面料查看记录
 * @param {PromotionRecordQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_PromotionRecordListResponse>} OK
 * @api {post} /fabric/promotion/provide/query-view-record
 * @apiGroup 面料推广提供-大知衣端
 */
export async function postFabricPromotionProvideQueryViewRecord(data: PromotionRecordQueryRequest): Promise<PaginationResult_PromotionRecordListResponse> {
  const url = baseUrl + `/fabric/promotion/provide/query-view-record`
  return await request.post<ApiResult_PaginationResult_PromotionRecordListResponse>(url, data, {})
}

/**
 * 取消推广
 * @param {ReviewFabricProjectRequest} data 请求数据
 * @returns {Promise<FabricProjectReviewResponse>} OK
 * @api {post} /fabric/project/admin/cancel
 * @apiGroup 面料管理-推广项目审核-后台管理
 */
export async function postFabricProjectAdminCancel(data: ReviewFabricProjectRequest): Promise<FabricProjectReviewResponse> {
  const url = baseUrl + `/fabric/project/admin/cancel`
  return await request.post<ApiResult_FabricProjectReviewResponse>(url, data, {})
}

/**
 * 查询审核列表
 * @param {object} [params] 查询参数
 * @param {array} [params.projectStatusList] 项目状态
 * @param {number} [params.pageSize] 分页参数 - 页大小
 * @param {number} [params.pageNo] 分页参数 - 跳转页
 * @param {number} [params.start] 分页参数 - 开始记录
 * @param {number} [params.limit] 分页参数 - 查询上限
 * @param {string} [params.applyDateStart] 申请时间-开始
 * @param {string} [params.applyDateEnd] 申请时间-结束
 * @param {string} [params.reviewDateStart] 审核时间-开始
 * @param {string} [params.reviewDateEnd] 审核时间-结束
 * @param {number} [params.reviewStatus] 布匹推广审核状态 0-待审核 1-通过 2-拒绝 3-取消
 * @param {string} [params.fabricId] 布匹id
 * @param {string} [params.fuzzyFabricName] 布匹名称
 * @param {string} [params.fuzzyCompanyName] 公司名称
 * @param {string} [params.fuzzyApplyUserName] 申请人姓名
 * @param {string} [params.fuzzyApplyUserPhone] 申请人手机号
 * @param {string} [params.projectId] 项目id
 * @param {string} [params.fuzzyProjectName] 项目名称
 * @returns {Promise<PaginationResult_FabricProjectReviewInfo>} OK
 * @api {get} /fabric/project/admin/list
 * @apiGroup 面料管理-推广项目审核-后台管理
 */
export async function getFabricProjectAdminList(params?: { projectStatusList?: number[]; pageSize?: number; pageNo?: number; start?: number; limit?: number; applyDateStart?: string; applyDateEnd?: string; reviewDateStart?: string; reviewDateEnd?: string; reviewStatus?: number; fabricId?: string; fuzzyFabricName?: string; fuzzyCompanyName?: string; fuzzyApplyUserName?: string; fuzzyApplyUserPhone?: string; projectId?: string; fuzzyProjectName?: string }): Promise<PaginationResult_FabricProjectReviewInfo> {
  const url = baseUrl + `/fabric/project/admin/list`
  return await request.get<ApiResult_PaginationResult_FabricProjectReviewInfo>(url, { params })
}

/**
 * 审核
 * @param {ReviewFabricProjectRequest} data 请求数据
 * @returns {Promise<FabricProjectReviewResponse>} OK
 * @api {post} /fabric/project/admin/review
 * @apiGroup 面料管理-推广项目审核-后台管理
 */
export async function postFabricProjectAdminReview(data: ReviewFabricProjectRequest): Promise<FabricProjectReviewResponse> {
  const url = baseUrl + `/fabric/project/admin/review`
  return await request.post<ApiResult_FabricProjectReviewResponse>(url, data, {})
}

/**
 * 后台面料管理列表查询
 * @param {FabricAdminQueryRequest} [data] 请求数据
 * @returns {Promise<ApiResultPaginationResultFabricAdminListResponse>} 响应数据
 * @api {post} /fabric/admin/list
 */
export async function postFabricAdminList(data?: FabricAdminQueryRequest): Promise<ApiResultPaginationResultFabricAdminListResponse> {
  const url = baseUrl + `/fabric/admin/list`
  return await request.post<ApiResultPaginationResultFabricAdminListResponse>(url, data, {})
}

/**
 * 编辑面料标签信息
 * @param {EditFabricLabelRequest} [data] 请求数据
 * @returns {Promise<ApiResultEditFabricLabelResponse>} 响应数据
 * @api {post} /fabric/admin/edit
 */
export async function postFabricAdminEdit(data?: EditFabricLabelRequest): Promise<ApiResultEditFabricLabelResponse> {
  const url = baseUrl + `/fabric/admin/edit`
  return await request.post<ApiResultEditFabricLabelResponse>(url, data, {})
}

/**
 * 查询全部商家面料
 * @param {SellerFabricQueryRequest} [data] 请求数据
 * @returns {Promise<ApiResultPaginationResultSellerFabricResponse>} 响应数据
 * @api {post} /fabric/admin/seller-fabric/list
 */
export async function postFabricAdminSellerFabricList(data?: SellerFabricQueryRequest): Promise<ApiResultPaginationResultSellerFabricResponse> {
  const url = baseUrl + `/fabric/admin/seller-fabric/list`
  return await request.post<ApiResultPaginationResultSellerFabricResponse>(url, data, {})
}

/**
 * 新增面料草稿箱
 * @param {FabricInfoEditRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /fabric/info/draft/add
 * @apiGroup 面料管理-面料草稿箱
 */
export async function postFabricInfoDraftAdd(data: FabricInfoEditRequest): Promise<string> {
  const url = baseUrl + `/fabric/info/draft/add`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 删除面料草稿箱
 * @param {FabricInfoEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/info/draft/delete
 * @apiGroup 面料管理-面料草稿箱
 */
export async function postFabricInfoDraftDelete(data: FabricInfoEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/info/draft/delete`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询面料草稿箱列表
 * @param {FabricInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricInfoListResponse>} OK
 * @api {post} /fabric/info/draft/page/list
 * @apiGroup 面料管理-面料草稿箱
 */
export async function postFabricInfoDraftPageList(data: FabricInfoQueryRequest): Promise<PaginationResult_FabricInfoListResponse> {
  const url = baseUrl + `/fabric/info/draft/page/list`
  return await request.post<ApiResult_PaginationResult_FabricInfoListResponse>(url, data, {})
}

/**
 * 查询面料草稿箱信息
 * @param {object} [params] 查询参数
 * @param {string} [params.fabricId] 面料id
 * @returns {Promise<FabricInfoListResponse>} OK
 * @api {get} /fabric/info/draft/query/info
 * @apiGroup 面料管理-面料草稿箱
 */
export async function getFabricInfoDraftQueryInfo(params?: { fabricId: string }): Promise<FabricInfoListResponse> {
  const url = baseUrl + `/fabric/info/draft/query/info`
  return await request.get<ApiResult_FabricInfoListResponse>(url, { params })
}

/**
 * 查询是否有新的草稿
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/info/draft/unread
 * @apiGroup 面料管理-面料草稿箱
 */
export async function getFabricInfoDraftUnread(): Promise<boolean> {
  const url = baseUrl + `/fabric/info/draft/unread`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 编辑面料草稿箱
 * @param {FabricInfoEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/info/draft/update
 * @apiGroup 面料管理-面料草稿箱
 */
export async function postFabricInfoDraftUpdate(data: FabricInfoEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/info/draft/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询推广面料详情
 * @param {FabricInfoDetailRequest} data 请求数据
 * @returns {Promise<FabricInfoDetailResponse>} OK
 * @api {post} /mobile/fabric/promotion/provide/fabric-detail
 * @apiGroup [移动端]面料推广提供-大知衣端
 */
export async function postMobileFabricPromotionProvideFabricDetail(data: FabricInfoDetailRequest): Promise<FabricInfoDetailResponse> {
  const url = baseUrl + `/mobile/fabric/promotion/provide/fabric-detail`
  return await request.post<ApiResult_FabricInfoDetailResponse>(url, data, {})
}

/**
 * 查询关联推广面料
 * @param {object} [params] 查询参数
 * @param {array} [params.excludeFabricIdList] 排除的面料列表
 * @param {number} [params.sourceChannel] 来源渠道
 * @param {string} [params.entityId] 关联实体id
 * @returns {Promise<QueryPromotionFabricResponse>} OK
 * @api {get} /mobile/fabric/promotion/provide/fabrics
 * @apiGroup [移动端]面料推广提供-大知衣端
 */
export async function getMobileFabricPromotionProvideFabrics(params?: { excludeFabricIdList?: string[]; sourceChannel?: number; entityId?: string }): Promise<QueryPromotionFabricResponse> {
  const url = baseUrl + `/mobile/fabric/promotion/provide/fabrics`
  return await request.get<ApiResult_QueryPromotionFabricResponse>(url, { params })
}

/**
 * 记录推广面料曝光
 * @param {QueryPromotionFabricRecordRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /mobile/fabric/promotion/provide/fabrics-record
 * @apiGroup [移动端]面料推广提供-大知衣端
 */
export async function postMobileFabricPromotionProvideFabricsRecord(data: QueryPromotionFabricRecordRequest): Promise<boolean> {
  const url = baseUrl + `/mobile/fabric/promotion/provide/fabrics-record`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 上报咨询面料
 * @param {FabricInquiryRequest} data 请求数据
 * @returns {Promise<FabricInquiryResponse>} OK
 * @api {post} /mobile/fabric/promotion/provide/inquiry-fabric
 * @apiGroup [移动端]面料推广提供-大知衣端
 */
export async function postMobileFabricPromotionProvideInquiryFabric(data: FabricInquiryRequest): Promise<FabricInquiryResponse> {
  const url = baseUrl + `/mobile/fabric/promotion/provide/inquiry-fabric`
  return await request.post<ApiResult_FabricInquiryResponse>(url, data, {})
}

/**
 * 查询咨询商家二维码
 * @returns {Promise<string>} OK
 * @api {get} /mobile/fabric/promotion/provide/inquiry-qr-code
 * @apiGroup [移动端]面料推广提供-大知衣端
 */
export async function getMobileFabricPromotionProvideInquiryQrCode(): Promise<string> {
  const url = baseUrl + `/mobile/fabric/promotion/provide/inquiry-qr-code`
  return await request.get<ApiResult_string>(url)
}

/**
 * 上报咨询商家
 * @param {FabricSellerInquiryRequest} data 请求数据
 * @returns {Promise<FabricInquiryResponse>} OK
 * @api {post} /mobile/fabric/promotion/provide/inquiry-seller
 * @apiGroup [移动端]面料推广提供-大知衣端
 */
export async function postMobileFabricPromotionProvideInquirySeller(data: FabricSellerInquiryRequest): Promise<FabricInquiryResponse> {
  const url = baseUrl + `/mobile/fabric/promotion/provide/inquiry-seller`
  return await request.post<ApiResult_FabricInquiryResponse>(url, data, {})
}

/**
 * 查询推广面料供应商信息
 * @param {object} [params] 查询参数
 * @param {string} [params.fabricId] fabricId
 * @returns {Promise<QueryPromotionCompanyResponse>} OK
 * @api {get} /mobile/fabric/promotion/provide/query-promotion-company
 * @apiGroup [移动端]面料推广提供-大知衣端
 */
export async function getMobileFabricPromotionProvideQueryPromotionCompany(params?: { fabricId: string }): Promise<QueryPromotionCompanyResponse> {
  const url = baseUrl + `/mobile/fabric/promotion/provide/query-promotion-company`
  return await request.get<ApiResult_QueryPromotionCompanyResponse>(url, { params })
}

/**
 * 新增用户授权
 * @param {FabricUserAuthRequest} [data] 请求数据
 * @returns {Promise<ApiResultString>} 响应数据
 * @api {post} /fabric/user/auth/add
 */
export async function postFabricUserAuthAdd(data?: FabricUserAuthRequest): Promise<ApiResultString> {
  const url = baseUrl + `/fabric/user/auth/add`
  return await request.post<ApiResultString>(url, data, {})
}

/**
 * 修改用户授权信息
 * @param {FabricUserAuthRequest} [data] 请求数据
 * @returns {Promise<ApiResultBoolean>} 响应数据
 * @api {post} /fabric/user/auth/update
 */
export async function postFabricUserAuthUpdate(data?: FabricUserAuthRequest): Promise<ApiResultBoolean> {
  const url = baseUrl + `/fabric/user/auth/update`
  return await request.post<ApiResultBoolean>(url, data, {})
}

/**
 * 获取用户授权信息和关注信息
 * @param {object} [params] 查询参数
 * @param {number} [params.authType] 授权类型
 * @returns {Promise<ApiResultFabricUserAuthResponse>} 响应数据
 * @api {get} /fabric/user/auth/get
 */
export async function getFabricUserAuthGet(params?: { authType: number }): Promise<ApiResultFabricUserAuthResponse> {
  const url = baseUrl + `/fabric/user/auth/get`
  return await request.get<ApiResultFabricUserAuthResponse>(url, { params })
}

/**
 * 取消用户授权
 * @param {FabricUserAuthRequest} [data] 请求数据
 * @returns {Promise<ApiResultBoolean>} 响应数据
 * @api {post} /fabric/user/auth/cancel
 */
export async function postFabricUserAuthCancel(data?: FabricUserAuthRequest): Promise<ApiResultBoolean> {
  const url = baseUrl + `/fabric/user/auth/cancel`
  return await request.post<ApiResultBoolean>(url, data, {})
}

/**
 * 新增授权用户关注信息
 * @param {FabricUserAuthExtensionRequest} [data] 请求数据
 * @returns {Promise<ApiResultString>} 响应数据
 * @api {post} /fabric/user/auth/add-extension
 */
export async function postFabricUserAuthAddExtension(data?: FabricUserAuthExtensionRequest): Promise<ApiResultString> {
  const url = baseUrl + `/fabric/user/auth/add-extension`
  return await request.post<ApiResultString>(url, data, {})
}

/**
 * 修改授权用户关注信息
 * @param {FabricUserAuthExtensionRequest} [data] 请求数据
 * @returns {Promise<ApiResultString>} 响应数据
 * @api {post} /fabric/user/auth/update-extension
 */
export async function postFabricUserAuthUpdateExtension(data?: FabricUserAuthExtensionRequest): Promise<ApiResultString> {
  const url = baseUrl + `/fabric/user/auth/update-extension`
  return await request.post<ApiResultString>(url, data, {})
}

/**
 * 删除授权用户关注信息
 * @param {FabricUserAuthExtensionRequest} [data] 请求数据
 * @returns {Promise<ApiResultString>} 响应数据
 * @api {post} /fabric/user/auth/delete-extension
 */
export async function postFabricUserAuthDeleteExtension(data?: FabricUserAuthExtensionRequest): Promise<ApiResultString> {
  const url = baseUrl + `/fabric/user/auth/delete-extension`
  return await request.post<ApiResultString>(url, data, {})
}

/**
 * 修改咨询记录-大知衣端
 * @param {FabricPromotionRecordRequest} [data] 请求数据
 * @returns {Promise<ApiResultInteger>} 响应数据
 * @api {post} /fabric/user/auth/update-record
 */
export async function postFabricUserAuthUpdateRecord(data?: FabricPromotionRecordRequest): Promise<ApiResultInteger> {
  const url = baseUrl + `/fabric/user/auth/update-record`
  return await request.post<ApiResultInteger>(url, data, {})
}

/**
 * 取消授权-大知衣端
 * @param {FabricPromotionRecordRequest} [data] 请求数据
 * @returns {Promise<ApiResultInteger>} 响应数据
 * @api {post} /fabric/user/auth/cancel-record
 */
export async function postFabricUserAuthCancelRecord(data?: FabricPromotionRecordRequest): Promise<ApiResultInteger> {
  const url = baseUrl + `/fabric/user/auth/cancel-record`
  return await request.post<ApiResultInteger>(url, data, {})
}

/**
 * 客户线索/咨询面料
 * @param {FabricUserAuthQueryRequest} [data] 请求数据
 * @returns {Promise<ApiResultPaginationResultFabricUserAuthResponse>} 响应数据
 * @api {post} /fabric/user/auth/customer/fabric
 */
export async function postFabricUserAuthCustomerFabric(data?: FabricUserAuthQueryRequest): Promise<ApiResultPaginationResultFabricUserAuthResponse> {
  const url = baseUrl + `/fabric/user/auth/customer/fabric`
  return await request.post<ApiResultPaginationResultFabricUserAuthResponse>(url, data, {})
}

/**
 * 客户线索/咨询商家
 * @param {FabricUserAuthQueryRequest} [data] 请求数据
 * @returns {Promise<ApiResultPaginationResultFabricUserAuthResponse>} 响应数据
 * @api {post} /fabric/user/auth/customer/seller
 */
export async function postFabricUserAuthCustomerSeller(data?: FabricUserAuthQueryRequest): Promise<ApiResultPaginationResultFabricUserAuthResponse> {
  const url = baseUrl + `/fabric/user/auth/customer/seller`
  return await request.post<ApiResultPaginationResultFabricUserAuthResponse>(url, data, {})
}

/**
 * 客户线索/智能推荐
 * @param {FabricUserAuthQueryRequest} [data] 请求数据
 * @returns {Promise<ApiResultPaginationResultFabricUserAuthResponse>} 响应数据
 * @api {post} /fabric/user/auth/customer/recommend
 */
export async function postFabricUserAuthCustomerRecommend(data?: FabricUserAuthQueryRequest): Promise<ApiResultPaginationResultFabricUserAuthResponse> {
  const url = baseUrl + `/fabric/user/auth/customer/recommend`
  return await request.post<ApiResultPaginationResultFabricUserAuthResponse>(url, data, {})
}

/**
 * 查询客户部门
 * @param {FabricUserAuthRequest} [data] 请求数据
 * @returns {Promise<ApiResultString>} 响应数据
 * @api {post} /fabric/user/auth/customer/department
 */
export async function postFabricUserAuthCustomerDepartment(data?: FabricUserAuthRequest): Promise<ApiResultString> {
  const url = baseUrl + `/fabric/user/auth/customer/department`
  return await request.post<ApiResultString>(url, data, {})
}

/**
 * 新增客户备注
 * @param {FabricUserAuthRequest} [data] 请求数据
 * @returns {Promise<ApiResultString>} 响应数据
 * @api {post} /fabric/user/auth/add/remark
 */
export async function postFabricUserAuthAddRemark(data?: FabricUserAuthRequest): Promise<ApiResultString> {
  const url = baseUrl + `/fabric/user/auth/add/remark`
  return await request.post<ApiResultString>(url, data, {})
}

/**
 * 打招呼次数
 * @returns {Promise<ApiResultFabricUserAuthGreetingCountResponse>} 响应数据
 * @api {post} /fabric/user/auth/greetingCount
 */
export async function postFabricUserAuthGreetingCount(): Promise<ApiResultFabricUserAuthGreetingCountResponse> {
  const url = baseUrl + `/fabric/user/auth/greetingCount`
  return await request.post<ApiResultFabricUserAuthGreetingCountResponse>(url, {})
}

/**
 * 客户线索/找布需求
 * @param {FabricRequirementQueryRequest} [data] 请求数据
 * @returns {Promise<ApiResultPaginationResultFabricCustomerRequirementResponse>} 响应数据
 * @api {post} /fabric/user/auth/customer/requirement
 */
export async function postFabricUserAuthCustomerRequirement(data?: FabricRequirementQueryRequest): Promise<ApiResultPaginationResultFabricCustomerRequirementResponse> {
  const url = baseUrl + `/fabric/user/auth/customer/requirement`
  return await request.post<ApiResultPaginationResultFabricCustomerRequirementResponse>(url, data, {})
}

/**
 * 获取未读线索条数
 * @returns {Promise<ApiResultInteger>} 响应数据
 * @api {get} /fabric/user/auth/customer/read
 */
export async function getFabricUserAuthCustomerRead(): Promise<ApiResultInteger> {
  const url = baseUrl + `/fabric/user/auth/customer/read`
  return await request.get<ApiResultInteger>(url)
}

/**
 * 查询用户偏好设置
 * @returns {Promise<ApiResultListFabricUserPreferenceResponse>} 响应数据
 * @api {get} /fabric/user/auth/preference
 */
export async function getFabricUserAuthPreference(): Promise<ApiResultListFabricUserPreferenceResponse> {
  const url = baseUrl + `/fabric/user/auth/preference`
  return await request.get<ApiResultListFabricUserPreferenceResponse>(url)
}

/**
 * 保存用户偏好设置
 * @param {FabricUserPreferenceRequest} [data] 请求数据
 * @returns {Promise<ApiResultFabricUserPreferenceResponse>} 响应数据
 * @api {post} /fabric/user/auth/save/preference
 */
export async function postFabricUserAuthSavePreference(data?: FabricUserPreferenceRequest): Promise<ApiResultFabricUserPreferenceResponse> {
  const url = baseUrl + `/fabric/user/auth/save/preference`
  return await request.post<ApiResultFabricUserPreferenceResponse>(url, data, {})
}

/**
 * 查询找布需求沟通记录列表
 * @param {object} [params] 查询参数
 * @param {string} [params.requirementId] 
 * @returns {Promise<ApiResultListFabricRequirementCommunicationResponse>} 响应数据
 * @api {get} /fabric/user/auth/communication/list
 */
export async function getFabricUserAuthCommunicationList(params?: { requirementId: string }): Promise<ApiResultListFabricRequirementCommunicationResponse> {
  const url = baseUrl + `/fabric/user/auth/communication/list`
  return await request.get<ApiResultListFabricRequirementCommunicationResponse>(url, { params })
}

/**
 * 新增面料案例
 * @param {FabricCaseInfoAddListRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /fabric/case/add
 * @apiGroup 面料案例
 */
export async function postFabricCaseAdd(data: FabricCaseInfoAddListRequest): Promise<string> {
  const url = baseUrl + `/fabric/case/add`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 删除面料案例
 * @param {FabricCaseInfoRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/case/delete
 * @apiGroup 面料案例
 */
export async function postFabricCaseDelete(data: FabricCaseInfoRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/case/delete`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 案例合集详情
 * @param {FabricCaseInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricCaseInfoQueryDetailResponse>} OK
 * @api {post} /fabric/case/query-by-fabric
 * @apiGroup 面料案例
 */
export async function postFabricCaseQueryByFabric(data: FabricCaseInfoQueryRequest): Promise<PaginationResult_FabricCaseInfoQueryDetailResponse> {
  const url = baseUrl + `/fabric/case/query-by-fabric`
  return await request.post<ApiResult_PaginationResult_FabricCaseInfoQueryDetailResponse>(url, data, {})
}

/**
 * 面料案例
 * @param {FabricCaseInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricCaseInfoQueryResponse>} OK
 * @api {post} /fabric/case/query-page
 * @apiGroup 面料案例
 */
export async function postFabricCaseQueryPage(data: FabricCaseInfoQueryRequest): Promise<PaginationResult_FabricCaseInfoQueryResponse> {
  const url = baseUrl + `/fabric/case/query-page`
  return await request.post<ApiResult_PaginationResult_FabricCaseInfoQueryResponse>(url, data, {})
}

/**
 * 案例合集
 * @param {FabricCaseInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricCaseInfoListResponse>} OK
 * @api {post} /fabric/case/query-page-list
 * @apiGroup 面料案例
 */
export async function postFabricCaseQueryPageList(data: FabricCaseInfoQueryRequest): Promise<PaginationResult_FabricCaseInfoListResponse> {
  const url = baseUrl + `/fabric/case/query-page-list`
  return await request.post<ApiResult_PaginationResult_FabricCaseInfoListResponse>(url, data, {})
}

/**
 * 修改面料案例
 * @param {FabricCaseInfoRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/case/update
 * @apiGroup 面料案例
 */
export async function postFabricCaseUpdate(data: FabricCaseInfoRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/case/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 新增客户授权
 * @param {FabricUserAuthRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /fabric/user/admin/add
 * @apiGroup 后台客户管理
 */
export async function postFabricUserAdminAdd(data: FabricUserAuthRequest): Promise<string> {
  const url = baseUrl + `/fabric/user/admin/add`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 删除客户授权
 * @param {FabricUserAuthRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/user/admin/del
 * @apiGroup 后台客户管理
 */
export async function postFabricUserAdminDel(data: FabricUserAuthRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/user/admin/del`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 后台客户管理列表查询
 * @param {FabricUserAuthQueryRequest} data 请求数据
 * @returns {Promise<ApiResultPaginationResultFabricUserAuthResponse>} OK
 * @api {post} /fabric/user/admin/list
 * @apiGroup 后台客户管理
 */
export async function postFabricUserAdminList(data: FabricUserAuthQueryRequest): Promise<ApiResultPaginationResultFabricUserAuthResponse> {
  const url = baseUrl + `/fabric/user/admin/list`
  return await request.post<ApiResultPaginationResultFabricUserAuthResponse>(url, data, {})
}

/**
 * 编辑客户授权
 * @param {FabricUserAuthRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/user/admin/update
 * @apiGroup 后台客户管理
 */
export async function postFabricUserAdminUpdate(data: FabricUserAuthRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/user/admin/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 删除标签
 * @param {FabricInspirationLabelEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/inspiration/label/admin/delete
 * @apiGroup 面料灵感-标签管理
 */
export async function postFabricInspirationLabelAdminDelete(data: FabricInspirationLabelEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/inspiration/label/admin/delete`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 新增标签
 * @param {FabricInspirationLabelEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/inspiration/label/admin/new
 * @apiGroup 面料灵感-标签管理
 */
export async function postFabricInspirationLabelAdminNew(data: FabricInspirationLabelEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/inspiration/label/admin/new`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 查询标签
 * @param {FabricInspirationLabelQryRequest} data 请求数据
 * @returns {Promise<FabricInspirationLabel[]>} OK
 * @api {post} /fabric/inspiration/label/admin/qry-list
 * @apiGroup 面料灵感-标签管理
 */
export async function postFabricInspirationLabelAdminQryList(data: FabricInspirationLabelQryRequest): Promise<FabricInspirationLabel[]> {
  const url = baseUrl + `/fabric/inspiration/label/admin/qry-list`
  return await request.post<ApiResult_List_FabricInspirationLabel>(url, data, {})
}

/**
 * 修改标签
 * @param {FabricInspirationLabelEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/inspiration/label/admin/save
 * @apiGroup 面料灵感-标签管理
 */
export async function postFabricInspirationLabelAdminSave(data: FabricInspirationLabelEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/inspiration/label/admin/save`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 删除灵感
 * @param {FabricInspirationEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/inspiration/admin/delete
 * @apiGroup 面料灵感管理
 */
export async function postFabricInspirationAdminDelete(data: FabricInspirationEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/inspiration/admin/delete`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 新增灵感
 * @param {FabricInspirationEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/inspiration/admin/new
 * @apiGroup 面料灵感管理
 */
export async function postFabricInspirationAdminNew(data: FabricInspirationEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/inspiration/admin/new`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 查询详情
 * @param {object} [params] 查询参数
 * @param {number} [params.inspirationId] inspirationId
 * @returns {Promise<FabricInspiration>} OK
 * @api {get} /fabric/inspiration/admin/qry-detail
 * @apiGroup 面料灵感管理
 */
export async function getFabricInspirationAdminQryDetail(params?: { inspirationId: number }): Promise<FabricInspiration> {
  const url = baseUrl + `/fabric/inspiration/admin/qry-detail`
  return await request.get<ApiResult_FabricInspiration>(url, { params })
}

/**
 * 分页查询
 * @param {FabricInspirationQryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricInspiration>} OK
 * @api {post} /fabric/inspiration/admin/qry-page
 * @apiGroup 面料灵感管理
 */
export async function postFabricInspirationAdminQryPage(data: FabricInspirationQryRequest): Promise<PaginationResult_FabricInspiration> {
  const url = baseUrl + `/fabric/inspiration/admin/qry-page`
  return await request.post<ApiResult_PaginationResult_FabricInspiration>(url, data, {})
}

/**
 * 查询灵感草稿
 * @returns {Promise<FabricInspiration>} OK
 * @api {get} /fabric/inspiration/admin/qry/draft/detail
 * @apiGroup 面料灵感管理
 */
export async function getFabricInspirationAdminQryDraftDetail(): Promise<FabricInspiration> {
  const url = baseUrl + `/fabric/inspiration/admin/qry/draft/detail`
  return await request.get<ApiResult_FabricInspiration>(url)
}

/**
 * 修改灵感
 * @param {FabricInspirationEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/inspiration/admin/save
 * @apiGroup 面料灵感管理
 */
export async function postFabricInspirationAdminSave(data: FabricInspirationEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/inspiration/admin/save`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 保存灵感草稿
 * @param {FabricInspirationEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/inspiration/admin/save/draft
 * @apiGroup 面料灵感管理
 */
export async function postFabricInspirationAdminSaveDraft(data: FabricInspirationEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/inspiration/admin/save/draft`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 修改灵感状态：启用/停用
 * @param {FabricInspirationEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/inspiration/admin/update-status
 * @apiGroup 面料灵感管理
 */
export async function postFabricInspirationAdminUpdateStatus(data: FabricInspirationEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/inspiration/admin/update-status`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 查询详情
 * @param {object} [params] 查询参数
 * @param {number} [params.inspirationId] inspirationId
 * @returns {Promise<FabricInspiration>} OK
 * @api {get} /fabric/inspiration/qry-detail
 * @apiGroup 面料灵感
 */
export async function getFabricInspirationQryDetail(params?: { inspirationId: number }): Promise<FabricInspiration> {
  const url = baseUrl + `/fabric/inspiration/qry-detail`
  return await request.get<ApiResult_FabricInspiration>(url, { params })
}

/**
 * 分页查询
 * @param {FabricInspirationQryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricInspiration>} OK
 * @api {post} /fabric/inspiration/qry-page
 * @apiGroup 面料灵感
 */
export async function postFabricInspirationQryPage(data: FabricInspirationQryRequest): Promise<PaginationResult_FabricInspiration> {
  const url = baseUrl + `/fabric/inspiration/qry-page`
  return await request.post<ApiResult_PaginationResult_FabricInspiration>(url, data, {})
}

/**
 * 提交找布需求
 * @param {FabricCustomerRequirementRequest} [data] 请求数据
 * @returns {Promise<ApiResultInteger>} 响应数据
 * @api {post} /fabric/customer/requirement/new
 */
export async function postFabricCustomerRequirementNew(data?: FabricCustomerRequirementRequest): Promise<ApiResultInteger> {
  const url = baseUrl + `/fabric/customer/requirement/new`
  return await request.post<ApiResultInteger>(url, data, {})
}

/**
 * 分页查询找布需求
 * @param {object} [params] 查询参数
 * @param {number} [params.sourceType] 提交来源：1-用户授权(pc端)，2-手动录入(官方提报)，3-用户授权(小程序)
 * @param {string} [params.fuzzySearch] 模糊搜索
 * @returns {Promise<ApiResultPaginationResultFabricCustomerRequirementResponse>} 响应数据
 * @api {get} /fabric/customer/requirement/qry-page-by-user
 */
export async function getFabricCustomerRequirementQryPageByUser(params?: { sourceType?: number; fuzzySearch?: string }): Promise<ApiResultPaginationResultFabricCustomerRequirementResponse> {
  const url = baseUrl + `/fabric/customer/requirement/qry-page-by-user`
  return await request.get<ApiResultPaginationResultFabricCustomerRequirementResponse>(url, { params })
}

/**
 * 对分配结果进行反馈（满意/不满意）
 * @param {FabricRequirementFeedbackRequest} [data] 请求数据
 * @returns {Promise<ApiResultBoolean>} 响应数据
 * @api {post} /fabric/customer/requirement/feedback
 */
export async function postFabricCustomerRequirementFeedback(data?: FabricRequirementFeedbackRequest): Promise<ApiResultBoolean> {
  const url = baseUrl + `/fabric/customer/requirement/feedback`
  return await request.post<ApiResultBoolean>(url, data, {})
}

/**
 * 找布需求-结束服务
 * @param {FabricRequirementFeedbackRequest} [data] 请求数据
 * @returns {Promise<ApiResultBoolean>} 响应数据
 * @api {post} /fabric/customer/requirement/finish
 */
export async function postFabricCustomerRequirementFinish(data?: FabricRequirementFeedbackRequest): Promise<ApiResultBoolean> {
  const url = baseUrl + `/fabric/customer/requirement/finish`
  return await request.post<ApiResultBoolean>(url, data, {})
}

/**
 * 查询找布需求历史分配记录
 * @param {object} [params] 查询参数
 * @param {string} [params.requirementId] 
 * @returns {Promise<ApiResultListFabricRequirementLogResponse>} 响应数据
 * @api {get} /fabric/customer/requirement/assign-logs
 */
export async function getFabricCustomerRequirementAssignLogs(params?: { requirementId: string }): Promise<ApiResultListFabricRequirementLogResponse> {
  const url = baseUrl + `/fabric/customer/requirement/assign-logs`
  return await request.get<ApiResultListFabricRequirementLogResponse>(url, { params })
}

/**
 * 新建咨询商家会话（用户端）
 * @param {FabricConversationEditRequest} data 请求数据
 * @returns {Promise<FabricConversationResponse>} OK
 * @api {post} /fabric/conversation/add
 * @apiGroup 用户在线咨询
 */
export async function postFabricConversationAdd(data: FabricConversationEditRequest): Promise<FabricConversationResponse> {
  const url = baseUrl + `/fabric/conversation/add`
  return await request.post<ApiResult_FabricConversationResponse>(url, data, {})
}

/**
 * 新建咨询官方客服会话（用户端）
 * @param {FabricConversationEditRequest} data 请求数据
 * @returns {Promise<FabricConversationResponse>} OK
 * @api {post} /fabric/conversation/add/customer
 * @apiGroup 用户在线咨询
 */
export async function postFabricConversationAddCustomer(data: FabricConversationEditRequest): Promise<FabricConversationResponse> {
  const url = baseUrl + `/fabric/conversation/add/customer`
  return await request.post<ApiResult_FabricConversationResponse>(url, data, {})
}

/**
 * 新建商家对用户会话（商家端）
 * @param {FabricConversationEditRequest} data 请求数据
 * @returns {Promise<FabricConversationResponse>} OK
 * @api {post} /fabric/conversation/add/seller
 * @apiGroup 用户在线咨询
 */
export async function postFabricConversationAddSeller(data: FabricConversationEditRequest): Promise<FabricConversationResponse> {
  const url = baseUrl + `/fabric/conversation/add/seller`
  return await request.post<ApiResult_FabricConversationResponse>(url, data, {})
}

/**
 * 关闭会话窗口
 * @param {FabricConversationEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/conversation/close
 * @apiGroup 用户在线咨询
 */
export async function postFabricConversationClose(data: FabricConversationEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/conversation/close`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询会话列表(商家端)
 * @returns {Promise<FabricConversationResponse[]>} OK
 * @api {get} /fabric/conversation/fabric/list
 * @apiGroup 用户在线咨询
 */
export async function getFabricConversationFabricList(): Promise<FabricConversationResponse[]> {
  const url = baseUrl + `/fabric/conversation/fabric/list`
  return await request.get<ApiResult_List_FabricConversationResponse>(url)
}

/**
 * 查询用户免打扰设置
 * @returns {Promise<FabricUserSettingResponse>} OK
 * @api {get} /fabric/conversation/query/dnd
 * @apiGroup 用户在线咨询
 */
export async function getFabricConversationQueryDnd(): Promise<FabricUserSettingResponse> {
  const url = baseUrl + `/fabric/conversation/query/dnd`
  return await request.get<ApiResult_FabricUserSettingResponse>(url)
}

/**
 * 查询会话框
 * @param {object} [params] 查询参数
 * @param {number} [params.id] id
 * @param {string} [params.conversationId] 会话ID
 * @param {number} [params.teamId] 团队id
 * @param {number} [params.userId] 用户id
 * @param {number} [params.fabricTeamId] 面料团队id
 * @param {number} [params.fabricUserId] 面料用户id
 * @param {number} [params.source] 来源 1、商品；2、面料；3、商家；4、智能推荐
 * @param {number} [params.sourceChannel] 商品渠道来源
 * @param {string} [params.entityId] 商品id
 * @param {number} [params.fabricSourceChannel] 面料渠道来源 0自主上传 6小红书
 * @param {string} [params.fabricId] 面料id
 * @param {number} [params.status] 用户状态 0、关闭；1、活跃
 * @param {number} [params.fabricStatus] 商家状态 0、关闭；1、活跃
 * @param {number} [params.type] 1、直接聊 2、打招呼
 * @param {string} [params.entitySubmitUrl] 商品详情页
 * @param {string} [params.fabricSubmitUrl] 面料详情页
 * @param {string} [params.teamSubmitUrl] 商家详情页
 * @param {string} [params.remark] 备注
 * @param {number} [params.isTop] 置顶 0、否；1、是
 * @param {number} [params.unreadOnly] 只看未读 0、否；1、是
 * @returns {Promise<FabricConversationResponse>} OK
 * @api {get} /fabric/conversation/query/info
 * @apiGroup 用户在线咨询
 */
export async function getFabricConversationQueryInfo(params?: { id?: number; conversationId?: string; teamId?: number; userId?: number; fabricTeamId?: number; fabricUserId?: number; source?: number; sourceChannel?: number; entityId?: string; fabricSourceChannel?: number; fabricId?: string; status?: number; fabricStatus?: number; type?: number; entitySubmitUrl?: string; fabricSubmitUrl?: string; teamSubmitUrl?: string; remark?: string; isTop?: number; unreadOnly?: number }): Promise<FabricConversationResponse> {
  const url = baseUrl + `/fabric/conversation/query/info`
  return await request.get<ApiResult_FabricConversationResponse>(url, { params })
}

/**
 * 用户设置是否置顶
 * @param {FabricConversationEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/conversation/save/top
 * @apiGroup 用户在线咨询
 */
export async function postFabricConversationSaveTop(data: FabricConversationEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/conversation/save/top`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 用户设置免打扰
 * @param {FabricUserMassagesSettingRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/conversation/set/dnd
 * @apiGroup 用户在线咨询
 */
export async function postFabricConversationSetDnd(data: FabricUserMassagesSettingRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/conversation/set/dnd`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 添加会话用户备注
 * @param {FabricConversationEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/conversation/set/remark
 * @apiGroup 用户在线咨询
 */
export async function postFabricConversationSetRemark(data: FabricConversationEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/conversation/set/remark`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询用户信息
 * @param {FabricConversationEditRequest} data 请求数据
 * @returns {Promise<FabricConversationResponse>} OK
 * @api {post} /fabric/conversation/user/info
 * @apiGroup 用户在线咨询
 */
export async function postFabricConversationUserInfo(data: FabricConversationEditRequest): Promise<FabricConversationResponse> {
  const url = baseUrl + `/fabric/conversation/user/info`
  return await request.post<ApiResult_FabricConversationResponse>(url, data, {})
}

/**
 * 查询会话列表(用户端)
 * @returns {Promise<FabricConversationResponse[]>} OK
 * @api {get} /fabric/conversation/user/list
 * @apiGroup 用户在线咨询
 */
export async function getFabricConversationUserList(): Promise<FabricConversationResponse[]> {
  const url = baseUrl + `/fabric/conversation/user/list`
  return await request.get<ApiResult_List_FabricConversationResponse>(url)
}

/**
 * 新增快捷回复
 * @param {FabricQuickReplyRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/message/add/reply
 * @apiGroup 用户在线聊天
 */
export async function postFabricMessageAddReply(data: FabricQuickReplyRequest): Promise<long> {
  const url = baseUrl + `/fabric/message/add/reply`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 删除快捷回复
 * @param {FabricQuickReplyRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/message/delete/reply
 * @apiGroup 用户在线聊天
 */
export async function postFabricMessageDeleteReply(data: FabricQuickReplyRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/message/delete/reply`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询消息未读数量（商家端）
 * @returns {Promise<FabricMessageLimitResponse>} OK
 * @api {get} /fabric/message/fabric/unread
 * @apiGroup 用户在线聊天
 */
export async function getFabricMessageFabricUnread(): Promise<FabricMessageLimitResponse> {
  const url = baseUrl + `/fabric/message/fabric/unread`
  return await request.get<ApiResult_FabricMessageLimitResponse>(url)
}

/**
 * 查询消息记录
 * @param {FabricMessageQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricMessageResponse>} OK
 * @api {post} /fabric/message/page/list
 * @apiGroup 用户在线聊天
 */
export async function postFabricMessagePageList(data: FabricMessageQueryRequest): Promise<PaginationResult_FabricMessageResponse> {
  const url = baseUrl + `/fabric/message/page/list`
  return await request.post<ApiResult_PaginationResult_FabricMessageResponse>(url, data, {})
}

/**
 * 读取消息
 * @param {any} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/message/read
 * @apiGroup 用户在线聊天
 */
export async function postFabricMessageRead(data: any): Promise<boolean> {
  const url = baseUrl + `/fabric/message/read`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 读取会话内所有消息
 * @param {FabricMessageEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/message/read/conversation
 * @apiGroup 用户在线聊天
 */
export async function postFabricMessageReadConversation(data: FabricMessageEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/message/read/conversation`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询快捷回复列表
 * @param {FabricQuickReplyRequest} data 请求数据
 * @returns {Promise<FabricQuickReplyResponse[]>} OK
 * @api {post} /fabric/message/reply/list
 * @apiGroup 用户在线聊天
 */
export async function postFabricMessageReplyList(data: FabricQuickReplyRequest): Promise<FabricQuickReplyResponse[]> {
  const url = baseUrl + `/fabric/message/reply/list`
  return await request.post<ApiResult_List_FabricQuickReplyResponse>(url, data, {})
}

/**
 * 发送消息
 * @param {FabricMessageEditRequest} data 请求数据
 * @returns {Promise<FabricMessageResponse>} OK
 * @api {post} /fabric/message/send
 * @apiGroup 用户在线聊天
 */
export async function postFabricMessageSend(data: FabricMessageEditRequest): Promise<FabricMessageResponse> {
  const url = baseUrl + `/fabric/message/send`
  return await request.post<ApiResult_FabricMessageResponse>(url, data, {})
}

/**
 * 修改聊天信息
 * @param {FabricMessageEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/message/update
 * @apiGroup 用户在线聊天
 */
export async function postFabricMessageUpdate(data: FabricMessageEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/message/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 修改快捷回复
 * @param {FabricQuickReplyRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/message/update/reply
 * @apiGroup 用户在线聊天
 */
export async function postFabricMessageUpdateReply(data: FabricQuickReplyRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/message/update/reply`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 修改快捷回复排序
 * @param {any} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/message/update/reply/sort
 * @apiGroup 用户在线聊天
 */
export async function postFabricMessageUpdateReplySort(data: any): Promise<boolean> {
  const url = baseUrl + `/fabric/message/update/reply/sort`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询消息未读数量（用户端）
 * @returns {Promise<int>} OK
 * @api {get} /fabric/message/user/unread
 * @apiGroup 用户在线聊天
 */
export async function getFabricMessageUserUnread(): Promise<number> {
  const url = baseUrl + `/fabric/message/user/unread`
  return await request.get<ApiResult_int>(url)
}

/**
 * 商家详情-全部面料
 * @param {FabricInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricMerchantDetailsResponse>} OK
 * @api {post} /mobile/merchant/fabric-page
 * @apiGroup [移动端]面料商家相关接口
 */
export async function postMobileMerchantFabricPage(data: FabricInfoQueryRequest): Promise<PaginationResult_FabricMerchantDetailsResponse> {
  const url = baseUrl + `/mobile/merchant/fabric-page`
  return await request.post<ApiResult_PaginationResult_FabricMerchantDetailsResponse>(url, data, {})
}

/**
 * 查询商家信息
 * @param {object} [params] 查询参数
 * @param {string} [params.teamId] 商家id
 * @returns {Promise<FabricTeamInfoResponse>} OK
 * @api {get} /mobile/merchant/info
 * @apiGroup [移动端]面料商家相关接口
 */
export async function getMobileMerchantInfo(params?: { teamId: string }): Promise<FabricTeamInfoResponse> {
  const url = baseUrl + `/mobile/merchant/info`
  return await request.get<ApiResult_FabricTeamInfoResponse>(url, { params })
}

/**
 * 面料详情页推荐商品
 * @param {FabricRecommendRequest} data 请求数据
 * @returns {Promise<RecommendCaseInfo[]>} OK
 * @api {post} /mobile/recommend/case-list-detail-page
 * @apiGroup [移动端]推荐面料案例
 */
export async function postMobileRecommendCaseListDetailPage(data: FabricRecommendRequest): Promise<RecommendCaseInfo[]> {
  const url = baseUrl + `/mobile/recommend/case-list-detail-page`
  return await request.post<ApiResult_List_RecommendCaseInfo>(url, data, {})
}

/**
 * 获取面料关联商品图源列表
 * @param {FabricSourceChannelRequest} data 请求数据
 * @returns {Promise<FabricSourceChannelResponse>} OK
 * @api {post} /mobile/recommend/fabric-source-channels
 * @apiGroup [移动端]推荐面料案例
 */
export async function postMobileRecommendFabricSourceChannels(data: FabricSourceChannelRequest): Promise<FabricSourceChannelResponse> {
  const url = baseUrl + `/mobile/recommend/fabric-source-channels`
  return await request.post<ApiResult_FabricSourceChannelResponse>(url, data, {})
}

/**
 * 查询面料数据字典
 * @returns {Promise<DataDictResponse[]>} OK
 * @api {get} /mobile/selection/dict/list
 * @apiGroup [移动端]筛选项相关接口
 */
export async function getMobileSelectionDictList(): Promise<DataDictResponse[]> {
  const url = baseUrl + `/mobile/selection/dict/list`
  return await request.get<ApiResult_List_DataDictResponse>(url)
}

/**
 * 新增找布需求
 * @param {FabricCustomerRequirementRequest} [data] 请求数据
 * @returns {Promise<ApiResultLong>} 响应数据
 * @api {post} /fabric/customer/admin/add
 */
export async function postFabricCustomerAdminAdd(data?: FabricCustomerRequirementRequest): Promise<ApiResultLong> {
  const url = baseUrl + `/fabric/customer/admin/add`
  return await request.post<ApiResultLong>(url, data, {})
}

/**
 * 编辑找布需求
 * @param {FabricCustomerRequirementRequest} [data] 请求数据
 * @returns {Promise<ApiResultBoolean>} 响应数据
 * @api {post} /fabric/customer/admin/update
 */
export async function postFabricCustomerAdminUpdate(data?: FabricCustomerRequirementRequest): Promise<ApiResultBoolean> {
  const url = baseUrl + `/fabric/customer/admin/update`
  return await request.post<ApiResultBoolean>(url, data, {})
}

/**
 * 后台找布需求列表查询
 * @param {FabricRequirementQueryRequest} [data] 请求数据
 * @returns {Promise<ApiResultPaginationResultFabricCustomerRequirementResponse>} 响应数据
 * @api {post} /fabric/customer/admin/list
 */
export async function postFabricCustomerAdminList(data?: FabricRequirementQueryRequest): Promise<ApiResultPaginationResultFabricCustomerRequirementResponse> {
  const url = baseUrl + `/fabric/customer/admin/list`
  return await request.post<ApiResultPaginationResultFabricCustomerRequirementResponse>(url, data, {})
}

/**
 * 删除找布需求
 * @param {FabricCustomerRequirementRequest} [data] 请求数据
 * @returns {Promise<ApiResultBoolean>} 响应数据
 * @api {post} /fabric/customer/admin/del
 */
export async function postFabricCustomerAdminDel(data?: FabricCustomerRequirementRequest): Promise<ApiResultBoolean> {
  const url = baseUrl + `/fabric/customer/admin/del`
  return await request.post<ApiResultBoolean>(url, data, {})
}

/**
 * 分配需求
 * @param {FabricRequirementAssignRequest} [data] 请求数据
 * @returns {Promise<ApiResultBoolean>} 响应数据
 * @api {post} /fabric/customer/admin/assign
 */
export async function postFabricCustomerAdminAssign(data?: FabricRequirementAssignRequest): Promise<ApiResultBoolean> {
  const url = baseUrl + `/fabric/customer/admin/assign`
  return await request.post<ApiResultBoolean>(url, data, {})
}

/**
 * 查询分配需求历史记录（管理端）
 * @param {object} [params] 查询参数
 * @param {string} [params.requirementId] 
 * @returns {Promise<ApiResultListFabricRequirementLogResponse>} 响应数据
 * @api {get} /fabric/customer/admin/assign-logs
 */
export async function getFabricCustomerAdminAssignLogs(params?: { requirementId: string }): Promise<ApiResultListFabricRequirementLogResponse> {
  const url = baseUrl + `/fabric/customer/admin/assign-logs`
  return await request.get<ApiResultListFabricRequirementLogResponse>(url, { params })
}

/**
 * 新增沟通记录
 * @param {FabricRequirementCommunicationRequest} [data] 请求数据
 * @returns {Promise<ApiResultLong>} 响应数据
 * @api {post} /fabric/customer/admin/communication/add
 */
export async function postFabricCustomerAdminCommunicationAdd(data?: FabricRequirementCommunicationRequest): Promise<ApiResultLong> {
  const url = baseUrl + `/fabric/customer/admin/communication/add`
  return await request.post<ApiResultLong>(url, data, {})
}

/**
 * 删除沟通记录
 * @param {FabricRequirementCommunicationRequest} [data] 请求数据
 * @returns {Promise<ApiResultBoolean>} 响应数据
 * @api {post} /fabric/customer/admin/communication/del
 */
export async function postFabricCustomerAdminCommunicationDel(data?: FabricRequirementCommunicationRequest): Promise<ApiResultBoolean> {
  const url = baseUrl + `/fabric/customer/admin/communication/del`
  return await request.post<ApiResultBoolean>(url, data, {})
}

/**
 * 查询找布需求沟通记录列表
 * @param {object} [params] 查询参数
 * @param {string} [params.requirementId] 
 * @returns {Promise<ApiResultListFabricRequirementCommunicationResponse>} 响应数据
 * @api {get} /fabric/customer/admin/communication/list
 */
export async function getFabricCustomerAdminCommunicationList(params?: { requirementId: string }): Promise<ApiResultListFabricRequirementCommunicationResponse> {
  const url = baseUrl + `/fabric/customer/admin/communication/list`
  return await request.get<ApiResultListFabricRequirementCommunicationResponse>(url, { params })
}

/**
 * 新增
 * @param {FabricSelectKeywordEditRequest} data 请求数据
 * @returns {Promise<int>} OK
 * @api {post} /fabric/select/keyword/admin/create
 * @apiGroup 精选面料热搜词管理
 */
export async function postFabricSelectKeywordAdminCreate(data: FabricSelectKeywordEditRequest): Promise<number> {
  const url = baseUrl + `/fabric/select/keyword/admin/create`
  return await request.post<ApiResult_int>(url, data, {})
}

/**
 * 编辑
 * @param {FabricSelectKeywordEditRequest} data 请求数据
 * @returns {Promise<int>} OK
 * @api {post} /fabric/select/keyword/admin/edit
 * @apiGroup 精选面料热搜词管理
 */
export async function postFabricSelectKeywordAdminEdit(data: FabricSelectKeywordEditRequest): Promise<number> {
  const url = baseUrl + `/fabric/select/keyword/admin/edit`
  return await request.post<ApiResult_int>(url, data, {})
}

/**
 * 修改在架状态
 * @param {FabricSelectKeywordEditRequest} data 请求数据
 * @returns {Promise<int>} OK
 * @api {post} /fabric/select/keyword/admin/edit-status
 * @apiGroup 精选面料热搜词管理
 */
export async function postFabricSelectKeywordAdminEditStatus(data: FabricSelectKeywordEditRequest): Promise<number> {
  const url = baseUrl + `/fabric/select/keyword/admin/edit-status`
  return await request.post<ApiResult_int>(url, data, {})
}

/**
 * 分页查询
 * @param {FabricSelectKeywordQryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricSelectKeywordResponse>} OK
 * @api {post} /fabric/select/keyword/admin/qry-page
 * @apiGroup 精选面料热搜词管理
 */
export async function postFabricSelectKeywordAdminQryPage(data: FabricSelectKeywordQryRequest): Promise<PaginationResult_FabricSelectKeywordResponse> {
  const url = baseUrl + `/fabric/select/keyword/admin/qry-page`
  return await request.post<ApiResult_PaginationResult_FabricSelectKeywordResponse>(url, data, {})
}

/**
 * 查询面料筛选项
 * @returns {Promise<DataDictResponse[]>} OK
 * @api {get} /fabric/select/option/dict/list
 * @apiGroup 精选面料筛选项
 */
export async function getFabricSelectOptionDictList(): Promise<DataDictResponse[]> {
  const url = baseUrl + `/fabric/select/option/dict/list`
  return await request.get<ApiResult_List_DataDictResponse>(url)
}

/**
 * 查询搜索词筛选项
 * @param {object} [params] 查询参数
 * @param {number} [params.limit] limit
 * @returns {Promise<FabricSelectKeywordResponse[]>} OK
 * @api {get} /fabric/select/option/keyword-list
 * @apiGroup 精选面料筛选项
 */
export async function getFabricSelectOptionKeywordList(params?: { limit?: number }): Promise<FabricSelectKeywordResponse[]> {
  const url = baseUrl + `/fabric/select/option/keyword-list`
  return await request.get<ApiResult_List_FabricSelectKeywordResponse>(url, { params })
}

/**
 * 查询店铺装修面料分类筛选项
 * @param {object} [params] 查询参数
 * @param {number} [params.teamId] teamId
 * @returns {Promise<FirstLevelClassifyVO[]>} OK
 * @api {get} /fabric/select/option/shop-classify
 * @apiGroup 精选面料筛选项
 */
export async function getFabricSelectOptionShopClassify(params?: { teamId: number }): Promise<FirstLevelClassifyVO[]> {
  const url = baseUrl + `/fabric/select/option/shop-classify`
  return await request.get<ApiResult_List_FirstLevelClassifyVO>(url, { params })
}

/**
 * 新增
 * @param {FabricSelectTopSettingEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/select/top-setting/create
 * @apiGroup 精选面料置顶推广管理
 */
export async function postFabricSelectTopSettingCreate(data: FabricSelectTopSettingEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/select/top-setting/create`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 编辑
 * @param {FabricSelectTopSettingEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/select/top-setting/edit
 * @apiGroup 精选面料置顶推广管理
 */
export async function postFabricSelectTopSettingEdit(data: FabricSelectTopSettingEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/select/top-setting/edit`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 取消
 * @param {FabricSelectTopSettingEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/select/top-setting/remove
 * @apiGroup 精选面料置顶推广管理
 */
export async function postFabricSelectTopSettingRemove(data: FabricSelectTopSettingEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/select/top-setting/remove`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 新增标签
 * @param {FabricTagDictEditRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /fabric/admin/tag/add
 * @apiGroup 面料-后台标签管理
 */
export async function postFabricAdminTagAdd(data: FabricTagDictEditRequest): Promise<string> {
  const url = baseUrl + `/fabric/admin/tag/add`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 删除标签
 * @param {FabricTagDictEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/admin/tag/delete
 * @apiGroup 面料-后台标签管理
 */
export async function postFabricAdminTagDelete(data: FabricTagDictEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/admin/tag/delete`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询已启用标签
 * @returns {Promise<FabricTagDictResponse[]>} OK
 * @api {get} /fabric/admin/tag/list
 * @apiGroup 面料-后台标签管理
 */
export async function getFabricAdminTagList(): Promise<FabricTagDictResponse[]> {
  const url = baseUrl + `/fabric/admin/tag/list`
  return await request.get<ApiResult_List_FabricTagDictResponse>(url)
}

/**
 * 分页查询面料标签列表
 * @param {FabricTagQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricTagDictResponse>} OK
 * @api {post} /fabric/admin/tag/page/list
 * @apiGroup 面料-后台标签管理
 */
export async function postFabricAdminTagPageList(data: FabricTagQueryRequest): Promise<PaginationResult_FabricTagDictResponse> {
  const url = baseUrl + `/fabric/admin/tag/page/list`
  return await request.post<ApiResult_PaginationResult_FabricTagDictResponse>(url, data, {})
}

/**
 * 修改标签
 * @param {FabricTagDictEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/admin/tag/update
 * @apiGroup 面料-后台标签管理
 */
export async function postFabricAdminTagUpdate(data: FabricTagDictEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/admin/tag/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 启用/禁用标签
 * @param {FabricTagDictEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/admin/tag/update/status
 * @apiGroup 面料-后台标签管理
 */
export async function postFabricAdminTagUpdateStatus(data: FabricTagDictEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/admin/tag/update/status`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询已引用标签
 * @returns {Promise<UserFabricTagReferenceResponse[]>} OK
 * @api {get} /fabric/tag/list
 * @apiGroup 面料-关联面料标签
 */
export async function getFabricTagList(): Promise<UserFabricTagReferenceResponse[]> {
  const url = baseUrl + `/fabric/tag/list`
  return await request.get<ApiResult_List_UserFabricTagReferenceResponse>(url)
}

/**
 * 分页查询标签关联面料列表
 * @param {FabricTagQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricTagRelationResponse>} OK
 * @api {post} /fabric/tag/page/list
 * @apiGroup 面料-关联面料标签
 */
export async function postFabricTagPageList(data: FabricTagQueryRequest): Promise<PaginationResult_FabricTagRelationResponse> {
  const url = baseUrl + `/fabric/tag/page/list`
  return await request.post<ApiResult_PaginationResult_FabricTagRelationResponse>(url, data, {})
}

/**
 * 查询商家面料标签
 * @param {object} [params] 查询参数
 * @param {number} [params.teamId] teamId
 * @returns {Promise<UserFabricTagReferenceResponse[]>} OK
 * @api {get} /fabric/tag/recommend/list
 * @apiGroup 面料-关联面料标签
 */
export async function getFabricTagRecommendList(params?: { teamId: number }): Promise<UserFabricTagReferenceResponse[]> {
  const url = baseUrl + `/fabric/tag/recommend/list`
  return await request.get<ApiResult_List_UserFabricTagReferenceResponse>(url, { params })
}

/**
 * 添加面料
 * @param {FabricTagReferenceEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/tag/relation
 * @apiGroup 面料-关联面料标签
 */
export async function postFabricTagRelation(data: FabricTagReferenceEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/tag/relation`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 面料关联多个标签
 * @param {FabricTagReferenceEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/tag/relation/tag
 * @apiGroup 面料-关联面料标签
 */
export async function postFabricTagRelationTag(data: FabricTagReferenceEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/tag/relation/tag`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 移除面料
 * @param {FabricTagReferenceEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/tag/remove
 * @apiGroup 面料-关联面料标签
 */
export async function postFabricTagRemove(data: FabricTagReferenceEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/tag/remove`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询面料标签筛选项
 * @param {object} [params] 查询参数
 * @param {array} [params.teamIdList] teamIdList
 * @returns {Promise<UserFabricTagReferenceResponse[]>} OK
 * @api {get} /fabric/tag/search/list
 * @apiGroup 面料-关联面料标签
 */
export async function getFabricTagSearchList(params?: { teamIdList?: number[] }): Promise<UserFabricTagReferenceResponse[]> {
  const url = baseUrl + `/fabric/tag/search/list`
  return await request.get<ApiResult_List_UserFabricTagReferenceResponse>(url, { params })
}

/**
 * 编辑引用标签
 * @param {FabricTagReferenceEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/tag/update/reference
 * @apiGroup 面料-关联面料标签
 */
export async function postFabricTagUpdateReference(data: FabricTagReferenceEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/tag/update/reference`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 新增
 * @param {FabricSelectSellerTopSettingEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/select/seller/top-setting/create
 * @apiGroup 精选商家置顶推广管理
 */
export async function postFabricSelectSellerTopSettingCreate(data: FabricSelectSellerTopSettingEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/select/seller/top-setting/create`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 编辑
 * @param {FabricSelectSellerTopSettingEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/select/seller/top-setting/edit
 * @apiGroup 精选商家置顶推广管理
 */
export async function postFabricSelectSellerTopSettingEdit(data: FabricSelectSellerTopSettingEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/select/seller/top-setting/edit`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 取消
 * @param {FabricSelectSellerTopSettingEditRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/select/seller/top-setting/remove
 * @apiGroup 精选商家置顶推广管理
 */
export async function postFabricSelectSellerTopSettingRemove(data: FabricSelectSellerTopSettingEditRequest): Promise<long> {
  const url = baseUrl + `/fabric/select/seller/top-setting/remove`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 查询面料分类页
 * @returns {Promise<FabricShopClassifyResponse>} OK
 * @api {get} /fabric/shop/query/classify
 * @apiGroup 面料-店铺装修页
 */
export async function getFabricShopQueryClassify(): Promise<FabricShopClassifyResponse> {
  const url = baseUrl + `/fabric/shop/query/classify`
  return await request.get<ApiResult_FabricShopClassifyResponse>(url)
}

/**
 * 查询店铺装修配置
 * @returns {Promise<FabricShopSettingResponse>} OK
 * @api {get} /fabric/shop/query/setting
 * @apiGroup 面料-店铺装修页
 */
export async function getFabricShopQuerySetting(): Promise<FabricShopSettingResponse> {
  const url = baseUrl + `/fabric/shop/query/setting`
  return await request.get<ApiResult_FabricShopSettingResponse>(url)
}

/**
 * 查询推荐面料列表
 * @param {FabricInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricInfoListResponse>} OK
 * @api {post} /fabric/shop/recommend/list
 * @apiGroup 面料-店铺装修页
 */
export async function postFabricShopRecommendList(data: FabricInfoQueryRequest): Promise<PaginationResult_FabricInfoListResponse> {
  const url = baseUrl + `/fabric/shop/recommend/list`
  return await request.post<ApiResult_PaginationResult_FabricInfoListResponse>(url, data, {})
}

/**
 * 发布面料分类
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/shop/release/classify
 * @apiGroup 面料-店铺装修页
 */
export async function getFabricShopReleaseClassify(): Promise<boolean> {
  const url = baseUrl + `/fabric/shop/release/classify`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 发布推荐面料
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/shop/release/recommend
 * @apiGroup 面料-店铺装修页
 */
export async function getFabricShopReleaseRecommend(): Promise<boolean> {
  const url = baseUrl + `/fabric/shop/release/recommend`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 保存面料分类
 * @param {FabricShopClassifySaveRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/shop/save/classify
 * @apiGroup 面料-店铺装修页
 */
export async function postFabricShopSaveClassify(data: FabricShopClassifySaveRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/shop/save/classify`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 保存推荐面料
 * @param {any} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/shop/save/recommend
 * @apiGroup 面料-店铺装修页
 */
export async function postFabricShopSaveRecommend(data: any): Promise<boolean> {
  const url = baseUrl + `/fabric/shop/save/recommend`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 启用/禁用分类页
 * @param {FabricShopSettingEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/shop/update/status
 * @apiGroup 面料-店铺装修页
 */
export async function postFabricShopUpdateStatus(data: FabricShopSettingEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/shop/update/status`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 获取商家记录
 * 根据商家ID查询商家记录, 如果商家审核中则不返回
 * @returns {Promise<FabricSeller>} OK
 * @api {get} /fabric/seller/info
 * @apiGroup 商家记录
 */
export async function getFabricSellerInfo(): Promise<FabricSeller> {
  const url = baseUrl + `/fabric/seller/info`
  return await request.get<ApiResult_FabricSeller>(url)
}

/**
 * 查询商家审核记录
 * 查询商家审核记录
 * @param {ListFabricSellerReviewRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricSellerReview>} OK
 * @api {post} /admin/fabric/seller/list
 * @apiGroup 商家记录-后台管理
 */
export async function postAdminFabricSellerList(data: ListFabricSellerReviewRequest): Promise<PaginationResult_FabricSellerReview> {
  const url = baseUrl + `/admin/fabric/seller/list`
  return await request.post<ApiResult_PaginationResult_FabricSellerReview>(url, data, {})
}

/**
 * 审核商家
 * 审核商家
 * @param {ReviewSellerRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /admin/fabric/seller/review
 * @apiGroup 商家记录-后台管理
 */
export async function postAdminFabricSellerReview(data: ReviewSellerRequest): Promise<boolean> {
  const url = baseUrl + `/admin/fabric/seller/review`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 获取商家审核记录
 * 根据商家ID查询商家审核记录, 如果商家审核中则返回
 * @returns {Promise<FabricSellerReview>} OK
 * @api {get} /fabric/seller/review
 * @apiGroup 商家记录
 */
export async function getFabricSellerReview(): Promise<FabricSellerReview> {
  const url = baseUrl + `/fabric/seller/review`
  return await request.get<ApiResult_FabricSellerReview>(url)
}

/**
 * 取消商家审核
 * 根据商家ID取消商家审核
 * @param {CancelSellerReviewRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /fabric/seller/review/cancel
 * @apiGroup 商家记录
 */
export async function postFabricSellerReviewCancel(data: CancelSellerReviewRequest): Promise<string> {
  const url = baseUrl + `/fabric/seller/review/cancel`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 删除商家信息草稿
 * 删除取消审核后保留的商家信息草稿
 * @param {CancelSellerReviewRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/seller/review/draft/delete
 * @apiGroup 商家记录
 */
export async function postFabricSellerReviewDraftDelete(data: CancelSellerReviewRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/seller/review/draft/delete`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 提交商家审核
 * 根据商家ID提交商家审核
 * @param {SellerReviewRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /fabric/seller/review/submit
 * @apiGroup 商家记录
 */
export async function postFabricSellerReviewSubmit(data: SellerReviewRequest): Promise<string> {
  const url = baseUrl + `/fabric/seller/review/submit`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 校验置顶推广权限
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/select/top-setting/check-permission
 * @apiGroup 精选面料置顶推广管理
 */
export async function getFabricSelectTopSettingCheckPermission(): Promise<boolean> {
  const url = baseUrl + `/fabric/select/top-setting/check-permission`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 商家信息是否完整
 * 根据商家ID查询商家信息是否完整
 * @param {object} [params] 查询参数
 * @param {number} [params.teamId] teamId
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/seller/info-complete
 * @apiGroup 商家记录
 */
export async function getFabricSellerInfoComplete(params?: { teamId?: number }): Promise<boolean> {
  const url = baseUrl + `/fabric/seller/info-complete`
  return await request.get<ApiResult_boolean>(url, { params })
}

/**
 * 获取商家列表
 * @param {object} [params] 查询参数
 * @param {string} [params.trustType] 托管类型
 * @returns {Promise<FabricSelectSeller[]>} OK
 * @api {get} /fabric/seller/list
 * @apiGroup 商家记录
 */
export async function getFabricSellerList(params?: { trustType?: string }): Promise<FabricSelectSeller[]> {
  const url = baseUrl + `/fabric/seller/list`
  return await request.get<ApiResult_List_FabricSelectSeller>(url, { params })
}

/**
 * 获取商家托管类型
 * @returns {Promise<FabricTeamTrustTypeResponse>} OK
 * @api {get} /fabric/seller/trust/type
 * @apiGroup 商家记录
 */
export async function getFabricSellerTrustType(): Promise<FabricTeamTrustTypeResponse> {
  const url = baseUrl + `/fabric/seller/trust/type`
  return await request.get<ApiResult_FabricTeamTrustTypeResponse>(url)
}

/**
 * 新增托管配置
 * @param {FabricTeamTrustEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /admin/team/trust/add
 * @apiGroup 面料-后台托管权限配置
 */
export async function postAdminTeamTrustAdd(data: FabricTeamTrustEditRequest): Promise<boolean> {
  const url = baseUrl + `/admin/team/trust/add`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 删除托管配置
 * @param {FabricTeamTrustEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /admin/team/trust/delete
 * @apiGroup 面料-后台托管权限配置
 */
export async function postAdminTeamTrustDelete(data: FabricTeamTrustEditRequest): Promise<boolean> {
  const url = baseUrl + `/admin/team/trust/delete`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 分页查询托管配置列表
 * @param {FabricTeamTrustQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricTeamTrustResponse>} OK
 * @api {post} /admin/team/trust/page/list
 * @apiGroup 面料-后台托管权限配置
 */
export async function postAdminTeamTrustPageList(data: FabricTeamTrustQueryRequest): Promise<PaginationResult_FabricTeamTrustResponse> {
  const url = baseUrl + `/admin/team/trust/page/list`
  return await request.post<ApiResult_PaginationResult_FabricTeamTrustResponse>(url, data, {})
}

/**
 * 修改托管配置
 * @param {FabricTeamTrustEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /admin/team/trust/update
 * @apiGroup 面料-后台托管权限配置
 */
export async function postAdminTeamTrustUpdate(data: FabricTeamTrustEditRequest): Promise<boolean> {
  const url = baseUrl + `/admin/team/trust/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 新增面料
 * @param {FabricInfoEditRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /fabric/info/trust/add
 * @apiGroup 后台面料管理-面料信息
 */
export async function postFabricInfoTrustAdd(data: FabricInfoEditRequest): Promise<string> {
  const url = baseUrl + `/fabric/info/trust/add`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 查询全部面料案例
 * @param {FabricCaseInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricCaseInfoQueryResponse>} OK
 * @api {post} /fabric/info/trust/case/list
 * @apiGroup 后台面料管理-面料信息
 */
export async function postFabricInfoTrustCaseList(data: FabricCaseInfoQueryRequest): Promise<PaginationResult_FabricCaseInfoQueryResponse> {
  const url = baseUrl + `/fabric/info/trust/case/list`
  return await request.post<ApiResult_PaginationResult_FabricCaseInfoQueryResponse>(url, data, {})
}

/**
 * 查询商家面料数量
 * @param {object} [params] 查询参数
 * @param {number} [params.teamId] teamId
 * @returns {Promise<FabricInfoCountResponse>} OK
 * @api {get} /fabric/info/trust/count
 * @apiGroup 后台面料管理-面料信息
 */
export async function getFabricInfoTrustCount(params?: { teamId?: number }): Promise<FabricInfoCountResponse> {
  const url = baseUrl + `/fabric/info/trust/count`
  return await request.get<ApiResult_FabricInfoCountResponse>(url, { params })
}

/**
 * 删除面料
 * @param {FabricInfoEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/info/trust/delete
 * @apiGroup 后台面料管理-面料信息
 */
export async function postFabricInfoTrustDelete(data: FabricInfoEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/info/trust/delete`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 新增面料草稿箱
 * @param {FabricInfoEditRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /fabric/info/trust/draft/add
 * @apiGroup 后台面料管理-面料信息
 */
export async function postFabricInfoTrustDraftAdd(data: FabricInfoEditRequest): Promise<string> {
  const url = baseUrl + `/fabric/info/trust/draft/add`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 删除面料草稿箱
 * @param {FabricInfoEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/info/trust/draft/delete
 * @apiGroup 后台面料管理-面料信息
 */
export async function postFabricInfoTrustDraftDelete(data: FabricInfoEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/info/trust/draft/delete`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询面料草稿箱列表
 * @param {FabricInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricInfoListResponse>} OK
 * @api {post} /fabric/info/trust/draft/list
 * @apiGroup 后台面料管理-面料信息
 */
export async function postFabricInfoTrustDraftList(data: FabricInfoQueryRequest): Promise<PaginationResult_FabricInfoListResponse> {
  const url = baseUrl + `/fabric/info/trust/draft/list`
  return await request.post<ApiResult_PaginationResult_FabricInfoListResponse>(url, data, {})
}

/**
 * 编辑面料草稿箱
 * @param {FabricInfoEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/info/trust/draft/update
 * @apiGroup 后台面料管理-面料信息
 */
export async function postFabricInfoTrustDraftUpdate(data: FabricInfoEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/info/trust/draft/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询托管商家面料列表
 * @param {FabricInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricInfoListResponse>} OK
 * @api {post} /fabric/info/trust/list
 * @apiGroup 后台面料管理-面料信息
 */
export async function postFabricInfoTrustList(data: FabricInfoQueryRequest): Promise<PaginationResult_FabricInfoListResponse> {
  const url = baseUrl + `/fabric/info/trust/list`
  return await request.post<ApiResult_PaginationResult_FabricInfoListResponse>(url, data, {})
}

/**
 * 下架面料
 * @param {FabricShelfReviewRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/info/trust/off/shelf
 * @apiGroup 后台面料管理-面料信息
 */
export async function postFabricInfoTrustOffShelf(data: FabricShelfReviewRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/info/trust/off/shelf`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询全部面料列表
 * @param {FabricInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricInfoListResponse>} OK
 * @api {post} /fabric/info/trust/page/list
 * @apiGroup 后台面料管理-面料信息
 */
export async function postFabricInfoTrustPageList(data: FabricInfoQueryRequest): Promise<PaginationResult_FabricInfoListResponse> {
  const url = baseUrl + `/fabric/info/trust/page/list`
  return await request.post<ApiResult_PaginationResult_FabricInfoListResponse>(url, data, {})
}

/**
 * 上架面料
 * @param {FabricShelfReviewRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/info/trust/shelf
 * @apiGroup 后台面料管理-面料信息
 */
export async function postFabricInfoTrustShelf(data: FabricShelfReviewRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/info/trust/shelf`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 编辑面料
 * @param {FabricInfoEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/info/trust/update
 * @apiGroup 后台面料管理-面料信息
 */
export async function postFabricInfoTrustUpdate(data: FabricInfoEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/info/trust/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 新增用户操作日志
 * @param {FabricUserOperationRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /user/operation/log/add
 * @apiGroup 用户操作日志
 */
export async function postUserOperationLogAdd(data: FabricUserOperationRequest): Promise<boolean> {
  const url = baseUrl + `/user/operation/log/add`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询用户操作日志
 * @param {FabricUserOperationRequest} data 请求数据
 * @returns {Promise<FabricUserOperationResponse[]>} OK
 * @api {post} /user/operation/log/list
 * @apiGroup 用户操作日志
 */
export async function postUserOperationLogList(data: FabricUserOperationRequest): Promise<FabricUserOperationResponse[]> {
  const url = baseUrl + `/user/operation/log/list`
  return await request.post<ApiResult_List_FabricUserOperationResponse>(url, data, {})
}

/**
 * 查询目标被操作日志
 * @param {FabricUserOperationQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricUserOperationResponse>} OK
 * @api {post} /user/operation/log/page/list
 * @apiGroup 用户操作日志
 */
export async function postUserOperationLogPageList(data: FabricUserOperationQueryRequest): Promise<PaginationResult_FabricUserOperationResponse> {
  const url = baseUrl + `/user/operation/log/page/list`
  return await request.post<ApiResult_PaginationResult_FabricUserOperationResponse>(url, data, {})
}

/**
 * 新建推广项目
 * @param {FabricPromotionEditRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /fabric/project/trust/add
 * @apiGroup 后台面料项目推广管理
 */
export async function postFabricProjectTrustAdd(data: FabricPromotionEditRequest): Promise<string> {
  const url = baseUrl + `/fabric/project/trust/add`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 删除推广项目
 * @param {FabricPromotionEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/project/trust/delete
 * @apiGroup 后台面料项目推广管理
 */
export async function postFabricProjectTrustDelete(data: FabricPromotionEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/project/trust/delete`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询商家推广项目数量
 * @param {object} [params] 查询参数
 * @param {number} [params.teamId] teamId
 * @returns {Promise<FabricPromotionProjectCountResponse>} OK
 * @api {get} /fabric/project/trust/operation/count
 * @apiGroup 后台面料项目推广管理
 */
export async function getFabricProjectTrustOperationCount(params?: { teamId?: number }): Promise<FabricPromotionProjectCountResponse> {
  const url = baseUrl + `/fabric/project/trust/operation/count`
  return await request.get<ApiResult_FabricPromotionProjectCountResponse>(url, { params })
}

/**
 * 查询推广项目列表
 * @param {FabricProjectQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricPromotionProjectResponse>} OK
 * @api {post} /fabric/project/trust/page/list
 * @apiGroup 后台面料项目推广管理
 */
export async function postFabricProjectTrustPageList(data: FabricProjectQueryRequest): Promise<PaginationResult_FabricPromotionProjectResponse> {
  const url = baseUrl + `/fabric/project/trust/page/list`
  return await request.post<ApiResult_PaginationResult_FabricPromotionProjectResponse>(url, data, {})
}

/**
 * 查询推广项目信息
 * @param {FabricProjectQueryRequest} data 请求数据
 * @returns {Promise<FabricPromotionProjectResponse>} OK
 * @api {post} /fabric/project/trust/query/info
 * @apiGroup 后台面料项目推广管理
 */
export async function postFabricProjectTrustQueryInfo(data: FabricProjectQueryRequest): Promise<FabricPromotionProjectResponse> {
  const url = baseUrl + `/fabric/project/trust/query/info`
  return await request.post<ApiResult_FabricPromotionProjectResponse>(url, data, {})
}

/**
 * 编辑推广项目
 * @param {FabricPromotionEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/project/trust/update
 * @apiGroup 后台面料项目推广管理
 */
export async function postFabricProjectTrustUpdate(data: FabricPromotionEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/project/trust/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 修改推广项目状态
 * @param {FabricPromotionEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/project/trust/update/status
 * @apiGroup 后台面料项目推广管理
 */
export async function postFabricProjectTrustUpdateStatus(data: FabricPromotionEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/project/trust/update/status`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * phoneLogin
 * @param {WechatPhoneLoginRequest} data 请求数据
 * @returns {Promise<LoginResponse>} OK
 * @api {post} /wechat/phone-login
 * @apiGroup we-chat-login-controller
 */
export async function postWechatPhoneLogin(data: WechatPhoneLoginRequest): Promise<LoginResponse> {
  const url = baseUrl + `/wechat/phone-login`
  return await request.post<ApiResult_LoginResponse>(url, data, {})
}

/**
 * 加入面料清单
 * @param {UserFabricCollectRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /applet/user/fabric-collect/add-collect
 * @apiGroup [小程序]用户面料清单接口
 */
export async function postAppletUserFabricCollectAddCollect(data: UserFabricCollectRequest): Promise<long> {
  const url = baseUrl + `/applet/user/fabric-collect/add-collect`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 清空面料清单
 * @returns {Promise<boolean>} OK
 * @api {post} /applet/user/fabric-collect/all-remove-collect
 * @apiGroup [小程序]用户面料清单接口
 */
export async function postAppletUserFabricCollectAllRemoveCollect(): Promise<boolean> {
  const url = baseUrl + `/applet/user/fabric-collect/all-remove-collect`
  return await request.post<ApiResult_boolean>(url, {})
}

/**
 * 批量移出面料清单
 * @param {UserFabricCollectRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /applet/user/fabric-collect/batch-remove-collect
 * @apiGroup [小程序]用户面料清单接口
 */
export async function postAppletUserFabricCollectBatchRemoveCollect(data: UserFabricCollectRequest): Promise<boolean> {
  const url = baseUrl + `/applet/user/fabric-collect/batch-remove-collect`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查看面料清单
 * @param {UserFabricCollectQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_UserFabricCollectResponse>} OK
 * @api {post} /applet/user/fabric-collect/list
 * @apiGroup [小程序]用户面料清单接口
 */
export async function postAppletUserFabricCollectList(data: UserFabricCollectQueryRequest): Promise<PaginationResult_UserFabricCollectResponse> {
  const url = baseUrl + `/applet/user/fabric-collect/list`
  return await request.post<ApiResult_PaginationResult_UserFabricCollectResponse>(url, data, {})
}

/**
 * 移出面料清单
 * @param {UserFabricCollectRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /applet/user/fabric-collect/remove-collect
 * @apiGroup [小程序]用户面料清单接口
 */
export async function postAppletUserFabricCollectRemoveCollect(data: UserFabricCollectRequest): Promise<boolean> {
  const url = baseUrl + `/applet/user/fabric-collect/remove-collect`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查看他人分享的面料清单
 * @param {UserFabricShareCollectQueryRequest} data 请求数据
 * @returns {Promise<UserFabricCollectResponse[]>} OK
 * @api {post} /applet/user/fabric-collect/share-list
 * @apiGroup [小程序]用户面料清单接口
 */
export async function postAppletUserFabricCollectShareList(data: UserFabricShareCollectQueryRequest): Promise<UserFabricCollectResponse[]> {
  const url = baseUrl + `/applet/user/fabric-collect/share-list`
  return await request.post<ApiResult_List_UserFabricCollectResponse>(url, data, {})
}

/**
 * 查询分享记录
 * @param {UserFabricShareQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_UserShareRecordResponse>} OK
 * @api {post} /admin/user/share/qry-record-page
 * @apiGroup 后台管理-用户分享接口
 */
export async function postAdminUserShareQryRecordPage(data: UserFabricShareQueryRequest): Promise<PaginationResult_UserShareRecordResponse> {
  const url = baseUrl + `/admin/user/share/qry-record-page`
  return await request.post<ApiResult_PaginationResult_UserShareRecordResponse>(url, data, {})
}

/**
 * 查询分享
 * @param {object} [params] 查询参数
 * @param {string} [params.shareId] shareId
 * @returns {Promise<UserShareRecordResponse>} OK
 * @api {get} /applet/user/share/qry-record
 * @apiGroup [小程序]用户分享接口
 */
export async function getAppletUserShareQryRecord(params?: { shareId: string }): Promise<UserShareRecordResponse> {
  const url = baseUrl + `/applet/user/share/qry-record`
  return await request.get<ApiResult_UserShareRecordResponse>(url, { params })
}

/**
 * 记录阅读分享
 * @param {object} [params] 查询参数
 * @param {string} [params.shareId] shareId
 * @returns {Promise<boolean>} OK
 * @api {get} /applet/user/share/save-read
 * @apiGroup [小程序]用户分享接口
 */
export async function getAppletUserShareSaveRead(params?: { shareId: string }): Promise<boolean> {
  const url = baseUrl + `/applet/user/share/save-read`
  return await request.get<ApiResult_boolean>(url, { params })
}

/**
 * 记录分享,返回分享记录id
 * @param {UserShareRecordRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /applet/user/share/save-record
 * @apiGroup [小程序]用户分享接口
 */
export async function postAppletUserShareSaveRecord(data: UserShareRecordRequest): Promise<string> {
  const url = baseUrl + `/applet/user/share/save-record`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 提交找布需求
 * @param {FabricCustomerRequirementRequest} [data] 请求数据
 * @returns {Promise<ApiResultInteger>} 响应数据
 * @api {post} /applet/fabric/customer/requirement/new
 */
export async function postAppletFabricCustomerRequirementNew(data?: FabricCustomerRequirementRequest): Promise<ApiResultInteger> {
  const url = baseUrl + `/applet/fabric/customer/requirement/new`
  return await request.post<ApiResultInteger>(url, data, {})
}

/**
 * 分页查询找布需求
 * @param {object} [params] 查询参数
 * @param {number} [params.sourceType] 提交来源：1-用户授权(pc端)，2-手动录入(官方提报)，3-用户授权(小程序)
 * @param {string} [params.fuzzySearch] 模糊搜索
 * @returns {Promise<ApiResultPaginationResultFabricCustomerRequirementResponse>} 响应数据
 * @api {get} /applet/fabric/customer/requirement/qry-page-by-user
 */
export async function getAppletFabricCustomerRequirementQryPageByUser(params?: { sourceType?: number; fuzzySearch?: string }): Promise<ApiResultPaginationResultFabricCustomerRequirementResponse> {
  const url = baseUrl + `/applet/fabric/customer/requirement/qry-page-by-user`
  return await request.get<ApiResultPaginationResultFabricCustomerRequirementResponse>(url, { params })
}

/**
 * 找布需求详情
 * @param {object} [params] 查询参数
 * @param {string} [params.requirementId] 找布需求id
 * @returns {Promise<ApiResultFabricCustomerRequirementResponse>} 响应数据
 * @api {get} /applet/fabric/customer/requirement/detail
 */
export async function getAppletFabricCustomerRequirementDetail(params?: { requirementId?: string }): Promise<ApiResultFabricCustomerRequirementResponse> {
  const url = baseUrl + `/applet/fabric/customer/requirement/detail`
  return await request.get<ApiResultFabricCustomerRequirementResponse>(url, { params })
}

/**
 * 对分配结果进行反馈（满意/不满意）
 * @param {FabricRequirementFeedbackRequest} [data] 请求数据
 * @returns {Promise<ApiResultBoolean>} 响应数据
 * @api {post} /applet/fabric/customer/requirement/feedback
 */
export async function postAppletFabricCustomerRequirementFeedback(data?: FabricRequirementFeedbackRequest): Promise<ApiResultBoolean> {
  const url = baseUrl + `/applet/fabric/customer/requirement/feedback`
  return await request.post<ApiResultBoolean>(url, data, {})
}

/**
 * 找布需求-结束服务
 * @param {FabricRequirementFeedbackRequest} [data] 请求数据
 * @returns {Promise<ApiResultBoolean>} 响应数据
 * @api {post} /applet/fabric/customer/requirement/finish
 */
export async function postAppletFabricCustomerRequirementFinish(data?: FabricRequirementFeedbackRequest): Promise<ApiResultBoolean> {
  const url = baseUrl + `/applet/fabric/customer/requirement/finish`
  return await request.post<ApiResultBoolean>(url, data, {})
}

/**
 * 查询找布需求流程记录列表
 * @param {object} [params] 查询参数
 * @param {string} [params.requirementId] 
 * @returns {Promise<ApiResultListFabricRequirementLogResponse>} 响应数据
 * @api {get} /applet/fabric/customer/requirement/assign-logs
 */
export async function getAppletFabricCustomerRequirementAssignLogs(params?: { requirementId: string }): Promise<ApiResultListFabricRequirementLogResponse> {
  const url = baseUrl + `/applet/fabric/customer/requirement/assign-logs`
  return await request.get<ApiResultListFabricRequirementLogResponse>(url, { params })
}

/**
 * 查询推广面料详情
 * @param {FabricInfoDetailRequest} data 请求数据
 * @returns {Promise<FabricInfoDetailResponse>} OK
 * @api {post} /applet/fabric/promotion/provide/fabric-detail
 * @apiGroup [小程序]面料推广提供
 */
export async function postAppletFabricPromotionProvideFabricDetail(data: FabricInfoDetailRequest): Promise<FabricInfoDetailResponse> {
  const url = baseUrl + `/applet/fabric/promotion/provide/fabric-detail`
  return await request.post<ApiResult_FabricInfoDetailResponse>(url, data, {})
}

/**
 * 上报咨询面料
 * @param {FabricInquiryRequest} data 请求数据
 * @returns {Promise<FabricInquiryResponse>} OK
 * @api {post} /applet/fabric/promotion/provide/inquiry-fabric
 * @apiGroup [小程序]面料推广提供
 */
export async function postAppletFabricPromotionProvideInquiryFabric(data: FabricInquiryRequest): Promise<FabricInquiryResponse> {
  const url = baseUrl + `/applet/fabric/promotion/provide/inquiry-fabric`
  return await request.post<ApiResult_FabricInquiryResponse>(url, data, {})
}

/**
 * 查询咨询销售二维码
 * @returns {Promise<string>} OK
 * @api {get} /applet/fabric/promotion/provide/inquiry-qr-code
 * @apiGroup [小程序]面料推广提供
 */
export async function getAppletFabricPromotionProvideInquiryQrCode(): Promise<string> {
  const url = baseUrl + `/applet/fabric/promotion/provide/inquiry-qr-code`
  return await request.get<ApiResult_string>(url)
}

/**
 * 上报咨询商家
 * @param {FabricSellerInquiryRequest} data 请求数据
 * @returns {Promise<FabricInquiryResponse>} OK
 * @api {post} /applet/fabric/promotion/provide/inquiry-seller
 * @apiGroup [小程序]面料推广提供
 */
export async function postAppletFabricPromotionProvideInquirySeller(data: FabricSellerInquiryRequest): Promise<FabricInquiryResponse> {
  const url = baseUrl + `/applet/fabric/promotion/provide/inquiry-seller`
  return await request.post<ApiResult_FabricInquiryResponse>(url, data, {})
}

/**
 * 查询精选布匹列表
 * @param {ListFabricSelectRequest} [data] 请求数据
 * @returns {Promise<ApiResultPaginationResultFabricSelect>} 响应数据
 * @api {post} /applet/fabric/select/list-fabric
 */
export async function postAppletFabricSelectListFabric(data?: ListFabricSelectRequest): Promise<ApiResultPaginationResultFabricSelect> {
  const url = baseUrl + `/applet/fabric/select/list-fabric`
  return await request.post<ApiResultPaginationResultFabricSelect>(url, data, {})
}

/**
 * 查询精选商家列表
 * @param {ListSellerSelectRequest} [data] 请求数据
 * @returns {Promise<ApiResultPaginationResultFabricSelectSeller>} 响应数据
 * @api {post} /applet/fabric/select/list-seller
 */
export async function postAppletFabricSelectListSeller(data?: ListSellerSelectRequest): Promise<ApiResultPaginationResultFabricSelectSeller> {
  const url = baseUrl + `/applet/fabric/select/list-seller`
  return await request.post<ApiResultPaginationResultFabricSelectSeller>(url, data, {})
}

/**
 * 查询商家推荐面料
 * @param {object} [params] 查询参数
 * @param {number} [params.teamId] 
 * @param {number} [params.limit] 
 * @returns {Promise<ApiResultListFabricSelectSimilar>} 响应数据
 * @api {get} /applet/fabric/select/fabric/recommend/list
 */
export async function getAppletFabricSelectFabricRecommendList(params?: { teamId: number; limit: number }): Promise<ApiResultListFabricSelectSimilar> {
  const url = baseUrl + `/applet/fabric/select/fabric/recommend/list`
  return await request.get<ApiResultListFabricSelectSimilar>(url, { params })
}

/**
 * 查询面料筛选项
 * @returns {Promise<DataDictResponse[]>} OK
 * @api {get} /applet/fabric/select/option/dict/list
 * @apiGroup [小程序]面料中心筛选项
 */
export async function getAppletFabricSelectOptionDictList(): Promise<DataDictResponse[]> {
  const url = baseUrl + `/applet/fabric/select/option/dict/list`
  return await request.get<ApiResult_List_DataDictResponse>(url)
}

/**
 * 查询搜索词筛选项
 * @param {object} [params] 查询参数
 * @param {number} [params.limit] limit
 * @returns {Promise<FabricSelectKeywordResponse[]>} OK
 * @api {get} /applet/fabric/select/option/keyword-list
 * @apiGroup [小程序]面料中心筛选项
 */
export async function getAppletFabricSelectOptionKeywordList(params?: { limit?: number }): Promise<FabricSelectKeywordResponse[]> {
  const url = baseUrl + `/applet/fabric/select/option/keyword-list`
  return await request.get<ApiResult_List_FabricSelectKeywordResponse>(url, { params })
}

/**
 * 查询店铺装修面料分类筛选项
 * @param {object} [params] 查询参数
 * @param {number} [params.teamId] teamId
 * @returns {Promise<FirstLevelClassifyVO[]>} OK
 * @api {get} /applet/fabric/select/option/shop-classify
 * @apiGroup [小程序]面料中心筛选项
 */
export async function getAppletFabricSelectOptionShopClassify(params?: { teamId: number }): Promise<FirstLevelClassifyVO[]> {
  const url = baseUrl + `/applet/fabric/select/option/shop-classify`
  return await request.get<ApiResult_List_FirstLevelClassifyVO>(url, { params })
}

/**
 * 商家详情-全部面料
 * @param {FabricInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricMerchantDetailsResponse>} OK
 * @api {post} /applet/merchant/fabric-page
 * @apiGroup [小程序]面料商家相关接口
 */
export async function postAppletMerchantFabricPage(data: FabricInfoQueryRequest): Promise<PaginationResult_FabricMerchantDetailsResponse> {
  const url = baseUrl + `/applet/merchant/fabric-page`
  return await request.post<ApiResult_PaginationResult_FabricMerchantDetailsResponse>(url, data, {})
}

/**
 * 查询商家信息
 * @param {object} [params] 查询参数
 * @param {string} [params.teamId] 商家id
 * @returns {Promise<FabricTeamInfoResponse>} OK
 * @api {get} /applet/merchant/info
 * @apiGroup [小程序]面料商家相关接口
 */
export async function getAppletMerchantInfo(params?: { teamId: string }): Promise<FabricTeamInfoResponse> {
  const url = baseUrl + `/applet/merchant/info`
  return await request.get<ApiResult_FabricTeamInfoResponse>(url, { params })
}

/**
 * links
 * @returns {Promise<any>} OK
 * @api {get} /service-manage
 * @apiGroup web-mvc-links-handler
 */
export async function getServiceManage(): Promise<any> {
  const url = baseUrl + `/service-manage`
  return await request.get<any>(url)
}

/**
 * handle
 * @param {any} [data] 请求数据
 * @returns {Promise<any>} OK
 * @api {get} /service-manage/beans
 * @apiGroup operation-handler
 */
export async function getServiceManageBeans(): Promise<any> {
  const url = baseUrl + `/service-manage/beans`
  return await request.get<any>(url)
}

/**
 * handle
 * @param {any} [data] 请求数据
 * @returns {Promise<any>} OK
 * @api {get} /service-manage/deregister
 * @apiGroup operation-handler
 */
export async function getServiceManageDeregister(): Promise<any> {
  const url = baseUrl + `/service-manage/deregister`
  return await request.get<any>(url)
}

/**
 * handle
 * @param {any} [data] 请求数据
 * @returns {Promise<any>} OK
 * @api {post} /service-manage/shutdown
 * @apiGroup operation-handler
 */
export async function postServiceManageShutdown(data?: any): Promise<any> {
  const url = baseUrl + `/service-manage/shutdown`
  return await request.post<any>(url, data, {})
}

/**
 * 查询面料数据字典
 * @returns {Promise<DataDictResponse[]>} OK
 * @api {get} /applet/fabric/common/dict/list
 * @apiGroup [小程序]面料公共接口
 */
export async function getAppletFabricCommonDictList(): Promise<DataDictResponse[]> {
  const url = baseUrl + `/applet/fabric/common/dict/list`
  return await request.get<ApiResult_List_DataDictResponse>(url)
}

/**
 * 获取用户授权信息和关注信息
 * @param {object} [params] 查询参数
 * @param {string} [params.authType] 授权类型
 * @returns {Promise<ApiResultFabricUserAuthResponse>} OK
 * @api {get} /applet/fabric/user/auth/get
 * @apiGroup [小程序]用户授权管理
 */
export async function getAppletFabricUserAuthGet(params?: { authType: string }): Promise<ApiResultFabricUserAuthResponse> {
  const url = baseUrl + `/applet/fabric/user/auth/get`
  return await request.get<ApiResultFabricUserAuthResponse>(url, { params })
}

/**
 * 查询最近关联面料（10条）
 * @param {object} [params] 查询参数
 * @param {number} [params.sellerId] sellerId
 * @returns {Promise<FabricInfoDetailResponse[]>} OK
 * @api {get} /fabric/seller/trust/association/list
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function getFabricSellerTrustAssociationList(params?: { sellerId: number }): Promise<FabricInfoDetailResponse[]> {
  const url = baseUrl + `/fabric/seller/trust/association/list`
  return await request.get<ApiResult_List_FabricInfoDetailResponse>(url, { params })
}

/**
 * 获取商家记录
 * 根据商家ID查询商家记录, 如果商家审核中则不返回
 * @param {object} [params] 查询参数
 * @param {number} [params.sellerId] sellerId
 * @returns {Promise<FabricSeller>} OK
 * @api {get} /fabric/seller/trust/info
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function getFabricSellerTrustInfo(params?: { sellerId: number }): Promise<FabricSeller> {
  const url = baseUrl + `/fabric/seller/trust/info`
  return await request.get<ApiResult_FabricSeller>(url, { params })
}

/**
 * 获取商家列表
 * 根据商家ID查询商家记录, 如果商家审核中则不返回
 * @param {FabricSellerQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricSeller>} OK
 * @api {get} /fabric/seller/trust/seller/list
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function getFabricSellerTrustSellerList(): Promise<PaginationResult_FabricSeller> {
  const url = baseUrl + `/fabric/seller/trust/seller/list`
  return await request.get<ApiResult_PaginationResult_FabricSeller>(url)
}

/**
 * 获取商家列表
 * 根据商家ID查询商家记录, 如果商家审核中则不返回
 * @param {FabricSellerQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricSeller>} OK
 * @api {post} /fabric/seller/trust/seller/list
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function postFabricSellerTrustSellerList(data: FabricSellerQueryRequest): Promise<PaginationResult_FabricSeller> {
  const url = baseUrl + `/fabric/seller/trust/seller/list`
  return await request.post<ApiResult_PaginationResult_FabricSeller>(url, data, {})
}

/**
 * 查询店铺装修配置
 * @param {object} [params] 查询参数
 * @param {number} [params.sellerId] sellerId
 * @returns {Promise<FabricShopSettingResponse>} OK
 * @api {get} /fabric/seller/trust/query/setting
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function getFabricSellerTrustQuerySetting(params?: { sellerId: number }): Promise<FabricShopSettingResponse> {
  const url = baseUrl + `/fabric/seller/trust/query/setting`
  return await request.get<ApiResult_FabricShopSettingResponse>(url, { params })
}

/**
 * 编辑商家信息
 * 根据商家ID编辑商家记录
 * @param {FabricSeller} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/seller/trust/seller/update
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function postFabricSellerTrustSellerUpdate(data: FabricSeller): Promise<boolean> {
  const url = baseUrl + `/fabric/seller/trust/seller/update`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询店铺面料列表
 * @param {FabricInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricInfoListResponse>} OK
 * @api {post} /fabric/seller/trust/shop/page/list
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function postFabricSellerTrustShopPageList(data: FabricInfoQueryRequest): Promise<PaginationResult_FabricInfoListResponse> {
  const url = baseUrl + `/fabric/seller/trust/shop/page/list`
  return await request.post<ApiResult_PaginationResult_FabricInfoListResponse>(url, data, {})
}

/**
 * 查询面料分类页
 * @param {object} [params] 查询参数
 * @param {number} [params.sellerId] sellerId
 * @returns {Promise<FabricShopClassifyResponse>} OK
 * @api {get} /fabric/seller/trust/shop/query/classify
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function getFabricSellerTrustShopQueryClassify(params?: { sellerId: number }): Promise<FabricShopClassifyResponse> {
  const url = baseUrl + `/fabric/seller/trust/shop/query/classify`
  return await request.get<ApiResult_FabricShopClassifyResponse>(url, { params })
}

/**
 * 查询店铺推荐面料列表
 * @param {FabricInfoQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricInfoListResponse>} OK
 * @api {post} /fabric/seller/trust/shop/recommend/list
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function postFabricSellerTrustShopRecommendList(data: FabricInfoQueryRequest): Promise<PaginationResult_FabricInfoListResponse> {
  const url = baseUrl + `/fabric/seller/trust/shop/recommend/list`
  return await request.post<ApiResult_PaginationResult_FabricInfoListResponse>(url, data, {})
}

/**
 * 发布面料分类
 * @param {object} [params] 查询参数
 * @param {number} [params.sellerId] sellerId
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/seller/trust/shop/release/classify
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function getFabricSellerTrustShopReleaseClassify(params?: { sellerId: number }): Promise<boolean> {
  const url = baseUrl + `/fabric/seller/trust/shop/release/classify`
  return await request.get<ApiResult_boolean>(url, { params })
}

/**
 * 发布推荐面料
 * @param {object} [params] 查询参数
 * @param {number} [params.sellerId] sellerId
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/seller/trust/shop/release/recommend
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function getFabricSellerTrustShopReleaseRecommend(params?: { sellerId: number }): Promise<boolean> {
  const url = baseUrl + `/fabric/seller/trust/shop/release/recommend`
  return await request.get<ApiResult_boolean>(url, { params })
}

/**
 * 保存面料分类
 * @param {FabricShopClassifySaveRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/seller/trust/shop/save/classify
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function postFabricSellerTrustShopSaveClassify(data: FabricShopClassifySaveRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/seller/trust/shop/save/classify`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 保存推荐面料
 * @param {FabricRecommendSaveRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/seller/trust/shop/save/recommend
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function postFabricSellerTrustShopSaveRecommend(data: FabricRecommendSaveRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/seller/trust/shop/save/recommend`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 启用/禁用分类页
 * @param {FabricShopSettingEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/seller/trust/shop/update/status
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function postFabricSellerTrustShopUpdateStatus(data: FabricShopSettingEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/seller/trust/shop/update/status`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 查询已引用标签
 * @param {object} [params] 查询参数
 * @param {number} [params.sellerId] sellerId
 * @returns {Promise<UserFabricTagReferenceResponse[]>} OK
 * @api {get} /fabric/seller/trust/tag/list
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function getFabricSellerTrustTagList(params?: { sellerId: number }): Promise<UserFabricTagReferenceResponse[]> {
  const url = baseUrl + `/fabric/seller/trust/tag/list`
  return await request.get<ApiResult_List_UserFabricTagReferenceResponse>(url, { params })
}

/**
 * 分页查询标签关联面料列表
 * @param {FabricTagQueryRequest} data 请求数据
 * @returns {Promise<PaginationResult_FabricTagRelationResponse>} OK
 * @api {post} /fabric/seller/trust/tag/page/list
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function postFabricSellerTrustTagPageList(data: FabricTagQueryRequest): Promise<PaginationResult_FabricTagRelationResponse> {
  const url = baseUrl + `/fabric/seller/trust/tag/page/list`
  return await request.post<ApiResult_PaginationResult_FabricTagRelationResponse>(url, data, {})
}

/**
 * 添加标签关联新面料
 * @param {FabricTagReferenceEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/seller/trust/tag/relation
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function postFabricSellerTrustTagRelation(data: FabricTagReferenceEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/seller/trust/tag/relation`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 移除标签关联的面料
 * @param {FabricTagReferenceEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/seller/trust/tag/remove
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function postFabricSellerTrustTagRemove(data: FabricTagReferenceEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/seller/trust/tag/remove`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 编辑引用标签
 * @param {FabricTagReferenceEditRequest} data 请求数据
 * @returns {Promise<boolean>} OK
 * @api {post} /fabric/seller/trust/tag/update/reference
 * @apiGroup 后台店铺管理-商家店铺管理
 */
export async function postFabricSellerTrustTagUpdateReference(data: FabricTagReferenceEditRequest): Promise<boolean> {
  const url = baseUrl + `/fabric/seller/trust/tag/update/reference`
  return await request.post<ApiResult_boolean>(url, data, {})
}

/**
 * 活动信息
 * @param {object} [params] 查询参数
 * @param {number} [params.activityId] activityId
 * @returns {Promise<FabricActivityResponse>} OK
 * @api {get} /fabric/activity/detail
 * @apiGroup 面料活动管理
 */
export async function getFabricActivityDetail(params?: { activityId?: number }): Promise<FabricActivityResponse> {
  const url = baseUrl + `/fabric/activity/detail`
  return await request.get<ApiResult_FabricActivityResponse>(url, { params })
}

/**
 * 查询用户是否报名
 * @param {object} [params] 查询参数
 * @param {number} [params.activityId] activityId
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/activity/get/registration
 * @apiGroup 面料活动管理
 */
export async function getFabricActivityGetRegistration(params?: { activityId?: number }): Promise<boolean> {
  const url = baseUrl + `/fabric/activity/get/registration`
  return await request.get<ApiResult_boolean>(url, { params })
}

/**
 * 是否能参加报名
 * @returns {Promise<boolean>} OK
 * @api {get} /fabric/activity/permission
 * @apiGroup 面料活动管理
 */
export async function getFabricActivityPermission(): Promise<boolean> {
  const url = baseUrl + `/fabric/activity/permission`
  return await request.get<ApiResult_boolean>(url)
}

/**
 * 用户报名
 * @param {ActivityRegistrationRequest} data 请求数据
 * @returns {Promise<long>} OK
 * @api {post} /fabric/activity/registration
 * @apiGroup 面料活动管理
 */
export async function postFabricActivityRegistration(data: ActivityRegistrationRequest): Promise<long> {
  const url = baseUrl + `/fabric/activity/registration`
  return await request.post<ApiResult_long>(url, data, {})
}

/**
 * 查询任务完成进度
 * @param {object} [params] 查询参数
 * @param {number} [params.activityId] activityId
 * @returns {Promise<FabricActivityTaskResponse>} OK
 * @api {get} /fabric/activity/task/progress
 * @apiGroup 面料活动管理
 */
export async function getFabricActivityTaskProgress(params?: { activityId?: number }): Promise<FabricActivityTaskResponse> {
  const url = baseUrl + `/fabric/activity/task/progress`
  return await request.get<ApiResult_FabricActivityTaskResponse>(url, { params })
}

/**
 * 查询用户获奖信息
 * @param {object} [params] 查询参数
 * @param {number} [params.activityId] activityId
 * @returns {Promise<FabricActivityDrawResponse>} OK
 * @api {get} /fabric/activity/user/award
 * @apiGroup 面料活动管理
 */
export async function getFabricActivityUserAward(params?: { activityId?: number }): Promise<FabricActivityDrawResponse> {
  const url = baseUrl + `/fabric/activity/user/award`
  return await request.get<ApiResult_FabricActivityDrawResponse>(url, { params })
}

/**
 * 用户抽奖
 * @param {object} [params] 查询参数
 * @param {number} [params.activityId] activityId
 * @returns {Promise<FabricActivityDrawResponse>} OK
 * @api {get} /fabric/activity/user/draw
 * @apiGroup 面料活动管理
 */
export async function getFabricActivityUserDraw(params?: { activityId?: number }): Promise<FabricActivityDrawResponse> {
  const url = baseUrl + `/fabric/activity/user/draw`
  return await request.get<ApiResult_FabricActivityDrawResponse>(url, { params })
}

/**
 * 获取小程序二维码
 * @param {WechatPhoneLoginRequest} data 请求数据
 * @returns {Promise<string>} OK
 * @api {post} /wechat/program/qrcode
 * @apiGroup wechat-mini-program-controller
 */
export async function postWechatProgramQrcode(data: WechatPhoneLoginRequest): Promise<string> {
  const url = baseUrl + `/wechat/program/qrcode`
  return await request.post<ApiResult_string>(url, data, {})
}

/**
 * 分页查询
 * @param {FabricInspirationQryRequest} [data] 请求数据
 * @returns {Promise<ApiResultPaginationResultFabricInspiration>} 响应数据
 * @api {post} /applet/fabric/inspiration/qry-page
 */
export async function postAppletFabricInspirationQryPage(data?: FabricInspirationQryRequest): Promise<ApiResultPaginationResultFabricInspiration> {
  const url = baseUrl + `/applet/fabric/inspiration/qry-page`
  return await request.post<ApiResultPaginationResultFabricInspiration>(url, data, {})
}

/**
 * 查询详情
 * @param {object} [params] 查询参数
 * @param {number} [params.inspirationId] 
 * @returns {Promise<ApiResultFabricInspiration>} 响应数据
 * @api {get} /applet/fabric/inspiration/qry-detail
 */
export async function getAppletFabricInspirationQryDetail(params?: { inspirationId: number }): Promise<ApiResultFabricInspiration> {
  const url = baseUrl + `/applet/fabric/inspiration/qry-detail`
  return await request.get<ApiResultFabricInspiration>(url, { params })
}

/**
 * 未命名接口
 * @param {any} [data] 请求数据
 * @returns {Promise<object>} 响应数据
 * @api {post} /hzej/login
 */
export async function postHzejLogin(data?: any): Promise<object> {
  const url = baseUrl + `/hzej/login`
  return await request.post<object>(url, data, {})
}

/**
 * 11
 * @param {any} [data] 请求数据
 * @returns {Promise<object>} 响应数据
 * @api {post} /order/venue/site/full_court/create
 */
export async function postOrderVenueSiteFull_courtCreate(data?: any): Promise<object> {
  const url = baseUrl + `/order/venue/site/full_court/create`
  return await request.post<object>(url, data, {})
}
